/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProgram:{
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProgram:{
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProgram:{
			data:{
				type:"ProgramCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProgramUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBulletPoint:{
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBulletPoint:{
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBulletPoint:{
			data:{
				type:"BulletPointCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BulletPointUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBulletPointItem:{
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBulletPointItem:{
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBulletPointItem:{
			data:{
				type:"BulletPointItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BulletPointItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFileItem:{
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFileItem:{
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFileItem:{
			data:{
				type:"FileItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFileList:{
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFileList:{
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFileList:{
			data:{
				type:"FileListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLink:{
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLink:{
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLink:{
			data:{
				type:"FooterLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLinkGroups:{
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkGroupsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLinkGroups:{
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkGroupsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLinkGroups:{
			data:{
				type:"FooterLinkGroupsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLinkGroupsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextItem:{
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextItem:{
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextItem:{
			data:{
				type:"TextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextList:{
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextList:{
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextList:{
			data:{
				type:"TextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProgramPage:{
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProgramPage:{
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProgramPage:{
			data:{
				type:"ProgramPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProgramPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGenericPage:{
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GenericPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGenericPage:{
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GenericPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGenericPage:{
			data:{
				type:"GenericPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GenericPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStaff:{
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStaff:{
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStaff:{
			data:{
				type:"StaffCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StaffUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStaffItem:{
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStaffItem:{
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStaffItem:{
			data:{
				type:"StaffItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StaffItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStaffList:{
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStaffList:{
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStaffList:{
			data:{
				type:"StaffListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StaffListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listIcon:{
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IconOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateIcon:{
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IconOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateIcon:{
			data:{
				type:"IconCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"IconUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPrincipleItem:{
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePrincipleItem:{
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePrincipleItem:{
			data:{
				type:"PrincipleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PrincipleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPrincipleList:{
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePrincipleList:{
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePrincipleList:{
			data:{
				type:"PrincipleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PrincipleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkSubGroup:{
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSubGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkSubGroup:{
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSubGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkSubGroup:{
			data:{
				type:"LinkSubGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkSubGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideoList:{
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideoList:{
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideoList:{
			data:{
				type:"YoutubeVideoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideoListItem:{
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideoListItem:{
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideoListItem:{
			data:{
				type:"YoutubeVideoListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCitationItem:{
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCitationItem:{
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCitationItem:{
			data:{
				type:"CitationItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CitationItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCitationList:{
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCitationList:{
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCitationList:{
			data:{
				type:"CitationListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CitationListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentImageLinkItem:{
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentImageLinkItem:{
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentImageLinkItem:{
			data:{
				type:"ContentImageLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentImageLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentImageLinkList:{
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentImageLinkList:{
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentImageLinkList:{
			data:{
				type:"ContentImageLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentImageLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNews:{
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNews:{
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNews:{
			data:{
				type:"NewsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStories:{
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStories:{
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStories:{
			data:{
				type:"StoriesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StoriesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsPage:{
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsPage:{
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsPage:{
			data:{
				type:"NewsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStoriesPage:{
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStoriesPage:{
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStoriesPage:{
			data:{
				type:"StoriesPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StoriesPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStoriesList:{
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStoriesList:{
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStoriesList:{
			data:{
				type:"StoriesListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StoriesListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Content:{
		blocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByReferences:{
			by:{
				type:"ContentBlocksByReferencesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UUID: "String",
	ContentBlock:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		references:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByLink:{
			by:{
				type:"ContentBlockReferencesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByFileList:{
			by:{
				type:"ContentBlockReferencesByFileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByTextList:{
			by:{
				type:"ContentBlockReferencesByTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByStaffList:{
			by:{
				type:"ContentBlockReferencesByStaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByPrincipleList:{
			by:{
				type:"ContentBlockReferencesByPrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByImageLinkList:{
			by:{
				type:"ContentBlockReferencesByImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByCitationList:{
			by:{
				type:"ContentBlockReferencesByCitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByStoriesList:{
			by:{
				type:"ContentBlockReferencesByStoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"YoutubeVideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"FileListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"TextListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"StaffListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"PrincipleListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"ViewCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"AligningCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentImageLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"CitationListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"StoriesListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceTypeCondition:{
		and:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceType: "enum",
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		isTargetBlank:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	LinkableWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"ProgramWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"ProgramPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"GenericPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"NewsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"NewsWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"StoriesWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"StoriesPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		ilustration:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		bulletPoint:{
			type:"BulletPointWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		showDetailLink:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProgramWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProgramWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProgramWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BooleanCondition:{
		and:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BulletPointItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BulletPointWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BulletPointWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BulletPointWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BulletPointWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BulletPointItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BulletPointItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BulletPointItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OneCondition:{
		and:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	One: "enum",
	RedirectWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProgramPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProgramPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProgramPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		darujmeWidget:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GenericPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GenericPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GenericPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDate:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateTimeCondition:{
		and:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateTime: "String",
	StoriesWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StoriesListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StoriesWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StoriesWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StoriesWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StoriesWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StoriesListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StoriesListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StoriesListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StoriesPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StoriesPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StoriesPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		videoId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"YoutubeVideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"YoutubeVideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"YoutubeVideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"FileItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FileListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FileListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FileListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileType:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"FileListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FileItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FileItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FileItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"TextItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TextListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TextListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TextListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TextListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TextItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TextItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TextItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StaffItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StaffListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StaffListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StaffListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StaffListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		staff:{
			type:"StaffWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StaffItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StaffItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StaffItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StaffWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StaffWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StaffWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"PrincipleItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PrincipleListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PrincipleListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PrincipleListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"PrincipleListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"IconWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PrincipleItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PrincipleItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PrincipleItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"IconWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"IconWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"IconWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ViewCondition:{
		and:{
			type:"ViewCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ViewCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ViewCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"View",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"View",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	View: "enum",
	AligningCondition:{
		and:{
			type:"AligningCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"AligningCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"AligningCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Aligning",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Aligning",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Aligning: "enum",
	ContentImageLinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContentImageLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentImageLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentImageLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentImageLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContentImageLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentImageLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentImageLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentImageLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"CitationItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CitationListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CitationListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CitationListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"CitationListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CitationItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CitationItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CitationItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReference:{
		block:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		youtubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		fileList:{
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		textList:{
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		staffList:{
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		principleList:{
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		imageLinkList:{
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		citationList:{
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		storiesList:{
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Link:{
		internalLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Linkable:{
		program:{
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		homePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		redirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		programPage:{
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		genericPage:{
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		newsPage:{
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		news:{
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		story:{
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		storiesPage:{
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Program:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		ilustration:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		bulletPoint:{
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Seo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BulletPoint:{
		items:{
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BulletPointItem:{
		list:{
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BulletPointItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BulletPointOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	BulletPointOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePage:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Redirect:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProgramPage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GenericPage:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	NewsPage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	News:{
		coverImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Stories:{
		coverImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		list:{
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	StoriesList:{
		items:{
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByContent:{
			by:{
				type:"StoriesListItemsByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsBySeo:{
			by:{
				type:"StoriesListItemsBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByLink:{
			by:{
				type:"StoriesListItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	StoriesOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StoriesListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"ProgramOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"ProgramPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"GenericPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"NewsPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"NewsOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"StoriesOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"StoriesPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		ilustration:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		bulletPoint:{
			type:"BulletPointOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		showDetailLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		darujmeWidget:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDate:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListItemsByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"FileListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"TextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"StaffListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"PrincipleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentImageLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"CitationListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"StoriesListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"FileItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"TextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StaffItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"PrincipleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContentImageLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"CitationItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"ProgramUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"ProgramPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"GenericPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"NewsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"NewsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"StoriesPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		ilustration:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		bulletPoint:{
			type:"BulletPointUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BulletPointItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListItemsBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListItemsByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FileList:{
		reference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		items:{
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FileItem:{
		list:{
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FileItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"FileListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"YoutubeVideoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"FileListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"TextListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"StaffListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"PrincipleListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentImageLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"CitationListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"StoriesListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		isTargetBlank:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		videoId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextList:{
		items:{
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByLink:{
			by:{
				type:"TextListItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TextItem:{
		list:{
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TextItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TextListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffList:{
		reference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		items:{
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	StaffItem:{
		list:{
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		staff:{
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Staff:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	StaffItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StaffListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		staff:{
			type:"StaffOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleList:{
		reference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		items:{
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PrincipleItem:{
		list:{
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		icon:{
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Icon:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PrincipleItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"PrincipleListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"IconOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkList:{
		items:{
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByImage:{
			by:{
				type:"ContentImageLinkListItemsByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByLink:{
			by:{
				type:"ContentImageLinkListItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentImageLinkItem:{
		list:{
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentImageLinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContentImageLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListItemsByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationList:{
		items:{
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	CitationItem:{
		list:{
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	CitationItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"CitationListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByFileListUniqueWhere:{
		fileList:{
			type:"FileListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByTextListUniqueWhere:{
		textList:{
			type:"TextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByStaffListUniqueWhere:{
		staffList:{
			type:"StaffListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByPrincipleListUniqueWhere:{
		principleList:{
			type:"PrincipleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByImageLinkListUniqueWhere:{
		imageLinkList:{
			type:"ContentImageLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByCitationListUniqueWhere:{
		citationList:{
			type:"CitationListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByStoriesListUniqueWhere:{
		storiesList:{
			type:"StoriesListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceCreateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceCreateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceCreateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceCreateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceCreatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceCreateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceCreateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceCreateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkCreateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isTargetBlank:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateProgramEntityRelationInput:{
		connect:{
			type:"ProgramUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProgramWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProgramCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProgramCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ilustration:{
			type:"ProgramCreateIlustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		bulletPoint:{
			type:"ProgramCreateBulletPointEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showDetailLink:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramCreateIlustrationEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramCreateBulletPointEntityRelationInput:{
		connect:{
			type:"BulletPointUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BulletPointCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BulletPointCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointCreateItemsEntityRelationInput:{
		connect:{
			type:"BulletPointItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BulletPointItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateHomePageEntityRelationInput:{
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateRedirectEntityRelationInput:{
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateProgramPageEntityRelationInput:{
		connect:{
			type:"ProgramPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProgramPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateGenericPageEntityRelationInput:{
		connect:{
			type:"GenericPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GenericPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GenericPageCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"GenericPageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"GenericPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		darujmeWidget:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateNewsPageEntityRelationInput:{
		connect:{
			type:"NewsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateNewsEntityRelationInput:{
		connect:{
			type:"NewsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDate:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"NewsCreateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"NewsCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsCreateCoverImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateStoryEntityRelationInput:{
		connect:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"StoriesCreateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"StoriesCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StoriesCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesCreateCoverImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesCreateListEntityRelationInput:{
		connect:{
			type:"StoriesListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateStoriesPageEntityRelationInput:{
		connect:{
			type:"StoriesPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateYoutubeVideoEntityRelationInput:{
		connect:{
			type:"YoutubeVideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		videoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateFileListEntityRelationInput:{
		connect:{
			type:"FileListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListWithoutReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"FileListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListCreateItemsEntityRelationInput:{
		connect:{
			type:"FileItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileType:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateTextListEntityRelationInput:{
		connect:{
			type:"TextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"TextListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListCreateItemsEntityRelationInput:{
		connect:{
			type:"TextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TextItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateStaffListEntityRelationInput:{
		connect:{
			type:"StaffListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListWithoutReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StaffListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListCreateItemsEntityRelationInput:{
		connect:{
			type:"StaffItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		staff:{
			type:"StaffItemCreateStaffEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemCreateStaffEntityRelationInput:{
		connect:{
			type:"StaffUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"StaffCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreatePrincipleListEntityRelationInput:{
		connect:{
			type:"PrincipleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrincipleListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListWithoutReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"PrincipleListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListCreateItemsEntityRelationInput:{
		connect:{
			type:"PrincipleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrincipleItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"PrincipleItemCreateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemCreateIconEntityRelationInput:{
		connect:{
			type:"IconUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IconCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"IconCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImageLinkListEntityRelationInput:{
		connect:{
			type:"ContentImageLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentImageLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContentImageLinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		link:{
			type:"ContentImageLinkListCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"ContentImageLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentImageLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentImageLinkItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentImageLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateCitationListEntityRelationInput:{
		connect:{
			type:"CitationListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CitationListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"CitationListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListCreateItemsEntityRelationInput:{
		connect:{
			type:"CitationItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CitationItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CitationItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateStoriesListEntityRelationInput:{
		connect:{
			type:"StoriesListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StoriesListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListCreateItemsEntityRelationInput:{
		connect:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"StoriesCreateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"StoriesCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StoriesCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutStoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutStoryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateInput:{
		blocks:{
			type:"ContentUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentUpsertBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockUpdateReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceUpdateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceUpdateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceUpdateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceUpdateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceUpdatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceUpdateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceUpdateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceUpdateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkUpdateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isTargetBlank:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateProgramEntityRelationInput:{
		create:{
			type:"ProgramWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProgramWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertProgramRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProgramUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramWithoutLinkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProgramUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProgramUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ilustration:{
			type:"ProgramUpdateIlustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		bulletPoint:{
			type:"ProgramUpdateBulletPointEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showDetailLink:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpdateIlustrationEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramUpsertIlustrationRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpsertIlustrationRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpdateBulletPointEntityRelationInput:{
		create:{
			type:"BulletPointCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BulletPointUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramUpsertBulletPointRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BulletPointUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointUpdateInput:{
		items:{
			type:"BulletPointUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointUpdateItemsEntityRelationInput:{
		create:{
			type:"BulletPointItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BulletPointUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BulletPointUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BulletPointItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BulletPointItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BulletPointItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointUpdateItemsRelationInput:{
		by:{
			type:"BulletPointItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BulletPointItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointUpsertItemsRelationInput:{
		by:{
			type:"BulletPointItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BulletPointItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BulletPointItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpsertBulletPointRelationInput:{
		update:{
			type:"BulletPointUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BulletPointCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertProgramRelationInput:{
		update:{
			type:"ProgramWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProgramWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateHomePageEntityRelationInput:{
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertHomePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertHomePageRelationInput:{
		update:{
			type:"HomePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateRedirectEntityRelationInput:{
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertRedirectRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkUpdateInput:{
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertTargetRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertRedirectRelationInput:{
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateProgramPageEntityRelationInput:{
		create:{
			type:"ProgramPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProgramPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertProgramPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProgramPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertProgramPageRelationInput:{
		update:{
			type:"ProgramPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProgramPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateGenericPageEntityRelationInput:{
		create:{
			type:"GenericPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GenericPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertGenericPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GenericPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageWithoutLinkUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GenericPageUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"GenericPageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"GenericPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		darujmeWidget:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GenericPageUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GenericPageUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GenericPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertGenericPageRelationInput:{
		update:{
			type:"GenericPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GenericPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateNewsPageEntityRelationInput:{
		create:{
			type:"NewsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertNewsPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertNewsPageRelationInput:{
		update:{
			type:"NewsPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateNewsEntityRelationInput:{
		create:{
			type:"NewsWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertNewsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsWithoutLinkUpdateInput:{
		publishDate:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"NewsUpdateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"NewsUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpdateCoverImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsUpsertCoverImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpsertCoverImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertNewsRelationInput:{
		update:{
			type:"NewsWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateStoryEntityRelationInput:{
		create:{
			type:"StoriesWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StoriesWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertStoryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"StoriesUpdateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"StoriesUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StoriesUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpdateCoverImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesUpsertCoverImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpsertCoverImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpdateListEntityRelationInput:{
		create:{
			type:"StoriesListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StoriesListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StoriesListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpsertListRelationInput:{
		update:{
			type:"StoriesListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertStoryRelationInput:{
		update:{
			type:"StoriesWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateStoriesPageEntityRelationInput:{
		create:{
			type:"StoriesPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StoriesPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertStoriesPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StoriesPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertStoriesPageRelationInput:{
		update:{
			type:"StoriesPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateYoutubeVideoEntityRelationInput:{
		create:{
			type:"YoutubeVideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"YoutubeVideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertYoutubeVideoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"YoutubeVideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoUpdateInput:{
		videoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertYoutubeVideoRelationInput:{
		update:{
			type:"YoutubeVideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateFileListEntityRelationInput:{
		create:{
			type:"FileListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileListWithoutReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertFileListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FileListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListWithoutReferenceUpdateInput:{
		items:{
			type:"FileListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListUpdateItemsEntityRelationInput:{
		create:{
			type:"FileItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FileListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FileItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FileItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FileItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListUpdateItemsRelationInput:{
		by:{
			type:"FileItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FileItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileType:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListUpsertItemsRelationInput:{
		by:{
			type:"FileItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertFileListRelationInput:{
		update:{
			type:"FileListWithoutReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateTextListEntityRelationInput:{
		create:{
			type:"TextListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertTextListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListUpdateInput:{
		items:{
			type:"TextListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListUpdateItemsEntityRelationInput:{
		create:{
			type:"TextItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListUpdateItemsRelationInput:{
		by:{
			type:"TextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TextItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TextItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListUpsertItemsRelationInput:{
		by:{
			type:"TextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertTextListRelationInput:{
		update:{
			type:"TextListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateStaffListEntityRelationInput:{
		create:{
			type:"StaffListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StaffListWithoutReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertStaffListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StaffListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListWithoutReferenceUpdateInput:{
		items:{
			type:"StaffListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListUpdateItemsEntityRelationInput:{
		create:{
			type:"StaffItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StaffListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StaffListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StaffItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"StaffItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"StaffItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListUpdateItemsRelationInput:{
		by:{
			type:"StaffItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"StaffItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		staff:{
			type:"StaffItemUpdateStaffEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemUpdateStaffEntityRelationInput:{
		create:{
			type:"StaffCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StaffUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StaffItemUpsertStaffRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StaffUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"StaffUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StaffUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemUpsertStaffRelationInput:{
		update:{
			type:"StaffUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListUpsertItemsRelationInput:{
		by:{
			type:"StaffItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StaffItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertStaffListRelationInput:{
		update:{
			type:"StaffListWithoutReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdatePrincipleListEntityRelationInput:{
		create:{
			type:"PrincipleListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrincipleListWithoutReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertPrincipleListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PrincipleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListWithoutReferenceUpdateInput:{
		items:{
			type:"PrincipleListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListUpdateItemsEntityRelationInput:{
		create:{
			type:"PrincipleItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrincipleListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrincipleListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PrincipleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PrincipleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PrincipleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListUpdateItemsRelationInput:{
		by:{
			type:"PrincipleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PrincipleItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"PrincipleItemUpdateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemUpdateIconEntityRelationInput:{
		create:{
			type:"IconCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IconUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrincipleItemUpsertIconRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"IconUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"IconUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IconUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemUpsertIconRelationInput:{
		update:{
			type:"IconUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IconCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListUpsertItemsRelationInput:{
		by:{
			type:"PrincipleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrincipleItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrincipleItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertPrincipleListRelationInput:{
		update:{
			type:"PrincipleListWithoutReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrincipleListWithoutReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImageLinkListEntityRelationInput:{
		create:{
			type:"ContentImageLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentImageLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImageLinkListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentImageLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContentImageLinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		link:{
			type:"ContentImageLinkListUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"ContentImageLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentImageLinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentImageLinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentImageLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentImageLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentImageLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListUpdateItemsRelationInput:{
		by:{
			type:"ContentImageLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentImageLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentImageLinkItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentImageLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentImageLinkItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentImageLinkItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListUpsertItemsRelationInput:{
		by:{
			type:"ContentImageLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentImageLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentImageLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentImageLinkListUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImageLinkListRelationInput:{
		update:{
			type:"ContentImageLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentImageLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateCitationListEntityRelationInput:{
		create:{
			type:"CitationListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CitationListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertCitationListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CitationListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListUpdateInput:{
		items:{
			type:"CitationListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListUpdateItemsEntityRelationInput:{
		create:{
			type:"CitationItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CitationListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CitationListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CitationItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"CitationItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"CitationItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListUpdateItemsRelationInput:{
		by:{
			type:"CitationItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"CitationItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemWithoutListUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CitationItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CitationItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListUpsertItemsRelationInput:{
		by:{
			type:"CitationItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CitationItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CitationItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertCitationListRelationInput:{
		update:{
			type:"CitationListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CitationListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateStoriesListEntityRelationInput:{
		create:{
			type:"StoriesListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StoriesListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertStoriesListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StoriesListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListUpdateInput:{
		items:{
			type:"StoriesListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListUpdateItemsEntityRelationInput:{
		create:{
			type:"StoriesWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StoriesListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListUpdateItemsRelationInput:{
		by:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"StoriesWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesWithoutListUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"StoriesUpdateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"StoriesUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StoriesUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutStoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutStoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutStoryUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutStoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutStoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesListUpsertItemsRelationInput:{
		by:{
			type:"StoriesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StoriesWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertStoriesListRelationInput:{
		update:{
			type:"StoriesListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StoriesListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpsertBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateContentEntityRelationInput:{
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertContentRelationInput:{
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceCreateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceCreateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceCreateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceCreateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceCreatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceCreateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceCreateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceCreateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceUpdateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceUpdateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceUpdateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceUpdateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceUpdatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceUpdateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceUpdateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceUpdateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeo:{
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FallbackSeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FallbackSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FallbackSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FallbackSeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FallbackSeoCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FallbackSeoUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FallbackSeoUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Footer:{
		logoFirst:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logoSecond:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		linksGroups:{
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkGroupsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinksGroups:{
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkGroupsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterLinkGroups:{
		links:{
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinks:{
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterLink:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"FooterLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialIdentifier:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterLinkGroupsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterLinkGroupsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterLinkGroupsWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialIdentifier:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksGroups:{
			type:"FooterLinkGroupsWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"FooterCreateLogoFirstEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"FooterCreateLogoSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksGroups:{
			type:"FooterCreateLinksGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FooterCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLogoFirstEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLogoSecondEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLinksGroupsEntityRelationInput:{
		connect:{
			type:"FooterLinkGroupsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLinkGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"FooterLinkGroupsCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		specialIdentifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsCreateLinksEntityRelationInput:{
		connect:{
			type:"FooterLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FooterLinkCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"FooterUpdateLogoFirstEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"FooterUpdateLogoSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksGroups:{
			type:"FooterUpdateLinksGroupsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FooterUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLogoFirstEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLogoFirstRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLogoFirstRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLogoSecondEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLogoSecondRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLogoSecondRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLinksGroupsEntityRelationInput:{
		create:{
			type:"FooterLinkGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterUpdateLinksGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLinksGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterLinkGroupsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FooterLinkGroupsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FooterLinkGroupsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLinksGroupsRelationInput:{
		by:{
			type:"FooterLinkGroupsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FooterLinkGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"FooterLinkGroupsUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		specialIdentifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsUpdateLinksEntityRelationInput:{
		create:{
			type:"FooterLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLinkGroupsUpdateLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLinkGroupsUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FooterLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FooterLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsUpdateLinksRelationInput:{
		by:{
			type:"FooterLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FooterLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FooterLinkUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLinkUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinkGroupsUpsertLinksRelationInput:{
		by:{
			type:"FooterLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLinksGroupsRelationInput:{
		by:{
			type:"FooterLinkGroupsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLinkGroupsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLinkGroupsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Header:{
		logoFirst:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logoSecond:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		linkGroups:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkList:{
		items:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByLink:{
			by:{
				type:"LinkListItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByGroup:{
			by:{
				type:"LinkListItemsByGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkItem:{
		list:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		group:{
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		group:{
			type:"LinkSubGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHighlighted:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkSubGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkSubGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkSubGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroup:{
		links:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		group:{
			type:"LinkSubGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHighlighted:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListItemsByGroupUniqueWhere:{
		group:{
			type:"LinkSubGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		group:{
			type:"LinkSubGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkGroups:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkGroups:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkGroups:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"HeaderCreateLogoFirstEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"HeaderCreateLogoSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkGroups:{
			type:"HeaderCreateLinkGroupsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLogoFirstEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLogoSecondEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLinkGroupsEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		group:{
			type:"LinkItemCreateGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHighlighted:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateGroupEntityRelationInput:{
		connect:{
			type:"LinkSubGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkSubGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkSubGroupCreateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupCreateLinksEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoFirst:{
			type:"HeaderUpdateLogoFirstEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoSecond:{
			type:"HeaderUpdateLogoSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkGroups:{
			type:"HeaderUpdateLinkGroupsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLogoFirstEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLogoFirstRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLogoFirstRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLogoSecondEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLogoSecondRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLogoSecondRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLinkGroupsEntityRelationInput:{
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLinkGroupsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateInput:{
		items:{
			type:"LinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateItemsRelationInput:{
		by:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"LinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		group:{
			type:"LinkItemUpdateGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHighlighted:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateGroupEntityRelationInput:{
		create:{
			type:"LinkSubGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkSubGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertGroupRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkSubGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkSubGroupUpdateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupUpdateLinksEntityRelationInput:{
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkSubGroupUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSubGroupUpsertLinksRelationInput:{
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertGroupRelationInput:{
		update:{
			type:"LinkSubGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkSubGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpsertItemsRelationInput:{
		by:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLinkGroupsRelationInput:{
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HomePageUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProgramCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProgramCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProgramCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ilustration:{
			type:"ProgramCreateIlustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		bulletPoint:{
			type:"ProgramCreateBulletPointEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showDetailLink:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutProgramCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutProgramCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProgramUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProgramUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProgramUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		ilustration:{
			type:"ProgramUpdateIlustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		bulletPoint:{
			type:"ProgramUpdateBulletPointEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showDetailLink:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutProgramCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutProgramUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutProgramUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutProgramUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutProgramCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateInput:{
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BulletPointItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemCreateListEntityRelationInput:{
		connect:{
			type:"BulletPointUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BulletPointWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BulletPointItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemUpdateListEntityRelationInput:{
		create:{
			type:"BulletPointWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BulletPointWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BulletPointItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BulletPointUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BulletPointItemUpsertListRelationInput:{
		update:{
			type:"BulletPointWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BulletPointWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileType:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"FileItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemCreateListEntityRelationInput:{
		connect:{
			type:"FileListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"FileListCreateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListCreateReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutFileListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutFileListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceCreateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceCreateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceCreateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceCreatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceCreateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceCreateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceCreateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileType:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"FileItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemUpdateListEntityRelationInput:{
		create:{
			type:"FileListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FileItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FileListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListWithoutItemsUpdateInput:{
		reference:{
			type:"FileListUpdateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListUpdateReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutFileListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutFileListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FileListUpsertReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutFileListUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceUpdateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceUpdateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceUpdateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceUpdatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceUpdateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceUpdateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceUpdateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListUpsertReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutFileListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutFileListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileItemUpsertListRelationInput:{
		update:{
			type:"FileListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"FileListCreateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"FileListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileListUpdateInput:{
		reference:{
			type:"FileListUpdateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"FileListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TextItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TextItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemCreateListEntityRelationInput:{
		connect:{
			type:"TextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TextItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TextItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemUpdateListEntityRelationInput:{
		create:{
			type:"TextListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextItemUpsertListRelationInput:{
		update:{
			type:"TextListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProgramPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutProgramPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutProgramPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProgramPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ProgramPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutProgramPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutProgramPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProgramPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutProgramPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProgramPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutProgramPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutProgramPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GenericPageCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"GenericPageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"GenericPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"GenericPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		darujmeWidget:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutGenericPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutGenericPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GenericPageUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"GenericPageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"GenericPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"GenericPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		darujmeWidget:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutGenericPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutGenericPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GenericPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutGenericPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GenericPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutGenericPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutGenericPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StaffItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staff:{
			type:"StaffItemCreateStaffEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemCreateListEntityRelationInput:{
		connect:{
			type:"StaffListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"StaffListCreateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListCreateReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutStaffListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutStaffListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceCreateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceCreateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceCreateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceCreatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceCreateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceCreateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceCreateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StaffItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staff:{
			type:"StaffItemUpdateStaffEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemUpdateListEntityRelationInput:{
		create:{
			type:"StaffListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StaffListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StaffItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StaffListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListWithoutItemsUpdateInput:{
		reference:{
			type:"StaffListUpdateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListUpdateReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutStaffListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutStaffListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StaffListUpsertReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutStaffListUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceUpdateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceUpdateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceUpdateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		principleList:{
			type:"ContentReferenceUpdatePrincipleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceUpdateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceUpdateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceUpdateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListUpsertReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutStaffListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutStaffListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffItemUpsertListRelationInput:{
		update:{
			type:"StaffListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StaffListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"StaffListCreateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StaffListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StaffListUpdateInput:{
		reference:{
			type:"StaffListUpdateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StaffListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"PrincipleItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"PrincipleItemCreateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemCreateListEntityRelationInput:{
		connect:{
			type:"PrincipleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrincipleListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"PrincipleListCreateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListCreateReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutPrincipleListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutPrincipleListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceCreateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceCreateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceCreateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceCreateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceCreateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceCreateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceCreateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"PrincipleItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"PrincipleItemUpdateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemUpdateListEntityRelationInput:{
		create:{
			type:"PrincipleListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrincipleListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrincipleItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PrincipleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListWithoutItemsUpdateInput:{
		reference:{
			type:"PrincipleListUpdateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListUpdateReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutPrincipleListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutPrincipleListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrincipleListUpsertReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutPrincipleListUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeVideo:{
			type:"ContentReferenceUpdateYoutubeVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileList:{
			type:"ContentReferenceUpdateFileListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		textList:{
			type:"ContentReferenceUpdateTextListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		staffList:{
			type:"ContentReferenceUpdateStaffListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		view:{
			type:"View",
			array:false,
			arrayRequired:false,
			required:false
		},
		aligning:{
			type:"Aligning",
			array:false,
			arrayRequired:false,
			required:false
		},
		numbered:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		tertiaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageLinkList:{
			type:"ContentReferenceUpdateImageLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		citationList:{
			type:"ContentReferenceUpdateCitationListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesList:{
			type:"ContentReferenceUpdateStoriesListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListUpsertReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutPrincipleListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutPrincipleListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleItemUpsertListRelationInput:{
		update:{
			type:"PrincipleListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrincipleListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		reference:{
			type:"PrincipleListCreateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"PrincipleListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrincipleListUpdateInput:{
		reference:{
			type:"PrincipleListUpdateReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"PrincipleListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		group:{
			type:"LinkItemCreateGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHighlighted:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateListEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		group:{
			type:"LinkItemUpdateGroupEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHighlighted:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateListEntityRelationInput:{
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertListRelationInput:{
		update:{
			type:"LinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoList:{
		items:{
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByYoutube:{
			by:{
				type:"YoutubeVideoListItemsByYoutubeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	YoutubeVideoListItem:{
		list:{
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		youtube:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	YoutubeVideoListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"YoutubeVideoListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"YoutubeVideoListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"YoutubeVideoListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"YoutubeVideoListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"YoutubeVideoListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"YoutubeVideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"YoutubeVideoListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"YoutubeVideoListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"YoutubeVideoListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"YoutubeVideoListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"YoutubeVideoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemsByYoutubeUniqueWhere:{
		youtube:{
			type:"YoutubeVideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"YoutubeVideoListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"YoutubeVideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"YoutubeVideoListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListCreateItemsEntityRelationInput:{
		connect:{
			type:"YoutubeVideoListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"YoutubeVideoListItemCreateYoutubeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemCreateYoutubeEntityRelationInput:{
		connect:{
			type:"YoutubeVideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListUpdateInput:{
		items:{
			type:"YoutubeVideoListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListUpdateItemsEntityRelationInput:{
		create:{
			type:"YoutubeVideoListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"YoutubeVideoListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"YoutubeVideoListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"YoutubeVideoListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"YoutubeVideoListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"YoutubeVideoListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListUpdateItemsRelationInput:{
		by:{
			type:"YoutubeVideoListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"YoutubeVideoListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"YoutubeVideoListItemUpdateYoutubeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemUpdateYoutubeEntityRelationInput:{
		create:{
			type:"YoutubeVideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"YoutubeVideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"YoutubeVideoListItemUpsertYoutubeRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"YoutubeVideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemUpsertYoutubeRelationInput:{
		update:{
			type:"YoutubeVideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListUpsertItemsRelationInput:{
		by:{
			type:"YoutubeVideoListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"YoutubeVideoListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"YoutubeVideoListItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"YoutubeVideoListItemCreateYoutubeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemCreateListEntityRelationInput:{
		connect:{
			type:"YoutubeVideoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"YoutubeVideoListItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"YoutubeVideoListItemUpdateYoutubeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemUpdateListEntityRelationInput:{
		create:{
			type:"YoutubeVideoListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"YoutubeVideoListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"YoutubeVideoListItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"YoutubeVideoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoListItemUpsertListRelationInput:{
		update:{
			type:"YoutubeVideoListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"YoutubeVideoListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageList:{
		items:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByImage:{
			by:{
				type:"ImageListItemsByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageListItem:{
		list:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemsByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListCreateItemsEntityRelationInput:{
		connect:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateInput:{
		items:{
			type:"ImageListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateItemsEntityRelationInput:{
		create:{
			type:"ImageListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateItemsRelationInput:{
		by:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ImageListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageListItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpsertItemsRelationInput:{
		by:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemCreateListEntityRelationInput:{
		connect:{
			type:"ImageListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpdateListEntityRelationInput:{
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageListItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpsertListRelationInput:{
		update:{
			type:"ImageListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"CitationItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CitationItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemCreateListEntityRelationInput:{
		connect:{
			type:"CitationListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CitationListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"CitationItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CitationItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemUpdateListEntityRelationInput:{
		create:{
			type:"CitationListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CitationListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CitationItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CitationListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CitationItemUpsertListRelationInput:{
		update:{
			type:"CitationListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CitationListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContentImageLinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentImageLinkItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentImageLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemCreateListEntityRelationInput:{
		connect:{
			type:"ContentImageLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentImageLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentImageLinkListCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContentImageLinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentImageLinkItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentImageLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUpdateListEntityRelationInput:{
		create:{
			type:"ContentImageLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentImageLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentImageLinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentImageLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkListWithoutItemsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentImageLinkListUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentImageLinkItemUpsertListRelationInput:{
		update:{
			type:"ContentImageLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentImageLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDate:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"NewsCreateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"NewsCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"NewsCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutNewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutNewsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpdateInput:{
		publishDate:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"NewsUpdateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"NewsUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"NewsUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutNewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutNewsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutNewsUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutNewsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutNewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"StoriesCreateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"StoriesCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StoriesCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StoriesCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		perex:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"StoriesUpdateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"StoriesUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StoriesUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"StoriesUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDraft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"NewsPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutNewsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutNewsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableCreateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"NewsPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"NewsPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutNewsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutNewsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutNewsPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		storiesPage:{
			type:"LinkableUpdateStoriesPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutNewsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutNewsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StoriesPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutStoriesPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutStoriesPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableCreateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableCreateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableCreateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableCreateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableCreateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableCreateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StoriesPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"StoriesPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutStoriesPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutStoriesPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StoriesPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutStoriesPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		program:{
			type:"LinkableUpdateProgramEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		programPage:{
			type:"LinkableUpdateProgramPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericPage:{
			type:"LinkableUpdateGenericPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsPage:{
			type:"LinkableUpdateNewsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		news:{
			type:"LinkableUpdateNewsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		story:{
			type:"LinkableUpdateStoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StoriesPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutStoriesPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutStoriesPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProgram:{
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProgram:{
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProgram:{
			data:{
				type:"ProgramCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProgramUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBulletPoint:{
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBulletPoint:{
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBulletPoint:{
			data:{
				type:"BulletPointCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BulletPointUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBulletPointItem:{
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBulletPointItem:{
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BulletPointItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBulletPointItem:{
			data:{
				type:"BulletPointItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BulletPointItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFileItem:{
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFileItem:{
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFileItem:{
			data:{
				type:"FileItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFileList:{
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFileList:{
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFileList:{
			data:{
				type:"FileListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLink:{
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLink:{
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLink:{
			data:{
				type:"FooterLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLinkGroups:{
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkGroupsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLinkGroups:{
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinkGroupsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLinkGroups:{
			data:{
				type:"FooterLinkGroupsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLinkGroupsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextItem:{
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextItem:{
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextItem:{
			data:{
				type:"TextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextList:{
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextList:{
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextList:{
			data:{
				type:"TextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProgramPage:{
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProgramPage:{
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProgramPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProgramPage:{
			data:{
				type:"ProgramPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProgramPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGenericPage:{
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GenericPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGenericPage:{
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GenericPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGenericPage:{
			data:{
				type:"GenericPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GenericPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStaff:{
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStaff:{
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStaff:{
			data:{
				type:"StaffCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StaffUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStaffItem:{
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStaffItem:{
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStaffItem:{
			data:{
				type:"StaffItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StaffItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStaffList:{
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStaffList:{
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StaffListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStaffList:{
			data:{
				type:"StaffListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StaffListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listIcon:{
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IconOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateIcon:{
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IconOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateIcon:{
			data:{
				type:"IconCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"IconUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPrincipleItem:{
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePrincipleItem:{
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePrincipleItem:{
			data:{
				type:"PrincipleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PrincipleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPrincipleList:{
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePrincipleList:{
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrincipleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePrincipleList:{
			data:{
				type:"PrincipleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PrincipleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkSubGroup:{
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSubGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkSubGroup:{
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSubGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkSubGroup:{
			data:{
				type:"LinkSubGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkSubGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideoList:{
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideoList:{
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideoList:{
			data:{
				type:"YoutubeVideoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideoListItem:{
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideoListItem:{
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideoListItem:{
			data:{
				type:"YoutubeVideoListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCitationItem:{
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCitationItem:{
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCitationItem:{
			data:{
				type:"CitationItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CitationItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCitationList:{
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCitationList:{
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CitationListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCitationList:{
			data:{
				type:"CitationListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CitationListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentImageLinkItem:{
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentImageLinkItem:{
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentImageLinkItem:{
			data:{
				type:"ContentImageLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentImageLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentImageLinkList:{
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentImageLinkList:{
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentImageLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentImageLinkList:{
			data:{
				type:"ContentImageLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentImageLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNews:{
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNews:{
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNews:{
			data:{
				type:"NewsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStories:{
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStories:{
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStories:{
			data:{
				type:"StoriesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StoriesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsPage:{
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsPage:{
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsPage:{
			data:{
				type:"NewsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStoriesPage:{
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStoriesPage:{
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStoriesPage:{
			data:{
				type:"StoriesPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StoriesPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStoriesList:{
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStoriesList:{
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StoriesListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStoriesList:{
			data:{
				type:"StoriesListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StoriesListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProgram:{
			data:{
				type:"ProgramCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProgramUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProgramUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProgramCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBulletPoint:{
			data:{
				type:"BulletPointCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BulletPointUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BulletPointUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BulletPointCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBulletPointItem:{
			data:{
				type:"BulletPointItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BulletPointItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BulletPointItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BulletPointItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFileItem:{
			data:{
				type:"FileItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFileList:{
			data:{
				type:"FileListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLink:{
			data:{
				type:"FooterLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLinkGroups:{
			data:{
				type:"FooterLinkGroupsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLinkGroupsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLinkGroupsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLinkGroupsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextItem:{
			data:{
				type:"TextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextList:{
			data:{
				type:"TextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProgramPage:{
			data:{
				type:"ProgramPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProgramPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProgramPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProgramPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGenericPage:{
			data:{
				type:"GenericPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GenericPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GenericPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GenericPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStaff:{
			data:{
				type:"StaffCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StaffUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StaffUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StaffCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStaffItem:{
			data:{
				type:"StaffItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StaffItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StaffItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StaffItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStaffList:{
			data:{
				type:"StaffListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StaffListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StaffListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StaffListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createIcon:{
			data:{
				type:"IconCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"IconUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"IconUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"IconCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPrincipleItem:{
			data:{
				type:"PrincipleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PrincipleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PrincipleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PrincipleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPrincipleList:{
			data:{
				type:"PrincipleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PrincipleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PrincipleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PrincipleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkSubGroup:{
			data:{
				type:"LinkSubGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkSubGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkSubGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkSubGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideoList:{
			data:{
				type:"YoutubeVideoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideoListItem:{
			data:{
				type:"YoutubeVideoListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCitationItem:{
			data:{
				type:"CitationItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CitationItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CitationItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CitationItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCitationList:{
			data:{
				type:"CitationListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CitationListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CitationListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CitationListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentImageLinkItem:{
			data:{
				type:"ContentImageLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentImageLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentImageLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentImageLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentImageLinkList:{
			data:{
				type:"ContentImageLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentImageLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentImageLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentImageLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNews:{
			data:{
				type:"NewsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStories:{
			data:{
				type:"StoriesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StoriesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StoriesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StoriesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsPage:{
			data:{
				type:"NewsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStoriesPage:{
			data:{
				type:"StoriesPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StoriesPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StoriesPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StoriesPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStoriesList:{
			data:{
				type:"StoriesListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StoriesListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StoriesListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StoriesListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		transaction:{
			options:{
				type:"MutationTransactionOptions",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			acl:{
				type:"S3Acl",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProgram:{
			data:{
				type:"ProgramCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProgramUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProgram:{
			by:{
				type:"ProgramUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProgramUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProgramCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBulletPoint:{
			data:{
				type:"BulletPointCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BulletPointUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBulletPoint:{
			by:{
				type:"BulletPointUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BulletPointUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BulletPointCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBulletPointItem:{
			data:{
				type:"BulletPointItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BulletPointItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBulletPointItem:{
			by:{
				type:"BulletPointItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BulletPointItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BulletPointItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BulletPointItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFileItem:{
			data:{
				type:"FileItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFileItem:{
			by:{
				type:"FileItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFileList:{
			data:{
				type:"FileListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFileList:{
			by:{
				type:"FileListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLink:{
			data:{
				type:"FooterLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLink:{
			by:{
				type:"FooterLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLinkGroups:{
			data:{
				type:"FooterLinkGroupsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLinkGroupsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLinkGroups:{
			by:{
				type:"FooterLinkGroupsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinkGroupsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLinkGroupsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLinkGroupsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextItem:{
			data:{
				type:"TextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextItem:{
			by:{
				type:"TextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextList:{
			data:{
				type:"TextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextList:{
			by:{
				type:"TextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProgramPage:{
			data:{
				type:"ProgramPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProgramPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProgramPage:{
			by:{
				type:"ProgramPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProgramPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProgramPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProgramPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGenericPage:{
			data:{
				type:"GenericPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GenericPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGenericPage:{
			by:{
				type:"GenericPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GenericPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GenericPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GenericPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStaff:{
			data:{
				type:"StaffCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StaffUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStaff:{
			by:{
				type:"StaffUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StaffUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StaffCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStaffItem:{
			data:{
				type:"StaffItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StaffItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStaffItem:{
			by:{
				type:"StaffItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StaffItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StaffItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStaffList:{
			data:{
				type:"StaffListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StaffListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStaffList:{
			by:{
				type:"StaffListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StaffListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StaffListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StaffListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createIcon:{
			data:{
				type:"IconCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"IconUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertIcon:{
			by:{
				type:"IconUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IconWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"IconUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"IconCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPrincipleItem:{
			data:{
				type:"PrincipleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PrincipleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPrincipleItem:{
			by:{
				type:"PrincipleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PrincipleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PrincipleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPrincipleList:{
			data:{
				type:"PrincipleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PrincipleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPrincipleList:{
			by:{
				type:"PrincipleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrincipleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PrincipleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PrincipleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkSubGroup:{
			data:{
				type:"LinkSubGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkSubGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkSubGroup:{
			by:{
				type:"LinkSubGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSubGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkSubGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkSubGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideoList:{
			data:{
				type:"YoutubeVideoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideoList:{
			by:{
				type:"YoutubeVideoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideoListItem:{
			data:{
				type:"YoutubeVideoListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideoListItem:{
			by:{
				type:"YoutubeVideoListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCitationItem:{
			data:{
				type:"CitationItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CitationItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCitationItem:{
			by:{
				type:"CitationItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CitationItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CitationItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCitationList:{
			data:{
				type:"CitationListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CitationListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCitationList:{
			by:{
				type:"CitationListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CitationListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CitationListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CitationListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentImageLinkItem:{
			data:{
				type:"ContentImageLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentImageLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentImageLinkItem:{
			by:{
				type:"ContentImageLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentImageLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentImageLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentImageLinkList:{
			data:{
				type:"ContentImageLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentImageLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentImageLinkList:{
			by:{
				type:"ContentImageLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentImageLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentImageLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentImageLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNews:{
			data:{
				type:"NewsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNews:{
			by:{
				type:"NewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStories:{
			data:{
				type:"StoriesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StoriesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStories:{
			by:{
				type:"StoriesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StoriesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StoriesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsPage:{
			data:{
				type:"NewsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsPage:{
			by:{
				type:"NewsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStoriesPage:{
			data:{
				type:"StoriesPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StoriesPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStoriesPage:{
			by:{
				type:"StoriesPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StoriesPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StoriesPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStoriesList:{
			data:{
				type:"StoriesListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StoriesListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStoriesList:{
			by:{
				type:"StoriesListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StoriesListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StoriesListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StoriesListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	MutationTransactionOptions:{
		deferForeignKeyConstraints:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum",
	S3Acl: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getFallbackSeo:"FallbackSeo",
		listFallbackSeo:"FallbackSeo",
		paginateFallbackSeo:"FallbackSeoConnection",
		validateCreateFallbackSeo:"_ValidationResult",
		validateUpdateFallbackSeo:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getProgram:"Program",
		listProgram:"Program",
		paginateProgram:"ProgramConnection",
		validateCreateProgram:"_ValidationResult",
		validateUpdateProgram:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getYoutubeVideo:"YoutubeVideo",
		listYoutubeVideo:"YoutubeVideo",
		paginateYoutubeVideo:"YoutubeVideoConnection",
		validateCreateYoutubeVideo:"_ValidationResult",
		validateUpdateYoutubeVideo:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getBulletPoint:"BulletPoint",
		listBulletPoint:"BulletPoint",
		paginateBulletPoint:"BulletPointConnection",
		validateCreateBulletPoint:"_ValidationResult",
		validateUpdateBulletPoint:"_ValidationResult",
		getBulletPointItem:"BulletPointItem",
		listBulletPointItem:"BulletPointItem",
		paginateBulletPointItem:"BulletPointItemConnection",
		validateCreateBulletPointItem:"_ValidationResult",
		validateUpdateBulletPointItem:"_ValidationResult",
		getFileItem:"FileItem",
		listFileItem:"FileItem",
		paginateFileItem:"FileItemConnection",
		validateCreateFileItem:"_ValidationResult",
		validateUpdateFileItem:"_ValidationResult",
		getFileList:"FileList",
		listFileList:"FileList",
		paginateFileList:"FileListConnection",
		validateCreateFileList:"_ValidationResult",
		validateUpdateFileList:"_ValidationResult",
		getFooterLink:"FooterLink",
		listFooterLink:"FooterLink",
		paginateFooterLink:"FooterLinkConnection",
		validateCreateFooterLink:"_ValidationResult",
		validateUpdateFooterLink:"_ValidationResult",
		getFooterLinkGroups:"FooterLinkGroups",
		listFooterLinkGroups:"FooterLinkGroups",
		paginateFooterLinkGroups:"FooterLinkGroupsConnection",
		validateCreateFooterLinkGroups:"_ValidationResult",
		validateUpdateFooterLinkGroups:"_ValidationResult",
		getTextItem:"TextItem",
		listTextItem:"TextItem",
		paginateTextItem:"TextItemConnection",
		validateCreateTextItem:"_ValidationResult",
		validateUpdateTextItem:"_ValidationResult",
		getTextList:"TextList",
		listTextList:"TextList",
		paginateTextList:"TextListConnection",
		validateCreateTextList:"_ValidationResult",
		validateUpdateTextList:"_ValidationResult",
		getProgramPage:"ProgramPage",
		listProgramPage:"ProgramPage",
		paginateProgramPage:"ProgramPageConnection",
		validateCreateProgramPage:"_ValidationResult",
		validateUpdateProgramPage:"_ValidationResult",
		getGenericPage:"GenericPage",
		listGenericPage:"GenericPage",
		paginateGenericPage:"GenericPageConnection",
		validateCreateGenericPage:"_ValidationResult",
		validateUpdateGenericPage:"_ValidationResult",
		getStaff:"Staff",
		listStaff:"Staff",
		paginateStaff:"StaffConnection",
		validateCreateStaff:"_ValidationResult",
		validateUpdateStaff:"_ValidationResult",
		getStaffItem:"StaffItem",
		listStaffItem:"StaffItem",
		paginateStaffItem:"StaffItemConnection",
		validateCreateStaffItem:"_ValidationResult",
		validateUpdateStaffItem:"_ValidationResult",
		getStaffList:"StaffList",
		listStaffList:"StaffList",
		paginateStaffList:"StaffListConnection",
		validateCreateStaffList:"_ValidationResult",
		validateUpdateStaffList:"_ValidationResult",
		getIcon:"Icon",
		listIcon:"Icon",
		paginateIcon:"IconConnection",
		validateCreateIcon:"_ValidationResult",
		validateUpdateIcon:"_ValidationResult",
		getPrincipleItem:"PrincipleItem",
		listPrincipleItem:"PrincipleItem",
		paginatePrincipleItem:"PrincipleItemConnection",
		validateCreatePrincipleItem:"_ValidationResult",
		validateUpdatePrincipleItem:"_ValidationResult",
		getPrincipleList:"PrincipleList",
		listPrincipleList:"PrincipleList",
		paginatePrincipleList:"PrincipleListConnection",
		validateCreatePrincipleList:"_ValidationResult",
		validateUpdatePrincipleList:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkSubGroup:"LinkSubGroup",
		listLinkSubGroup:"LinkSubGroup",
		paginateLinkSubGroup:"LinkSubGroupConnection",
		validateCreateLinkSubGroup:"_ValidationResult",
		validateUpdateLinkSubGroup:"_ValidationResult",
		getYoutubeVideoList:"YoutubeVideoList",
		listYoutubeVideoList:"YoutubeVideoList",
		paginateYoutubeVideoList:"YoutubeVideoListConnection",
		validateCreateYoutubeVideoList:"_ValidationResult",
		validateUpdateYoutubeVideoList:"_ValidationResult",
		getYoutubeVideoListItem:"YoutubeVideoListItem",
		listYoutubeVideoListItem:"YoutubeVideoListItem",
		paginateYoutubeVideoListItem:"YoutubeVideoListItemConnection",
		validateCreateYoutubeVideoListItem:"_ValidationResult",
		validateUpdateYoutubeVideoListItem:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult",
		getCitationItem:"CitationItem",
		listCitationItem:"CitationItem",
		paginateCitationItem:"CitationItemConnection",
		validateCreateCitationItem:"_ValidationResult",
		validateUpdateCitationItem:"_ValidationResult",
		getCitationList:"CitationList",
		listCitationList:"CitationList",
		paginateCitationList:"CitationListConnection",
		validateCreateCitationList:"_ValidationResult",
		validateUpdateCitationList:"_ValidationResult",
		getContentImageLinkItem:"ContentImageLinkItem",
		listContentImageLinkItem:"ContentImageLinkItem",
		paginateContentImageLinkItem:"ContentImageLinkItemConnection",
		validateCreateContentImageLinkItem:"_ValidationResult",
		validateUpdateContentImageLinkItem:"_ValidationResult",
		getContentImageLinkList:"ContentImageLinkList",
		listContentImageLinkList:"ContentImageLinkList",
		paginateContentImageLinkList:"ContentImageLinkListConnection",
		validateCreateContentImageLinkList:"_ValidationResult",
		validateUpdateContentImageLinkList:"_ValidationResult",
		getNews:"News",
		listNews:"News",
		paginateNews:"NewsConnection",
		validateCreateNews:"_ValidationResult",
		validateUpdateNews:"_ValidationResult",
		getStories:"Stories",
		listStories:"Stories",
		paginateStories:"StoriesConnection",
		validateCreateStories:"_ValidationResult",
		validateUpdateStories:"_ValidationResult",
		getNewsPage:"NewsPage",
		listNewsPage:"NewsPage",
		paginateNewsPage:"NewsPageConnection",
		validateCreateNewsPage:"_ValidationResult",
		validateUpdateNewsPage:"_ValidationResult",
		getStoriesPage:"StoriesPage",
		listStoriesPage:"StoriesPage",
		paginateStoriesPage:"StoriesPageConnection",
		validateCreateStoriesPage:"_ValidationResult",
		validateUpdateStoriesPage:"_ValidationResult",
		getStoriesList:"StoriesList",
		listStoriesList:"StoriesList",
		paginateStoriesList:"StoriesListConnection",
		validateCreateStoriesList:"_ValidationResult",
		validateUpdateStoriesList:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByLink:"ContentReference",
		referencesByFileList:"ContentReference",
		referencesByTextList:"ContentReference",
		referencesByStaffList:"ContentReference",
		referencesByPrincipleList:"ContentReference",
		referencesByImageLinkList:"ContentReference",
		referencesByCitationList:"ContentReference",
		referencesByStoriesList:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		block:"ContentBlock",
		link:"Link",
		image:"Image",
		youtubeVideo:"YoutubeVideo",
		primaryText:"String",
		secondaryText:"String",
		fileList:"FileList",
		textList:"TextList",
		staffList:"StaffList",
		principleList:"PrincipleList",
		view:"View",
		aligning:"Aligning",
		numbered:"Boolean",
		tertiaryText:"String",
		imageLinkList:"ContentImageLinkList",
		citationList:"CitationList",
		storiesList:"StoriesList"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		block:"FieldMeta",
		link:"FieldMeta",
		image:"FieldMeta",
		youtubeVideo:"FieldMeta",
		primaryText:"FieldMeta",
		secondaryText:"FieldMeta",
		fileList:"FieldMeta",
		textList:"FieldMeta",
		staffList:"FieldMeta",
		principleList:"FieldMeta",
		view:"FieldMeta",
		aligning:"FieldMeta",
		numbered:"FieldMeta",
		tertiaryText:"FieldMeta",
		imageLinkList:"FieldMeta",
		citationList:"FieldMeta",
		storiesList:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable",
		isTargetBlank:"Boolean"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta",
		isTargetBlank:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		program:"Program",
		homePage:"HomePage",
		redirect:"Redirect",
		programPage:"ProgramPage",
		genericPage:"GenericPage",
		newsPage:"NewsPage",
		news:"News",
		story:"Stories",
		storiesPage:"StoriesPage"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		program:"FieldMeta",
		homePage:"FieldMeta",
		redirect:"FieldMeta",
		programPage:"FieldMeta",
		genericPage:"FieldMeta",
		newsPage:"FieldMeta",
		news:"FieldMeta",
		story:"FieldMeta",
		storiesPage:"FieldMeta"
	},
	Program:{
		_meta:"ProgramMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		title:"String",
		leadParagraph:"String",
		link:"Linkable",
		image:"Image",
		content:"Content",
		seo:"Seo",
		ilustration:"Image",
		bulletPoint:"BulletPoint",
		showDetailLink:"Boolean"
	},
	ProgramMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		title:"FieldMeta",
		leadParagraph:"FieldMeta",
		link:"FieldMeta",
		image:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		ilustration:"FieldMeta",
		bulletPoint:"FieldMeta",
		showDetailLink:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String",
		fileName:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta",
		fileName:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		ogImage:"Image",
		noIndex:"Boolean",
		noFollow:"Boolean"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		ogImage:"FieldMeta",
		noIndex:"FieldMeta",
		noFollow:"FieldMeta"
	},
	BulletPoint:{
		_meta:"BulletPointMeta",
		id:"UUID",
		items:"BulletPointItem",
		paginateItems:"BulletPointItemConnection"
	},
	BulletPointMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	BulletPointItem:{
		_meta:"BulletPointItemMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		list:"BulletPoint"
	},
	BulletPointItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta"
	},
	BulletPointItemConnection:{
		pageInfo:"PageInfo",
		edges:"BulletPointItemEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	BulletPointItemEdge:{
		node:"BulletPointItem"
	},
	HomePage:{
		_meta:"HomePageMeta",
		id:"UUID",
		unique:"One",
		leadParagraph:"String",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		logo:"Image"
	},
	HomePageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		leadParagraph:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		logo:"FieldMeta"
	},
	Redirect:{
		_meta:"RedirectMeta",
		id:"UUID",
		targetUrl:"String",
		link:"Linkable",
		target:"Linkable"
	},
	RedirectMeta:{
		id:"FieldMeta",
		targetUrl:"FieldMeta",
		link:"FieldMeta",
		target:"FieldMeta"
	},
	ProgramPage:{
		_meta:"ProgramPageMeta",
		id:"UUID",
		unique:"One",
		leadParagraph:"String",
		link:"Linkable",
		seo:"Seo"
	},
	ProgramPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		leadParagraph:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta"
	},
	GenericPage:{
		_meta:"GenericPageMeta",
		id:"UUID",
		name:"String",
		leadParagraph:"String",
		image:"Image",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		darujmeWidget:"Boolean"
	},
	GenericPageMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		leadParagraph:"FieldMeta",
		image:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		darujmeWidget:"FieldMeta"
	},
	NewsPage:{
		_meta:"NewsPageMeta",
		id:"UUID",
		unique:"One",
		leadParagraph:"String",
		link:"Linkable",
		seo:"Seo"
	},
	NewsPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		leadParagraph:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta"
	},
	News:{
		_meta:"NewsMeta",
		id:"UUID",
		publishDate:"DateTime",
		title:"String",
		perex:"String",
		coverImage:"Image",
		content:"Content",
		seo:"Seo",
		order:"Int",
		link:"Linkable",
		isDraft:"Boolean"
	},
	NewsMeta:{
		id:"FieldMeta",
		publishDate:"FieldMeta",
		title:"FieldMeta",
		perex:"FieldMeta",
		coverImage:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta",
		isDraft:"FieldMeta"
	},
	Stories:{
		_meta:"StoriesMeta",
		id:"UUID",
		title:"String",
		perex:"String",
		coverImage:"Image",
		content:"Content",
		seo:"Seo",
		order:"Int",
		link:"Linkable",
		list:"StoriesList",
		isDraft:"Boolean"
	},
	StoriesMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		perex:"FieldMeta",
		coverImage:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta",
		list:"FieldMeta",
		isDraft:"FieldMeta"
	},
	StoriesList:{
		_meta:"StoriesListMeta",
		id:"UUID",
		items:"Stories",
		itemsByContent:"Stories",
		itemsBySeo:"Stories",
		itemsByLink:"Stories",
		paginateItems:"StoriesConnection"
	},
	StoriesListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	StoriesConnection:{
		pageInfo:"PageInfo",
		edges:"StoriesEdge"
	},
	StoriesEdge:{
		node:"Stories"
	},
	StoriesPage:{
		_meta:"StoriesPageMeta",
		id:"UUID",
		unique:"One",
		leadParagraph:"String",
		link:"Linkable",
		seo:"Seo"
	},
	StoriesPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		leadParagraph:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta"
	},
	YoutubeVideo:{
		_meta:"YoutubeVideoMeta",
		id:"UUID",
		videoId:"String"
	},
	YoutubeVideoMeta:{
		id:"FieldMeta",
		videoId:"FieldMeta"
	},
	FileList:{
		_meta:"FileListMeta",
		id:"UUID",
		reference:"ContentReference",
		items:"FileItem",
		paginateItems:"FileItemConnection"
	},
	FileListMeta:{
		id:"FieldMeta",
		reference:"FieldMeta",
		items:"FieldMeta"
	},
	FileItem:{
		_meta:"FileItemMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		url:"String",
		fileType:"String",
		list:"FileList"
	},
	FileItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		url:"FieldMeta",
		fileType:"FieldMeta",
		list:"FieldMeta"
	},
	FileItemConnection:{
		pageInfo:"PageInfo",
		edges:"FileItemEdge"
	},
	FileItemEdge:{
		node:"FileItem"
	},
	TextList:{
		_meta:"TextListMeta",
		id:"UUID",
		items:"TextItem",
		itemsByLink:"TextItem",
		paginateItems:"TextItemConnection"
	},
	TextListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	TextItem:{
		_meta:"TextItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		text:"String",
		list:"TextList",
		link:"Link"
	},
	TextItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta"
	},
	TextItemConnection:{
		pageInfo:"PageInfo",
		edges:"TextItemEdge"
	},
	TextItemEdge:{
		node:"TextItem"
	},
	StaffList:{
		_meta:"StaffListMeta",
		id:"UUID",
		reference:"ContentReference",
		items:"StaffItem",
		paginateItems:"StaffItemConnection"
	},
	StaffListMeta:{
		id:"FieldMeta",
		reference:"FieldMeta",
		items:"FieldMeta"
	},
	StaffItem:{
		_meta:"StaffItemMeta",
		id:"UUID",
		order:"Int",
		list:"StaffList",
		staff:"Staff"
	},
	StaffItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		staff:"FieldMeta"
	},
	Staff:{
		_meta:"StaffMeta",
		id:"UUID",
		name:"String",
		position:"String",
		image:"Image",
		order:"Int",
		info:"String"
	},
	StaffMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		position:"FieldMeta",
		image:"FieldMeta",
		order:"FieldMeta",
		info:"FieldMeta"
	},
	StaffItemConnection:{
		pageInfo:"PageInfo",
		edges:"StaffItemEdge"
	},
	StaffItemEdge:{
		node:"StaffItem"
	},
	PrincipleList:{
		_meta:"PrincipleListMeta",
		id:"UUID",
		reference:"ContentReference",
		items:"PrincipleItem",
		paginateItems:"PrincipleItemConnection"
	},
	PrincipleListMeta:{
		id:"FieldMeta",
		reference:"FieldMeta",
		items:"FieldMeta"
	},
	PrincipleItem:{
		_meta:"PrincipleItemMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		list:"PrincipleList",
		icon:"Icon",
		title:"String"
	},
	PrincipleItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		icon:"FieldMeta",
		title:"FieldMeta"
	},
	Icon:{
		_meta:"IconMeta",
		id:"UUID",
		order:"Int",
		image:"Image"
	},
	IconMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		image:"FieldMeta"
	},
	PrincipleItemConnection:{
		pageInfo:"PageInfo",
		edges:"PrincipleItemEdge"
	},
	PrincipleItemEdge:{
		node:"PrincipleItem"
	},
	ContentImageLinkList:{
		_meta:"ContentImageLinkListMeta",
		id:"UUID",
		title:"String",
		items:"ContentImageLinkItem",
		link:"Link",
		itemsByImage:"ContentImageLinkItem",
		itemsByLink:"ContentImageLinkItem",
		paginateItems:"ContentImageLinkItemConnection"
	},
	ContentImageLinkListMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		items:"FieldMeta",
		link:"FieldMeta"
	},
	ContentImageLinkItem:{
		_meta:"ContentImageLinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"ContentImageLinkList",
		image:"Image",
		link:"Link"
	},
	ContentImageLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta",
		link:"FieldMeta"
	},
	ContentImageLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"ContentImageLinkItemEdge"
	},
	ContentImageLinkItemEdge:{
		node:"ContentImageLinkItem"
	},
	CitationList:{
		_meta:"CitationListMeta",
		id:"UUID",
		items:"CitationItem",
		paginateItems:"CitationItemConnection"
	},
	CitationListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	CitationItem:{
		_meta:"CitationItemMeta",
		id:"UUID",
		title:"String",
		text:"String",
		list:"CitationList",
		image:"Image",
		order:"Int"
	},
	CitationItemMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta",
		order:"FieldMeta"
	},
	CitationItemConnection:{
		pageInfo:"PageInfo",
		edges:"CitationItemEdge"
	},
	CitationItemEdge:{
		node:"CitationItem"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	FallbackSeo:{
		_meta:"FallbackSeoMeta",
		id:"UUID",
		unique:"One",
		seo:"Seo"
	},
	FallbackSeoMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		seo:"FieldMeta"
	},
	FallbackSeoConnection:{
		pageInfo:"PageInfo",
		edges:"FallbackSeoEdge"
	},
	FallbackSeoEdge:{
		node:"FallbackSeo"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		unique:"One",
		copyright:"String",
		logoFirst:"Image",
		logoSecond:"Image",
		linksGroups:"FooterLinkGroups",
		phone:"String",
		email:"String",
		text:"String",
		link:"Link",
		paginateLinksGroups:"FooterLinkGroupsConnection"
	},
	FooterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		copyright:"FieldMeta",
		logoFirst:"FieldMeta",
		logoSecond:"FieldMeta",
		linksGroups:"FieldMeta",
		phone:"FieldMeta",
		email:"FieldMeta",
		text:"FieldMeta",
		link:"FieldMeta"
	},
	FooterLinkGroups:{
		_meta:"FooterLinkGroupsMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		links:"FooterLink",
		specialIdentifier:"String",
		paginateLinks:"FooterLinkConnection"
	},
	FooterLinkGroupsMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		links:"FieldMeta",
		specialIdentifier:"FieldMeta"
	},
	FooterLink:{
		_meta:"FooterLinkMeta",
		id:"UUID",
		order:"Int",
		link:"Link"
	},
	FooterLinkMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	FooterLinkConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLinkEdge"
	},
	FooterLinkEdge:{
		node:"FooterLink"
	},
	FooterLinkGroupsConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLinkGroupsEdge"
	},
	FooterLinkGroupsEdge:{
		node:"FooterLinkGroups"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		unique:"One",
		logoFirst:"Image",
		logoSecond:"Image",
		linkGroups:"LinkList"
	},
	HeaderMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		logoFirst:"FieldMeta",
		logoSecond:"FieldMeta",
		linkGroups:"FieldMeta"
	},
	LinkList:{
		_meta:"LinkListMeta",
		id:"UUID",
		items:"LinkItem",
		itemsByLink:"LinkItem",
		itemsByGroup:"LinkItem",
		paginateItems:"LinkItemConnection"
	},
	LinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	LinkItem:{
		_meta:"LinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"LinkList",
		link:"Link",
		group:"LinkSubGroup",
		isHighlighted:"Boolean"
	},
	LinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta",
		group:"FieldMeta",
		isHighlighted:"FieldMeta"
	},
	LinkSubGroup:{
		_meta:"LinkSubGroupMeta",
		id:"UUID",
		order:"Int",
		links:"LinkList"
	},
	LinkSubGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		links:"FieldMeta"
	},
	LinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"LinkItemEdge"
	},
	LinkItemEdge:{
		node:"LinkItem"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	HomePageConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageEdge"
	},
	HomePageEdge:{
		node:"HomePage"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	ProgramConnection:{
		pageInfo:"PageInfo",
		edges:"ProgramEdge"
	},
	ProgramEdge:{
		node:"Program"
	},
	RedirectConnection:{
		pageInfo:"PageInfo",
		edges:"RedirectEdge"
	},
	RedirectEdge:{
		node:"Redirect"
	},
	YoutubeVideoConnection:{
		pageInfo:"PageInfo",
		edges:"YoutubeVideoEdge"
	},
	YoutubeVideoEdge:{
		node:"YoutubeVideo"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	BulletPointConnection:{
		pageInfo:"PageInfo",
		edges:"BulletPointEdge"
	},
	BulletPointEdge:{
		node:"BulletPoint"
	},
	FileListConnection:{
		pageInfo:"PageInfo",
		edges:"FileListEdge"
	},
	FileListEdge:{
		node:"FileList"
	},
	TextListConnection:{
		pageInfo:"PageInfo",
		edges:"TextListEdge"
	},
	TextListEdge:{
		node:"TextList"
	},
	ProgramPageConnection:{
		pageInfo:"PageInfo",
		edges:"ProgramPageEdge"
	},
	ProgramPageEdge:{
		node:"ProgramPage"
	},
	GenericPageConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageEdge"
	},
	GenericPageEdge:{
		node:"GenericPage"
	},
	StaffConnection:{
		pageInfo:"PageInfo",
		edges:"StaffEdge"
	},
	StaffEdge:{
		node:"Staff"
	},
	StaffListConnection:{
		pageInfo:"PageInfo",
		edges:"StaffListEdge"
	},
	StaffListEdge:{
		node:"StaffList"
	},
	IconConnection:{
		pageInfo:"PageInfo",
		edges:"IconEdge"
	},
	IconEdge:{
		node:"Icon"
	},
	PrincipleListConnection:{
		pageInfo:"PageInfo",
		edges:"PrincipleListEdge"
	},
	PrincipleListEdge:{
		node:"PrincipleList"
	},
	LinkListConnection:{
		pageInfo:"PageInfo",
		edges:"LinkListEdge"
	},
	LinkListEdge:{
		node:"LinkList"
	},
	LinkSubGroupConnection:{
		pageInfo:"PageInfo",
		edges:"LinkSubGroupEdge"
	},
	LinkSubGroupEdge:{
		node:"LinkSubGroup"
	},
	YoutubeVideoList:{
		_meta:"YoutubeVideoListMeta",
		id:"UUID",
		items:"YoutubeVideoListItem",
		itemsByYoutube:"YoutubeVideoListItem",
		paginateItems:"YoutubeVideoListItemConnection"
	},
	YoutubeVideoListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	YoutubeVideoListItem:{
		_meta:"YoutubeVideoListItemMeta",
		id:"UUID",
		order:"Int",
		list:"YoutubeVideoList",
		youtube:"YoutubeVideo"
	},
	YoutubeVideoListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		youtube:"FieldMeta"
	},
	YoutubeVideoListItemConnection:{
		pageInfo:"PageInfo",
		edges:"YoutubeVideoListItemEdge"
	},
	YoutubeVideoListItemEdge:{
		node:"YoutubeVideoListItem"
	},
	YoutubeVideoListConnection:{
		pageInfo:"PageInfo",
		edges:"YoutubeVideoListEdge"
	},
	YoutubeVideoListEdge:{
		node:"YoutubeVideoList"
	},
	ImageList:{
		_meta:"ImageListMeta",
		id:"UUID",
		items:"ImageListItem",
		itemsByImage:"ImageListItem",
		paginateItems:"ImageListItemConnection"
	},
	ImageListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ImageListItem:{
		_meta:"ImageListItemMeta",
		id:"UUID",
		order:"Int",
		list:"ImageList",
		image:"Image"
	},
	ImageListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	ImageListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListItemEdge"
	},
	ImageListItemEdge:{
		node:"ImageListItem"
	},
	ImageListConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListEdge"
	},
	ImageListEdge:{
		node:"ImageList"
	},
	CitationListConnection:{
		pageInfo:"PageInfo",
		edges:"CitationListEdge"
	},
	CitationListEdge:{
		node:"CitationList"
	},
	ContentImageLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"ContentImageLinkListEdge"
	},
	ContentImageLinkListEdge:{
		node:"ContentImageLinkList"
	},
	NewsConnection:{
		pageInfo:"PageInfo",
		edges:"NewsEdge"
	},
	NewsEdge:{
		node:"News"
	},
	NewsPageConnection:{
		pageInfo:"PageInfo",
		edges:"NewsPageEdge"
	},
	NewsPageEdge:{
		node:"NewsPage"
	},
	StoriesPageConnection:{
		pageInfo:"PageInfo",
		edges:"StoriesPageEdge"
	},
	StoriesPageEdge:{
		node:"StoriesPage"
	},
	StoriesListConnection:{
		pageInfo:"PageInfo",
		edges:"StoriesListEdge"
	},
	StoriesListEdge:{
		node:"StoriesList"
	},
	QueryTransaction:{
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getFallbackSeo:"FallbackSeo",
		listFallbackSeo:"FallbackSeo",
		paginateFallbackSeo:"FallbackSeoConnection",
		validateCreateFallbackSeo:"_ValidationResult",
		validateUpdateFallbackSeo:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getProgram:"Program",
		listProgram:"Program",
		paginateProgram:"ProgramConnection",
		validateCreateProgram:"_ValidationResult",
		validateUpdateProgram:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getYoutubeVideo:"YoutubeVideo",
		listYoutubeVideo:"YoutubeVideo",
		paginateYoutubeVideo:"YoutubeVideoConnection",
		validateCreateYoutubeVideo:"_ValidationResult",
		validateUpdateYoutubeVideo:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getBulletPoint:"BulletPoint",
		listBulletPoint:"BulletPoint",
		paginateBulletPoint:"BulletPointConnection",
		validateCreateBulletPoint:"_ValidationResult",
		validateUpdateBulletPoint:"_ValidationResult",
		getBulletPointItem:"BulletPointItem",
		listBulletPointItem:"BulletPointItem",
		paginateBulletPointItem:"BulletPointItemConnection",
		validateCreateBulletPointItem:"_ValidationResult",
		validateUpdateBulletPointItem:"_ValidationResult",
		getFileItem:"FileItem",
		listFileItem:"FileItem",
		paginateFileItem:"FileItemConnection",
		validateCreateFileItem:"_ValidationResult",
		validateUpdateFileItem:"_ValidationResult",
		getFileList:"FileList",
		listFileList:"FileList",
		paginateFileList:"FileListConnection",
		validateCreateFileList:"_ValidationResult",
		validateUpdateFileList:"_ValidationResult",
		getFooterLink:"FooterLink",
		listFooterLink:"FooterLink",
		paginateFooterLink:"FooterLinkConnection",
		validateCreateFooterLink:"_ValidationResult",
		validateUpdateFooterLink:"_ValidationResult",
		getFooterLinkGroups:"FooterLinkGroups",
		listFooterLinkGroups:"FooterLinkGroups",
		paginateFooterLinkGroups:"FooterLinkGroupsConnection",
		validateCreateFooterLinkGroups:"_ValidationResult",
		validateUpdateFooterLinkGroups:"_ValidationResult",
		getTextItem:"TextItem",
		listTextItem:"TextItem",
		paginateTextItem:"TextItemConnection",
		validateCreateTextItem:"_ValidationResult",
		validateUpdateTextItem:"_ValidationResult",
		getTextList:"TextList",
		listTextList:"TextList",
		paginateTextList:"TextListConnection",
		validateCreateTextList:"_ValidationResult",
		validateUpdateTextList:"_ValidationResult",
		getProgramPage:"ProgramPage",
		listProgramPage:"ProgramPage",
		paginateProgramPage:"ProgramPageConnection",
		validateCreateProgramPage:"_ValidationResult",
		validateUpdateProgramPage:"_ValidationResult",
		getGenericPage:"GenericPage",
		listGenericPage:"GenericPage",
		paginateGenericPage:"GenericPageConnection",
		validateCreateGenericPage:"_ValidationResult",
		validateUpdateGenericPage:"_ValidationResult",
		getStaff:"Staff",
		listStaff:"Staff",
		paginateStaff:"StaffConnection",
		validateCreateStaff:"_ValidationResult",
		validateUpdateStaff:"_ValidationResult",
		getStaffItem:"StaffItem",
		listStaffItem:"StaffItem",
		paginateStaffItem:"StaffItemConnection",
		validateCreateStaffItem:"_ValidationResult",
		validateUpdateStaffItem:"_ValidationResult",
		getStaffList:"StaffList",
		listStaffList:"StaffList",
		paginateStaffList:"StaffListConnection",
		validateCreateStaffList:"_ValidationResult",
		validateUpdateStaffList:"_ValidationResult",
		getIcon:"Icon",
		listIcon:"Icon",
		paginateIcon:"IconConnection",
		validateCreateIcon:"_ValidationResult",
		validateUpdateIcon:"_ValidationResult",
		getPrincipleItem:"PrincipleItem",
		listPrincipleItem:"PrincipleItem",
		paginatePrincipleItem:"PrincipleItemConnection",
		validateCreatePrincipleItem:"_ValidationResult",
		validateUpdatePrincipleItem:"_ValidationResult",
		getPrincipleList:"PrincipleList",
		listPrincipleList:"PrincipleList",
		paginatePrincipleList:"PrincipleListConnection",
		validateCreatePrincipleList:"_ValidationResult",
		validateUpdatePrincipleList:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkSubGroup:"LinkSubGroup",
		listLinkSubGroup:"LinkSubGroup",
		paginateLinkSubGroup:"LinkSubGroupConnection",
		validateCreateLinkSubGroup:"_ValidationResult",
		validateUpdateLinkSubGroup:"_ValidationResult",
		getYoutubeVideoList:"YoutubeVideoList",
		listYoutubeVideoList:"YoutubeVideoList",
		paginateYoutubeVideoList:"YoutubeVideoListConnection",
		validateCreateYoutubeVideoList:"_ValidationResult",
		validateUpdateYoutubeVideoList:"_ValidationResult",
		getYoutubeVideoListItem:"YoutubeVideoListItem",
		listYoutubeVideoListItem:"YoutubeVideoListItem",
		paginateYoutubeVideoListItem:"YoutubeVideoListItemConnection",
		validateCreateYoutubeVideoListItem:"_ValidationResult",
		validateUpdateYoutubeVideoListItem:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult",
		getCitationItem:"CitationItem",
		listCitationItem:"CitationItem",
		paginateCitationItem:"CitationItemConnection",
		validateCreateCitationItem:"_ValidationResult",
		validateUpdateCitationItem:"_ValidationResult",
		getCitationList:"CitationList",
		listCitationList:"CitationList",
		paginateCitationList:"CitationListConnection",
		validateCreateCitationList:"_ValidationResult",
		validateUpdateCitationList:"_ValidationResult",
		getContentImageLinkItem:"ContentImageLinkItem",
		listContentImageLinkItem:"ContentImageLinkItem",
		paginateContentImageLinkItem:"ContentImageLinkItemConnection",
		validateCreateContentImageLinkItem:"_ValidationResult",
		validateUpdateContentImageLinkItem:"_ValidationResult",
		getContentImageLinkList:"ContentImageLinkList",
		listContentImageLinkList:"ContentImageLinkList",
		paginateContentImageLinkList:"ContentImageLinkListConnection",
		validateCreateContentImageLinkList:"_ValidationResult",
		validateUpdateContentImageLinkList:"_ValidationResult",
		getNews:"News",
		listNews:"News",
		paginateNews:"NewsConnection",
		validateCreateNews:"_ValidationResult",
		validateUpdateNews:"_ValidationResult",
		getStories:"Stories",
		listStories:"Stories",
		paginateStories:"StoriesConnection",
		validateCreateStories:"_ValidationResult",
		validateUpdateStories:"_ValidationResult",
		getNewsPage:"NewsPage",
		listNewsPage:"NewsPage",
		paginateNewsPage:"NewsPageConnection",
		validateCreateNewsPage:"_ValidationResult",
		validateUpdateNewsPage:"_ValidationResult",
		getStoriesPage:"StoriesPage",
		listStoriesPage:"StoriesPage",
		paginateStoriesPage:"StoriesPageConnection",
		validateCreateStoriesPage:"_ValidationResult",
		validateUpdateStoriesPage:"_ValidationResult",
		getStoriesList:"StoriesList",
		listStoriesList:"StoriesList",
		paginateStoriesList:"StoriesListConnection",
		validateCreateStoriesList:"_ValidationResult",
		validateUpdateStoriesList:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createFallbackSeo:"FallbackSeoCreateResult",
		deleteFallbackSeo:"FallbackSeoDeleteResult",
		updateFallbackSeo:"FallbackSeoUpdateResult",
		upsertFallbackSeo:"FallbackSeoUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createProgram:"ProgramCreateResult",
		deleteProgram:"ProgramDeleteResult",
		updateProgram:"ProgramUpdateResult",
		upsertProgram:"ProgramUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createYoutubeVideo:"YoutubeVideoCreateResult",
		deleteYoutubeVideo:"YoutubeVideoDeleteResult",
		updateYoutubeVideo:"YoutubeVideoUpdateResult",
		upsertYoutubeVideo:"YoutubeVideoUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createBulletPoint:"BulletPointCreateResult",
		deleteBulletPoint:"BulletPointDeleteResult",
		updateBulletPoint:"BulletPointUpdateResult",
		upsertBulletPoint:"BulletPointUpsertResult",
		createBulletPointItem:"BulletPointItemCreateResult",
		deleteBulletPointItem:"BulletPointItemDeleteResult",
		updateBulletPointItem:"BulletPointItemUpdateResult",
		upsertBulletPointItem:"BulletPointItemUpsertResult",
		createFileItem:"FileItemCreateResult",
		deleteFileItem:"FileItemDeleteResult",
		updateFileItem:"FileItemUpdateResult",
		upsertFileItem:"FileItemUpsertResult",
		createFileList:"FileListCreateResult",
		deleteFileList:"FileListDeleteResult",
		updateFileList:"FileListUpdateResult",
		upsertFileList:"FileListUpsertResult",
		createFooterLink:"FooterLinkCreateResult",
		deleteFooterLink:"FooterLinkDeleteResult",
		updateFooterLink:"FooterLinkUpdateResult",
		upsertFooterLink:"FooterLinkUpsertResult",
		createFooterLinkGroups:"FooterLinkGroupsCreateResult",
		deleteFooterLinkGroups:"FooterLinkGroupsDeleteResult",
		updateFooterLinkGroups:"FooterLinkGroupsUpdateResult",
		upsertFooterLinkGroups:"FooterLinkGroupsUpsertResult",
		createTextItem:"TextItemCreateResult",
		deleteTextItem:"TextItemDeleteResult",
		updateTextItem:"TextItemUpdateResult",
		upsertTextItem:"TextItemUpsertResult",
		createTextList:"TextListCreateResult",
		deleteTextList:"TextListDeleteResult",
		updateTextList:"TextListUpdateResult",
		upsertTextList:"TextListUpsertResult",
		createProgramPage:"ProgramPageCreateResult",
		deleteProgramPage:"ProgramPageDeleteResult",
		updateProgramPage:"ProgramPageUpdateResult",
		upsertProgramPage:"ProgramPageUpsertResult",
		createGenericPage:"GenericPageCreateResult",
		deleteGenericPage:"GenericPageDeleteResult",
		updateGenericPage:"GenericPageUpdateResult",
		upsertGenericPage:"GenericPageUpsertResult",
		createStaff:"StaffCreateResult",
		deleteStaff:"StaffDeleteResult",
		updateStaff:"StaffUpdateResult",
		upsertStaff:"StaffUpsertResult",
		createStaffItem:"StaffItemCreateResult",
		deleteStaffItem:"StaffItemDeleteResult",
		updateStaffItem:"StaffItemUpdateResult",
		upsertStaffItem:"StaffItemUpsertResult",
		createStaffList:"StaffListCreateResult",
		deleteStaffList:"StaffListDeleteResult",
		updateStaffList:"StaffListUpdateResult",
		upsertStaffList:"StaffListUpsertResult",
		createIcon:"IconCreateResult",
		deleteIcon:"IconDeleteResult",
		updateIcon:"IconUpdateResult",
		upsertIcon:"IconUpsertResult",
		createPrincipleItem:"PrincipleItemCreateResult",
		deletePrincipleItem:"PrincipleItemDeleteResult",
		updatePrincipleItem:"PrincipleItemUpdateResult",
		upsertPrincipleItem:"PrincipleItemUpsertResult",
		createPrincipleList:"PrincipleListCreateResult",
		deletePrincipleList:"PrincipleListDeleteResult",
		updatePrincipleList:"PrincipleListUpdateResult",
		upsertPrincipleList:"PrincipleListUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkSubGroup:"LinkSubGroupCreateResult",
		deleteLinkSubGroup:"LinkSubGroupDeleteResult",
		updateLinkSubGroup:"LinkSubGroupUpdateResult",
		upsertLinkSubGroup:"LinkSubGroupUpsertResult",
		createYoutubeVideoList:"YoutubeVideoListCreateResult",
		deleteYoutubeVideoList:"YoutubeVideoListDeleteResult",
		updateYoutubeVideoList:"YoutubeVideoListUpdateResult",
		upsertYoutubeVideoList:"YoutubeVideoListUpsertResult",
		createYoutubeVideoListItem:"YoutubeVideoListItemCreateResult",
		deleteYoutubeVideoListItem:"YoutubeVideoListItemDeleteResult",
		updateYoutubeVideoListItem:"YoutubeVideoListItemUpdateResult",
		upsertYoutubeVideoListItem:"YoutubeVideoListItemUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		createCitationItem:"CitationItemCreateResult",
		deleteCitationItem:"CitationItemDeleteResult",
		updateCitationItem:"CitationItemUpdateResult",
		upsertCitationItem:"CitationItemUpsertResult",
		createCitationList:"CitationListCreateResult",
		deleteCitationList:"CitationListDeleteResult",
		updateCitationList:"CitationListUpdateResult",
		upsertCitationList:"CitationListUpsertResult",
		createContentImageLinkItem:"ContentImageLinkItemCreateResult",
		deleteContentImageLinkItem:"ContentImageLinkItemDeleteResult",
		updateContentImageLinkItem:"ContentImageLinkItemUpdateResult",
		upsertContentImageLinkItem:"ContentImageLinkItemUpsertResult",
		createContentImageLinkList:"ContentImageLinkListCreateResult",
		deleteContentImageLinkList:"ContentImageLinkListDeleteResult",
		updateContentImageLinkList:"ContentImageLinkListUpdateResult",
		upsertContentImageLinkList:"ContentImageLinkListUpsertResult",
		createNews:"NewsCreateResult",
		deleteNews:"NewsDeleteResult",
		updateNews:"NewsUpdateResult",
		upsertNews:"NewsUpsertResult",
		createStories:"StoriesCreateResult",
		deleteStories:"StoriesDeleteResult",
		updateStories:"StoriesUpdateResult",
		upsertStories:"StoriesUpsertResult",
		createNewsPage:"NewsPageCreateResult",
		deleteNewsPage:"NewsPageDeleteResult",
		updateNewsPage:"NewsPageUpdateResult",
		upsertNewsPage:"NewsPageUpsertResult",
		createStoriesPage:"StoriesPageCreateResult",
		deleteStoriesPage:"StoriesPageDeleteResult",
		updateStoriesPage:"StoriesPageUpdateResult",
		upsertStoriesPage:"StoriesPageUpsertResult",
		createStoriesList:"StoriesListCreateResult",
		deleteStoriesList:"StoriesListDeleteResult",
		updateStoriesList:"StoriesListUpdateResult",
		upsertStoriesList:"StoriesListUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on FallbackSeoCreateResult": "FallbackSeoCreateResult",
		"...on FallbackSeoDeleteResult": "FallbackSeoDeleteResult",
		"...on FallbackSeoUpdateResult": "FallbackSeoUpdateResult",
		"...on FallbackSeoUpsertResult": "FallbackSeoUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on HomePageCreateResult": "HomePageCreateResult",
		"...on HomePageDeleteResult": "HomePageDeleteResult",
		"...on HomePageUpdateResult": "HomePageUpdateResult",
		"...on HomePageUpsertResult": "HomePageUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on ProgramCreateResult": "ProgramCreateResult",
		"...on ProgramDeleteResult": "ProgramDeleteResult",
		"...on ProgramUpdateResult": "ProgramUpdateResult",
		"...on ProgramUpsertResult": "ProgramUpsertResult",
		"...on RedirectCreateResult": "RedirectCreateResult",
		"...on RedirectDeleteResult": "RedirectDeleteResult",
		"...on RedirectUpdateResult": "RedirectUpdateResult",
		"...on RedirectUpsertResult": "RedirectUpsertResult",
		"...on YoutubeVideoCreateResult": "YoutubeVideoCreateResult",
		"...on YoutubeVideoDeleteResult": "YoutubeVideoDeleteResult",
		"...on YoutubeVideoUpdateResult": "YoutubeVideoUpdateResult",
		"...on YoutubeVideoUpsertResult": "YoutubeVideoUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on BulletPointCreateResult": "BulletPointCreateResult",
		"...on BulletPointDeleteResult": "BulletPointDeleteResult",
		"...on BulletPointUpdateResult": "BulletPointUpdateResult",
		"...on BulletPointUpsertResult": "BulletPointUpsertResult",
		"...on BulletPointItemCreateResult": "BulletPointItemCreateResult",
		"...on BulletPointItemDeleteResult": "BulletPointItemDeleteResult",
		"...on BulletPointItemUpdateResult": "BulletPointItemUpdateResult",
		"...on BulletPointItemUpsertResult": "BulletPointItemUpsertResult",
		"...on FileItemCreateResult": "FileItemCreateResult",
		"...on FileItemDeleteResult": "FileItemDeleteResult",
		"...on FileItemUpdateResult": "FileItemUpdateResult",
		"...on FileItemUpsertResult": "FileItemUpsertResult",
		"...on FileListCreateResult": "FileListCreateResult",
		"...on FileListDeleteResult": "FileListDeleteResult",
		"...on FileListUpdateResult": "FileListUpdateResult",
		"...on FileListUpsertResult": "FileListUpsertResult",
		"...on FooterLinkCreateResult": "FooterLinkCreateResult",
		"...on FooterLinkDeleteResult": "FooterLinkDeleteResult",
		"...on FooterLinkUpdateResult": "FooterLinkUpdateResult",
		"...on FooterLinkUpsertResult": "FooterLinkUpsertResult",
		"...on FooterLinkGroupsCreateResult": "FooterLinkGroupsCreateResult",
		"...on FooterLinkGroupsDeleteResult": "FooterLinkGroupsDeleteResult",
		"...on FooterLinkGroupsUpdateResult": "FooterLinkGroupsUpdateResult",
		"...on FooterLinkGroupsUpsertResult": "FooterLinkGroupsUpsertResult",
		"...on TextItemCreateResult": "TextItemCreateResult",
		"...on TextItemDeleteResult": "TextItemDeleteResult",
		"...on TextItemUpdateResult": "TextItemUpdateResult",
		"...on TextItemUpsertResult": "TextItemUpsertResult",
		"...on TextListCreateResult": "TextListCreateResult",
		"...on TextListDeleteResult": "TextListDeleteResult",
		"...on TextListUpdateResult": "TextListUpdateResult",
		"...on TextListUpsertResult": "TextListUpsertResult",
		"...on ProgramPageCreateResult": "ProgramPageCreateResult",
		"...on ProgramPageDeleteResult": "ProgramPageDeleteResult",
		"...on ProgramPageUpdateResult": "ProgramPageUpdateResult",
		"...on ProgramPageUpsertResult": "ProgramPageUpsertResult",
		"...on GenericPageCreateResult": "GenericPageCreateResult",
		"...on GenericPageDeleteResult": "GenericPageDeleteResult",
		"...on GenericPageUpdateResult": "GenericPageUpdateResult",
		"...on GenericPageUpsertResult": "GenericPageUpsertResult",
		"...on StaffCreateResult": "StaffCreateResult",
		"...on StaffDeleteResult": "StaffDeleteResult",
		"...on StaffUpdateResult": "StaffUpdateResult",
		"...on StaffUpsertResult": "StaffUpsertResult",
		"...on StaffItemCreateResult": "StaffItemCreateResult",
		"...on StaffItemDeleteResult": "StaffItemDeleteResult",
		"...on StaffItemUpdateResult": "StaffItemUpdateResult",
		"...on StaffItemUpsertResult": "StaffItemUpsertResult",
		"...on StaffListCreateResult": "StaffListCreateResult",
		"...on StaffListDeleteResult": "StaffListDeleteResult",
		"...on StaffListUpdateResult": "StaffListUpdateResult",
		"...on StaffListUpsertResult": "StaffListUpsertResult",
		"...on IconCreateResult": "IconCreateResult",
		"...on IconDeleteResult": "IconDeleteResult",
		"...on IconUpdateResult": "IconUpdateResult",
		"...on IconUpsertResult": "IconUpsertResult",
		"...on PrincipleItemCreateResult": "PrincipleItemCreateResult",
		"...on PrincipleItemDeleteResult": "PrincipleItemDeleteResult",
		"...on PrincipleItemUpdateResult": "PrincipleItemUpdateResult",
		"...on PrincipleItemUpsertResult": "PrincipleItemUpsertResult",
		"...on PrincipleListCreateResult": "PrincipleListCreateResult",
		"...on PrincipleListDeleteResult": "PrincipleListDeleteResult",
		"...on PrincipleListUpdateResult": "PrincipleListUpdateResult",
		"...on PrincipleListUpsertResult": "PrincipleListUpsertResult",
		"...on LinkItemCreateResult": "LinkItemCreateResult",
		"...on LinkItemDeleteResult": "LinkItemDeleteResult",
		"...on LinkItemUpdateResult": "LinkItemUpdateResult",
		"...on LinkItemUpsertResult": "LinkItemUpsertResult",
		"...on LinkListCreateResult": "LinkListCreateResult",
		"...on LinkListDeleteResult": "LinkListDeleteResult",
		"...on LinkListUpdateResult": "LinkListUpdateResult",
		"...on LinkListUpsertResult": "LinkListUpsertResult",
		"...on LinkSubGroupCreateResult": "LinkSubGroupCreateResult",
		"...on LinkSubGroupDeleteResult": "LinkSubGroupDeleteResult",
		"...on LinkSubGroupUpdateResult": "LinkSubGroupUpdateResult",
		"...on LinkSubGroupUpsertResult": "LinkSubGroupUpsertResult",
		"...on YoutubeVideoListCreateResult": "YoutubeVideoListCreateResult",
		"...on YoutubeVideoListDeleteResult": "YoutubeVideoListDeleteResult",
		"...on YoutubeVideoListUpdateResult": "YoutubeVideoListUpdateResult",
		"...on YoutubeVideoListUpsertResult": "YoutubeVideoListUpsertResult",
		"...on YoutubeVideoListItemCreateResult": "YoutubeVideoListItemCreateResult",
		"...on YoutubeVideoListItemDeleteResult": "YoutubeVideoListItemDeleteResult",
		"...on YoutubeVideoListItemUpdateResult": "YoutubeVideoListItemUpdateResult",
		"...on YoutubeVideoListItemUpsertResult": "YoutubeVideoListItemUpsertResult",
		"...on ImageListCreateResult": "ImageListCreateResult",
		"...on ImageListDeleteResult": "ImageListDeleteResult",
		"...on ImageListUpdateResult": "ImageListUpdateResult",
		"...on ImageListUpsertResult": "ImageListUpsertResult",
		"...on ImageListItemCreateResult": "ImageListItemCreateResult",
		"...on ImageListItemDeleteResult": "ImageListItemDeleteResult",
		"...on ImageListItemUpdateResult": "ImageListItemUpdateResult",
		"...on ImageListItemUpsertResult": "ImageListItemUpsertResult",
		"...on CitationItemCreateResult": "CitationItemCreateResult",
		"...on CitationItemDeleteResult": "CitationItemDeleteResult",
		"...on CitationItemUpdateResult": "CitationItemUpdateResult",
		"...on CitationItemUpsertResult": "CitationItemUpsertResult",
		"...on CitationListCreateResult": "CitationListCreateResult",
		"...on CitationListDeleteResult": "CitationListDeleteResult",
		"...on CitationListUpdateResult": "CitationListUpdateResult",
		"...on CitationListUpsertResult": "CitationListUpsertResult",
		"...on ContentImageLinkItemCreateResult": "ContentImageLinkItemCreateResult",
		"...on ContentImageLinkItemDeleteResult": "ContentImageLinkItemDeleteResult",
		"...on ContentImageLinkItemUpdateResult": "ContentImageLinkItemUpdateResult",
		"...on ContentImageLinkItemUpsertResult": "ContentImageLinkItemUpsertResult",
		"...on ContentImageLinkListCreateResult": "ContentImageLinkListCreateResult",
		"...on ContentImageLinkListDeleteResult": "ContentImageLinkListDeleteResult",
		"...on ContentImageLinkListUpdateResult": "ContentImageLinkListUpdateResult",
		"...on ContentImageLinkListUpsertResult": "ContentImageLinkListUpsertResult",
		"...on NewsCreateResult": "NewsCreateResult",
		"...on NewsDeleteResult": "NewsDeleteResult",
		"...on NewsUpdateResult": "NewsUpdateResult",
		"...on NewsUpsertResult": "NewsUpsertResult",
		"...on StoriesCreateResult": "StoriesCreateResult",
		"...on StoriesDeleteResult": "StoriesDeleteResult",
		"...on StoriesUpdateResult": "StoriesUpdateResult",
		"...on StoriesUpsertResult": "StoriesUpsertResult",
		"...on NewsPageCreateResult": "NewsPageCreateResult",
		"...on NewsPageDeleteResult": "NewsPageDeleteResult",
		"...on NewsPageUpdateResult": "NewsPageUpdateResult",
		"...on NewsPageUpsertResult": "NewsPageUpsertResult",
		"...on StoriesPageCreateResult": "StoriesPageCreateResult",
		"...on StoriesPageDeleteResult": "StoriesPageDeleteResult",
		"...on StoriesPageUpdateResult": "StoriesPageUpdateResult",
		"...on StoriesPageUpsertResult": "StoriesPageUpsertResult",
		"...on StoriesListCreateResult": "StoriesListCreateResult",
		"...on StoriesListDeleteResult": "StoriesListDeleteResult",
		"...on StoriesListUpdateResult": "StoriesListUpdateResult",
		"...on StoriesListUpsertResult": "StoriesListUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	FallbackSeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FallbackSeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo"
	},
	FallbackSeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FallbackSeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HomePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage"
	},
	HomePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	ProgramCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Program",
		validation:"_ValidationResult"
	},
	ProgramDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Program"
	},
	ProgramUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Program",
		validation:"_ValidationResult"
	},
	ProgramUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Program",
		validation:"_ValidationResult"
	},
	RedirectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect"
	},
	RedirectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	YoutubeVideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo",
		validation:"_ValidationResult"
	},
	YoutubeVideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo"
	},
	YoutubeVideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo",
		validation:"_ValidationResult"
	},
	YoutubeVideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	BulletPointCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPoint",
		validation:"_ValidationResult"
	},
	BulletPointDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPoint"
	},
	BulletPointUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPoint",
		validation:"_ValidationResult"
	},
	BulletPointUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPoint",
		validation:"_ValidationResult"
	},
	BulletPointItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPointItem",
		validation:"_ValidationResult"
	},
	BulletPointItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPointItem"
	},
	BulletPointItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPointItem",
		validation:"_ValidationResult"
	},
	BulletPointItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BulletPointItem",
		validation:"_ValidationResult"
	},
	FileItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileItem",
		validation:"_ValidationResult"
	},
	FileItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileItem"
	},
	FileItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileItem",
		validation:"_ValidationResult"
	},
	FileItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileItem",
		validation:"_ValidationResult"
	},
	FileListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileList",
		validation:"_ValidationResult"
	},
	FileListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileList"
	},
	FileListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileList",
		validation:"_ValidationResult"
	},
	FileListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileList",
		validation:"_ValidationResult"
	},
	FooterLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink",
		validation:"_ValidationResult"
	},
	FooterLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink"
	},
	FooterLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink",
		validation:"_ValidationResult"
	},
	FooterLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink",
		validation:"_ValidationResult"
	},
	FooterLinkGroupsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinkGroups",
		validation:"_ValidationResult"
	},
	FooterLinkGroupsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinkGroups"
	},
	FooterLinkGroupsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinkGroups",
		validation:"_ValidationResult"
	},
	FooterLinkGroupsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinkGroups",
		validation:"_ValidationResult"
	},
	TextItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem"
	},
	TextItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	TextListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList"
	},
	TextListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	TextListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	ProgramPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProgramPage",
		validation:"_ValidationResult"
	},
	ProgramPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProgramPage"
	},
	ProgramPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProgramPage",
		validation:"_ValidationResult"
	},
	ProgramPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProgramPage",
		validation:"_ValidationResult"
	},
	GenericPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	GenericPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage"
	},
	GenericPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	GenericPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	StaffCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff",
		validation:"_ValidationResult"
	},
	StaffDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff"
	},
	StaffUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff",
		validation:"_ValidationResult"
	},
	StaffUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff",
		validation:"_ValidationResult"
	},
	StaffItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffItem",
		validation:"_ValidationResult"
	},
	StaffItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffItem"
	},
	StaffItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffItem",
		validation:"_ValidationResult"
	},
	StaffItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffItem",
		validation:"_ValidationResult"
	},
	StaffListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffList",
		validation:"_ValidationResult"
	},
	StaffListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffList"
	},
	StaffListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffList",
		validation:"_ValidationResult"
	},
	StaffListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StaffList",
		validation:"_ValidationResult"
	},
	IconCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon",
		validation:"_ValidationResult"
	},
	IconDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon"
	},
	IconUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon",
		validation:"_ValidationResult"
	},
	IconUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon",
		validation:"_ValidationResult"
	},
	PrincipleItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleItem",
		validation:"_ValidationResult"
	},
	PrincipleItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleItem"
	},
	PrincipleItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleItem",
		validation:"_ValidationResult"
	},
	PrincipleItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleItem",
		validation:"_ValidationResult"
	},
	PrincipleListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleList",
		validation:"_ValidationResult"
	},
	PrincipleListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleList"
	},
	PrincipleListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleList",
		validation:"_ValidationResult"
	},
	PrincipleListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrincipleList",
		validation:"_ValidationResult"
	},
	LinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem"
	},
	LinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList"
	},
	LinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkSubGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSubGroup",
		validation:"_ValidationResult"
	},
	LinkSubGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSubGroup"
	},
	LinkSubGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSubGroup",
		validation:"_ValidationResult"
	},
	LinkSubGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSubGroup",
		validation:"_ValidationResult"
	},
	YoutubeVideoListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoList",
		validation:"_ValidationResult"
	},
	YoutubeVideoListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoList"
	},
	YoutubeVideoListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoList",
		validation:"_ValidationResult"
	},
	YoutubeVideoListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoList",
		validation:"_ValidationResult"
	},
	YoutubeVideoListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoListItem",
		validation:"_ValidationResult"
	},
	YoutubeVideoListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoListItem"
	},
	YoutubeVideoListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoListItem",
		validation:"_ValidationResult"
	},
	YoutubeVideoListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideoListItem",
		validation:"_ValidationResult"
	},
	ImageListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList"
	},
	ImageListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem"
	},
	ImageListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	CitationItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationItem",
		validation:"_ValidationResult"
	},
	CitationItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationItem"
	},
	CitationItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationItem",
		validation:"_ValidationResult"
	},
	CitationItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationItem",
		validation:"_ValidationResult"
	},
	CitationListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationList",
		validation:"_ValidationResult"
	},
	CitationListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationList"
	},
	CitationListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationList",
		validation:"_ValidationResult"
	},
	CitationListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CitationList",
		validation:"_ValidationResult"
	},
	ContentImageLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkItem",
		validation:"_ValidationResult"
	},
	ContentImageLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkItem"
	},
	ContentImageLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkItem",
		validation:"_ValidationResult"
	},
	ContentImageLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkItem",
		validation:"_ValidationResult"
	},
	ContentImageLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkList",
		validation:"_ValidationResult"
	},
	ContentImageLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkList"
	},
	ContentImageLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkList",
		validation:"_ValidationResult"
	},
	ContentImageLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentImageLinkList",
		validation:"_ValidationResult"
	},
	NewsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"News",
		validation:"_ValidationResult"
	},
	NewsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"News"
	},
	NewsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"News",
		validation:"_ValidationResult"
	},
	NewsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"News",
		validation:"_ValidationResult"
	},
	StoriesCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Stories",
		validation:"_ValidationResult"
	},
	StoriesDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Stories"
	},
	StoriesUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Stories",
		validation:"_ValidationResult"
	},
	StoriesUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Stories",
		validation:"_ValidationResult"
	},
	NewsPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsPage",
		validation:"_ValidationResult"
	},
	NewsPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsPage"
	},
	NewsPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsPage",
		validation:"_ValidationResult"
	},
	NewsPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsPage",
		validation:"_ValidationResult"
	},
	StoriesPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesPage",
		validation:"_ValidationResult"
	},
	StoriesPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesPage"
	},
	StoriesPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesPage",
		validation:"_ValidationResult"
	},
	StoriesPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesPage",
		validation:"_ValidationResult"
	},
	StoriesListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesList",
		validation:"_ValidationResult"
	},
	StoriesListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesList"
	},
	StoriesListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesList",
		validation:"_ValidationResult"
	},
	StoriesListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StoriesList",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createFallbackSeo:"FallbackSeoCreateResult",
		deleteFallbackSeo:"FallbackSeoDeleteResult",
		updateFallbackSeo:"FallbackSeoUpdateResult",
		upsertFallbackSeo:"FallbackSeoUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createProgram:"ProgramCreateResult",
		deleteProgram:"ProgramDeleteResult",
		updateProgram:"ProgramUpdateResult",
		upsertProgram:"ProgramUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createYoutubeVideo:"YoutubeVideoCreateResult",
		deleteYoutubeVideo:"YoutubeVideoDeleteResult",
		updateYoutubeVideo:"YoutubeVideoUpdateResult",
		upsertYoutubeVideo:"YoutubeVideoUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createBulletPoint:"BulletPointCreateResult",
		deleteBulletPoint:"BulletPointDeleteResult",
		updateBulletPoint:"BulletPointUpdateResult",
		upsertBulletPoint:"BulletPointUpsertResult",
		createBulletPointItem:"BulletPointItemCreateResult",
		deleteBulletPointItem:"BulletPointItemDeleteResult",
		updateBulletPointItem:"BulletPointItemUpdateResult",
		upsertBulletPointItem:"BulletPointItemUpsertResult",
		createFileItem:"FileItemCreateResult",
		deleteFileItem:"FileItemDeleteResult",
		updateFileItem:"FileItemUpdateResult",
		upsertFileItem:"FileItemUpsertResult",
		createFileList:"FileListCreateResult",
		deleteFileList:"FileListDeleteResult",
		updateFileList:"FileListUpdateResult",
		upsertFileList:"FileListUpsertResult",
		createFooterLink:"FooterLinkCreateResult",
		deleteFooterLink:"FooterLinkDeleteResult",
		updateFooterLink:"FooterLinkUpdateResult",
		upsertFooterLink:"FooterLinkUpsertResult",
		createFooterLinkGroups:"FooterLinkGroupsCreateResult",
		deleteFooterLinkGroups:"FooterLinkGroupsDeleteResult",
		updateFooterLinkGroups:"FooterLinkGroupsUpdateResult",
		upsertFooterLinkGroups:"FooterLinkGroupsUpsertResult",
		createTextItem:"TextItemCreateResult",
		deleteTextItem:"TextItemDeleteResult",
		updateTextItem:"TextItemUpdateResult",
		upsertTextItem:"TextItemUpsertResult",
		createTextList:"TextListCreateResult",
		deleteTextList:"TextListDeleteResult",
		updateTextList:"TextListUpdateResult",
		upsertTextList:"TextListUpsertResult",
		createProgramPage:"ProgramPageCreateResult",
		deleteProgramPage:"ProgramPageDeleteResult",
		updateProgramPage:"ProgramPageUpdateResult",
		upsertProgramPage:"ProgramPageUpsertResult",
		createGenericPage:"GenericPageCreateResult",
		deleteGenericPage:"GenericPageDeleteResult",
		updateGenericPage:"GenericPageUpdateResult",
		upsertGenericPage:"GenericPageUpsertResult",
		createStaff:"StaffCreateResult",
		deleteStaff:"StaffDeleteResult",
		updateStaff:"StaffUpdateResult",
		upsertStaff:"StaffUpsertResult",
		createStaffItem:"StaffItemCreateResult",
		deleteStaffItem:"StaffItemDeleteResult",
		updateStaffItem:"StaffItemUpdateResult",
		upsertStaffItem:"StaffItemUpsertResult",
		createStaffList:"StaffListCreateResult",
		deleteStaffList:"StaffListDeleteResult",
		updateStaffList:"StaffListUpdateResult",
		upsertStaffList:"StaffListUpsertResult",
		createIcon:"IconCreateResult",
		deleteIcon:"IconDeleteResult",
		updateIcon:"IconUpdateResult",
		upsertIcon:"IconUpsertResult",
		createPrincipleItem:"PrincipleItemCreateResult",
		deletePrincipleItem:"PrincipleItemDeleteResult",
		updatePrincipleItem:"PrincipleItemUpdateResult",
		upsertPrincipleItem:"PrincipleItemUpsertResult",
		createPrincipleList:"PrincipleListCreateResult",
		deletePrincipleList:"PrincipleListDeleteResult",
		updatePrincipleList:"PrincipleListUpdateResult",
		upsertPrincipleList:"PrincipleListUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkSubGroup:"LinkSubGroupCreateResult",
		deleteLinkSubGroup:"LinkSubGroupDeleteResult",
		updateLinkSubGroup:"LinkSubGroupUpdateResult",
		upsertLinkSubGroup:"LinkSubGroupUpsertResult",
		createYoutubeVideoList:"YoutubeVideoListCreateResult",
		deleteYoutubeVideoList:"YoutubeVideoListDeleteResult",
		updateYoutubeVideoList:"YoutubeVideoListUpdateResult",
		upsertYoutubeVideoList:"YoutubeVideoListUpsertResult",
		createYoutubeVideoListItem:"YoutubeVideoListItemCreateResult",
		deleteYoutubeVideoListItem:"YoutubeVideoListItemDeleteResult",
		updateYoutubeVideoListItem:"YoutubeVideoListItemUpdateResult",
		upsertYoutubeVideoListItem:"YoutubeVideoListItemUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		createCitationItem:"CitationItemCreateResult",
		deleteCitationItem:"CitationItemDeleteResult",
		updateCitationItem:"CitationItemUpdateResult",
		upsertCitationItem:"CitationItemUpsertResult",
		createCitationList:"CitationListCreateResult",
		deleteCitationList:"CitationListDeleteResult",
		updateCitationList:"CitationListUpdateResult",
		upsertCitationList:"CitationListUpsertResult",
		createContentImageLinkItem:"ContentImageLinkItemCreateResult",
		deleteContentImageLinkItem:"ContentImageLinkItemDeleteResult",
		updateContentImageLinkItem:"ContentImageLinkItemUpdateResult",
		upsertContentImageLinkItem:"ContentImageLinkItemUpsertResult",
		createContentImageLinkList:"ContentImageLinkListCreateResult",
		deleteContentImageLinkList:"ContentImageLinkListDeleteResult",
		updateContentImageLinkList:"ContentImageLinkListUpdateResult",
		upsertContentImageLinkList:"ContentImageLinkListUpsertResult",
		createNews:"NewsCreateResult",
		deleteNews:"NewsDeleteResult",
		updateNews:"NewsUpdateResult",
		upsertNews:"NewsUpsertResult",
		createStories:"StoriesCreateResult",
		deleteStories:"StoriesDeleteResult",
		updateStories:"StoriesUpdateResult",
		upsertStories:"StoriesUpsertResult",
		createNewsPage:"NewsPageCreateResult",
		deleteNewsPage:"NewsPageDeleteResult",
		updateNewsPage:"NewsPageUpdateResult",
		upsertNewsPage:"NewsPageUpsertResult",
		createStoriesPage:"StoriesPageCreateResult",
		deleteStoriesPage:"StoriesPageDeleteResult",
		updateStoriesPage:"StoriesPageUpdateResult",
		upsertStoriesPage:"StoriesPageUpsertResult",
		createStoriesList:"StoriesListCreateResult",
		deleteStoriesList:"StoriesListDeleteResult",
		updateStoriesList:"StoriesListUpdateResult",
		upsertStoriesList:"StoriesListUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeo"]],
listFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FallbackSeo"]],
paginateFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FallbackSeoConnection"]],
validateCreateFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null},ValueTypes["Program"]],
listProgram?: [{	filter?:ValueTypes["ProgramWhere"] | null,	orderBy?:ValueTypes["ProgramOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Program"]],
paginateProgram?: [{	filter?:ValueTypes["ProgramWhere"] | null,	orderBy?:ValueTypes["ProgramOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProgramConnection"]],
validateCreateProgram?: [{	data:ValueTypes["ProgramCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	data:ValueTypes["ProgramUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideo"]],
listYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideo"]],
paginateYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoConnection"]],
validateCreateYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null},ValueTypes["BulletPoint"]],
listBulletPoint?: [{	filter?:ValueTypes["BulletPointWhere"] | null,	orderBy?:ValueTypes["BulletPointOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BulletPoint"]],
paginateBulletPoint?: [{	filter?:ValueTypes["BulletPointWhere"] | null,	orderBy?:ValueTypes["BulletPointOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BulletPointConnection"]],
validateCreateBulletPoint?: [{	data:ValueTypes["BulletPointCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	data:ValueTypes["BulletPointUpdateInput"]},ValueTypes["_ValidationResult"]],
getBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null},ValueTypes["BulletPointItem"]],
listBulletPointItem?: [{	filter?:ValueTypes["BulletPointItemWhere"] | null,	orderBy?:ValueTypes["BulletPointItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BulletPointItem"]],
paginateBulletPointItem?: [{	filter?:ValueTypes["BulletPointItemWhere"] | null,	orderBy?:ValueTypes["BulletPointItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BulletPointItemConnection"]],
validateCreateBulletPointItem?: [{	data:ValueTypes["BulletPointItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	data:ValueTypes["BulletPointItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null},ValueTypes["FileItem"]],
listFileItem?: [{	filter?:ValueTypes["FileItemWhere"] | null,	orderBy?:ValueTypes["FileItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileItem"]],
paginateFileItem?: [{	filter?:ValueTypes["FileItemWhere"] | null,	orderBy?:ValueTypes["FileItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileItemConnection"]],
validateCreateFileItem?: [{	data:ValueTypes["FileItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	data:ValueTypes["FileItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null},ValueTypes["FileList"]],
listFileList?: [{	filter?:ValueTypes["FileListWhere"] | null,	orderBy?:ValueTypes["FileListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileList"]],
paginateFileList?: [{	filter?:ValueTypes["FileListWhere"] | null,	orderBy?:ValueTypes["FileListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileListConnection"]],
validateCreateFileList?: [{	data:ValueTypes["FileListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	data:ValueTypes["FileListUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLink"]],
listFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLink"]],
paginateFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null},ValueTypes["FooterLinkGroups"]],
listFooterLinkGroups?: [{	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	orderBy?:ValueTypes["FooterLinkGroupsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLinkGroups"]],
paginateFooterLinkGroups?: [{	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	orderBy?:ValueTypes["FooterLinkGroupsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkGroupsConnection"]],
validateCreateFooterLinkGroups?: [{	data:ValueTypes["FooterLinkGroupsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	data:ValueTypes["FooterLinkGroupsUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null},ValueTypes["TextItem"]],
listTextItem?: [{	filter?:ValueTypes["TextItemWhere"] | null,	orderBy?:ValueTypes["TextItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextItem"]],
paginateTextItem?: [{	filter?:ValueTypes["TextItemWhere"] | null,	orderBy?:ValueTypes["TextItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data:ValueTypes["TextItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	data:ValueTypes["TextItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null},ValueTypes["TextList"]],
listTextList?: [{	filter?:ValueTypes["TextListWhere"] | null,	orderBy?:ValueTypes["TextListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextList"]],
paginateTextList?: [{	filter?:ValueTypes["TextListWhere"] | null,	orderBy?:ValueTypes["TextListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextListConnection"]],
validateCreateTextList?: [{	data:ValueTypes["TextListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	data:ValueTypes["TextListUpdateInput"]},ValueTypes["_ValidationResult"]],
getProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null},ValueTypes["ProgramPage"]],
listProgramPage?: [{	filter?:ValueTypes["ProgramPageWhere"] | null,	orderBy?:ValueTypes["ProgramPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProgramPage"]],
paginateProgramPage?: [{	filter?:ValueTypes["ProgramPageWhere"] | null,	orderBy?:ValueTypes["ProgramPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProgramPageConnection"]],
validateCreateProgramPage?: [{	data:ValueTypes["ProgramPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	data:ValueTypes["ProgramPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null},ValueTypes["Staff"]],
listStaff?: [{	filter?:ValueTypes["StaffWhere"] | null,	orderBy?:ValueTypes["StaffOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Staff"]],
paginateStaff?: [{	filter?:ValueTypes["StaffWhere"] | null,	orderBy?:ValueTypes["StaffOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StaffConnection"]],
validateCreateStaff?: [{	data:ValueTypes["StaffCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	data:ValueTypes["StaffUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null},ValueTypes["StaffItem"]],
listStaffItem?: [{	filter?:ValueTypes["StaffItemWhere"] | null,	orderBy?:ValueTypes["StaffItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StaffItem"]],
paginateStaffItem?: [{	filter?:ValueTypes["StaffItemWhere"] | null,	orderBy?:ValueTypes["StaffItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StaffItemConnection"]],
validateCreateStaffItem?: [{	data:ValueTypes["StaffItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	data:ValueTypes["StaffItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null},ValueTypes["StaffList"]],
listStaffList?: [{	filter?:ValueTypes["StaffListWhere"] | null,	orderBy?:ValueTypes["StaffListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StaffList"]],
paginateStaffList?: [{	filter?:ValueTypes["StaffListWhere"] | null,	orderBy?:ValueTypes["StaffListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StaffListConnection"]],
validateCreateStaffList?: [{	data:ValueTypes["StaffListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	data:ValueTypes["StaffListUpdateInput"]},ValueTypes["_ValidationResult"]],
getIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null},ValueTypes["Icon"]],
listIcon?: [{	filter?:ValueTypes["IconWhere"] | null,	orderBy?:ValueTypes["IconOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Icon"]],
paginateIcon?: [{	filter?:ValueTypes["IconWhere"] | null,	orderBy?:ValueTypes["IconOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IconConnection"]],
validateCreateIcon?: [{	data:ValueTypes["IconCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIcon?: [{	by:ValueTypes["IconUniqueWhere"],	data:ValueTypes["IconUpdateInput"]},ValueTypes["_ValidationResult"]],
getPrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null},ValueTypes["PrincipleItem"]],
listPrincipleItem?: [{	filter?:ValueTypes["PrincipleItemWhere"] | null,	orderBy?:ValueTypes["PrincipleItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrincipleItem"]],
paginatePrincipleItem?: [{	filter?:ValueTypes["PrincipleItemWhere"] | null,	orderBy?:ValueTypes["PrincipleItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrincipleItemConnection"]],
validateCreatePrincipleItem?: [{	data:ValueTypes["PrincipleItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	data:ValueTypes["PrincipleItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null},ValueTypes["PrincipleList"]],
listPrincipleList?: [{	filter?:ValueTypes["PrincipleListWhere"] | null,	orderBy?:ValueTypes["PrincipleListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrincipleList"]],
paginatePrincipleList?: [{	filter?:ValueTypes["PrincipleListWhere"] | null,	orderBy?:ValueTypes["PrincipleListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrincipleListConnection"]],
validateCreatePrincipleList?: [{	data:ValueTypes["PrincipleListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	data:ValueTypes["PrincipleListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null},ValueTypes["LinkSubGroup"]],
listLinkSubGroup?: [{	filter?:ValueTypes["LinkSubGroupWhere"] | null,	orderBy?:ValueTypes["LinkSubGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkSubGroup"]],
paginateLinkSubGroup?: [{	filter?:ValueTypes["LinkSubGroupWhere"] | null,	orderBy?:ValueTypes["LinkSubGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkSubGroupConnection"]],
validateCreateLinkSubGroup?: [{	data:ValueTypes["LinkSubGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	data:ValueTypes["LinkSubGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null},ValueTypes["YoutubeVideoList"]],
listYoutubeVideoList?: [{	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideoList"]],
paginateYoutubeVideoList?: [{	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoListConnection"]],
validateCreateYoutubeVideoList?: [{	data:ValueTypes["YoutubeVideoListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	data:ValueTypes["YoutubeVideoListUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null},ValueTypes["YoutubeVideoListItem"]],
listYoutubeVideoListItem?: [{	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideoListItem"]],
paginateYoutubeVideoListItem?: [{	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoListItemConnection"]],
validateCreateYoutubeVideoListItem?: [{	data:ValueTypes["YoutubeVideoListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	data:ValueTypes["YoutubeVideoListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null},ValueTypes["CitationItem"]],
listCitationItem?: [{	filter?:ValueTypes["CitationItemWhere"] | null,	orderBy?:ValueTypes["CitationItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CitationItem"]],
paginateCitationItem?: [{	filter?:ValueTypes["CitationItemWhere"] | null,	orderBy?:ValueTypes["CitationItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CitationItemConnection"]],
validateCreateCitationItem?: [{	data:ValueTypes["CitationItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	data:ValueTypes["CitationItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null},ValueTypes["CitationList"]],
listCitationList?: [{	filter?:ValueTypes["CitationListWhere"] | null,	orderBy?:ValueTypes["CitationListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CitationList"]],
paginateCitationList?: [{	filter?:ValueTypes["CitationListWhere"] | null,	orderBy?:ValueTypes["CitationListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CitationListConnection"]],
validateCreateCitationList?: [{	data:ValueTypes["CitationListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	data:ValueTypes["CitationListUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null},ValueTypes["ContentImageLinkItem"]],
listContentImageLinkItem?: [{	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentImageLinkItem"]],
paginateContentImageLinkItem?: [{	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentImageLinkItemConnection"]],
validateCreateContentImageLinkItem?: [{	data:ValueTypes["ContentImageLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	data:ValueTypes["ContentImageLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null},ValueTypes["ContentImageLinkList"]],
listContentImageLinkList?: [{	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentImageLinkList"]],
paginateContentImageLinkList?: [{	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentImageLinkListConnection"]],
validateCreateContentImageLinkList?: [{	data:ValueTypes["ContentImageLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	data:ValueTypes["ContentImageLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null},ValueTypes["News"]],
listNews?: [{	filter?:ValueTypes["NewsWhere"] | null,	orderBy?:ValueTypes["NewsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["News"]],
paginateNews?: [{	filter?:ValueTypes["NewsWhere"] | null,	orderBy?:ValueTypes["NewsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsConnection"]],
validateCreateNews?: [{	data:ValueTypes["NewsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNews?: [{	by:ValueTypes["NewsUniqueWhere"],	data:ValueTypes["NewsUpdateInput"]},ValueTypes["_ValidationResult"]],
getStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["Stories"]],
listStories?: [{	filter?:ValueTypes["StoriesWhere"] | null,	orderBy?:ValueTypes["StoriesOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Stories"]],
paginateStories?: [{	filter?:ValueTypes["StoriesWhere"] | null,	orderBy?:ValueTypes["StoriesOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StoriesConnection"]],
validateCreateStories?: [{	data:ValueTypes["StoriesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	data:ValueTypes["StoriesUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null},ValueTypes["NewsPage"]],
listNewsPage?: [{	filter?:ValueTypes["NewsPageWhere"] | null,	orderBy?:ValueTypes["NewsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsPage"]],
paginateNewsPage?: [{	filter?:ValueTypes["NewsPageWhere"] | null,	orderBy?:ValueTypes["NewsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsPageConnection"]],
validateCreateNewsPage?: [{	data:ValueTypes["NewsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	data:ValueTypes["NewsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null},ValueTypes["StoriesPage"]],
listStoriesPage?: [{	filter?:ValueTypes["StoriesPageWhere"] | null,	orderBy?:ValueTypes["StoriesPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StoriesPage"]],
paginateStoriesPage?: [{	filter?:ValueTypes["StoriesPageWhere"] | null,	orderBy?:ValueTypes["StoriesPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StoriesPageConnection"]],
validateCreateStoriesPage?: [{	data:ValueTypes["StoriesPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	data:ValueTypes["StoriesPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null},ValueTypes["StoriesList"]],
listStoriesList?: [{	filter?:ValueTypes["StoriesListWhere"] | null,	orderBy?:ValueTypes["StoriesListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StoriesList"]],
paginateStoriesList?: [{	filter?:ValueTypes["StoriesListWhere"] | null,	orderBy?:ValueTypes["StoriesListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StoriesListConnection"]],
validateCreateStoriesList?: [{	data:ValueTypes["StoriesListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	data:ValueTypes["StoriesListUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:true,
		__typename?: true
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:true,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by:ValueTypes["ContentBlocksByReferencesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: true
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FieldMeta"]: AliasType<{
	readable?:true,
	updatable?:true,
		__typename?: true
}>;
	["UUID"]:string;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:true,
	order?:true,
	json?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
references?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
referencesByLink?: [{	by:ValueTypes["ContentBlockReferencesByLinkUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByFileList?: [{	by:ValueTypes["ContentBlockReferencesByFileListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByTextList?: [{	by:ValueTypes["ContentBlockReferencesByTextListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByStaffList?: [{	by:ValueTypes["ContentBlockReferencesByStaffListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByPrincipleList?: [{	by:ValueTypes["ContentBlockReferencesByPrincipleListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByImageLinkList?: [{	by:ValueTypes["ContentBlockReferencesByImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByCitationList?: [{	by:ValueTypes["ContentBlockReferencesByCitationListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByStoriesList?: [{	by:ValueTypes["ContentBlockReferencesByStoriesListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: true
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	and?:(ValueTypes["ContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentWhere"] | undefined | null)[],
	not?:ValueTypes["ContentWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	references?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["ContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ContentReferenceTypeCondition"] | null,
	block?:ValueTypes["ContentBlockWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	youtubeVideo?:ValueTypes["YoutubeVideoWhere"] | null,
	primaryText?:ValueTypes["StringCondition"] | null,
	secondaryText?:ValueTypes["StringCondition"] | null,
	fileList?:ValueTypes["FileListWhere"] | null,
	textList?:ValueTypes["TextListWhere"] | null,
	staffList?:ValueTypes["StaffListWhere"] | null,
	principleList?:ValueTypes["PrincipleListWhere"] | null,
	view?:ValueTypes["ViewCondition"] | null,
	aligning?:ValueTypes["AligningCondition"] | null,
	numbered?:ValueTypes["BooleanCondition"] | null,
	tertiaryText?:ValueTypes["StringCondition"] | null,
	imageLinkList?:ValueTypes["ContentImageLinkListWhere"] | null,
	citationList?:ValueTypes["CitationListWhere"] | null,
	storiesList?:ValueTypes["StoriesListWhere"] | null,
	and?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceWhere"] | null
};
	["ContentReferenceTypeCondition"]: {
	and?:ValueTypes["ContentReferenceTypeCondition"][],
	or?:ValueTypes["ContentReferenceTypeCondition"][],
	not?:ValueTypes["ContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceType"] | null,
	notEq?:ValueTypes["ContentReferenceType"] | null,
	in?:ValueTypes["ContentReferenceType"][],
	notIn?:ValueTypes["ContentReferenceType"][],
	lt?:ValueTypes["ContentReferenceType"] | null,
	lte?:ValueTypes["ContentReferenceType"] | null,
	gt?:ValueTypes["ContentReferenceType"] | null,
	gte?:ValueTypes["ContentReferenceType"] | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	internalLink?:ValueTypes["LinkableWhere"] | null,
	isTargetBlank?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	program?:ValueTypes["ProgramWhere"] | null,
	homePage?:ValueTypes["HomePageWhere"] | null,
	redirect?:ValueTypes["RedirectWhere"] | null,
	programPage?:ValueTypes["ProgramPageWhere"] | null,
	genericPage?:ValueTypes["GenericPageWhere"] | null,
	newsPage?:ValueTypes["NewsPageWhere"] | null,
	news?:ValueTypes["NewsWhere"] | null,
	story?:ValueTypes["StoriesWhere"] | null,
	storiesPage?:ValueTypes["StoriesPageWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["ProgramWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	ilustration?:ValueTypes["ImageWhere"] | null,
	bulletPoint?:ValueTypes["BulletPointWhere"] | null,
	showDetailLink?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["ProgramWhere"] | undefined | null)[],
	or?:(ValueTypes["ProgramWhere"] | undefined | null)[],
	not?:ValueTypes["ProgramWhere"] | null
};
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	fileName?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	noIndex?:ValueTypes["BooleanCondition"] | null,
	noFollow?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["BulletPointWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["BulletPointItemWhere"] | null,
	and?:(ValueTypes["BulletPointWhere"] | undefined | null)[],
	or?:(ValueTypes["BulletPointWhere"] | undefined | null)[],
	not?:ValueTypes["BulletPointWhere"] | null
};
	["BulletPointItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["BulletPointWhere"] | null,
	and?:(ValueTypes["BulletPointItemWhere"] | undefined | null)[],
	or?:(ValueTypes["BulletPointItemWhere"] | undefined | null)[],
	not?:ValueTypes["BulletPointItemWhere"] | null
};
	["HomePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	or?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	not?:ValueTypes["HomePageWhere"] | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["One"]:One;
	["RedirectWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	targetUrl?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	target?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	or?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	not?:ValueTypes["RedirectWhere"] | null
};
	["ProgramPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["ProgramPageWhere"] | undefined | null)[],
	or?:(ValueTypes["ProgramPageWhere"] | undefined | null)[],
	not?:ValueTypes["ProgramPageWhere"] | null
};
	["GenericPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	darujmeWidget?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["GenericPageWhere"] | undefined | null)[],
	or?:(ValueTypes["GenericPageWhere"] | undefined | null)[],
	not?:ValueTypes["GenericPageWhere"] | null
};
	["NewsPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["NewsPageWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsPageWhere"] | undefined | null)[],
	not?:ValueTypes["NewsPageWhere"] | null
};
	["NewsWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	publishDate?:ValueTypes["DateTimeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	perex?:ValueTypes["StringCondition"] | null,
	coverImage?:ValueTypes["ImageWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	isDraft?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["NewsWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsWhere"] | undefined | null)[],
	not?:ValueTypes["NewsWhere"] | null
};
	["DateTimeCondition"]: {
	and?:ValueTypes["DateTimeCondition"][],
	or?:ValueTypes["DateTimeCondition"][],
	not?:ValueTypes["DateTimeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["DateTime"] | null,
	notEq?:ValueTypes["DateTime"] | null,
	in?:ValueTypes["DateTime"][],
	notIn?:ValueTypes["DateTime"][],
	lt?:ValueTypes["DateTime"] | null,
	lte?:ValueTypes["DateTime"] | null,
	gt?:ValueTypes["DateTime"] | null,
	gte?:ValueTypes["DateTime"] | null
};
	["DateTime"]:string;
	["StoriesWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	perex?:ValueTypes["StringCondition"] | null,
	coverImage?:ValueTypes["ImageWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	list?:ValueTypes["StoriesListWhere"] | null,
	isDraft?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["StoriesWhere"] | undefined | null)[],
	or?:(ValueTypes["StoriesWhere"] | undefined | null)[],
	not?:ValueTypes["StoriesWhere"] | null
};
	["StoriesListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["StoriesWhere"] | null,
	and?:(ValueTypes["StoriesListWhere"] | undefined | null)[],
	or?:(ValueTypes["StoriesListWhere"] | undefined | null)[],
	not?:ValueTypes["StoriesListWhere"] | null
};
	["StoriesPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["StoriesPageWhere"] | undefined | null)[],
	or?:(ValueTypes["StoriesPageWhere"] | undefined | null)[],
	not?:ValueTypes["StoriesPageWhere"] | null
};
	["YoutubeVideoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	videoId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["YoutubeVideoWhere"] | undefined | null)[],
	or?:(ValueTypes["YoutubeVideoWhere"] | undefined | null)[],
	not?:ValueTypes["YoutubeVideoWhere"] | null
};
	["FileListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	reference?:ValueTypes["ContentReferenceWhere"] | null,
	items?:ValueTypes["FileItemWhere"] | null,
	and?:(ValueTypes["FileListWhere"] | undefined | null)[],
	or?:(ValueTypes["FileListWhere"] | undefined | null)[],
	not?:ValueTypes["FileListWhere"] | null
};
	["FileItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	fileType?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["FileListWhere"] | null,
	and?:(ValueTypes["FileItemWhere"] | undefined | null)[],
	or?:(ValueTypes["FileItemWhere"] | undefined | null)[],
	not?:ValueTypes["FileItemWhere"] | null
};
	["TextListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["TextItemWhere"] | null,
	and?:(ValueTypes["TextListWhere"] | undefined | null)[],
	or?:(ValueTypes["TextListWhere"] | undefined | null)[],
	not?:ValueTypes["TextListWhere"] | null
};
	["TextItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["TextListWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["TextItemWhere"] | undefined | null)[],
	or?:(ValueTypes["TextItemWhere"] | undefined | null)[],
	not?:ValueTypes["TextItemWhere"] | null
};
	["StaffListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	reference?:ValueTypes["ContentReferenceWhere"] | null,
	items?:ValueTypes["StaffItemWhere"] | null,
	and?:(ValueTypes["StaffListWhere"] | undefined | null)[],
	or?:(ValueTypes["StaffListWhere"] | undefined | null)[],
	not?:ValueTypes["StaffListWhere"] | null
};
	["StaffItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["StaffListWhere"] | null,
	staff?:ValueTypes["StaffWhere"] | null,
	and?:(ValueTypes["StaffItemWhere"] | undefined | null)[],
	or?:(ValueTypes["StaffItemWhere"] | undefined | null)[],
	not?:ValueTypes["StaffItemWhere"] | null
};
	["StaffWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	position?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	info?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["StaffWhere"] | undefined | null)[],
	or?:(ValueTypes["StaffWhere"] | undefined | null)[],
	not?:ValueTypes["StaffWhere"] | null
};
	["PrincipleListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	reference?:ValueTypes["ContentReferenceWhere"] | null,
	items?:ValueTypes["PrincipleItemWhere"] | null,
	and?:(ValueTypes["PrincipleListWhere"] | undefined | null)[],
	or?:(ValueTypes["PrincipleListWhere"] | undefined | null)[],
	not?:ValueTypes["PrincipleListWhere"] | null
};
	["PrincipleItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["PrincipleListWhere"] | null,
	icon?:ValueTypes["IconWhere"] | null,
	title?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["PrincipleItemWhere"] | undefined | null)[],
	or?:(ValueTypes["PrincipleItemWhere"] | undefined | null)[],
	not?:ValueTypes["PrincipleItemWhere"] | null
};
	["IconWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["IconWhere"] | undefined | null)[],
	or?:(ValueTypes["IconWhere"] | undefined | null)[],
	not?:ValueTypes["IconWhere"] | null
};
	["ViewCondition"]: {
	and?:ValueTypes["ViewCondition"][],
	or?:ValueTypes["ViewCondition"][],
	not?:ValueTypes["ViewCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["View"] | null,
	notEq?:ValueTypes["View"] | null,
	in?:ValueTypes["View"][],
	notIn?:ValueTypes["View"][],
	lt?:ValueTypes["View"] | null,
	lte?:ValueTypes["View"] | null,
	gt?:ValueTypes["View"] | null,
	gte?:ValueTypes["View"] | null
};
	["View"]:View;
	["AligningCondition"]: {
	and?:ValueTypes["AligningCondition"][],
	or?:ValueTypes["AligningCondition"][],
	not?:ValueTypes["AligningCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["Aligning"] | null,
	notEq?:ValueTypes["Aligning"] | null,
	in?:ValueTypes["Aligning"][],
	notIn?:ValueTypes["Aligning"][],
	lt?:ValueTypes["Aligning"] | null,
	lte?:ValueTypes["Aligning"] | null,
	gt?:ValueTypes["Aligning"] | null,
	gte?:ValueTypes["Aligning"] | null
};
	["Aligning"]:Aligning;
	["ContentImageLinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	items?:ValueTypes["ContentImageLinkItemWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["ContentImageLinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentImageLinkListWhere"] | undefined | null)[],
	not?:ValueTypes["ContentImageLinkListWhere"] | null
};
	["ContentImageLinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ContentImageLinkListWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["ContentImageLinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentImageLinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["ContentImageLinkItemWhere"] | null
};
	["CitationListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["CitationItemWhere"] | null,
	and?:(ValueTypes["CitationListWhere"] | undefined | null)[],
	or?:(ValueTypes["CitationListWhere"] | undefined | null)[],
	not?:ValueTypes["CitationListWhere"] | null
};
	["CitationItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["CitationListWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["CitationItemWhere"] | undefined | null)[],
	or?:(ValueTypes["CitationItemWhere"] | undefined | null)[],
	not?:ValueTypes["CitationItemWhere"] | null
};
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:true,
	type?:true,
block?: [{	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
youtubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideo"]],
	primaryText?:true,
	secondaryText?:true,
fileList?: [{	filter?:ValueTypes["FileListWhere"] | null},ValueTypes["FileList"]],
textList?: [{	filter?:ValueTypes["TextListWhere"] | null},ValueTypes["TextList"]],
staffList?: [{	filter?:ValueTypes["StaffListWhere"] | null},ValueTypes["StaffList"]],
principleList?: [{	filter?:ValueTypes["PrincipleListWhere"] | null},ValueTypes["PrincipleList"]],
	view?:true,
	aligning?:true,
	numbered?:true,
	tertiaryText?:true,
imageLinkList?: [{	filter?:ValueTypes["ContentImageLinkListWhere"] | null},ValueTypes["ContentImageLinkList"]],
citationList?: [{	filter?:ValueTypes["CitationListWhere"] | null},ValueTypes["CitationList"]],
storiesList?: [{	filter?:ValueTypes["StoriesListWhere"] | null},ValueTypes["StoriesList"]],
		__typename?: true
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	youtubeVideo?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	fileList?:ValueTypes["FieldMeta"],
	textList?:ValueTypes["FieldMeta"],
	staffList?:ValueTypes["FieldMeta"],
	principleList?:ValueTypes["FieldMeta"],
	view?:ValueTypes["FieldMeta"],
	aligning?:ValueTypes["FieldMeta"],
	numbered?:ValueTypes["FieldMeta"],
	tertiaryText?:ValueTypes["FieldMeta"],
	imageLinkList?:ValueTypes["FieldMeta"],
	citationList?:ValueTypes["FieldMeta"],
	storiesList?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:true,
	type?:true,
	title?:true,
	externalLink?:true,
internalLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	isTargetBlank?:true,
		__typename?: true
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
	isTargetBlank?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:true,
	url?:true,
program?: [{	filter?:ValueTypes["ProgramWhere"] | null},ValueTypes["Program"]],
homePage?: [{	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
redirect?: [{	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
programPage?: [{	filter?:ValueTypes["ProgramPageWhere"] | null},ValueTypes["ProgramPage"]],
genericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
newsPage?: [{	filter?:ValueTypes["NewsPageWhere"] | null},ValueTypes["NewsPage"]],
news?: [{	filter?:ValueTypes["NewsWhere"] | null},ValueTypes["News"]],
story?: [{	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["Stories"]],
storiesPage?: [{	filter?:ValueTypes["StoriesPageWhere"] | null},ValueTypes["StoriesPage"]],
		__typename?: true
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	program?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
	programPage?:ValueTypes["FieldMeta"],
	genericPage?:ValueTypes["FieldMeta"],
	newsPage?:ValueTypes["FieldMeta"],
	news?:ValueTypes["FieldMeta"],
	story?:ValueTypes["FieldMeta"],
	storiesPage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Program"]: AliasType<{
	_meta?:ValueTypes["ProgramMeta"],
	id?:true,
	order?:true,
	name?:true,
	title?:true,
	leadParagraph?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
ilustration?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
bulletPoint?: [{	filter?:ValueTypes["BulletPointWhere"] | null},ValueTypes["BulletPoint"]],
	showDetailLink?:true,
		__typename?: true
}>;
	["ProgramMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	ilustration?:ValueTypes["FieldMeta"],
	bulletPoint?:ValueTypes["FieldMeta"],
	showDetailLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:true,
	url?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	alt?:true,
	fileName?:true,
		__typename?: true
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
	fileName?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:true,
	title?:true,
	description?:true,
	ogTitle?:true,
	ogDescription?:true,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	noIndex?:true,
	noFollow?:true,
		__typename?: true
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
	noIndex?:ValueTypes["FieldMeta"],
	noFollow?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BulletPoint"]: AliasType<{
	_meta?:ValueTypes["BulletPointMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["BulletPointItemWhere"] | null,	orderBy?:ValueTypes["BulletPointItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BulletPointItem"]],
paginateItems?: [{	filter?:ValueTypes["BulletPointItemWhere"] | null,	orderBy?:ValueTypes["BulletPointItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BulletPointItemConnection"]],
		__typename?: true
}>;
	["BulletPointMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BulletPointItem"]: AliasType<{
	_meta?:ValueTypes["BulletPointItemMeta"],
	id?:true,
	order?:true,
	text?:true,
list?: [{	filter?:ValueTypes["BulletPointWhere"] | null},ValueTypes["BulletPoint"]],
		__typename?: true
}>;
	["BulletPointItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BulletPointItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["BulletPointOrderBy"] | null
};
	["OrderDirection"]:OrderDirection;
	["BulletPointOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["BulletPointItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BulletPointItemEdge"],
		__typename?: true
}>;
	["PageInfo"]: AliasType<{
	totalCount?:true,
		__typename?: true
}>;
	["BulletPointItemEdge"]: AliasType<{
	node?:ValueTypes["BulletPointItem"],
		__typename?: true
}>;
	["HomePage"]: AliasType<{
	_meta?:ValueTypes["HomePageMeta"],
	id?:true,
	unique?:true,
	leadParagraph?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["HomePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:true,
	targetUrl?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
target?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	targetUrl?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProgramPage"]: AliasType<{
	_meta?:ValueTypes["ProgramPageMeta"],
	id?:true,
	unique?:true,
	leadParagraph?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["ProgramPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GenericPage"]: AliasType<{
	_meta?:ValueTypes["GenericPageMeta"],
	id?:true,
	name?:true,
	leadParagraph?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	darujmeWidget?:true,
		__typename?: true
}>;
	["GenericPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	darujmeWidget?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["NewsPage"]: AliasType<{
	_meta?:ValueTypes["NewsPageMeta"],
	id?:true,
	unique?:true,
	leadParagraph?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["NewsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["News"]: AliasType<{
	_meta?:ValueTypes["NewsMeta"],
	id?:true,
	publishDate?:true,
	title?:true,
	perex?:true,
coverImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	order?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	isDraft?:true,
		__typename?: true
}>;
	["NewsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	publishDate?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	perex?:ValueTypes["FieldMeta"],
	coverImage?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	isDraft?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Stories"]: AliasType<{
	_meta?:ValueTypes["StoriesMeta"],
	id?:true,
	title?:true,
	perex?:true,
coverImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	order?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
list?: [{	filter?:ValueTypes["StoriesListWhere"] | null},ValueTypes["StoriesList"]],
	isDraft?:true,
		__typename?: true
}>;
	["StoriesMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	perex?:ValueTypes["FieldMeta"],
	coverImage?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	isDraft?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["StoriesList"]: AliasType<{
	_meta?:ValueTypes["StoriesListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["StoriesWhere"] | null,	orderBy?:ValueTypes["StoriesOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Stories"]],
itemsByContent?: [{	by:ValueTypes["StoriesListItemsByContentUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["Stories"]],
itemsBySeo?: [{	by:ValueTypes["StoriesListItemsBySeoUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["Stories"]],
itemsByLink?: [{	by:ValueTypes["StoriesListItemsByLinkUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["Stories"]],
paginateItems?: [{	filter?:ValueTypes["StoriesWhere"] | null,	orderBy?:ValueTypes["StoriesOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StoriesConnection"]],
		__typename?: true
}>;
	["StoriesListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["StoriesOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	perex?:ValueTypes["OrderDirection"] | null,
	coverImage?:ValueTypes["ImageOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	list?:ValueTypes["StoriesListOrderBy"] | null,
	isDraft?:ValueTypes["OrderDirection"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null,
	fileName?:ValueTypes["OrderDirection"] | null
};
	["ContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null,
	noIndex?:ValueTypes["OrderDirection"] | null,
	noFollow?:ValueTypes["OrderDirection"] | null
};
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	program?:ValueTypes["ProgramOrderBy"] | null,
	homePage?:ValueTypes["HomePageOrderBy"] | null,
	redirect?:ValueTypes["RedirectOrderBy"] | null,
	programPage?:ValueTypes["ProgramPageOrderBy"] | null,
	genericPage?:ValueTypes["GenericPageOrderBy"] | null,
	newsPage?:ValueTypes["NewsPageOrderBy"] | null,
	news?:ValueTypes["NewsOrderBy"] | null,
	story?:ValueTypes["StoriesOrderBy"] | null,
	storiesPage?:ValueTypes["StoriesPageOrderBy"] | null
};
	["ProgramOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	ilustration?:ValueTypes["ImageOrderBy"] | null,
	bulletPoint?:ValueTypes["BulletPointOrderBy"] | null,
	showDetailLink?:ValueTypes["OrderDirection"] | null
};
	["HomePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null
};
	["RedirectOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	targetUrl?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	target?:ValueTypes["LinkableOrderBy"] | null
};
	["ProgramPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["GenericPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	darujmeWidget?:ValueTypes["OrderDirection"] | null
};
	["NewsPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["NewsOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	publishDate?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	perex?:ValueTypes["OrderDirection"] | null,
	coverImage?:ValueTypes["ImageOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	isDraft?:ValueTypes["OrderDirection"] | null
};
	["StoriesPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["StoriesListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["StoriesListItemsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["ContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null,
	fileList?:ValueTypes["FileListUniqueWhere"] | null,
	textList?:ValueTypes["TextListUniqueWhere"] | null,
	staffList?:ValueTypes["StaffListUniqueWhere"] | null,
	principleList?:ValueTypes["PrincipleListUniqueWhere"] | null,
	imageLinkList?:ValueTypes["ContentImageLinkListUniqueWhere"] | null,
	citationList?:ValueTypes["CitationListUniqueWhere"] | null,
	storiesList?:ValueTypes["StoriesListUniqueWhere"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FileListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	items?:ValueTypes["FileItemUniqueWhere"] | null
};
	["FileItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["TextListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["TextItemUniqueWhere"] | null
};
	["TextItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["StaffListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	items?:ValueTypes["StaffItemUniqueWhere"] | null
};
	["StaffItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["PrincipleListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	items?:ValueTypes["PrincipleItemUniqueWhere"] | null
};
	["PrincipleItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentImageLinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ContentImageLinkItemUniqueWhere"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentImageLinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["CitationListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["CitationItemUniqueWhere"] | null
};
	["CitationItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["StoriesListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["StoriesUniqueWhere"] | null
};
	["StoriesUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["ProgramUniqueWhere"] | null,
	homePage?:ValueTypes["HomePageUniqueWhere"] | null,
	redirect?:ValueTypes["RedirectUniqueWhere"] | null,
	programPage?:ValueTypes["ProgramPageUniqueWhere"] | null,
	genericPage?:ValueTypes["GenericPageUniqueWhere"] | null,
	newsPage?:ValueTypes["NewsPageUniqueWhere"] | null,
	news?:ValueTypes["NewsUniqueWhere"] | null,
	story?:ValueTypes["StoriesUniqueWhere"] | null,
	storiesPage?:ValueTypes["StoriesPageUniqueWhere"] | null
};
	["ProgramUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	ilustration?:ValueTypes["ImageUniqueWhere"] | null,
	bulletPoint?:ValueTypes["BulletPointUniqueWhere"] | null
};
	["BulletPointUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["BulletPointItemUniqueWhere"] | null
};
	["BulletPointItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["HomePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null
};
	["RedirectUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["ProgramPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["GenericPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["NewsPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["NewsUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["StoriesPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["StoriesListItemsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["StoriesListItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["StoriesConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StoriesEdge"],
		__typename?: true
}>;
	["StoriesEdge"]: AliasType<{
	node?:ValueTypes["Stories"],
		__typename?: true
}>;
	["StoriesPage"]: AliasType<{
	_meta?:ValueTypes["StoriesPageMeta"],
	id?:true,
	unique?:true,
	leadParagraph?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["StoriesPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["YoutubeVideo"]: AliasType<{
	_meta?:ValueTypes["YoutubeVideoMeta"],
	id?:true,
	videoId?:true,
		__typename?: true
}>;
	["YoutubeVideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	videoId?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FileList"]: AliasType<{
	_meta?:ValueTypes["FileListMeta"],
	id?:true,
reference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
items?: [{	filter?:ValueTypes["FileItemWhere"] | null,	orderBy?:ValueTypes["FileItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileItem"]],
paginateItems?: [{	filter?:ValueTypes["FileItemWhere"] | null,	orderBy?:ValueTypes["FileItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileItemConnection"]],
		__typename?: true
}>;
	["FileListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	reference?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FileItem"]: AliasType<{
	_meta?:ValueTypes["FileItemMeta"],
	id?:true,
	order?:true,
	name?:true,
	url?:true,
	fileType?:true,
list?: [{	filter?:ValueTypes["FileListWhere"] | null},ValueTypes["FileList"]],
		__typename?: true
}>;
	["FileItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	fileType?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FileItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	fileType?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["FileListOrderBy"] | null
};
	["FileListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	reference?:ValueTypes["ContentReferenceOrderBy"] | null
};
	["ContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	block?:ValueTypes["ContentBlockOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	youtubeVideo?:ValueTypes["YoutubeVideoOrderBy"] | null,
	primaryText?:ValueTypes["OrderDirection"] | null,
	secondaryText?:ValueTypes["OrderDirection"] | null,
	fileList?:ValueTypes["FileListOrderBy"] | null,
	textList?:ValueTypes["TextListOrderBy"] | null,
	staffList?:ValueTypes["StaffListOrderBy"] | null,
	principleList?:ValueTypes["PrincipleListOrderBy"] | null,
	view?:ValueTypes["OrderDirection"] | null,
	aligning?:ValueTypes["OrderDirection"] | null,
	numbered?:ValueTypes["OrderDirection"] | null,
	tertiaryText?:ValueTypes["OrderDirection"] | null,
	imageLinkList?:ValueTypes["ContentImageLinkListOrderBy"] | null,
	citationList?:ValueTypes["CitationListOrderBy"] | null,
	storiesList?:ValueTypes["StoriesListOrderBy"] | null
};
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	internalLink?:ValueTypes["LinkableOrderBy"] | null,
	isTargetBlank?:ValueTypes["OrderDirection"] | null
};
	["YoutubeVideoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	videoId?:ValueTypes["OrderDirection"] | null
};
	["TextListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["StaffListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	reference?:ValueTypes["ContentReferenceOrderBy"] | null
};
	["PrincipleListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	reference?:ValueTypes["ContentReferenceOrderBy"] | null
};
	["ContentImageLinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["CitationListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["FileItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FileItemEdge"],
		__typename?: true
}>;
	["FileItemEdge"]: AliasType<{
	node?:ValueTypes["FileItem"],
		__typename?: true
}>;
	["TextList"]: AliasType<{
	_meta?:ValueTypes["TextListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["TextItemWhere"] | null,	orderBy?:ValueTypes["TextItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextItem"]],
itemsByLink?: [{	by:ValueTypes["TextListItemsByLinkUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null},ValueTypes["TextItem"]],
paginateItems?: [{	filter?:ValueTypes["TextItemWhere"] | null,	orderBy?:ValueTypes["TextItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextItemConnection"]],
		__typename?: true
}>;
	["TextListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TextItem"]: AliasType<{
	_meta?:ValueTypes["TextItemMeta"],
	id?:true,
	order?:true,
	title?:true,
	text?:true,
list?: [{	filter?:ValueTypes["TextListWhere"] | null},ValueTypes["TextList"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["TextItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TextItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["TextListOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["TextListItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["TextItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextItemEdge"],
		__typename?: true
}>;
	["TextItemEdge"]: AliasType<{
	node?:ValueTypes["TextItem"],
		__typename?: true
}>;
	["StaffList"]: AliasType<{
	_meta?:ValueTypes["StaffListMeta"],
	id?:true,
reference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
items?: [{	filter?:ValueTypes["StaffItemWhere"] | null,	orderBy?:ValueTypes["StaffItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StaffItem"]],
paginateItems?: [{	filter?:ValueTypes["StaffItemWhere"] | null,	orderBy?:ValueTypes["StaffItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StaffItemConnection"]],
		__typename?: true
}>;
	["StaffListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	reference?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["StaffItem"]: AliasType<{
	_meta?:ValueTypes["StaffItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["StaffListWhere"] | null},ValueTypes["StaffList"]],
staff?: [{	filter?:ValueTypes["StaffWhere"] | null},ValueTypes["Staff"]],
		__typename?: true
}>;
	["StaffItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Staff"]: AliasType<{
	_meta?:ValueTypes["StaffMeta"],
	id?:true,
	name?:true,
	position?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	order?:true,
	info?:true,
		__typename?: true
}>;
	["StaffMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	info?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["StaffItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["StaffListOrderBy"] | null,
	staff?:ValueTypes["StaffOrderBy"] | null
};
	["StaffOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	position?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	info?:ValueTypes["OrderDirection"] | null
};
	["StaffItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StaffItemEdge"],
		__typename?: true
}>;
	["StaffItemEdge"]: AliasType<{
	node?:ValueTypes["StaffItem"],
		__typename?: true
}>;
	["PrincipleList"]: AliasType<{
	_meta?:ValueTypes["PrincipleListMeta"],
	id?:true,
reference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
items?: [{	filter?:ValueTypes["PrincipleItemWhere"] | null,	orderBy?:ValueTypes["PrincipleItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrincipleItem"]],
paginateItems?: [{	filter?:ValueTypes["PrincipleItemWhere"] | null,	orderBy?:ValueTypes["PrincipleItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrincipleItemConnection"]],
		__typename?: true
}>;
	["PrincipleListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	reference?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PrincipleItem"]: AliasType<{
	_meta?:ValueTypes["PrincipleItemMeta"],
	id?:true,
	order?:true,
	text?:true,
list?: [{	filter?:ValueTypes["PrincipleListWhere"] | null},ValueTypes["PrincipleList"]],
icon?: [{	filter?:ValueTypes["IconWhere"] | null},ValueTypes["Icon"]],
	title?:true,
		__typename?: true
}>;
	["PrincipleItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Icon"]: AliasType<{
	_meta?:ValueTypes["IconMeta"],
	id?:true,
	order?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["IconMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PrincipleItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["PrincipleListOrderBy"] | null,
	icon?:ValueTypes["IconOrderBy"] | null,
	title?:ValueTypes["OrderDirection"] | null
};
	["IconOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["PrincipleItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PrincipleItemEdge"],
		__typename?: true
}>;
	["PrincipleItemEdge"]: AliasType<{
	node?:ValueTypes["PrincipleItem"],
		__typename?: true
}>;
	["ContentImageLinkList"]: AliasType<{
	_meta?:ValueTypes["ContentImageLinkListMeta"],
	id?:true,
	title?:true,
items?: [{	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentImageLinkItem"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
itemsByImage?: [{	by:ValueTypes["ContentImageLinkListItemsByImageUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null},ValueTypes["ContentImageLinkItem"]],
itemsByLink?: [{	by:ValueTypes["ContentImageLinkListItemsByLinkUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null},ValueTypes["ContentImageLinkItem"]],
paginateItems?: [{	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentImageLinkItemConnection"]],
		__typename?: true
}>;
	["ContentImageLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentImageLinkItem"]: AliasType<{
	_meta?:ValueTypes["ContentImageLinkItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ContentImageLinkListWhere"] | null},ValueTypes["ContentImageLinkList"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["ContentImageLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentImageLinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ContentImageLinkListOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["ContentImageLinkListItemsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ContentImageLinkListItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentImageLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentImageLinkItemEdge"],
		__typename?: true
}>;
	["ContentImageLinkItemEdge"]: AliasType<{
	node?:ValueTypes["ContentImageLinkItem"],
		__typename?: true
}>;
	["CitationList"]: AliasType<{
	_meta?:ValueTypes["CitationListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["CitationItemWhere"] | null,	orderBy?:ValueTypes["CitationItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CitationItem"]],
paginateItems?: [{	filter?:ValueTypes["CitationItemWhere"] | null,	orderBy?:ValueTypes["CitationItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CitationItemConnection"]],
		__typename?: true
}>;
	["CitationListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["CitationItem"]: AliasType<{
	_meta?:ValueTypes["CitationItemMeta"],
	id?:true,
	title?:true,
	text?:true,
list?: [{	filter?:ValueTypes["CitationListWhere"] | null},ValueTypes["CitationList"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	order?:true,
		__typename?: true
}>;
	["CitationItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["CitationItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["CitationListOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["CitationItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CitationItemEdge"],
		__typename?: true
}>;
	["CitationItemEdge"]: AliasType<{
	node?:ValueTypes["CitationItem"],
		__typename?: true
}>;
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentBlockReferencesByFileListUniqueWhere"]: {
	fileList?:ValueTypes["FileListUniqueWhere"] | null
};
	["ContentBlockReferencesByTextListUniqueWhere"]: {
	textList?:ValueTypes["TextListUniqueWhere"] | null
};
	["ContentBlockReferencesByStaffListUniqueWhere"]: {
	staffList?:ValueTypes["StaffListUniqueWhere"] | null
};
	["ContentBlockReferencesByPrincipleListUniqueWhere"]: {
	principleList?:ValueTypes["PrincipleListUniqueWhere"] | null
};
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: {
	imageLinkList?:ValueTypes["ContentImageLinkListUniqueWhere"] | null
};
	["ContentBlockReferencesByCitationListUniqueWhere"]: {
	citationList?:ValueTypes["CitationListUniqueWhere"] | null
};
	["ContentBlockReferencesByStoriesListUniqueWhere"]: {
	storiesList?:ValueTypes["StoriesListUniqueWhere"] | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: true
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: true
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: true
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["_ValidationResult"]: AliasType<{
	valid?:true,
	errors?:ValueTypes["_ValidationError"],
		__typename?: true
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: true
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: true
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:true,
		__typename?: true
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:true,
	alias?:true,
		__typename?: true
}>;
	["_ValidationMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["ContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceCreateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceCreateStaffListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceCreatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceCreateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceCreateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | null,
	isTargetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateProgramEntityRelationInput"]: {
	connect?:ValueTypes["ProgramUniqueWhere"] | null,
	create?:ValueTypes["ProgramWithoutLinkCreateInput"] | null
};
	["ProgramWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	title?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["ProgramCreateImageEntityRelationInput"] | null,
	content?:ValueTypes["ProgramCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ProgramCreateSeoEntityRelationInput"] | null,
	ilustration?:ValueTypes["ProgramCreateIlustrationEntityRelationInput"] | null,
	bulletPoint?:ValueTypes["ProgramCreateBulletPointEntityRelationInput"] | null,
	showDetailLink?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ProgramCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	fileName?:string | null,
	_dummy_field_?:boolean | null
};
	["ProgramCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ProgramCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ProgramCreateIlustrationEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ProgramCreateBulletPointEntityRelationInput"]: {
	connect?:ValueTypes["BulletPointUniqueWhere"] | null,
	create?:ValueTypes["BulletPointCreateInput"] | null
};
	["BulletPointCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["BulletPointCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BulletPointCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["BulletPointItemUniqueWhere"] | null,
	create?:ValueTypes["BulletPointItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["BulletPointItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null
};
	["HomePageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	content?:ValueTypes["HomePageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	logo?:ValueTypes["HomePageCreateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["HomePageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HomePageCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["RedirectWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	targetUrl?:string | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateProgramPageEntityRelationInput"]: {
	connect?:ValueTypes["ProgramPageUniqueWhere"] | null,
	create?:ValueTypes["ProgramPageWithoutLinkCreateInput"] | null
};
	["ProgramPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["ProgramPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	create?:ValueTypes["GenericPageWithoutLinkCreateInput"] | null
};
	["GenericPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["GenericPageCreateImageEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["GenericPageCreateSeoEntityRelationInput"] | null,
	darujmeWidget?:boolean | null,
	_dummy_field_?:boolean | null
};
	["GenericPageCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["GenericPageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["GenericPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateNewsPageEntityRelationInput"]: {
	connect?:ValueTypes["NewsPageUniqueWhere"] | null,
	create?:ValueTypes["NewsPageWithoutLinkCreateInput"] | null
};
	["NewsPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["NewsPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateNewsEntityRelationInput"]: {
	connect?:ValueTypes["NewsUniqueWhere"] | null,
	create?:ValueTypes["NewsWithoutLinkCreateInput"] | null
};
	["NewsWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	publishDate?:ValueTypes["DateTime"] | null,
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["NewsCreateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["NewsCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["NewsCreateSeoEntityRelationInput"] | null,
	order?:number | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["NewsCreateCoverImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["NewsCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["NewsCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateStoryEntityRelationInput"]: {
	connect?:ValueTypes["StoriesUniqueWhere"] | null,
	create?:ValueTypes["StoriesWithoutLinkCreateInput"] | null
};
	["StoriesWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["StoriesCreateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["StoriesCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesCreateSeoEntityRelationInput"] | null,
	order?:number | null,
	list?:ValueTypes["StoriesCreateListEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["StoriesCreateCoverImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["StoriesCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["StoriesCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["StoriesCreateListEntityRelationInput"]: {
	connect?:ValueTypes["StoriesListUniqueWhere"] | null,
	create?:ValueTypes["StoriesListWithoutItemsCreateInput"] | null
};
	["StoriesListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateStoriesPageEntityRelationInput"]: {
	connect?:ValueTypes["StoriesPageUniqueWhere"] | null,
	create?:ValueTypes["StoriesPageWithoutLinkCreateInput"] | null
};
	["StoriesPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["StoriesPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StoriesPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateYoutubeVideoEntityRelationInput"]: {
	connect?:ValueTypes["YoutubeVideoUniqueWhere"] | null,
	create?:ValueTypes["YoutubeVideoCreateInput"] | null
};
	["YoutubeVideoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["YoutubeVideoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	videoId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateFileListEntityRelationInput"]: {
	connect?:ValueTypes["FileListUniqueWhere"] | null,
	create?:ValueTypes["FileListWithoutReferenceCreateInput"] | null
};
	["FileListWithoutReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["FileListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FileListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["FileItemUniqueWhere"] | null,
	create?:ValueTypes["FileItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["FileItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	url?:string | null,
	fileType?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
	connect?:ValueTypes["TextListUniqueWhere"] | null,
	create?:ValueTypes["TextListCreateInput"] | null
};
	["TextListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["TextListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["TextItemUniqueWhere"] | null,
	create?:ValueTypes["TextItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["TextItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	text?:string | null,
	link?:ValueTypes["TextItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceCreateStaffListEntityRelationInput"]: {
	connect?:ValueTypes["StaffListUniqueWhere"] | null,
	create?:ValueTypes["StaffListWithoutReferenceCreateInput"] | null
};
	["StaffListWithoutReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["StaffListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["StaffListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["StaffItemUniqueWhere"] | null,
	create?:ValueTypes["StaffItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["StaffItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	staff?:ValueTypes["StaffItemCreateStaffEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffItemCreateStaffEntityRelationInput"]: {
	connect?:ValueTypes["StaffUniqueWhere"] | null,
	create?:ValueTypes["StaffCreateInput"] | null
};
	["StaffUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["StaffCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	position?:string | null,
	image?:ValueTypes["StaffCreateImageEntityRelationInput"] | null,
	order?:number | null,
	info?:string | null,
	_dummy_field_?:boolean | null
};
	["StaffCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreatePrincipleListEntityRelationInput"]: {
	connect?:ValueTypes["PrincipleListUniqueWhere"] | null,
	create?:ValueTypes["PrincipleListWithoutReferenceCreateInput"] | null
};
	["PrincipleListWithoutReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["PrincipleListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PrincipleListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["PrincipleItemUniqueWhere"] | null,
	create?:ValueTypes["PrincipleItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["PrincipleItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	icon?:ValueTypes["PrincipleItemCreateIconEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["PrincipleItemCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["IconUniqueWhere"] | null,
	create?:ValueTypes["IconCreateInput"] | null
};
	["IconUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["IconCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["IconCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["IconCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: {
	connect?:ValueTypes["ContentImageLinkListUniqueWhere"] | null,
	create?:ValueTypes["ContentImageLinkListCreateInput"] | null
};
	["ContentImageLinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	items?:ValueTypes["ContentImageLinkListCreateItemsEntityRelationInput"][],
	link?:ValueTypes["ContentImageLinkListCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ContentImageLinkItemUniqueWhere"] | null,
	create?:ValueTypes["ContentImageLinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ContentImageLinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["ContentImageLinkItemCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentImageLinkItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentImageLinkItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentImageLinkListCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceCreateCitationListEntityRelationInput"]: {
	connect?:ValueTypes["CitationListUniqueWhere"] | null,
	create?:ValueTypes["CitationListCreateInput"] | null
};
	["CitationListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["CitationListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CitationListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["CitationItemUniqueWhere"] | null,
	create?:ValueTypes["CitationItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["CitationItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	image?:ValueTypes["CitationItemCreateImageEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["CitationItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateStoriesListEntityRelationInput"]: {
	connect?:ValueTypes["StoriesListUniqueWhere"] | null,
	create?:ValueTypes["StoriesListCreateInput"] | null
};
	["StoriesListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["StoriesListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["StoriesListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["StoriesUniqueWhere"] | null,
	create?:ValueTypes["StoriesWithoutListCreateInput"] | null,
	alias?:string | null
};
	["StoriesWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["StoriesCreateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["StoriesCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesCreateSeoEntityRelationInput"] | null,
	order?:number | null,
	link?:ValueTypes["StoriesCreateLinkEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["StoriesCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutStoryCreateInput"] | null
};
	["LinkableWithoutStoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentUpdateInput"]: {
	blocks?:ValueTypes["ContentUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["ContentUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	update?:ValueTypes["ContentBlockUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceUpdateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceUpdateStaffListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceUpdateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceUpdateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | null,
	isTargetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateProgramEntityRelationInput"]: {
	create?:ValueTypes["ProgramWithoutLinkCreateInput"] | null,
	update?:ValueTypes["ProgramWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertProgramRelationInput"] | null,
	connect?:ValueTypes["ProgramUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProgramWithoutLinkUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	title?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["ProgramUpdateImageEntityRelationInput"] | null,
	content?:ValueTypes["ProgramUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ProgramUpdateSeoEntityRelationInput"] | null,
	ilustration?:ValueTypes["ProgramUpdateIlustrationEntityRelationInput"] | null,
	bulletPoint?:ValueTypes["ProgramUpdateBulletPointEntityRelationInput"] | null,
	showDetailLink?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ProgramUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ProgramUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	fileName?:string | null,
	_dummy_field_?:boolean | null
};
	["ProgramUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ProgramUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ProgramUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProgramUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ProgramUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ProgramUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ProgramUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ProgramUpdateIlustrationEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ProgramUpsertIlustrationRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProgramUpsertIlustrationRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ProgramUpdateBulletPointEntityRelationInput"]: {
	create?:ValueTypes["BulletPointCreateInput"] | null,
	update?:ValueTypes["BulletPointUpdateInput"] | null,
	upsert?:ValueTypes["ProgramUpsertBulletPointRelationInput"] | null,
	connect?:ValueTypes["BulletPointUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BulletPointUpdateInput"]: {
	items?:ValueTypes["BulletPointUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BulletPointUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["BulletPointItemWithoutListCreateInput"] | null,
	update?:ValueTypes["BulletPointUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["BulletPointUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["BulletPointItemUniqueWhere"] | null,
	disconnect?:ValueTypes["BulletPointItemUniqueWhere"] | null,
	delete?:ValueTypes["BulletPointItemUniqueWhere"] | null,
	alias?:string | null
};
	["BulletPointUpdateItemsRelationInput"]: {
	by?:ValueTypes["BulletPointItemUniqueWhere"] | null,
	data?:ValueTypes["BulletPointItemWithoutListUpdateInput"] | null
};
	["BulletPointItemWithoutListUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["BulletPointUpsertItemsRelationInput"]: {
	by?:ValueTypes["BulletPointItemUniqueWhere"] | null,
	update?:ValueTypes["BulletPointItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["BulletPointItemWithoutListCreateInput"] | null
};
	["ProgramUpsertBulletPointRelationInput"]: {
	update?:ValueTypes["BulletPointUpdateInput"] | null,
	create?:ValueTypes["BulletPointCreateInput"] | null
};
	["LinkableUpsertProgramRelationInput"]: {
	update?:ValueTypes["ProgramWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["ProgramWithoutLinkCreateInput"] | null
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["HomePageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertHomePageRelationInput"] | null,
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	content?:ValueTypes["HomePageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	logo?:ValueTypes["HomePageUpdateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["HomePageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HomePageUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LinkableUpsertHomePageRelationInput"]: {
	update?:ValueTypes["HomePageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null,
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertRedirectRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectWithoutLinkUpdateInput"]: {
	targetUrl?:string | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableUpsertRedirectRelationInput"]: {
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["LinkableUpdateProgramPageEntityRelationInput"]: {
	create?:ValueTypes["ProgramPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["ProgramPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertProgramPageRelationInput"] | null,
	connect?:ValueTypes["ProgramPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProgramPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["ProgramPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ProgramPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProgramPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertProgramPageRelationInput"]: {
	update?:ValueTypes["ProgramPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["ProgramPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	create?:ValueTypes["GenericPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["GenericPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertGenericPageRelationInput"] | null,
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageWithoutLinkUpdateInput"]: {
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["GenericPageUpdateImageEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["GenericPageUpdateSeoEntityRelationInput"] | null,
	darujmeWidget?:boolean | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["GenericPageUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["GenericPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update?:ValueTypes["GenericPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["GenericPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateNewsPageEntityRelationInput"]: {
	create?:ValueTypes["NewsPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["NewsPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertNewsPageRelationInput"] | null,
	connect?:ValueTypes["NewsPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["NewsPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["NewsPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertNewsPageRelationInput"]: {
	update?:ValueTypes["NewsPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["NewsPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateNewsEntityRelationInput"]: {
	create?:ValueTypes["NewsWithoutLinkCreateInput"] | null,
	update?:ValueTypes["NewsWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertNewsRelationInput"] | null,
	connect?:ValueTypes["NewsUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsWithoutLinkUpdateInput"]: {
	publishDate?:ValueTypes["DateTime"] | null,
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["NewsUpdateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["NewsUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["NewsUpdateSeoEntityRelationInput"] | null,
	order?:number | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["NewsUpdateCoverImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["NewsUpsertCoverImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsUpsertCoverImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["NewsUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["NewsUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["NewsUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["NewsUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertNewsRelationInput"]: {
	update?:ValueTypes["NewsWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["NewsWithoutLinkCreateInput"] | null
};
	["LinkableUpdateStoryEntityRelationInput"]: {
	create?:ValueTypes["StoriesWithoutLinkCreateInput"] | null,
	update?:ValueTypes["StoriesWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertStoryRelationInput"] | null,
	connect?:ValueTypes["StoriesUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesWithoutLinkUpdateInput"]: {
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["StoriesUpdateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["StoriesUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesUpdateSeoEntityRelationInput"] | null,
	order?:number | null,
	list?:ValueTypes["StoriesUpdateListEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["StoriesUpdateCoverImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["StoriesUpsertCoverImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesUpsertCoverImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["StoriesUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["StoriesUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["StoriesUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["StoriesUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["StoriesUpdateListEntityRelationInput"]: {
	create?:ValueTypes["StoriesListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["StoriesListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["StoriesUpsertListRelationInput"] | null,
	connect?:ValueTypes["StoriesListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["StoriesUpsertListRelationInput"]: {
	update?:ValueTypes["StoriesListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["StoriesListWithoutItemsCreateInput"] | null
};
	["LinkableUpsertStoryRelationInput"]: {
	update?:ValueTypes["StoriesWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["StoriesWithoutLinkCreateInput"] | null
};
	["LinkableUpdateStoriesPageEntityRelationInput"]: {
	create?:ValueTypes["StoriesPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["StoriesPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertStoriesPageRelationInput"] | null,
	connect?:ValueTypes["StoriesPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	seo?:ValueTypes["StoriesPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StoriesPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["StoriesPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertStoriesPageRelationInput"]: {
	update?:ValueTypes["StoriesPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["StoriesPageWithoutLinkCreateInput"] | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceUpdateYoutubeVideoEntityRelationInput"]: {
	create?:ValueTypes["YoutubeVideoCreateInput"] | null,
	update?:ValueTypes["YoutubeVideoUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertYoutubeVideoRelationInput"] | null,
	connect?:ValueTypes["YoutubeVideoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["YoutubeVideoUpdateInput"]: {
	videoId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertYoutubeVideoRelationInput"]: {
	update?:ValueTypes["YoutubeVideoUpdateInput"] | null,
	create?:ValueTypes["YoutubeVideoCreateInput"] | null
};
	["ContentReferenceUpdateFileListEntityRelationInput"]: {
	create?:ValueTypes["FileListWithoutReferenceCreateInput"] | null,
	update?:ValueTypes["FileListWithoutReferenceUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertFileListRelationInput"] | null,
	connect?:ValueTypes["FileListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FileListWithoutReferenceUpdateInput"]: {
	items?:ValueTypes["FileListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FileListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["FileItemWithoutListCreateInput"] | null,
	update?:ValueTypes["FileListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["FileListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["FileItemUniqueWhere"] | null,
	disconnect?:ValueTypes["FileItemUniqueWhere"] | null,
	delete?:ValueTypes["FileItemUniqueWhere"] | null,
	alias?:string | null
};
	["FileListUpdateItemsRelationInput"]: {
	by?:ValueTypes["FileItemUniqueWhere"] | null,
	data?:ValueTypes["FileItemWithoutListUpdateInput"] | null
};
	["FileItemWithoutListUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	url?:string | null,
	fileType?:string | null,
	_dummy_field_?:boolean | null
};
	["FileListUpsertItemsRelationInput"]: {
	by?:ValueTypes["FileItemUniqueWhere"] | null,
	update?:ValueTypes["FileItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["FileItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertFileListRelationInput"]: {
	update?:ValueTypes["FileListWithoutReferenceUpdateInput"] | null,
	create?:ValueTypes["FileListWithoutReferenceCreateInput"] | null
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
	create?:ValueTypes["TextListCreateInput"] | null,
	update?:ValueTypes["TextListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertTextListRelationInput"] | null,
	connect?:ValueTypes["TextListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TextListUpdateInput"]: {
	items?:ValueTypes["TextListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["TextItemWithoutListCreateInput"] | null,
	update?:ValueTypes["TextListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["TextListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["TextItemUniqueWhere"] | null,
	disconnect?:ValueTypes["TextItemUniqueWhere"] | null,
	delete?:ValueTypes["TextItemUniqueWhere"] | null,
	alias?:string | null
};
	["TextListUpdateItemsRelationInput"]: {
	by?:ValueTypes["TextItemUniqueWhere"] | null,
	data?:ValueTypes["TextItemWithoutListUpdateInput"] | null
};
	["TextItemWithoutListUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	text?:string | null,
	link?:ValueTypes["TextItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["TextItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TextItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["TextListUpsertItemsRelationInput"]: {
	by?:ValueTypes["TextItemUniqueWhere"] | null,
	update?:ValueTypes["TextItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["TextItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertTextListRelationInput"]: {
	update?:ValueTypes["TextListUpdateInput"] | null,
	create?:ValueTypes["TextListCreateInput"] | null
};
	["ContentReferenceUpdateStaffListEntityRelationInput"]: {
	create?:ValueTypes["StaffListWithoutReferenceCreateInput"] | null,
	update?:ValueTypes["StaffListWithoutReferenceUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertStaffListRelationInput"] | null,
	connect?:ValueTypes["StaffListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StaffListWithoutReferenceUpdateInput"]: {
	items?:ValueTypes["StaffListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["StaffListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["StaffItemWithoutListCreateInput"] | null,
	update?:ValueTypes["StaffListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["StaffListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["StaffItemUniqueWhere"] | null,
	disconnect?:ValueTypes["StaffItemUniqueWhere"] | null,
	delete?:ValueTypes["StaffItemUniqueWhere"] | null,
	alias?:string | null
};
	["StaffListUpdateItemsRelationInput"]: {
	by?:ValueTypes["StaffItemUniqueWhere"] | null,
	data?:ValueTypes["StaffItemWithoutListUpdateInput"] | null
};
	["StaffItemWithoutListUpdateInput"]: {
	order?:number | null,
	staff?:ValueTypes["StaffItemUpdateStaffEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffItemUpdateStaffEntityRelationInput"]: {
	create?:ValueTypes["StaffCreateInput"] | null,
	update?:ValueTypes["StaffUpdateInput"] | null,
	upsert?:ValueTypes["StaffItemUpsertStaffRelationInput"] | null,
	connect?:ValueTypes["StaffUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StaffUpdateInput"]: {
	name?:string | null,
	position?:string | null,
	image?:ValueTypes["StaffUpdateImageEntityRelationInput"] | null,
	order?:number | null,
	info?:string | null,
	_dummy_field_?:boolean | null
};
	["StaffUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["StaffUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StaffUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["StaffItemUpsertStaffRelationInput"]: {
	update?:ValueTypes["StaffUpdateInput"] | null,
	create?:ValueTypes["StaffCreateInput"] | null
};
	["StaffListUpsertItemsRelationInput"]: {
	by?:ValueTypes["StaffItemUniqueWhere"] | null,
	update?:ValueTypes["StaffItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["StaffItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertStaffListRelationInput"]: {
	update?:ValueTypes["StaffListWithoutReferenceUpdateInput"] | null,
	create?:ValueTypes["StaffListWithoutReferenceCreateInput"] | null
};
	["ContentReferenceUpdatePrincipleListEntityRelationInput"]: {
	create?:ValueTypes["PrincipleListWithoutReferenceCreateInput"] | null,
	update?:ValueTypes["PrincipleListWithoutReferenceUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertPrincipleListRelationInput"] | null,
	connect?:ValueTypes["PrincipleListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PrincipleListWithoutReferenceUpdateInput"]: {
	items?:ValueTypes["PrincipleListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PrincipleListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["PrincipleItemWithoutListCreateInput"] | null,
	update?:ValueTypes["PrincipleListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["PrincipleListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["PrincipleItemUniqueWhere"] | null,
	disconnect?:ValueTypes["PrincipleItemUniqueWhere"] | null,
	delete?:ValueTypes["PrincipleItemUniqueWhere"] | null,
	alias?:string | null
};
	["PrincipleListUpdateItemsRelationInput"]: {
	by?:ValueTypes["PrincipleItemUniqueWhere"] | null,
	data?:ValueTypes["PrincipleItemWithoutListUpdateInput"] | null
};
	["PrincipleItemWithoutListUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	icon?:ValueTypes["PrincipleItemUpdateIconEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["PrincipleItemUpdateIconEntityRelationInput"]: {
	create?:ValueTypes["IconCreateInput"] | null,
	update?:ValueTypes["IconUpdateInput"] | null,
	upsert?:ValueTypes["PrincipleItemUpsertIconRelationInput"] | null,
	connect?:ValueTypes["IconUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IconUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["IconUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["IconUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["IconUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IconUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["PrincipleItemUpsertIconRelationInput"]: {
	update?:ValueTypes["IconUpdateInput"] | null,
	create?:ValueTypes["IconCreateInput"] | null
};
	["PrincipleListUpsertItemsRelationInput"]: {
	by?:ValueTypes["PrincipleItemUniqueWhere"] | null,
	update?:ValueTypes["PrincipleItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["PrincipleItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertPrincipleListRelationInput"]: {
	update?:ValueTypes["PrincipleListWithoutReferenceUpdateInput"] | null,
	create?:ValueTypes["PrincipleListWithoutReferenceCreateInput"] | null
};
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: {
	create?:ValueTypes["ContentImageLinkListCreateInput"] | null,
	update?:ValueTypes["ContentImageLinkListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageLinkListRelationInput"] | null,
	connect?:ValueTypes["ContentImageLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentImageLinkListUpdateInput"]: {
	title?:string | null,
	items?:ValueTypes["ContentImageLinkListUpdateItemsEntityRelationInput"][],
	link?:ValueTypes["ContentImageLinkListUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ContentImageLinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ContentImageLinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ContentImageLinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ContentImageLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentImageLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["ContentImageLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["ContentImageLinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ContentImageLinkItemUniqueWhere"] | null,
	data?:ValueTypes["ContentImageLinkItemWithoutListUpdateInput"] | null
};
	["ContentImageLinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["ContentImageLinkItemUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentImageLinkItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentImageLinkItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentImageLinkItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentImageLinkItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentImageLinkItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentImageLinkItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentImageLinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ContentImageLinkItemUniqueWhere"] | null,
	update?:ValueTypes["ContentImageLinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ContentImageLinkItemWithoutListCreateInput"] | null
};
	["ContentImageLinkListUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentImageLinkListUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentImageLinkListUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpsertImageLinkListRelationInput"]: {
	update?:ValueTypes["ContentImageLinkListUpdateInput"] | null,
	create?:ValueTypes["ContentImageLinkListCreateInput"] | null
};
	["ContentReferenceUpdateCitationListEntityRelationInput"]: {
	create?:ValueTypes["CitationListCreateInput"] | null,
	update?:ValueTypes["CitationListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertCitationListRelationInput"] | null,
	connect?:ValueTypes["CitationListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CitationListUpdateInput"]: {
	items?:ValueTypes["CitationListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CitationListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["CitationItemWithoutListCreateInput"] | null,
	update?:ValueTypes["CitationListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["CitationListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["CitationItemUniqueWhere"] | null,
	disconnect?:ValueTypes["CitationItemUniqueWhere"] | null,
	delete?:ValueTypes["CitationItemUniqueWhere"] | null,
	alias?:string | null
};
	["CitationListUpdateItemsRelationInput"]: {
	by?:ValueTypes["CitationItemUniqueWhere"] | null,
	data?:ValueTypes["CitationItemWithoutListUpdateInput"] | null
};
	["CitationItemWithoutListUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	image?:ValueTypes["CitationItemUpdateImageEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["CitationItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["CitationItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CitationItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["CitationListUpsertItemsRelationInput"]: {
	by?:ValueTypes["CitationItemUniqueWhere"] | null,
	update?:ValueTypes["CitationItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["CitationItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertCitationListRelationInput"]: {
	update?:ValueTypes["CitationListUpdateInput"] | null,
	create?:ValueTypes["CitationListCreateInput"] | null
};
	["ContentReferenceUpdateStoriesListEntityRelationInput"]: {
	create?:ValueTypes["StoriesListCreateInput"] | null,
	update?:ValueTypes["StoriesListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertStoriesListRelationInput"] | null,
	connect?:ValueTypes["StoriesListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StoriesListUpdateInput"]: {
	items?:ValueTypes["StoriesListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["StoriesListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["StoriesWithoutListCreateInput"] | null,
	update?:ValueTypes["StoriesListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["StoriesListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["StoriesUniqueWhere"] | null,
	disconnect?:ValueTypes["StoriesUniqueWhere"] | null,
	delete?:ValueTypes["StoriesUniqueWhere"] | null,
	alias?:string | null
};
	["StoriesListUpdateItemsRelationInput"]: {
	by?:ValueTypes["StoriesUniqueWhere"] | null,
	data?:ValueTypes["StoriesWithoutListUpdateInput"] | null
};
	["StoriesWithoutListUpdateInput"]: {
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["StoriesUpdateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["StoriesUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesUpdateSeoEntityRelationInput"] | null,
	order?:number | null,
	link?:ValueTypes["StoriesUpdateLinkEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["StoriesUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutStoryCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutStoryUpdateInput"] | null,
	upsert?:ValueTypes["StoriesUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutStoryUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StoriesUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutStoryUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutStoryCreateInput"] | null
};
	["StoriesListUpsertItemsRelationInput"]: {
	by?:ValueTypes["StoriesUniqueWhere"] | null,
	update?:ValueTypes["StoriesWithoutListUpdateInput"] | null,
	create?:ValueTypes["StoriesWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertStoriesListRelationInput"]: {
	update?:ValueTypes["StoriesListUpdateInput"] | null,
	create?:ValueTypes["StoriesListCreateInput"] | null
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null
};
	["ContentUpsertBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null
};
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null,
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceCreateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceCreateStaffListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceCreatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceCreateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceCreateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceUpdateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceUpdateStaffListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceUpdateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceUpdateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null,
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBlockRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["FallbackSeo"]: AliasType<{
	_meta?:ValueTypes["FallbackSeoMeta"],
	id?:true,
	unique?:true,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["FallbackSeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FallbackSeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["FallbackSeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["FallbackSeoWhere"] | undefined | null)[],
	or?:(ValueTypes["FallbackSeoWhere"] | undefined | null)[],
	not?:ValueTypes["FallbackSeoWhere"] | null
};
	["FallbackSeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["FallbackSeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FallbackSeoEdge"],
		__typename?: true
}>;
	["FallbackSeoEdge"]: AliasType<{
	node?:ValueTypes["FallbackSeo"],
		__typename?: true
}>;
	["FallbackSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["FallbackSeoCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FallbackSeoCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["FallbackSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["FallbackSeoUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FallbackSeoUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["FallbackSeoUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FallbackSeoUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:true,
	unique?:true,
	copyright?:true,
logoFirst?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
logoSecond?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
linksGroups?: [{	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	orderBy?:ValueTypes["FooterLinkGroupsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLinkGroups"]],
	phone?:true,
	email?:true,
	text?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
paginateLinksGroups?: [{	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	orderBy?:ValueTypes["FooterLinkGroupsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkGroupsConnection"]],
		__typename?: true
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	copyright?:ValueTypes["FieldMeta"],
	logoFirst?:ValueTypes["FieldMeta"],
	logoSecond?:ValueTypes["FieldMeta"],
	linksGroups?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterLinkGroups"]: AliasType<{
	_meta?:ValueTypes["FooterLinkGroupsMeta"],
	id?:true,
	order?:true,
	title?:true,
links?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLink"]],
	specialIdentifier?:true,
paginateLinks?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkConnection"]],
		__typename?: true
}>;
	["FooterLinkGroupsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	specialIdentifier?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterLink"]: AliasType<{
	_meta?:ValueTypes["FooterLinkMeta"],
	id?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["FooterLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["FooterLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterLinkWhere"] | undefined | null)[],
	not?:ValueTypes["FooterLinkWhere"] | null
};
	["FooterLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["FooterLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLinkEdge"],
		__typename?: true
}>;
	["FooterLinkEdge"]: AliasType<{
	node?:ValueTypes["FooterLink"],
		__typename?: true
}>;
	["FooterLinkGroupsWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	links?:ValueTypes["FooterLinkWhere"] | null,
	specialIdentifier?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["FooterLinkGroupsWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterLinkGroupsWhere"] | undefined | null)[],
	not?:ValueTypes["FooterLinkGroupsWhere"] | null
};
	["FooterLinkGroupsOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	specialIdentifier?:ValueTypes["OrderDirection"] | null
};
	["FooterLinkGroupsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLinkGroupsEdge"],
		__typename?: true
}>;
	["FooterLinkGroupsEdge"]: AliasType<{
	node?:ValueTypes["FooterLinkGroups"],
		__typename?: true
}>;
	["FooterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logoFirst?:ValueTypes["ImageUniqueWhere"] | null,
	logoSecond?:ValueTypes["ImageUniqueWhere"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["FooterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	copyright?:ValueTypes["StringCondition"] | null,
	logoFirst?:ValueTypes["ImageWhere"] | null,
	logoSecond?:ValueTypes["ImageWhere"] | null,
	linksGroups?:ValueTypes["FooterLinkGroupsWhere"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["FooterWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterWhere"] | undefined | null)[],
	not?:ValueTypes["FooterWhere"] | null
};
	["FooterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	copyright?:ValueTypes["OrderDirection"] | null,
	logoFirst?:ValueTypes["ImageOrderBy"] | null,
	logoSecond?:ValueTypes["ImageOrderBy"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: true
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	copyright?:string | null,
	logoFirst?:ValueTypes["FooterCreateLogoFirstEntityRelationInput"] | null,
	logoSecond?:ValueTypes["FooterCreateLogoSecondEntityRelationInput"] | null,
	linksGroups?:ValueTypes["FooterCreateLinksGroupsEntityRelationInput"][],
	phone?:string | null,
	email?:string | null,
	text?:string | null,
	link?:ValueTypes["FooterCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateLogoFirstEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterCreateLogoSecondEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterCreateLinksGroupsEntityRelationInput"]: {
	connect?:ValueTypes["FooterLinkGroupsUniqueWhere"] | null,
	create?:ValueTypes["FooterLinkGroupsCreateInput"] | null,
	alias?:string | null
};
	["FooterLinkGroupsUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FooterLinkGroupsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	links?:ValueTypes["FooterLinkGroupsCreateLinksEntityRelationInput"][],
	specialIdentifier?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkGroupsCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["FooterLinkUniqueWhere"] | null,
	create?:ValueTypes["FooterLinkCreateInput"] | null,
	alias?:string | null
};
	["FooterLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["FooterLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["FooterLinkCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	copyright?:string | null,
	logoFirst?:ValueTypes["FooterUpdateLogoFirstEntityRelationInput"] | null,
	logoSecond?:ValueTypes["FooterUpdateLogoSecondEntityRelationInput"] | null,
	linksGroups?:ValueTypes["FooterUpdateLinksGroupsEntityRelationInput"][],
	phone?:string | null,
	email?:string | null,
	text?:string | null,
	link?:ValueTypes["FooterUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateLogoFirstEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertLogoFirstRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertLogoFirstRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterUpdateLogoSecondEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertLogoSecondRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertLogoSecondRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterUpdateLinksGroupsEntityRelationInput"]: {
	create?:ValueTypes["FooterLinkGroupsCreateInput"] | null,
	update?:ValueTypes["FooterUpdateLinksGroupsRelationInput"] | null,
	upsert?:ValueTypes["FooterUpsertLinksGroupsRelationInput"] | null,
	connect?:ValueTypes["FooterLinkGroupsUniqueWhere"] | null,
	disconnect?:ValueTypes["FooterLinkGroupsUniqueWhere"] | null,
	delete?:ValueTypes["FooterLinkGroupsUniqueWhere"] | null,
	alias?:string | null
};
	["FooterUpdateLinksGroupsRelationInput"]: {
	by?:ValueTypes["FooterLinkGroupsUniqueWhere"] | null,
	data?:ValueTypes["FooterLinkGroupsUpdateInput"] | null
};
	["FooterLinkGroupsUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	links?:ValueTypes["FooterLinkGroupsUpdateLinksEntityRelationInput"][],
	specialIdentifier?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkGroupsUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["FooterLinkCreateInput"] | null,
	update?:ValueTypes["FooterLinkGroupsUpdateLinksRelationInput"] | null,
	upsert?:ValueTypes["FooterLinkGroupsUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["FooterLinkUniqueWhere"] | null,
	disconnect?:ValueTypes["FooterLinkUniqueWhere"] | null,
	delete?:ValueTypes["FooterLinkUniqueWhere"] | null,
	alias?:string | null
};
	["FooterLinkGroupsUpdateLinksRelationInput"]: {
	by?:ValueTypes["FooterLinkUniqueWhere"] | null,
	data?:ValueTypes["FooterLinkUpdateInput"] | null
};
	["FooterLinkUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["FooterLinkUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FooterLinkUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterLinkUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterLinkGroupsUpsertLinksRelationInput"]: {
	by?:ValueTypes["FooterLinkUniqueWhere"] | null,
	update?:ValueTypes["FooterLinkUpdateInput"] | null,
	create?:ValueTypes["FooterLinkCreateInput"] | null
};
	["FooterUpsertLinksGroupsRelationInput"]: {
	by?:ValueTypes["FooterLinkGroupsUniqueWhere"] | null,
	update?:ValueTypes["FooterLinkGroupsUpdateInput"] | null,
	create?:ValueTypes["FooterLinkGroupsCreateInput"] | null
};
	["FooterUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:true,
	unique?:true,
logoFirst?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
logoSecond?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
linkGroups?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
		__typename?: true
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	logoFirst?:ValueTypes["FieldMeta"],
	logoSecond?:ValueTypes["FieldMeta"],
	linkGroups?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["LinkList"]: AliasType<{
	_meta?:ValueTypes["LinkListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
itemsByLink?: [{	by:ValueTypes["LinkListItemsByLinkUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
itemsByGroup?: [{	by:ValueTypes["LinkListItemsByGroupUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
paginateItems?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
		__typename?: true
}>;
	["LinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["LinkItem"]: AliasType<{
	_meta?:ValueTypes["LinkItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
group?: [{	filter?:ValueTypes["LinkSubGroupWhere"] | null},ValueTypes["LinkSubGroup"]],
	isHighlighted?:true,
		__typename?: true
}>;
	["LinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	group?:ValueTypes["FieldMeta"],
	isHighlighted?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["LinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["LinkItemWhere"] | null,
	and?:(ValueTypes["LinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkListWhere"] | undefined | null)[],
	not?:ValueTypes["LinkListWhere"] | null
};
	["LinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["LinkListWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	group?:ValueTypes["LinkSubGroupWhere"] | null,
	isHighlighted?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["LinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["LinkItemWhere"] | null
};
	["LinkSubGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	links?:ValueTypes["LinkListWhere"] | null,
	and?:(ValueTypes["LinkSubGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkSubGroupWhere"] | undefined | null)[],
	not?:ValueTypes["LinkSubGroupWhere"] | null
};
	["LinkSubGroup"]: AliasType<{
	_meta?:ValueTypes["LinkSubGroupMeta"],
	id?:true,
	order?:true,
links?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
		__typename?: true
}>;
	["LinkSubGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["LinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["LinkListOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	group?:ValueTypes["LinkSubGroupOrderBy"] | null,
	isHighlighted?:ValueTypes["OrderDirection"] | null
};
	["LinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["LinkSubGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	links?:ValueTypes["LinkListOrderBy"] | null
};
	["LinkListItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["LinkListItemsByGroupUniqueWhere"]: {
	group?:ValueTypes["LinkSubGroupUniqueWhere"] | null
};
	["LinkSubGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	links?:ValueTypes["LinkListUniqueWhere"] | null
};
	["LinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LinkItemUniqueWhere"] | null
};
	["LinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null,
	group?:ValueTypes["LinkSubGroupUniqueWhere"] | null
};
	["LinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkItemEdge"],
		__typename?: true
}>;
	["LinkItemEdge"]: AliasType<{
	node?:ValueTypes["LinkItem"],
		__typename?: true
}>;
	["HeaderUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logoFirst?:ValueTypes["ImageUniqueWhere"] | null,
	logoSecond?:ValueTypes["ImageUniqueWhere"] | null,
	linkGroups?:ValueTypes["LinkListUniqueWhere"] | null
};
	["HeaderWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	logoFirst?:ValueTypes["ImageWhere"] | null,
	logoSecond?:ValueTypes["ImageWhere"] | null,
	linkGroups?:ValueTypes["LinkListWhere"] | null,
	and?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderWhere"] | null
};
	["HeaderOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	logoFirst?:ValueTypes["ImageOrderBy"] | null,
	logoSecond?:ValueTypes["ImageOrderBy"] | null,
	linkGroups?:ValueTypes["LinkListOrderBy"] | null
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: true
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logoFirst?:ValueTypes["HeaderCreateLogoFirstEntityRelationInput"] | null,
	logoSecond?:ValueTypes["HeaderCreateLogoSecondEntityRelationInput"] | null,
	linkGroups?:ValueTypes["HeaderCreateLinkGroupsEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderCreateLogoFirstEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderCreateLogoSecondEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderCreateLinkGroupsEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["LinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["LinkItemUniqueWhere"] | null,
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["LinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["LinkItemCreateLinkEntityRelationInput"] | null,
	group?:ValueTypes["LinkItemCreateGroupEntityRelationInput"] | null,
	isHighlighted?:boolean | null,
	_dummy_field_?:boolean | null
};
	["LinkItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkItemCreateGroupEntityRelationInput"]: {
	connect?:ValueTypes["LinkSubGroupUniqueWhere"] | null,
	create?:ValueTypes["LinkSubGroupCreateInput"] | null
};
	["LinkSubGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	links?:ValueTypes["LinkSubGroupCreateLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkSubGroupCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["HeaderUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logoFirst?:ValueTypes["HeaderUpdateLogoFirstEntityRelationInput"] | null,
	logoSecond?:ValueTypes["HeaderUpdateLogoSecondEntityRelationInput"] | null,
	linkGroups?:ValueTypes["HeaderUpdateLinkGroupsEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLogoFirstEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLogoFirstRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertLogoFirstRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderUpdateLogoSecondEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLogoSecondRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertLogoSecondRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderUpdateLinkGroupsEntityRelationInput"]: {
	create?:ValueTypes["LinkListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLinkGroupsRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkListUpdateInput"]: {
	items?:ValueTypes["LinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["LinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["LinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["LinkItemUniqueWhere"] | null,
	delete?:ValueTypes["LinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["LinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["LinkItemUniqueWhere"] | null,
	data?:ValueTypes["LinkItemWithoutListUpdateInput"] | null
};
	["LinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | null,
	group?:ValueTypes["LinkItemUpdateGroupEntityRelationInput"] | null,
	isHighlighted?:boolean | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkItemUpdateGroupEntityRelationInput"]: {
	create?:ValueTypes["LinkSubGroupCreateInput"] | null,
	update?:ValueTypes["LinkSubGroupUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertGroupRelationInput"] | null,
	connect?:ValueTypes["LinkSubGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkSubGroupUpdateInput"]: {
	order?:number | null,
	links?:ValueTypes["LinkSubGroupUpdateLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkSubGroupUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["LinkListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateInput"] | null,
	upsert?:ValueTypes["LinkSubGroupUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkSubGroupUpsertLinksRelationInput"]: {
	update?:ValueTypes["LinkListUpdateInput"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["LinkItemUpsertGroupRelationInput"]: {
	update?:ValueTypes["LinkSubGroupUpdateInput"] | null,
	create?:ValueTypes["LinkSubGroupCreateInput"] | null
};
	["LinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["LinkItemUniqueWhere"] | null,
	update?:ValueTypes["LinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null
};
	["HeaderUpsertLinkGroupsRelationInput"]: {
	update?:ValueTypes["LinkListUpdateInput"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["HomePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageEdge"],
		__typename?: true
}>;
	["HomePageEdge"]: AliasType<{
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	content?:ValueTypes["HomePageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["HomePageCreateLinkEntityRelationInput"] | null,
	logo?:ValueTypes["HomePageCreateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["LinkableWithoutHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	content?:ValueTypes["HomePageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["HomePageUpdateLinkEntityRelationInput"] | null,
	logo?:ValueTypes["HomePageUpdateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutHomePageUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: true
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: true
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["ProgramConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProgramEdge"],
		__typename?: true
}>;
	["ProgramEdge"]: AliasType<{
	node?:ValueTypes["Program"],
		__typename?: true
}>;
	["ProgramCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	title?:string | null,
	leadParagraph?:string | null,
	link?:ValueTypes["ProgramCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ProgramCreateImageEntityRelationInput"] | null,
	content?:ValueTypes["ProgramCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ProgramCreateSeoEntityRelationInput"] | null,
	ilustration?:ValueTypes["ProgramCreateIlustrationEntityRelationInput"] | null,
	bulletPoint?:ValueTypes["ProgramCreateBulletPointEntityRelationInput"] | null,
	showDetailLink?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ProgramCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutProgramCreateInput"] | null
};
	["LinkableWithoutProgramCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	title?:string | null,
	leadParagraph?:string | null,
	link?:ValueTypes["ProgramUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ProgramUpdateImageEntityRelationInput"] | null,
	content?:ValueTypes["ProgramUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ProgramUpdateSeoEntityRelationInput"] | null,
	ilustration?:ValueTypes["ProgramUpdateIlustrationEntityRelationInput"] | null,
	bulletPoint?:ValueTypes["ProgramUpdateBulletPointEntityRelationInput"] | null,
	showDetailLink?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ProgramUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutProgramCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutProgramUpdateInput"] | null,
	upsert?:ValueTypes["ProgramUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutProgramUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutProgramUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutProgramCreateInput"] | null
};
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: true
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	targetUrl?:string | null,
	link?:ValueTypes["RedirectCreateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateInput"]: {
	targetUrl?:string | null,
	link?:ValueTypes["RedirectUpdateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["YoutubeVideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["YoutubeVideoEdge"],
		__typename?: true
}>;
	["YoutubeVideoEdge"]: AliasType<{
	node?:ValueTypes["YoutubeVideo"],
		__typename?: true
}>;
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: true
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: true
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["BulletPointConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BulletPointEdge"],
		__typename?: true
}>;
	["BulletPointEdge"]: AliasType<{
	node?:ValueTypes["BulletPoint"],
		__typename?: true
}>;
	["BulletPointItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	list?:ValueTypes["BulletPointItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BulletPointItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["BulletPointUniqueWhere"] | null,
	create?:ValueTypes["BulletPointWithoutItemsCreateInput"] | null
};
	["BulletPointWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["BulletPointItemUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	list?:ValueTypes["BulletPointItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BulletPointItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["BulletPointWithoutItemsCreateInput"] | null,
	update?:ValueTypes["BulletPointWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["BulletPointItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["BulletPointUniqueWhere"] | null,
	delete?:boolean | null
};
	["BulletPointWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["BulletPointItemUpsertListRelationInput"]: {
	update?:ValueTypes["BulletPointWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["BulletPointWithoutItemsCreateInput"] | null
};
	["FileItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	url?:string | null,
	fileType?:string | null,
	list?:ValueTypes["FileItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["FileListUniqueWhere"] | null,
	create?:ValueTypes["FileListWithoutItemsCreateInput"] | null
};
	["FileListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["FileListCreateReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileListCreateReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutFileListCreateInput"] | null
};
	["ContentReferenceWithoutFileListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	textList?:ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceCreateStaffListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceCreatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceCreateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceCreateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileItemUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	url?:string | null,
	fileType?:string | null,
	list?:ValueTypes["FileItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["FileListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["FileListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["FileItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["FileListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FileListWithoutItemsUpdateInput"]: {
	reference?:ValueTypes["FileListUpdateReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileListUpdateReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutFileListCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutFileListUpdateInput"] | null,
	upsert?:ValueTypes["FileListUpsertReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutFileListUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	textList?:ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceUpdateStaffListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceUpdateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceUpdateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileListUpsertReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutFileListUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutFileListCreateInput"] | null
};
	["FileItemUpsertListRelationInput"]: {
	update?:ValueTypes["FileListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["FileListWithoutItemsCreateInput"] | null
};
	["FileListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FileListEdge"],
		__typename?: true
}>;
	["FileListEdge"]: AliasType<{
	node?:ValueTypes["FileList"],
		__typename?: true
}>;
	["FileListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["FileListCreateReferenceEntityRelationInput"] | null,
	items?:ValueTypes["FileListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FileListUpdateInput"]: {
	reference?:ValueTypes["FileListUpdateReferenceEntityRelationInput"] | null,
	items?:ValueTypes["FileListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["TextItemCreateListEntityRelationInput"] | null,
	link?:ValueTypes["TextItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["TextListUniqueWhere"] | null,
	create?:ValueTypes["TextListWithoutItemsCreateInput"] | null
};
	["TextListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["TextItemUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["TextItemUpdateListEntityRelationInput"] | null,
	link?:ValueTypes["TextItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["TextListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["TextListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["TextItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["TextListUniqueWhere"] | null,
	delete?:boolean | null
};
	["TextListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["TextItemUpsertListRelationInput"]: {
	update?:ValueTypes["TextListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["TextListWithoutItemsCreateInput"] | null
};
	["TextListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextListEdge"],
		__typename?: true
}>;
	["TextListEdge"]: AliasType<{
	node?:ValueTypes["TextList"],
		__typename?: true
}>;
	["ProgramPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProgramPageEdge"],
		__typename?: true
}>;
	["ProgramPageEdge"]: AliasType<{
	node?:ValueTypes["ProgramPage"],
		__typename?: true
}>;
	["ProgramPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	link?:ValueTypes["ProgramPageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ProgramPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutProgramPageCreateInput"] | null
};
	["LinkableWithoutProgramPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	link?:ValueTypes["ProgramPageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ProgramPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutProgramPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutProgramPageUpdateInput"] | null,
	upsert?:ValueTypes["ProgramPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutProgramPageUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProgramPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutProgramPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutProgramPageCreateInput"] | null
};
	["GenericPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageEdge"],
		__typename?: true
}>;
	["GenericPageEdge"]: AliasType<{
	node?:ValueTypes["GenericPage"],
		__typename?: true
}>;
	["GenericPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["GenericPageCreateImageEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["GenericPageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["GenericPageCreateLinkEntityRelationInput"] | null,
	darujmeWidget?:boolean | null,
	_dummy_field_?:boolean | null
};
	["GenericPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutGenericPageCreateInput"] | null
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpdateInput"]: {
	name?:string | null,
	leadParagraph?:string | null,
	image?:ValueTypes["GenericPageUpdateImageEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["GenericPageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["GenericPageUpdateLinkEntityRelationInput"] | null,
	darujmeWidget?:boolean | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutGenericPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutGenericPageUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutGenericPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutGenericPageCreateInput"] | null
};
	["StaffConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StaffEdge"],
		__typename?: true
}>;
	["StaffEdge"]: AliasType<{
	node?:ValueTypes["Staff"],
		__typename?: true
}>;
	["StaffItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["StaffItemCreateListEntityRelationInput"] | null,
	staff?:ValueTypes["StaffItemCreateStaffEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["StaffListUniqueWhere"] | null,
	create?:ValueTypes["StaffListWithoutItemsCreateInput"] | null
};
	["StaffListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["StaffListCreateReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffListCreateReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutStaffListCreateInput"] | null
};
	["ContentReferenceWithoutStaffListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceCreateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceCreatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceCreateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceCreateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["StaffItemUpdateListEntityRelationInput"] | null,
	staff?:ValueTypes["StaffItemUpdateStaffEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["StaffListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["StaffListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["StaffItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["StaffListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StaffListWithoutItemsUpdateInput"]: {
	reference?:ValueTypes["StaffListUpdateReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffListUpdateReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutStaffListCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutStaffListUpdateInput"] | null,
	upsert?:ValueTypes["StaffListUpsertReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutStaffListUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceUpdateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | null,
	principleList?:ValueTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceUpdateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceUpdateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StaffListUpsertReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutStaffListUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutStaffListCreateInput"] | null
};
	["StaffItemUpsertListRelationInput"]: {
	update?:ValueTypes["StaffListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["StaffListWithoutItemsCreateInput"] | null
};
	["StaffListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StaffListEdge"],
		__typename?: true
}>;
	["StaffListEdge"]: AliasType<{
	node?:ValueTypes["StaffList"],
		__typename?: true
}>;
	["StaffListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["StaffListCreateReferenceEntityRelationInput"] | null,
	items?:ValueTypes["StaffListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["StaffListUpdateInput"]: {
	reference?:ValueTypes["StaffListUpdateReferenceEntityRelationInput"] | null,
	items?:ValueTypes["StaffListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["IconConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IconEdge"],
		__typename?: true
}>;
	["IconEdge"]: AliasType<{
	node?:ValueTypes["Icon"],
		__typename?: true
}>;
	["PrincipleItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	list?:ValueTypes["PrincipleItemCreateListEntityRelationInput"] | null,
	icon?:ValueTypes["PrincipleItemCreateIconEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["PrincipleItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["PrincipleListUniqueWhere"] | null,
	create?:ValueTypes["PrincipleListWithoutItemsCreateInput"] | null
};
	["PrincipleListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["PrincipleListCreateReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrincipleListCreateReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutPrincipleListCreateInput"] | null
};
	["ContentReferenceWithoutPrincipleListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceCreateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceCreateStaffListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceCreateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceCreateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceCreateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrincipleItemUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	list?:ValueTypes["PrincipleItemUpdateListEntityRelationInput"] | null,
	icon?:ValueTypes["PrincipleItemUpdateIconEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["PrincipleItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["PrincipleListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["PrincipleListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["PrincipleItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["PrincipleListUniqueWhere"] | null,
	delete?:boolean | null
};
	["PrincipleListWithoutItemsUpdateInput"]: {
	reference?:ValueTypes["PrincipleListUpdateReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrincipleListUpdateReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutPrincipleListCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutPrincipleListUpdateInput"] | null,
	upsert?:ValueTypes["PrincipleListUpsertReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutPrincipleListUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	youtubeVideo?:ValueTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fileList?:ValueTypes["ContentReferenceUpdateFileListEntityRelationInput"] | null,
	textList?:ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | null,
	staffList?:ValueTypes["ContentReferenceUpdateStaffListEntityRelationInput"] | null,
	view?:ValueTypes["View"] | null,
	aligning?:ValueTypes["Aligning"] | null,
	numbered?:boolean | null,
	tertiaryText?:string | null,
	imageLinkList?:ValueTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"] | null,
	citationList?:ValueTypes["ContentReferenceUpdateCitationListEntityRelationInput"] | null,
	storiesList?:ValueTypes["ContentReferenceUpdateStoriesListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrincipleListUpsertReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutPrincipleListUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutPrincipleListCreateInput"] | null
};
	["PrincipleItemUpsertListRelationInput"]: {
	update?:ValueTypes["PrincipleListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["PrincipleListWithoutItemsCreateInput"] | null
};
	["PrincipleListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PrincipleListEdge"],
		__typename?: true
}>;
	["PrincipleListEdge"]: AliasType<{
	node?:ValueTypes["PrincipleList"],
		__typename?: true
}>;
	["PrincipleListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	reference?:ValueTypes["PrincipleListCreateReferenceEntityRelationInput"] | null,
	items?:ValueTypes["PrincipleListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PrincipleListUpdateInput"]: {
	reference?:ValueTypes["PrincipleListUpdateReferenceEntityRelationInput"] | null,
	items?:ValueTypes["PrincipleListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["LinkItemCreateListEntityRelationInput"] | null,
	link?:ValueTypes["LinkItemCreateLinkEntityRelationInput"] | null,
	group?:ValueTypes["LinkItemCreateGroupEntityRelationInput"] | null,
	isHighlighted?:boolean | null,
	_dummy_field_?:boolean | null
};
	["LinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null
};
	["LinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["LinkItemUpdateListEntityRelationInput"] | null,
	link?:ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | null,
	group?:ValueTypes["LinkItemUpdateGroupEntityRelationInput"] | null,
	isHighlighted?:boolean | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["LinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	delete?:boolean | null
};
	["LinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["LinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["LinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null
};
	["LinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkListEdge"],
		__typename?: true
}>;
	["LinkListEdge"]: AliasType<{
	node?:ValueTypes["LinkList"],
		__typename?: true
}>;
	["LinkSubGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkSubGroupEdge"],
		__typename?: true
}>;
	["LinkSubGroupEdge"]: AliasType<{
	node?:ValueTypes["LinkSubGroup"],
		__typename?: true
}>;
	["YoutubeVideoList"]: AliasType<{
	_meta?:ValueTypes["YoutubeVideoListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideoListItem"]],
itemsByYoutube?: [{	by:ValueTypes["YoutubeVideoListItemsByYoutubeUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null},ValueTypes["YoutubeVideoListItem"]],
paginateItems?: [{	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoListItemConnection"]],
		__typename?: true
}>;
	["YoutubeVideoListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["YoutubeVideoListItem"]: AliasType<{
	_meta?:ValueTypes["YoutubeVideoListItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["YoutubeVideoListWhere"] | null},ValueTypes["YoutubeVideoList"]],
youtube?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideo"]],
		__typename?: true
}>;
	["YoutubeVideoListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	youtube?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["YoutubeVideoListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["YoutubeVideoListItemWhere"] | null,
	and?:(ValueTypes["YoutubeVideoListWhere"] | undefined | null)[],
	or?:(ValueTypes["YoutubeVideoListWhere"] | undefined | null)[],
	not?:ValueTypes["YoutubeVideoListWhere"] | null
};
	["YoutubeVideoListItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["YoutubeVideoListWhere"] | null,
	youtube?:ValueTypes["YoutubeVideoWhere"] | null,
	and?:(ValueTypes["YoutubeVideoListItemWhere"] | undefined | null)[],
	or?:(ValueTypes["YoutubeVideoListItemWhere"] | undefined | null)[],
	not?:ValueTypes["YoutubeVideoListItemWhere"] | null
};
	["YoutubeVideoListItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["YoutubeVideoListOrderBy"] | null,
	youtube?:ValueTypes["YoutubeVideoOrderBy"] | null
};
	["YoutubeVideoListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["YoutubeVideoListItemsByYoutubeUniqueWhere"]: {
	youtube?:ValueTypes["YoutubeVideoUniqueWhere"] | null
};
	["YoutubeVideoListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["YoutubeVideoListItemEdge"],
		__typename?: true
}>;
	["YoutubeVideoListItemEdge"]: AliasType<{
	node?:ValueTypes["YoutubeVideoListItem"],
		__typename?: true
}>;
	["YoutubeVideoListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["YoutubeVideoListItemUniqueWhere"] | null
};
	["YoutubeVideoListItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	youtube?:ValueTypes["YoutubeVideoUniqueWhere"] | null
};
	["YoutubeVideoListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["YoutubeVideoListEdge"],
		__typename?: true
}>;
	["YoutubeVideoListEdge"]: AliasType<{
	node?:ValueTypes["YoutubeVideoList"],
		__typename?: true
}>;
	["YoutubeVideoListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["YoutubeVideoListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["YoutubeVideoListItemUniqueWhere"] | null,
	create?:ValueTypes["YoutubeVideoListItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["YoutubeVideoListItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	youtube?:ValueTypes["YoutubeVideoListItemCreateYoutubeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListItemCreateYoutubeEntityRelationInput"]: {
	connect?:ValueTypes["YoutubeVideoUniqueWhere"] | null,
	create?:ValueTypes["YoutubeVideoCreateInput"] | null
};
	["YoutubeVideoListUpdateInput"]: {
	items?:ValueTypes["YoutubeVideoListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["YoutubeVideoListItemWithoutListCreateInput"] | null,
	update?:ValueTypes["YoutubeVideoListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["YoutubeVideoListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["YoutubeVideoListItemUniqueWhere"] | null,
	disconnect?:ValueTypes["YoutubeVideoListItemUniqueWhere"] | null,
	delete?:ValueTypes["YoutubeVideoListItemUniqueWhere"] | null,
	alias?:string | null
};
	["YoutubeVideoListUpdateItemsRelationInput"]: {
	by?:ValueTypes["YoutubeVideoListItemUniqueWhere"] | null,
	data?:ValueTypes["YoutubeVideoListItemWithoutListUpdateInput"] | null
};
	["YoutubeVideoListItemWithoutListUpdateInput"]: {
	order?:number | null,
	youtube?:ValueTypes["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"]: {
	create?:ValueTypes["YoutubeVideoCreateInput"] | null,
	update?:ValueTypes["YoutubeVideoUpdateInput"] | null,
	upsert?:ValueTypes["YoutubeVideoListItemUpsertYoutubeRelationInput"] | null,
	connect?:ValueTypes["YoutubeVideoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["YoutubeVideoListItemUpsertYoutubeRelationInput"]: {
	update?:ValueTypes["YoutubeVideoUpdateInput"] | null,
	create?:ValueTypes["YoutubeVideoCreateInput"] | null
};
	["YoutubeVideoListUpsertItemsRelationInput"]: {
	by?:ValueTypes["YoutubeVideoListItemUniqueWhere"] | null,
	update?:ValueTypes["YoutubeVideoListItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["YoutubeVideoListItemWithoutListCreateInput"] | null
};
	["YoutubeVideoListItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["YoutubeVideoListItemCreateListEntityRelationInput"] | null,
	youtube?:ValueTypes["YoutubeVideoListItemCreateYoutubeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["YoutubeVideoListUniqueWhere"] | null,
	create?:ValueTypes["YoutubeVideoListWithoutItemsCreateInput"] | null
};
	["YoutubeVideoListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["YoutubeVideoListItemUpdateListEntityRelationInput"] | null,
	youtube?:ValueTypes["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["YoutubeVideoListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["YoutubeVideoListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["YoutubeVideoListItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["YoutubeVideoListUniqueWhere"] | null,
	delete?:boolean | null
};
	["YoutubeVideoListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["YoutubeVideoListItemUpsertListRelationInput"]: {
	update?:ValueTypes["YoutubeVideoListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["YoutubeVideoListWithoutItemsCreateInput"] | null
};
	["ImageList"]: AliasType<{
	_meta?:ValueTypes["ImageListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageListItem"]],
itemsByImage?: [{	by:ValueTypes["ImageListItemsByImageUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItem"]],
paginateItems?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListItemConnection"]],
		__typename?: true
}>;
	["ImageListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ImageListItem"]: AliasType<{
	_meta?:ValueTypes["ImageListItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["ImageListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ImageListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ImageListItemWhere"] | null,
	and?:(ValueTypes["ImageListWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageListWhere"] | undefined | null)[],
	not?:ValueTypes["ImageListWhere"] | null
};
	["ImageListItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ImageListWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ImageListItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageListItemWhere"] | undefined | null)[],
	not?:ValueTypes["ImageListItemWhere"] | null
};
	["ImageListItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ImageListOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ImageListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ImageListItemsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListItemEdge"],
		__typename?: true
}>;
	["ImageListItemEdge"]: AliasType<{
	node?:ValueTypes["ImageListItem"],
		__typename?: true
}>;
	["ImageListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ImageListItemUniqueWhere"] | null
};
	["ImageListItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListEdge"],
		__typename?: true
}>;
	["ImageListEdge"]: AliasType<{
	node?:ValueTypes["ImageList"],
		__typename?: true
}>;
	["ImageListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ImageListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ImageListItemUniqueWhere"] | null,
	create?:ValueTypes["ImageListItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ImageListItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["ImageListItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageListUpdateInput"]: {
	items?:ValueTypes["ImageListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ImageListItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ImageListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ImageListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ImageListItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ImageListItemUniqueWhere"] | null,
	delete?:ValueTypes["ImageListItemUniqueWhere"] | null,
	alias?:string | null
};
	["ImageListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ImageListItemUniqueWhere"] | null,
	data?:ValueTypes["ImageListItemWithoutListUpdateInput"] | null
};
	["ImageListItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ImageListItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageListItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ImageListItemUniqueWhere"] | null,
	update?:ValueTypes["ImageListItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ImageListItemWithoutListCreateInput"] | null
};
	["ImageListItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ImageListItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["ImageListItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ImageListUniqueWhere"] | null,
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null
};
	["ImageListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ImageListItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ImageListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ImageListItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ImageListUniqueWhere"] | null,
	delete?:boolean | null
};
	["ImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ImageListItemUpsertListRelationInput"]: {
	update?:ValueTypes["ImageListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null
};
	["CitationItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["CitationItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["CitationItemCreateImageEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["CitationItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["CitationListUniqueWhere"] | null,
	create?:ValueTypes["CitationListWithoutItemsCreateInput"] | null
};
	["CitationListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["CitationItemUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["CitationItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["CitationItemUpdateImageEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["CitationItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["CitationListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["CitationListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["CitationItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["CitationListUniqueWhere"] | null,
	delete?:boolean | null
};
	["CitationListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["CitationItemUpsertListRelationInput"]: {
	update?:ValueTypes["CitationListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["CitationListWithoutItemsCreateInput"] | null
};
	["CitationListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CitationListEdge"],
		__typename?: true
}>;
	["CitationListEdge"]: AliasType<{
	node?:ValueTypes["CitationList"],
		__typename?: true
}>;
	["ContentImageLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ContentImageLinkItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["ContentImageLinkItemCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentImageLinkItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ContentImageLinkListUniqueWhere"] | null,
	create?:ValueTypes["ContentImageLinkListWithoutItemsCreateInput"] | null
};
	["ContentImageLinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["ContentImageLinkListCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ContentImageLinkItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["ContentImageLinkItemUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentImageLinkItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ContentImageLinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ContentImageLinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ContentImageLinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ContentImageLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentImageLinkListWithoutItemsUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["ContentImageLinkListUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentImageLinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["ContentImageLinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ContentImageLinkListWithoutItemsCreateInput"] | null
};
	["ContentImageLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentImageLinkListEdge"],
		__typename?: true
}>;
	["ContentImageLinkListEdge"]: AliasType<{
	node?:ValueTypes["ContentImageLinkList"],
		__typename?: true
}>;
	["NewsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsEdge"],
		__typename?: true
}>;
	["NewsEdge"]: AliasType<{
	node?:ValueTypes["News"],
		__typename?: true
}>;
	["NewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	publishDate?:ValueTypes["DateTime"] | null,
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["NewsCreateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["NewsCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["NewsCreateSeoEntityRelationInput"] | null,
	order?:number | null,
	link?:ValueTypes["NewsCreateLinkEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["NewsCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutNewsCreateInput"] | null
};
	["LinkableWithoutNewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsUpdateInput"]: {
	publishDate?:ValueTypes["DateTime"] | null,
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["NewsUpdateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["NewsUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["NewsUpdateSeoEntityRelationInput"] | null,
	order?:number | null,
	link?:ValueTypes["NewsUpdateLinkEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["NewsUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutNewsCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutNewsUpdateInput"] | null,
	upsert?:ValueTypes["NewsUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutNewsUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutNewsUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutNewsCreateInput"] | null
};
	["StoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["StoriesCreateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["StoriesCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesCreateSeoEntityRelationInput"] | null,
	order?:number | null,
	link?:ValueTypes["StoriesCreateLinkEntityRelationInput"] | null,
	list?:ValueTypes["StoriesCreateListEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["StoriesUpdateInput"]: {
	title?:string | null,
	perex?:string | null,
	coverImage?:ValueTypes["StoriesUpdateCoverImageEntityRelationInput"] | null,
	content?:ValueTypes["StoriesUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesUpdateSeoEntityRelationInput"] | null,
	order?:number | null,
	link?:ValueTypes["StoriesUpdateLinkEntityRelationInput"] | null,
	list?:ValueTypes["StoriesUpdateListEntityRelationInput"] | null,
	isDraft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["NewsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsPageEdge"],
		__typename?: true
}>;
	["NewsPageEdge"]: AliasType<{
	node?:ValueTypes["NewsPage"],
		__typename?: true
}>;
	["NewsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	link?:ValueTypes["NewsPageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["NewsPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutNewsPageCreateInput"] | null
};
	["LinkableWithoutNewsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableCreateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	link?:ValueTypes["NewsPageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["NewsPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutNewsPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutNewsPageUpdateInput"] | null,
	upsert?:ValueTypes["NewsPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutNewsPageUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	storiesPage?:ValueTypes["LinkableUpdateStoriesPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutNewsPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutNewsPageCreateInput"] | null
};
	["StoriesPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StoriesPageEdge"],
		__typename?: true
}>;
	["StoriesPageEdge"]: AliasType<{
	node?:ValueTypes["StoriesPage"],
		__typename?: true
}>;
	["StoriesPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	link?:ValueTypes["StoriesPageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StoriesPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutStoriesPageCreateInput"] | null
};
	["LinkableWithoutStoriesPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	program?:ValueTypes["LinkableCreateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableCreateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableCreateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableCreateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableCreateStoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StoriesPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	leadParagraph?:string | null,
	link?:ValueTypes["StoriesPageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["StoriesPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StoriesPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutStoriesPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutStoriesPageUpdateInput"] | null,
	upsert?:ValueTypes["StoriesPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutStoriesPageUpdateInput"]: {
	url?:string | null,
	program?:ValueTypes["LinkableUpdateProgramEntityRelationInput"] | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	programPage?:ValueTypes["LinkableUpdateProgramPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	newsPage?:ValueTypes["LinkableUpdateNewsPageEntityRelationInput"] | null,
	news?:ValueTypes["LinkableUpdateNewsEntityRelationInput"] | null,
	story?:ValueTypes["LinkableUpdateStoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StoriesPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutStoriesPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutStoriesPageCreateInput"] | null
};
	["StoriesListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StoriesListEdge"],
		__typename?: true
}>;
	["StoriesListEdge"]: AliasType<{
	node?:ValueTypes["StoriesList"],
		__typename?: true
}>;
	["QueryTransaction"]: AliasType<{
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeo"]],
listFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FallbackSeo"]],
paginateFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FallbackSeoConnection"]],
validateCreateFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null},ValueTypes["Program"]],
listProgram?: [{	filter?:ValueTypes["ProgramWhere"] | null,	orderBy?:ValueTypes["ProgramOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Program"]],
paginateProgram?: [{	filter?:ValueTypes["ProgramWhere"] | null,	orderBy?:ValueTypes["ProgramOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProgramConnection"]],
validateCreateProgram?: [{	data:ValueTypes["ProgramCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	data:ValueTypes["ProgramUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideo"]],
listYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideo"]],
paginateYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoConnection"]],
validateCreateYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null},ValueTypes["BulletPoint"]],
listBulletPoint?: [{	filter?:ValueTypes["BulletPointWhere"] | null,	orderBy?:ValueTypes["BulletPointOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BulletPoint"]],
paginateBulletPoint?: [{	filter?:ValueTypes["BulletPointWhere"] | null,	orderBy?:ValueTypes["BulletPointOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BulletPointConnection"]],
validateCreateBulletPoint?: [{	data:ValueTypes["BulletPointCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	data:ValueTypes["BulletPointUpdateInput"]},ValueTypes["_ValidationResult"]],
getBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null},ValueTypes["BulletPointItem"]],
listBulletPointItem?: [{	filter?:ValueTypes["BulletPointItemWhere"] | null,	orderBy?:ValueTypes["BulletPointItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BulletPointItem"]],
paginateBulletPointItem?: [{	filter?:ValueTypes["BulletPointItemWhere"] | null,	orderBy?:ValueTypes["BulletPointItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BulletPointItemConnection"]],
validateCreateBulletPointItem?: [{	data:ValueTypes["BulletPointItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	data:ValueTypes["BulletPointItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null},ValueTypes["FileItem"]],
listFileItem?: [{	filter?:ValueTypes["FileItemWhere"] | null,	orderBy?:ValueTypes["FileItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileItem"]],
paginateFileItem?: [{	filter?:ValueTypes["FileItemWhere"] | null,	orderBy?:ValueTypes["FileItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileItemConnection"]],
validateCreateFileItem?: [{	data:ValueTypes["FileItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	data:ValueTypes["FileItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null},ValueTypes["FileList"]],
listFileList?: [{	filter?:ValueTypes["FileListWhere"] | null,	orderBy?:ValueTypes["FileListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileList"]],
paginateFileList?: [{	filter?:ValueTypes["FileListWhere"] | null,	orderBy?:ValueTypes["FileListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileListConnection"]],
validateCreateFileList?: [{	data:ValueTypes["FileListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	data:ValueTypes["FileListUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLink"]],
listFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLink"]],
paginateFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null},ValueTypes["FooterLinkGroups"]],
listFooterLinkGroups?: [{	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	orderBy?:ValueTypes["FooterLinkGroupsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLinkGroups"]],
paginateFooterLinkGroups?: [{	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	orderBy?:ValueTypes["FooterLinkGroupsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkGroupsConnection"]],
validateCreateFooterLinkGroups?: [{	data:ValueTypes["FooterLinkGroupsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	data:ValueTypes["FooterLinkGroupsUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null},ValueTypes["TextItem"]],
listTextItem?: [{	filter?:ValueTypes["TextItemWhere"] | null,	orderBy?:ValueTypes["TextItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextItem"]],
paginateTextItem?: [{	filter?:ValueTypes["TextItemWhere"] | null,	orderBy?:ValueTypes["TextItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data:ValueTypes["TextItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	data:ValueTypes["TextItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null},ValueTypes["TextList"]],
listTextList?: [{	filter?:ValueTypes["TextListWhere"] | null,	orderBy?:ValueTypes["TextListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextList"]],
paginateTextList?: [{	filter?:ValueTypes["TextListWhere"] | null,	orderBy?:ValueTypes["TextListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextListConnection"]],
validateCreateTextList?: [{	data:ValueTypes["TextListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	data:ValueTypes["TextListUpdateInput"]},ValueTypes["_ValidationResult"]],
getProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null},ValueTypes["ProgramPage"]],
listProgramPage?: [{	filter?:ValueTypes["ProgramPageWhere"] | null,	orderBy?:ValueTypes["ProgramPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProgramPage"]],
paginateProgramPage?: [{	filter?:ValueTypes["ProgramPageWhere"] | null,	orderBy?:ValueTypes["ProgramPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProgramPageConnection"]],
validateCreateProgramPage?: [{	data:ValueTypes["ProgramPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	data:ValueTypes["ProgramPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null},ValueTypes["Staff"]],
listStaff?: [{	filter?:ValueTypes["StaffWhere"] | null,	orderBy?:ValueTypes["StaffOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Staff"]],
paginateStaff?: [{	filter?:ValueTypes["StaffWhere"] | null,	orderBy?:ValueTypes["StaffOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StaffConnection"]],
validateCreateStaff?: [{	data:ValueTypes["StaffCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	data:ValueTypes["StaffUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null},ValueTypes["StaffItem"]],
listStaffItem?: [{	filter?:ValueTypes["StaffItemWhere"] | null,	orderBy?:ValueTypes["StaffItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StaffItem"]],
paginateStaffItem?: [{	filter?:ValueTypes["StaffItemWhere"] | null,	orderBy?:ValueTypes["StaffItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StaffItemConnection"]],
validateCreateStaffItem?: [{	data:ValueTypes["StaffItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	data:ValueTypes["StaffItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null},ValueTypes["StaffList"]],
listStaffList?: [{	filter?:ValueTypes["StaffListWhere"] | null,	orderBy?:ValueTypes["StaffListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StaffList"]],
paginateStaffList?: [{	filter?:ValueTypes["StaffListWhere"] | null,	orderBy?:ValueTypes["StaffListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StaffListConnection"]],
validateCreateStaffList?: [{	data:ValueTypes["StaffListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	data:ValueTypes["StaffListUpdateInput"]},ValueTypes["_ValidationResult"]],
getIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null},ValueTypes["Icon"]],
listIcon?: [{	filter?:ValueTypes["IconWhere"] | null,	orderBy?:ValueTypes["IconOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Icon"]],
paginateIcon?: [{	filter?:ValueTypes["IconWhere"] | null,	orderBy?:ValueTypes["IconOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IconConnection"]],
validateCreateIcon?: [{	data:ValueTypes["IconCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIcon?: [{	by:ValueTypes["IconUniqueWhere"],	data:ValueTypes["IconUpdateInput"]},ValueTypes["_ValidationResult"]],
getPrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null},ValueTypes["PrincipleItem"]],
listPrincipleItem?: [{	filter?:ValueTypes["PrincipleItemWhere"] | null,	orderBy?:ValueTypes["PrincipleItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrincipleItem"]],
paginatePrincipleItem?: [{	filter?:ValueTypes["PrincipleItemWhere"] | null,	orderBy?:ValueTypes["PrincipleItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrincipleItemConnection"]],
validateCreatePrincipleItem?: [{	data:ValueTypes["PrincipleItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	data:ValueTypes["PrincipleItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null},ValueTypes["PrincipleList"]],
listPrincipleList?: [{	filter?:ValueTypes["PrincipleListWhere"] | null,	orderBy?:ValueTypes["PrincipleListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrincipleList"]],
paginatePrincipleList?: [{	filter?:ValueTypes["PrincipleListWhere"] | null,	orderBy?:ValueTypes["PrincipleListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrincipleListConnection"]],
validateCreatePrincipleList?: [{	data:ValueTypes["PrincipleListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	data:ValueTypes["PrincipleListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null},ValueTypes["LinkSubGroup"]],
listLinkSubGroup?: [{	filter?:ValueTypes["LinkSubGroupWhere"] | null,	orderBy?:ValueTypes["LinkSubGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkSubGroup"]],
paginateLinkSubGroup?: [{	filter?:ValueTypes["LinkSubGroupWhere"] | null,	orderBy?:ValueTypes["LinkSubGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkSubGroupConnection"]],
validateCreateLinkSubGroup?: [{	data:ValueTypes["LinkSubGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	data:ValueTypes["LinkSubGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null},ValueTypes["YoutubeVideoList"]],
listYoutubeVideoList?: [{	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideoList"]],
paginateYoutubeVideoList?: [{	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoListConnection"]],
validateCreateYoutubeVideoList?: [{	data:ValueTypes["YoutubeVideoListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	data:ValueTypes["YoutubeVideoListUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null},ValueTypes["YoutubeVideoListItem"]],
listYoutubeVideoListItem?: [{	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideoListItem"]],
paginateYoutubeVideoListItem?: [{	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoListItemConnection"]],
validateCreateYoutubeVideoListItem?: [{	data:ValueTypes["YoutubeVideoListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	data:ValueTypes["YoutubeVideoListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null},ValueTypes["CitationItem"]],
listCitationItem?: [{	filter?:ValueTypes["CitationItemWhere"] | null,	orderBy?:ValueTypes["CitationItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CitationItem"]],
paginateCitationItem?: [{	filter?:ValueTypes["CitationItemWhere"] | null,	orderBy?:ValueTypes["CitationItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CitationItemConnection"]],
validateCreateCitationItem?: [{	data:ValueTypes["CitationItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	data:ValueTypes["CitationItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null},ValueTypes["CitationList"]],
listCitationList?: [{	filter?:ValueTypes["CitationListWhere"] | null,	orderBy?:ValueTypes["CitationListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CitationList"]],
paginateCitationList?: [{	filter?:ValueTypes["CitationListWhere"] | null,	orderBy?:ValueTypes["CitationListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CitationListConnection"]],
validateCreateCitationList?: [{	data:ValueTypes["CitationListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	data:ValueTypes["CitationListUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null},ValueTypes["ContentImageLinkItem"]],
listContentImageLinkItem?: [{	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentImageLinkItem"]],
paginateContentImageLinkItem?: [{	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentImageLinkItemConnection"]],
validateCreateContentImageLinkItem?: [{	data:ValueTypes["ContentImageLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	data:ValueTypes["ContentImageLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null},ValueTypes["ContentImageLinkList"]],
listContentImageLinkList?: [{	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentImageLinkList"]],
paginateContentImageLinkList?: [{	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	orderBy?:ValueTypes["ContentImageLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentImageLinkListConnection"]],
validateCreateContentImageLinkList?: [{	data:ValueTypes["ContentImageLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	data:ValueTypes["ContentImageLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null},ValueTypes["News"]],
listNews?: [{	filter?:ValueTypes["NewsWhere"] | null,	orderBy?:ValueTypes["NewsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["News"]],
paginateNews?: [{	filter?:ValueTypes["NewsWhere"] | null,	orderBy?:ValueTypes["NewsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsConnection"]],
validateCreateNews?: [{	data:ValueTypes["NewsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNews?: [{	by:ValueTypes["NewsUniqueWhere"],	data:ValueTypes["NewsUpdateInput"]},ValueTypes["_ValidationResult"]],
getStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["Stories"]],
listStories?: [{	filter?:ValueTypes["StoriesWhere"] | null,	orderBy?:ValueTypes["StoriesOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Stories"]],
paginateStories?: [{	filter?:ValueTypes["StoriesWhere"] | null,	orderBy?:ValueTypes["StoriesOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StoriesConnection"]],
validateCreateStories?: [{	data:ValueTypes["StoriesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	data:ValueTypes["StoriesUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null},ValueTypes["NewsPage"]],
listNewsPage?: [{	filter?:ValueTypes["NewsPageWhere"] | null,	orderBy?:ValueTypes["NewsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsPage"]],
paginateNewsPage?: [{	filter?:ValueTypes["NewsPageWhere"] | null,	orderBy?:ValueTypes["NewsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsPageConnection"]],
validateCreateNewsPage?: [{	data:ValueTypes["NewsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	data:ValueTypes["NewsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null},ValueTypes["StoriesPage"]],
listStoriesPage?: [{	filter?:ValueTypes["StoriesPageWhere"] | null,	orderBy?:ValueTypes["StoriesPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StoriesPage"]],
paginateStoriesPage?: [{	filter?:ValueTypes["StoriesPageWhere"] | null,	orderBy?:ValueTypes["StoriesPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StoriesPageConnection"]],
validateCreateStoriesPage?: [{	data:ValueTypes["StoriesPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	data:ValueTypes["StoriesPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null},ValueTypes["StoriesList"]],
listStoriesList?: [{	filter?:ValueTypes["StoriesListWhere"] | null,	orderBy?:ValueTypes["StoriesListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StoriesList"]],
paginateStoriesList?: [{	filter?:ValueTypes["StoriesListWhere"] | null,	orderBy?:ValueTypes["StoriesListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StoriesListConnection"]],
validateCreateStoriesList?: [{	data:ValueTypes["StoriesListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	data:ValueTypes["StoriesListUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: true
}>;
	["Info"]: AliasType<{
	description?:true,
		__typename?: true
}>;
	["Mutation"]: AliasType<{
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoCreateResult"]],
deleteFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeoDeleteResult"]],
updateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["FallbackSeoUpdateResult"]],
upsertFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	update:ValueTypes["FallbackSeoUpdateInput"],	create:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createProgram?: [{	data:ValueTypes["ProgramCreateInput"]},ValueTypes["ProgramCreateResult"]],
deleteProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null},ValueTypes["ProgramDeleteResult"]],
updateProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null,	data:ValueTypes["ProgramUpdateInput"]},ValueTypes["ProgramUpdateResult"]],
upsertProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null,	update:ValueTypes["ProgramUpdateInput"],	create:ValueTypes["ProgramCreateInput"]},ValueTypes["ProgramUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoCreateResult"]],
deleteYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideoDeleteResult"]],
updateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["YoutubeVideoUpdateResult"]],
upsertYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	update:ValueTypes["YoutubeVideoUpdateInput"],	create:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createBulletPoint?: [{	data:ValueTypes["BulletPointCreateInput"]},ValueTypes["BulletPointCreateResult"]],
deleteBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null},ValueTypes["BulletPointDeleteResult"]],
updateBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null,	data:ValueTypes["BulletPointUpdateInput"]},ValueTypes["BulletPointUpdateResult"]],
upsertBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null,	update:ValueTypes["BulletPointUpdateInput"],	create:ValueTypes["BulletPointCreateInput"]},ValueTypes["BulletPointUpsertResult"]],
createBulletPointItem?: [{	data:ValueTypes["BulletPointItemCreateInput"]},ValueTypes["BulletPointItemCreateResult"]],
deleteBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null},ValueTypes["BulletPointItemDeleteResult"]],
updateBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null,	data:ValueTypes["BulletPointItemUpdateInput"]},ValueTypes["BulletPointItemUpdateResult"]],
upsertBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null,	update:ValueTypes["BulletPointItemUpdateInput"],	create:ValueTypes["BulletPointItemCreateInput"]},ValueTypes["BulletPointItemUpsertResult"]],
createFileItem?: [{	data:ValueTypes["FileItemCreateInput"]},ValueTypes["FileItemCreateResult"]],
deleteFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null},ValueTypes["FileItemDeleteResult"]],
updateFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null,	data:ValueTypes["FileItemUpdateInput"]},ValueTypes["FileItemUpdateResult"]],
upsertFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null,	update:ValueTypes["FileItemUpdateInput"],	create:ValueTypes["FileItemCreateInput"]},ValueTypes["FileItemUpsertResult"]],
createFileList?: [{	data:ValueTypes["FileListCreateInput"]},ValueTypes["FileListCreateResult"]],
deleteFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null},ValueTypes["FileListDeleteResult"]],
updateFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null,	data:ValueTypes["FileListUpdateInput"]},ValueTypes["FileListUpdateResult"]],
upsertFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null,	update:ValueTypes["FileListUpdateInput"],	create:ValueTypes["FileListCreateInput"]},ValueTypes["FileListUpsertResult"]],
createFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	update:ValueTypes["FooterLinkUpdateInput"],	create:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkUpsertResult"]],
createFooterLinkGroups?: [{	data:ValueTypes["FooterLinkGroupsCreateInput"]},ValueTypes["FooterLinkGroupsCreateResult"]],
deleteFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null},ValueTypes["FooterLinkGroupsDeleteResult"]],
updateFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	data:ValueTypes["FooterLinkGroupsUpdateInput"]},ValueTypes["FooterLinkGroupsUpdateResult"]],
upsertFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	update:ValueTypes["FooterLinkGroupsUpdateInput"],	create:ValueTypes["FooterLinkGroupsCreateInput"]},ValueTypes["FooterLinkGroupsUpsertResult"]],
createTextItem?: [{	data:ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null},ValueTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null,	data:ValueTypes["TextItemUpdateInput"]},ValueTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null,	update:ValueTypes["TextItemUpdateInput"],	create:ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemUpsertResult"]],
createTextList?: [{	data:ValueTypes["TextListCreateInput"]},ValueTypes["TextListCreateResult"]],
deleteTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null},ValueTypes["TextListDeleteResult"]],
updateTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null,	data:ValueTypes["TextListUpdateInput"]},ValueTypes["TextListUpdateResult"]],
upsertTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null,	update:ValueTypes["TextListUpdateInput"],	create:ValueTypes["TextListCreateInput"]},ValueTypes["TextListUpsertResult"]],
createProgramPage?: [{	data:ValueTypes["ProgramPageCreateInput"]},ValueTypes["ProgramPageCreateResult"]],
deleteProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null},ValueTypes["ProgramPageDeleteResult"]],
updateProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null,	data:ValueTypes["ProgramPageUpdateInput"]},ValueTypes["ProgramPageUpdateResult"]],
upsertProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null,	update:ValueTypes["ProgramPageUpdateInput"],	create:ValueTypes["ProgramPageCreateInput"]},ValueTypes["ProgramPageUpsertResult"]],
createGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	update:ValueTypes["GenericPageUpdateInput"],	create:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageUpsertResult"]],
createStaff?: [{	data:ValueTypes["StaffCreateInput"]},ValueTypes["StaffCreateResult"]],
deleteStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null},ValueTypes["StaffDeleteResult"]],
updateStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null,	data:ValueTypes["StaffUpdateInput"]},ValueTypes["StaffUpdateResult"]],
upsertStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null,	update:ValueTypes["StaffUpdateInput"],	create:ValueTypes["StaffCreateInput"]},ValueTypes["StaffUpsertResult"]],
createStaffItem?: [{	data:ValueTypes["StaffItemCreateInput"]},ValueTypes["StaffItemCreateResult"]],
deleteStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null},ValueTypes["StaffItemDeleteResult"]],
updateStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null,	data:ValueTypes["StaffItemUpdateInput"]},ValueTypes["StaffItemUpdateResult"]],
upsertStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null,	update:ValueTypes["StaffItemUpdateInput"],	create:ValueTypes["StaffItemCreateInput"]},ValueTypes["StaffItemUpsertResult"]],
createStaffList?: [{	data:ValueTypes["StaffListCreateInput"]},ValueTypes["StaffListCreateResult"]],
deleteStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null},ValueTypes["StaffListDeleteResult"]],
updateStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null,	data:ValueTypes["StaffListUpdateInput"]},ValueTypes["StaffListUpdateResult"]],
upsertStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null,	update:ValueTypes["StaffListUpdateInput"],	create:ValueTypes["StaffListCreateInput"]},ValueTypes["StaffListUpsertResult"]],
createIcon?: [{	data:ValueTypes["IconCreateInput"]},ValueTypes["IconCreateResult"]],
deleteIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null},ValueTypes["IconDeleteResult"]],
updateIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null,	data:ValueTypes["IconUpdateInput"]},ValueTypes["IconUpdateResult"]],
upsertIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null,	update:ValueTypes["IconUpdateInput"],	create:ValueTypes["IconCreateInput"]},ValueTypes["IconUpsertResult"]],
createPrincipleItem?: [{	data:ValueTypes["PrincipleItemCreateInput"]},ValueTypes["PrincipleItemCreateResult"]],
deletePrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null},ValueTypes["PrincipleItemDeleteResult"]],
updatePrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null,	data:ValueTypes["PrincipleItemUpdateInput"]},ValueTypes["PrincipleItemUpdateResult"]],
upsertPrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null,	update:ValueTypes["PrincipleItemUpdateInput"],	create:ValueTypes["PrincipleItemCreateInput"]},ValueTypes["PrincipleItemUpsertResult"]],
createPrincipleList?: [{	data:ValueTypes["PrincipleListCreateInput"]},ValueTypes["PrincipleListCreateResult"]],
deletePrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null},ValueTypes["PrincipleListDeleteResult"]],
updatePrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null,	data:ValueTypes["PrincipleListUpdateInput"]},ValueTypes["PrincipleListUpdateResult"]],
upsertPrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null,	update:ValueTypes["PrincipleListUpdateInput"],	create:ValueTypes["PrincipleListCreateInput"]},ValueTypes["PrincipleListUpsertResult"]],
createLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	update:ValueTypes["LinkItemUpdateInput"],	create:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemUpsertResult"]],
createLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	update:ValueTypes["LinkListUpdateInput"],	create:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkSubGroup?: [{	data:ValueTypes["LinkSubGroupCreateInput"]},ValueTypes["LinkSubGroupCreateResult"]],
deleteLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null},ValueTypes["LinkSubGroupDeleteResult"]],
updateLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null,	data:ValueTypes["LinkSubGroupUpdateInput"]},ValueTypes["LinkSubGroupUpdateResult"]],
upsertLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null,	update:ValueTypes["LinkSubGroupUpdateInput"],	create:ValueTypes["LinkSubGroupCreateInput"]},ValueTypes["LinkSubGroupUpsertResult"]],
createYoutubeVideoList?: [{	data:ValueTypes["YoutubeVideoListCreateInput"]},ValueTypes["YoutubeVideoListCreateResult"]],
deleteYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null},ValueTypes["YoutubeVideoListDeleteResult"]],
updateYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	data:ValueTypes["YoutubeVideoListUpdateInput"]},ValueTypes["YoutubeVideoListUpdateResult"]],
upsertYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	update:ValueTypes["YoutubeVideoListUpdateInput"],	create:ValueTypes["YoutubeVideoListCreateInput"]},ValueTypes["YoutubeVideoListUpsertResult"]],
createYoutubeVideoListItem?: [{	data:ValueTypes["YoutubeVideoListItemCreateInput"]},ValueTypes["YoutubeVideoListItemCreateResult"]],
deleteYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null},ValueTypes["YoutubeVideoListItemDeleteResult"]],
updateYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	data:ValueTypes["YoutubeVideoListItemUpdateInput"]},ValueTypes["YoutubeVideoListItemUpdateResult"]],
upsertYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	update:ValueTypes["YoutubeVideoListItemUpdateInput"],	create:ValueTypes["YoutubeVideoListItemCreateInput"]},ValueTypes["YoutubeVideoListItemUpsertResult"]],
createImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	update:ValueTypes["ImageListUpdateInput"],	create:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	update:ValueTypes["ImageListItemUpdateInput"],	create:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemUpsertResult"]],
createCitationItem?: [{	data:ValueTypes["CitationItemCreateInput"]},ValueTypes["CitationItemCreateResult"]],
deleteCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null},ValueTypes["CitationItemDeleteResult"]],
updateCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null,	data:ValueTypes["CitationItemUpdateInput"]},ValueTypes["CitationItemUpdateResult"]],
upsertCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null,	update:ValueTypes["CitationItemUpdateInput"],	create:ValueTypes["CitationItemCreateInput"]},ValueTypes["CitationItemUpsertResult"]],
createCitationList?: [{	data:ValueTypes["CitationListCreateInput"]},ValueTypes["CitationListCreateResult"]],
deleteCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null},ValueTypes["CitationListDeleteResult"]],
updateCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null,	data:ValueTypes["CitationListUpdateInput"]},ValueTypes["CitationListUpdateResult"]],
upsertCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null,	update:ValueTypes["CitationListUpdateInput"],	create:ValueTypes["CitationListCreateInput"]},ValueTypes["CitationListUpsertResult"]],
createContentImageLinkItem?: [{	data:ValueTypes["ContentImageLinkItemCreateInput"]},ValueTypes["ContentImageLinkItemCreateResult"]],
deleteContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null},ValueTypes["ContentImageLinkItemDeleteResult"]],
updateContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	data:ValueTypes["ContentImageLinkItemUpdateInput"]},ValueTypes["ContentImageLinkItemUpdateResult"]],
upsertContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	update:ValueTypes["ContentImageLinkItemUpdateInput"],	create:ValueTypes["ContentImageLinkItemCreateInput"]},ValueTypes["ContentImageLinkItemUpsertResult"]],
createContentImageLinkList?: [{	data:ValueTypes["ContentImageLinkListCreateInput"]},ValueTypes["ContentImageLinkListCreateResult"]],
deleteContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null},ValueTypes["ContentImageLinkListDeleteResult"]],
updateContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	data:ValueTypes["ContentImageLinkListUpdateInput"]},ValueTypes["ContentImageLinkListUpdateResult"]],
upsertContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	update:ValueTypes["ContentImageLinkListUpdateInput"],	create:ValueTypes["ContentImageLinkListCreateInput"]},ValueTypes["ContentImageLinkListUpsertResult"]],
createNews?: [{	data:ValueTypes["NewsCreateInput"]},ValueTypes["NewsCreateResult"]],
deleteNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null},ValueTypes["NewsDeleteResult"]],
updateNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null,	data:ValueTypes["NewsUpdateInput"]},ValueTypes["NewsUpdateResult"]],
upsertNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null,	update:ValueTypes["NewsUpdateInput"],	create:ValueTypes["NewsCreateInput"]},ValueTypes["NewsUpsertResult"]],
createStories?: [{	data:ValueTypes["StoriesCreateInput"]},ValueTypes["StoriesCreateResult"]],
deleteStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["StoriesDeleteResult"]],
updateStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null,	data:ValueTypes["StoriesUpdateInput"]},ValueTypes["StoriesUpdateResult"]],
upsertStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null,	update:ValueTypes["StoriesUpdateInput"],	create:ValueTypes["StoriesCreateInput"]},ValueTypes["StoriesUpsertResult"]],
createNewsPage?: [{	data:ValueTypes["NewsPageCreateInput"]},ValueTypes["NewsPageCreateResult"]],
deleteNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null},ValueTypes["NewsPageDeleteResult"]],
updateNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null,	data:ValueTypes["NewsPageUpdateInput"]},ValueTypes["NewsPageUpdateResult"]],
upsertNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null,	update:ValueTypes["NewsPageUpdateInput"],	create:ValueTypes["NewsPageCreateInput"]},ValueTypes["NewsPageUpsertResult"]],
createStoriesPage?: [{	data:ValueTypes["StoriesPageCreateInput"]},ValueTypes["StoriesPageCreateResult"]],
deleteStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null},ValueTypes["StoriesPageDeleteResult"]],
updateStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null,	data:ValueTypes["StoriesPageUpdateInput"]},ValueTypes["StoriesPageUpdateResult"]],
upsertStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null,	update:ValueTypes["StoriesPageUpdateInput"],	create:ValueTypes["StoriesPageCreateInput"]},ValueTypes["StoriesPageUpsertResult"]],
createStoriesList?: [{	data:ValueTypes["StoriesListCreateInput"]},ValueTypes["StoriesListCreateResult"]],
deleteStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null},ValueTypes["StoriesListDeleteResult"]],
updateStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null,	data:ValueTypes["StoriesListUpdateInput"]},ValueTypes["StoriesListUpdateResult"]],
upsertStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null,	update:ValueTypes["StoriesListUpdateInput"],	create:ValueTypes["StoriesListCreateInput"]},ValueTypes["StoriesListUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null,	acl?:ValueTypes["S3Acl"] | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: true
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationResult"]:AliasType<{
		ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"];
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoCreateResult']?: Omit<ValueTypes["FallbackSeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoDeleteResult']?: Omit<ValueTypes["FallbackSeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoUpdateResult']?: Omit<ValueTypes["FallbackSeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoUpsertResult']?: Omit<ValueTypes["FallbackSeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageCreateResult']?: Omit<ValueTypes["HomePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageDeleteResult']?: Omit<ValueTypes["HomePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpdateResult']?: Omit<ValueTypes["HomePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpsertResult']?: Omit<ValueTypes["HomePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramCreateResult']?: Omit<ValueTypes["ProgramCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramDeleteResult']?: Omit<ValueTypes["ProgramDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramUpdateResult']?: Omit<ValueTypes["ProgramUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramUpsertResult']?: Omit<ValueTypes["ProgramUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoCreateResult']?: Omit<ValueTypes["YoutubeVideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoDeleteResult']?: Omit<ValueTypes["YoutubeVideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoUpdateResult']?: Omit<ValueTypes["YoutubeVideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoUpsertResult']?: Omit<ValueTypes["YoutubeVideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointCreateResult']?: Omit<ValueTypes["BulletPointCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointDeleteResult']?: Omit<ValueTypes["BulletPointDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointUpdateResult']?: Omit<ValueTypes["BulletPointUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointUpsertResult']?: Omit<ValueTypes["BulletPointUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointItemCreateResult']?: Omit<ValueTypes["BulletPointItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointItemDeleteResult']?: Omit<ValueTypes["BulletPointItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointItemUpdateResult']?: Omit<ValueTypes["BulletPointItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BulletPointItemUpsertResult']?: Omit<ValueTypes["BulletPointItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileItemCreateResult']?: Omit<ValueTypes["FileItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileItemDeleteResult']?: Omit<ValueTypes["FileItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileItemUpdateResult']?: Omit<ValueTypes["FileItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileItemUpsertResult']?: Omit<ValueTypes["FileItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileListCreateResult']?: Omit<ValueTypes["FileListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileListDeleteResult']?: Omit<ValueTypes["FileListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileListUpdateResult']?: Omit<ValueTypes["FileListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileListUpsertResult']?: Omit<ValueTypes["FileListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkCreateResult']?: Omit<ValueTypes["FooterLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkDeleteResult']?: Omit<ValueTypes["FooterLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkUpdateResult']?: Omit<ValueTypes["FooterLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkUpsertResult']?: Omit<ValueTypes["FooterLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkGroupsCreateResult']?: Omit<ValueTypes["FooterLinkGroupsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkGroupsDeleteResult']?: Omit<ValueTypes["FooterLinkGroupsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkGroupsUpdateResult']?: Omit<ValueTypes["FooterLinkGroupsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkGroupsUpsertResult']?: Omit<ValueTypes["FooterLinkGroupsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemCreateResult']?: Omit<ValueTypes["TextItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemDeleteResult']?: Omit<ValueTypes["TextItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemUpdateResult']?: Omit<ValueTypes["TextItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemUpsertResult']?: Omit<ValueTypes["TextItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListCreateResult']?: Omit<ValueTypes["TextListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListDeleteResult']?: Omit<ValueTypes["TextListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListUpdateResult']?: Omit<ValueTypes["TextListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListUpsertResult']?: Omit<ValueTypes["TextListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramPageCreateResult']?: Omit<ValueTypes["ProgramPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramPageDeleteResult']?: Omit<ValueTypes["ProgramPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramPageUpdateResult']?: Omit<ValueTypes["ProgramPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProgramPageUpsertResult']?: Omit<ValueTypes["ProgramPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageCreateResult']?: Omit<ValueTypes["GenericPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageDeleteResult']?: Omit<ValueTypes["GenericPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpdateResult']?: Omit<ValueTypes["GenericPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpsertResult']?: Omit<ValueTypes["GenericPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffCreateResult']?: Omit<ValueTypes["StaffCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffDeleteResult']?: Omit<ValueTypes["StaffDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffUpdateResult']?: Omit<ValueTypes["StaffUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffUpsertResult']?: Omit<ValueTypes["StaffUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffItemCreateResult']?: Omit<ValueTypes["StaffItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffItemDeleteResult']?: Omit<ValueTypes["StaffItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffItemUpdateResult']?: Omit<ValueTypes["StaffItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffItemUpsertResult']?: Omit<ValueTypes["StaffItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffListCreateResult']?: Omit<ValueTypes["StaffListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffListDeleteResult']?: Omit<ValueTypes["StaffListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffListUpdateResult']?: Omit<ValueTypes["StaffListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffListUpsertResult']?: Omit<ValueTypes["StaffListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconCreateResult']?: Omit<ValueTypes["IconCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconDeleteResult']?: Omit<ValueTypes["IconDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconUpdateResult']?: Omit<ValueTypes["IconUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconUpsertResult']?: Omit<ValueTypes["IconUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleItemCreateResult']?: Omit<ValueTypes["PrincipleItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleItemDeleteResult']?: Omit<ValueTypes["PrincipleItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleItemUpdateResult']?: Omit<ValueTypes["PrincipleItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleItemUpsertResult']?: Omit<ValueTypes["PrincipleItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleListCreateResult']?: Omit<ValueTypes["PrincipleListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleListDeleteResult']?: Omit<ValueTypes["PrincipleListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleListUpdateResult']?: Omit<ValueTypes["PrincipleListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrincipleListUpsertResult']?: Omit<ValueTypes["PrincipleListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemCreateResult']?: Omit<ValueTypes["LinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemDeleteResult']?: Omit<ValueTypes["LinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpdateResult']?: Omit<ValueTypes["LinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpsertResult']?: Omit<ValueTypes["LinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListCreateResult']?: Omit<ValueTypes["LinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListDeleteResult']?: Omit<ValueTypes["LinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpdateResult']?: Omit<ValueTypes["LinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpsertResult']?: Omit<ValueTypes["LinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSubGroupCreateResult']?: Omit<ValueTypes["LinkSubGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSubGroupDeleteResult']?: Omit<ValueTypes["LinkSubGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSubGroupUpdateResult']?: Omit<ValueTypes["LinkSubGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSubGroupUpsertResult']?: Omit<ValueTypes["LinkSubGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListCreateResult']?: Omit<ValueTypes["YoutubeVideoListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListDeleteResult']?: Omit<ValueTypes["YoutubeVideoListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListUpdateResult']?: Omit<ValueTypes["YoutubeVideoListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListUpsertResult']?: Omit<ValueTypes["YoutubeVideoListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListItemCreateResult']?: Omit<ValueTypes["YoutubeVideoListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListItemDeleteResult']?: Omit<ValueTypes["YoutubeVideoListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListItemUpdateResult']?: Omit<ValueTypes["YoutubeVideoListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoListItemUpsertResult']?: Omit<ValueTypes["YoutubeVideoListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListCreateResult']?: Omit<ValueTypes["ImageListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListDeleteResult']?: Omit<ValueTypes["ImageListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpdateResult']?: Omit<ValueTypes["ImageListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpsertResult']?: Omit<ValueTypes["ImageListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemCreateResult']?: Omit<ValueTypes["ImageListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemDeleteResult']?: Omit<ValueTypes["ImageListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpdateResult']?: Omit<ValueTypes["ImageListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpsertResult']?: Omit<ValueTypes["ImageListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationItemCreateResult']?: Omit<ValueTypes["CitationItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationItemDeleteResult']?: Omit<ValueTypes["CitationItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationItemUpdateResult']?: Omit<ValueTypes["CitationItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationItemUpsertResult']?: Omit<ValueTypes["CitationItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationListCreateResult']?: Omit<ValueTypes["CitationListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationListDeleteResult']?: Omit<ValueTypes["CitationListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationListUpdateResult']?: Omit<ValueTypes["CitationListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CitationListUpsertResult']?: Omit<ValueTypes["CitationListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkItemCreateResult']?: Omit<ValueTypes["ContentImageLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkItemDeleteResult']?: Omit<ValueTypes["ContentImageLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkItemUpdateResult']?: Omit<ValueTypes["ContentImageLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkItemUpsertResult']?: Omit<ValueTypes["ContentImageLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkListCreateResult']?: Omit<ValueTypes["ContentImageLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkListDeleteResult']?: Omit<ValueTypes["ContentImageLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkListUpdateResult']?: Omit<ValueTypes["ContentImageLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentImageLinkListUpsertResult']?: Omit<ValueTypes["ContentImageLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsCreateResult']?: Omit<ValueTypes["NewsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsDeleteResult']?: Omit<ValueTypes["NewsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsUpdateResult']?: Omit<ValueTypes["NewsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsUpsertResult']?: Omit<ValueTypes["NewsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesCreateResult']?: Omit<ValueTypes["StoriesCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesDeleteResult']?: Omit<ValueTypes["StoriesDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesUpdateResult']?: Omit<ValueTypes["StoriesUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesUpsertResult']?: Omit<ValueTypes["StoriesUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsPageCreateResult']?: Omit<ValueTypes["NewsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsPageDeleteResult']?: Omit<ValueTypes["NewsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsPageUpdateResult']?: Omit<ValueTypes["NewsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsPageUpsertResult']?: Omit<ValueTypes["NewsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesPageCreateResult']?: Omit<ValueTypes["StoriesPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesPageDeleteResult']?: Omit<ValueTypes["StoriesPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesPageUpdateResult']?: Omit<ValueTypes["StoriesPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesPageUpsertResult']?: Omit<ValueTypes["StoriesPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesListCreateResult']?: Omit<ValueTypes["StoriesListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesListDeleteResult']?: Omit<ValueTypes["StoriesListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesListUpdateResult']?: Omit<ValueTypes["StoriesListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoriesListUpsertResult']?: Omit<ValueTypes["StoriesListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: true
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:true,
	message?:true,
		__typename?: true
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["ContentDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
		__typename?: true
}>;
	["FallbackSeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProgramCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Program"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProgramDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Program"],
		__typename?: true
}>;
	["ProgramUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Program"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProgramUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Program"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
		__typename?: true
}>;
	["YoutubeVideoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BulletPointCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPoint"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BulletPointDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPoint"],
		__typename?: true
}>;
	["BulletPointUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPoint"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BulletPointUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPoint"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BulletPointItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPointItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BulletPointItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPointItem"],
		__typename?: true
}>;
	["BulletPointItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPointItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BulletPointItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BulletPointItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileItem"],
		__typename?: true
}>;
	["FileItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileList"],
		__typename?: true
}>;
	["FileListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
		__typename?: true
}>;
	["FooterLinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLinkGroupsCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinkGroups"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLinkGroupsDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinkGroups"],
		__typename?: true
}>;
	["FooterLinkGroupsUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinkGroups"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLinkGroupsUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinkGroups"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TextItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TextItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
		__typename?: true
}>;
	["TextItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TextItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TextListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TextListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
		__typename?: true
}>;
	["TextListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TextListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProgramPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProgramPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProgramPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProgramPage"],
		__typename?: true
}>;
	["ProgramPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProgramPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProgramPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProgramPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GenericPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GenericPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
		__typename?: true
}>;
	["GenericPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GenericPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
		__typename?: true
}>;
	["StaffUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffItem"],
		__typename?: true
}>;
	["StaffItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffList"],
		__typename?: true
}>;
	["StaffListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StaffListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StaffList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["IconCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["IconDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
		__typename?: true
}>;
	["IconUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["IconUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PrincipleItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PrincipleItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleItem"],
		__typename?: true
}>;
	["PrincipleItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PrincipleItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PrincipleListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PrincipleListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleList"],
		__typename?: true
}>;
	["PrincipleListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PrincipleListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrincipleList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
		__typename?: true
}>;
	["LinkItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
		__typename?: true
}>;
	["LinkListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkSubGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSubGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkSubGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSubGroup"],
		__typename?: true
}>;
	["LinkSubGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSubGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkSubGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSubGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoList"],
		__typename?: true
}>;
	["YoutubeVideoListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoListItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoListItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoListItem"],
		__typename?: true
}>;
	["YoutubeVideoListItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoListItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideoListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
		__typename?: true
}>;
	["ImageListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
		__typename?: true
}>;
	["ImageListItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CitationItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CitationItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationItem"],
		__typename?: true
}>;
	["CitationItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CitationItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CitationListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CitationListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationList"],
		__typename?: true
}>;
	["CitationListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CitationListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CitationList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentImageLinkItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentImageLinkItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkItem"],
		__typename?: true
}>;
	["ContentImageLinkItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentImageLinkItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentImageLinkListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentImageLinkListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkList"],
		__typename?: true
}>;
	["ContentImageLinkListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentImageLinkListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentImageLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["News"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["News"],
		__typename?: true
}>;
	["NewsUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["News"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["News"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Stories"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Stories"],
		__typename?: true
}>;
	["StoriesUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Stories"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Stories"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsPage"],
		__typename?: true
}>;
	["NewsPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesPage"],
		__typename?: true
}>;
	["StoriesPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesList"],
		__typename?: true
}>;
	["StoriesListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StoriesListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StoriesList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationTransaction"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoCreateResult"]],
deleteFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeoDeleteResult"]],
updateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["FallbackSeoUpdateResult"]],
upsertFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	update:ValueTypes["FallbackSeoUpdateInput"],	create:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createProgram?: [{	data:ValueTypes["ProgramCreateInput"]},ValueTypes["ProgramCreateResult"]],
deleteProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null},ValueTypes["ProgramDeleteResult"]],
updateProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null,	data:ValueTypes["ProgramUpdateInput"]},ValueTypes["ProgramUpdateResult"]],
upsertProgram?: [{	by:ValueTypes["ProgramUniqueWhere"],	filter?:ValueTypes["ProgramWhere"] | null,	update:ValueTypes["ProgramUpdateInput"],	create:ValueTypes["ProgramCreateInput"]},ValueTypes["ProgramUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoCreateResult"]],
deleteYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideoDeleteResult"]],
updateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["YoutubeVideoUpdateResult"]],
upsertYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	update:ValueTypes["YoutubeVideoUpdateInput"],	create:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createBulletPoint?: [{	data:ValueTypes["BulletPointCreateInput"]},ValueTypes["BulletPointCreateResult"]],
deleteBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null},ValueTypes["BulletPointDeleteResult"]],
updateBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null,	data:ValueTypes["BulletPointUpdateInput"]},ValueTypes["BulletPointUpdateResult"]],
upsertBulletPoint?: [{	by:ValueTypes["BulletPointUniqueWhere"],	filter?:ValueTypes["BulletPointWhere"] | null,	update:ValueTypes["BulletPointUpdateInput"],	create:ValueTypes["BulletPointCreateInput"]},ValueTypes["BulletPointUpsertResult"]],
createBulletPointItem?: [{	data:ValueTypes["BulletPointItemCreateInput"]},ValueTypes["BulletPointItemCreateResult"]],
deleteBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null},ValueTypes["BulletPointItemDeleteResult"]],
updateBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null,	data:ValueTypes["BulletPointItemUpdateInput"]},ValueTypes["BulletPointItemUpdateResult"]],
upsertBulletPointItem?: [{	by:ValueTypes["BulletPointItemUniqueWhere"],	filter?:ValueTypes["BulletPointItemWhere"] | null,	update:ValueTypes["BulletPointItemUpdateInput"],	create:ValueTypes["BulletPointItemCreateInput"]},ValueTypes["BulletPointItemUpsertResult"]],
createFileItem?: [{	data:ValueTypes["FileItemCreateInput"]},ValueTypes["FileItemCreateResult"]],
deleteFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null},ValueTypes["FileItemDeleteResult"]],
updateFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null,	data:ValueTypes["FileItemUpdateInput"]},ValueTypes["FileItemUpdateResult"]],
upsertFileItem?: [{	by:ValueTypes["FileItemUniqueWhere"],	filter?:ValueTypes["FileItemWhere"] | null,	update:ValueTypes["FileItemUpdateInput"],	create:ValueTypes["FileItemCreateInput"]},ValueTypes["FileItemUpsertResult"]],
createFileList?: [{	data:ValueTypes["FileListCreateInput"]},ValueTypes["FileListCreateResult"]],
deleteFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null},ValueTypes["FileListDeleteResult"]],
updateFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null,	data:ValueTypes["FileListUpdateInput"]},ValueTypes["FileListUpdateResult"]],
upsertFileList?: [{	by:ValueTypes["FileListUniqueWhere"],	filter?:ValueTypes["FileListWhere"] | null,	update:ValueTypes["FileListUpdateInput"],	create:ValueTypes["FileListCreateInput"]},ValueTypes["FileListUpsertResult"]],
createFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	update:ValueTypes["FooterLinkUpdateInput"],	create:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkUpsertResult"]],
createFooterLinkGroups?: [{	data:ValueTypes["FooterLinkGroupsCreateInput"]},ValueTypes["FooterLinkGroupsCreateResult"]],
deleteFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null},ValueTypes["FooterLinkGroupsDeleteResult"]],
updateFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	data:ValueTypes["FooterLinkGroupsUpdateInput"]},ValueTypes["FooterLinkGroupsUpdateResult"]],
upsertFooterLinkGroups?: [{	by:ValueTypes["FooterLinkGroupsUniqueWhere"],	filter?:ValueTypes["FooterLinkGroupsWhere"] | null,	update:ValueTypes["FooterLinkGroupsUpdateInput"],	create:ValueTypes["FooterLinkGroupsCreateInput"]},ValueTypes["FooterLinkGroupsUpsertResult"]],
createTextItem?: [{	data:ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null},ValueTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null,	data:ValueTypes["TextItemUpdateInput"]},ValueTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by:ValueTypes["TextItemUniqueWhere"],	filter?:ValueTypes["TextItemWhere"] | null,	update:ValueTypes["TextItemUpdateInput"],	create:ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemUpsertResult"]],
createTextList?: [{	data:ValueTypes["TextListCreateInput"]},ValueTypes["TextListCreateResult"]],
deleteTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null},ValueTypes["TextListDeleteResult"]],
updateTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null,	data:ValueTypes["TextListUpdateInput"]},ValueTypes["TextListUpdateResult"]],
upsertTextList?: [{	by:ValueTypes["TextListUniqueWhere"],	filter?:ValueTypes["TextListWhere"] | null,	update:ValueTypes["TextListUpdateInput"],	create:ValueTypes["TextListCreateInput"]},ValueTypes["TextListUpsertResult"]],
createProgramPage?: [{	data:ValueTypes["ProgramPageCreateInput"]},ValueTypes["ProgramPageCreateResult"]],
deleteProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null},ValueTypes["ProgramPageDeleteResult"]],
updateProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null,	data:ValueTypes["ProgramPageUpdateInput"]},ValueTypes["ProgramPageUpdateResult"]],
upsertProgramPage?: [{	by:ValueTypes["ProgramPageUniqueWhere"],	filter?:ValueTypes["ProgramPageWhere"] | null,	update:ValueTypes["ProgramPageUpdateInput"],	create:ValueTypes["ProgramPageCreateInput"]},ValueTypes["ProgramPageUpsertResult"]],
createGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	update:ValueTypes["GenericPageUpdateInput"],	create:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageUpsertResult"]],
createStaff?: [{	data:ValueTypes["StaffCreateInput"]},ValueTypes["StaffCreateResult"]],
deleteStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null},ValueTypes["StaffDeleteResult"]],
updateStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null,	data:ValueTypes["StaffUpdateInput"]},ValueTypes["StaffUpdateResult"]],
upsertStaff?: [{	by:ValueTypes["StaffUniqueWhere"],	filter?:ValueTypes["StaffWhere"] | null,	update:ValueTypes["StaffUpdateInput"],	create:ValueTypes["StaffCreateInput"]},ValueTypes["StaffUpsertResult"]],
createStaffItem?: [{	data:ValueTypes["StaffItemCreateInput"]},ValueTypes["StaffItemCreateResult"]],
deleteStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null},ValueTypes["StaffItemDeleteResult"]],
updateStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null,	data:ValueTypes["StaffItemUpdateInput"]},ValueTypes["StaffItemUpdateResult"]],
upsertStaffItem?: [{	by:ValueTypes["StaffItemUniqueWhere"],	filter?:ValueTypes["StaffItemWhere"] | null,	update:ValueTypes["StaffItemUpdateInput"],	create:ValueTypes["StaffItemCreateInput"]},ValueTypes["StaffItemUpsertResult"]],
createStaffList?: [{	data:ValueTypes["StaffListCreateInput"]},ValueTypes["StaffListCreateResult"]],
deleteStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null},ValueTypes["StaffListDeleteResult"]],
updateStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null,	data:ValueTypes["StaffListUpdateInput"]},ValueTypes["StaffListUpdateResult"]],
upsertStaffList?: [{	by:ValueTypes["StaffListUniqueWhere"],	filter?:ValueTypes["StaffListWhere"] | null,	update:ValueTypes["StaffListUpdateInput"],	create:ValueTypes["StaffListCreateInput"]},ValueTypes["StaffListUpsertResult"]],
createIcon?: [{	data:ValueTypes["IconCreateInput"]},ValueTypes["IconCreateResult"]],
deleteIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null},ValueTypes["IconDeleteResult"]],
updateIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null,	data:ValueTypes["IconUpdateInput"]},ValueTypes["IconUpdateResult"]],
upsertIcon?: [{	by:ValueTypes["IconUniqueWhere"],	filter?:ValueTypes["IconWhere"] | null,	update:ValueTypes["IconUpdateInput"],	create:ValueTypes["IconCreateInput"]},ValueTypes["IconUpsertResult"]],
createPrincipleItem?: [{	data:ValueTypes["PrincipleItemCreateInput"]},ValueTypes["PrincipleItemCreateResult"]],
deletePrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null},ValueTypes["PrincipleItemDeleteResult"]],
updatePrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null,	data:ValueTypes["PrincipleItemUpdateInput"]},ValueTypes["PrincipleItemUpdateResult"]],
upsertPrincipleItem?: [{	by:ValueTypes["PrincipleItemUniqueWhere"],	filter?:ValueTypes["PrincipleItemWhere"] | null,	update:ValueTypes["PrincipleItemUpdateInput"],	create:ValueTypes["PrincipleItemCreateInput"]},ValueTypes["PrincipleItemUpsertResult"]],
createPrincipleList?: [{	data:ValueTypes["PrincipleListCreateInput"]},ValueTypes["PrincipleListCreateResult"]],
deletePrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null},ValueTypes["PrincipleListDeleteResult"]],
updatePrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null,	data:ValueTypes["PrincipleListUpdateInput"]},ValueTypes["PrincipleListUpdateResult"]],
upsertPrincipleList?: [{	by:ValueTypes["PrincipleListUniqueWhere"],	filter?:ValueTypes["PrincipleListWhere"] | null,	update:ValueTypes["PrincipleListUpdateInput"],	create:ValueTypes["PrincipleListCreateInput"]},ValueTypes["PrincipleListUpsertResult"]],
createLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	update:ValueTypes["LinkItemUpdateInput"],	create:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemUpsertResult"]],
createLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	update:ValueTypes["LinkListUpdateInput"],	create:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkSubGroup?: [{	data:ValueTypes["LinkSubGroupCreateInput"]},ValueTypes["LinkSubGroupCreateResult"]],
deleteLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null},ValueTypes["LinkSubGroupDeleteResult"]],
updateLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null,	data:ValueTypes["LinkSubGroupUpdateInput"]},ValueTypes["LinkSubGroupUpdateResult"]],
upsertLinkSubGroup?: [{	by:ValueTypes["LinkSubGroupUniqueWhere"],	filter?:ValueTypes["LinkSubGroupWhere"] | null,	update:ValueTypes["LinkSubGroupUpdateInput"],	create:ValueTypes["LinkSubGroupCreateInput"]},ValueTypes["LinkSubGroupUpsertResult"]],
createYoutubeVideoList?: [{	data:ValueTypes["YoutubeVideoListCreateInput"]},ValueTypes["YoutubeVideoListCreateResult"]],
deleteYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null},ValueTypes["YoutubeVideoListDeleteResult"]],
updateYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	data:ValueTypes["YoutubeVideoListUpdateInput"]},ValueTypes["YoutubeVideoListUpdateResult"]],
upsertYoutubeVideoList?: [{	by:ValueTypes["YoutubeVideoListUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListWhere"] | null,	update:ValueTypes["YoutubeVideoListUpdateInput"],	create:ValueTypes["YoutubeVideoListCreateInput"]},ValueTypes["YoutubeVideoListUpsertResult"]],
createYoutubeVideoListItem?: [{	data:ValueTypes["YoutubeVideoListItemCreateInput"]},ValueTypes["YoutubeVideoListItemCreateResult"]],
deleteYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null},ValueTypes["YoutubeVideoListItemDeleteResult"]],
updateYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	data:ValueTypes["YoutubeVideoListItemUpdateInput"]},ValueTypes["YoutubeVideoListItemUpdateResult"]],
upsertYoutubeVideoListItem?: [{	by:ValueTypes["YoutubeVideoListItemUniqueWhere"],	filter?:ValueTypes["YoutubeVideoListItemWhere"] | null,	update:ValueTypes["YoutubeVideoListItemUpdateInput"],	create:ValueTypes["YoutubeVideoListItemCreateInput"]},ValueTypes["YoutubeVideoListItemUpsertResult"]],
createImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	update:ValueTypes["ImageListUpdateInput"],	create:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	update:ValueTypes["ImageListItemUpdateInput"],	create:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemUpsertResult"]],
createCitationItem?: [{	data:ValueTypes["CitationItemCreateInput"]},ValueTypes["CitationItemCreateResult"]],
deleteCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null},ValueTypes["CitationItemDeleteResult"]],
updateCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null,	data:ValueTypes["CitationItemUpdateInput"]},ValueTypes["CitationItemUpdateResult"]],
upsertCitationItem?: [{	by:ValueTypes["CitationItemUniqueWhere"],	filter?:ValueTypes["CitationItemWhere"] | null,	update:ValueTypes["CitationItemUpdateInput"],	create:ValueTypes["CitationItemCreateInput"]},ValueTypes["CitationItemUpsertResult"]],
createCitationList?: [{	data:ValueTypes["CitationListCreateInput"]},ValueTypes["CitationListCreateResult"]],
deleteCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null},ValueTypes["CitationListDeleteResult"]],
updateCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null,	data:ValueTypes["CitationListUpdateInput"]},ValueTypes["CitationListUpdateResult"]],
upsertCitationList?: [{	by:ValueTypes["CitationListUniqueWhere"],	filter?:ValueTypes["CitationListWhere"] | null,	update:ValueTypes["CitationListUpdateInput"],	create:ValueTypes["CitationListCreateInput"]},ValueTypes["CitationListUpsertResult"]],
createContentImageLinkItem?: [{	data:ValueTypes["ContentImageLinkItemCreateInput"]},ValueTypes["ContentImageLinkItemCreateResult"]],
deleteContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null},ValueTypes["ContentImageLinkItemDeleteResult"]],
updateContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	data:ValueTypes["ContentImageLinkItemUpdateInput"]},ValueTypes["ContentImageLinkItemUpdateResult"]],
upsertContentImageLinkItem?: [{	by:ValueTypes["ContentImageLinkItemUniqueWhere"],	filter?:ValueTypes["ContentImageLinkItemWhere"] | null,	update:ValueTypes["ContentImageLinkItemUpdateInput"],	create:ValueTypes["ContentImageLinkItemCreateInput"]},ValueTypes["ContentImageLinkItemUpsertResult"]],
createContentImageLinkList?: [{	data:ValueTypes["ContentImageLinkListCreateInput"]},ValueTypes["ContentImageLinkListCreateResult"]],
deleteContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null},ValueTypes["ContentImageLinkListDeleteResult"]],
updateContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	data:ValueTypes["ContentImageLinkListUpdateInput"]},ValueTypes["ContentImageLinkListUpdateResult"]],
upsertContentImageLinkList?: [{	by:ValueTypes["ContentImageLinkListUniqueWhere"],	filter?:ValueTypes["ContentImageLinkListWhere"] | null,	update:ValueTypes["ContentImageLinkListUpdateInput"],	create:ValueTypes["ContentImageLinkListCreateInput"]},ValueTypes["ContentImageLinkListUpsertResult"]],
createNews?: [{	data:ValueTypes["NewsCreateInput"]},ValueTypes["NewsCreateResult"]],
deleteNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null},ValueTypes["NewsDeleteResult"]],
updateNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null,	data:ValueTypes["NewsUpdateInput"]},ValueTypes["NewsUpdateResult"]],
upsertNews?: [{	by:ValueTypes["NewsUniqueWhere"],	filter?:ValueTypes["NewsWhere"] | null,	update:ValueTypes["NewsUpdateInput"],	create:ValueTypes["NewsCreateInput"]},ValueTypes["NewsUpsertResult"]],
createStories?: [{	data:ValueTypes["StoriesCreateInput"]},ValueTypes["StoriesCreateResult"]],
deleteStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null},ValueTypes["StoriesDeleteResult"]],
updateStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null,	data:ValueTypes["StoriesUpdateInput"]},ValueTypes["StoriesUpdateResult"]],
upsertStories?: [{	by:ValueTypes["StoriesUniqueWhere"],	filter?:ValueTypes["StoriesWhere"] | null,	update:ValueTypes["StoriesUpdateInput"],	create:ValueTypes["StoriesCreateInput"]},ValueTypes["StoriesUpsertResult"]],
createNewsPage?: [{	data:ValueTypes["NewsPageCreateInput"]},ValueTypes["NewsPageCreateResult"]],
deleteNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null},ValueTypes["NewsPageDeleteResult"]],
updateNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null,	data:ValueTypes["NewsPageUpdateInput"]},ValueTypes["NewsPageUpdateResult"]],
upsertNewsPage?: [{	by:ValueTypes["NewsPageUniqueWhere"],	filter?:ValueTypes["NewsPageWhere"] | null,	update:ValueTypes["NewsPageUpdateInput"],	create:ValueTypes["NewsPageCreateInput"]},ValueTypes["NewsPageUpsertResult"]],
createStoriesPage?: [{	data:ValueTypes["StoriesPageCreateInput"]},ValueTypes["StoriesPageCreateResult"]],
deleteStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null},ValueTypes["StoriesPageDeleteResult"]],
updateStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null,	data:ValueTypes["StoriesPageUpdateInput"]},ValueTypes["StoriesPageUpdateResult"]],
upsertStoriesPage?: [{	by:ValueTypes["StoriesPageUniqueWhere"],	filter?:ValueTypes["StoriesPageWhere"] | null,	update:ValueTypes["StoriesPageUpdateInput"],	create:ValueTypes["StoriesPageCreateInput"]},ValueTypes["StoriesPageUpsertResult"]],
createStoriesList?: [{	data:ValueTypes["StoriesListCreateInput"]},ValueTypes["StoriesListCreateResult"]],
deleteStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null},ValueTypes["StoriesListDeleteResult"]],
updateStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null,	data:ValueTypes["StoriesListUpdateInput"]},ValueTypes["StoriesListUpdateResult"]],
upsertStoriesList?: [{	by:ValueTypes["StoriesListUniqueWhere"],	filter?:ValueTypes["StoriesListWhere"] | null,	update:ValueTypes["StoriesListUpdateInput"],	create:ValueTypes["StoriesListCreateInput"]},ValueTypes["StoriesListUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: true
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null
};
	/** Json custom scalar type */
["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: true
}>;
	["_Entity"]: AliasType<{
	name?:true,
	customPrimaryAllowed?:true,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: true
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:true,
		__typename?: true
}>;
	["_Field"]:AliasType<{
		name?:true,
	type?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: true
}>;
	["_Column"]: AliasType<{
	name?:true,
	type?:true,
	enumName?:true,
	defaultValue?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:true,
	direction?:true,
		__typename?: true
}>;
	["_Relation"]: AliasType<{
	name?:true,
	type?:true,
	side?:true,
	targetEntity?:true,
	ownedBy?:true,
	inversedBy?:true,
	nullable?:true,
	onDelete?:true,
	orphanRemoval?:true,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:true,
		__typename?: true
}>;
	["_Validator"]: AliasType<{
	operation?:true,
	arguments?:ValueTypes["_Argument"],
		__typename?: true
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: true
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:true,
		__typename?: true
}>;
	["_PathArgument"]: AliasType<{
	path?:true,
		__typename?: true
}>;
	["_LiteralArgument"]: AliasType<{
	value?:true,
		__typename?: true
}>;
	["_RuleMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["_Enum"]: AliasType<{
	name?:true,
	values?:true,
		__typename?: true
}>;
	["S3SignedUpload"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
	publicUrl?:true,
		__typename?: true
}>;
	["S3Header"]: AliasType<{
	key?:true,
	value?:true,
		__typename?: true
}>;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
		__typename?: true
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getFallbackSeo?:ModelTypes["FallbackSeo"],
	listFallbackSeo:ModelTypes["FallbackSeo"][],
	paginateFallbackSeo:ModelTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo:ModelTypes["_ValidationResult"],
	validateUpdateFallbackSeo:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getProgram?:ModelTypes["Program"],
	listProgram:ModelTypes["Program"][],
	paginateProgram:ModelTypes["ProgramConnection"],
	validateCreateProgram:ModelTypes["_ValidationResult"],
	validateUpdateProgram:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getYoutubeVideo?:ModelTypes["YoutubeVideo"],
	listYoutubeVideo:ModelTypes["YoutubeVideo"][],
	paginateYoutubeVideo:ModelTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideo:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getBulletPoint?:ModelTypes["BulletPoint"],
	listBulletPoint:ModelTypes["BulletPoint"][],
	paginateBulletPoint:ModelTypes["BulletPointConnection"],
	validateCreateBulletPoint:ModelTypes["_ValidationResult"],
	validateUpdateBulletPoint:ModelTypes["_ValidationResult"],
	getBulletPointItem?:ModelTypes["BulletPointItem"],
	listBulletPointItem:ModelTypes["BulletPointItem"][],
	paginateBulletPointItem:ModelTypes["BulletPointItemConnection"],
	validateCreateBulletPointItem:ModelTypes["_ValidationResult"],
	validateUpdateBulletPointItem:ModelTypes["_ValidationResult"],
	getFileItem?:ModelTypes["FileItem"],
	listFileItem:ModelTypes["FileItem"][],
	paginateFileItem:ModelTypes["FileItemConnection"],
	validateCreateFileItem:ModelTypes["_ValidationResult"],
	validateUpdateFileItem:ModelTypes["_ValidationResult"],
	getFileList?:ModelTypes["FileList"],
	listFileList:ModelTypes["FileList"][],
	paginateFileList:ModelTypes["FileListConnection"],
	validateCreateFileList:ModelTypes["_ValidationResult"],
	validateUpdateFileList:ModelTypes["_ValidationResult"],
	getFooterLink?:ModelTypes["FooterLink"],
	listFooterLink:ModelTypes["FooterLink"][],
	paginateFooterLink:ModelTypes["FooterLinkConnection"],
	validateCreateFooterLink:ModelTypes["_ValidationResult"],
	validateUpdateFooterLink:ModelTypes["_ValidationResult"],
	getFooterLinkGroups?:ModelTypes["FooterLinkGroups"],
	listFooterLinkGroups:ModelTypes["FooterLinkGroups"][],
	paginateFooterLinkGroups:ModelTypes["FooterLinkGroupsConnection"],
	validateCreateFooterLinkGroups:ModelTypes["_ValidationResult"],
	validateUpdateFooterLinkGroups:ModelTypes["_ValidationResult"],
	getTextItem?:ModelTypes["TextItem"],
	listTextItem:ModelTypes["TextItem"][],
	paginateTextItem:ModelTypes["TextItemConnection"],
	validateCreateTextItem:ModelTypes["_ValidationResult"],
	validateUpdateTextItem:ModelTypes["_ValidationResult"],
	getTextList?:ModelTypes["TextList"],
	listTextList:ModelTypes["TextList"][],
	paginateTextList:ModelTypes["TextListConnection"],
	validateCreateTextList:ModelTypes["_ValidationResult"],
	validateUpdateTextList:ModelTypes["_ValidationResult"],
	getProgramPage?:ModelTypes["ProgramPage"],
	listProgramPage:ModelTypes["ProgramPage"][],
	paginateProgramPage:ModelTypes["ProgramPageConnection"],
	validateCreateProgramPage:ModelTypes["_ValidationResult"],
	validateUpdateProgramPage:ModelTypes["_ValidationResult"],
	getGenericPage?:ModelTypes["GenericPage"],
	listGenericPage:ModelTypes["GenericPage"][],
	paginateGenericPage:ModelTypes["GenericPageConnection"],
	validateCreateGenericPage:ModelTypes["_ValidationResult"],
	validateUpdateGenericPage:ModelTypes["_ValidationResult"],
	getStaff?:ModelTypes["Staff"],
	listStaff:ModelTypes["Staff"][],
	paginateStaff:ModelTypes["StaffConnection"],
	validateCreateStaff:ModelTypes["_ValidationResult"],
	validateUpdateStaff:ModelTypes["_ValidationResult"],
	getStaffItem?:ModelTypes["StaffItem"],
	listStaffItem:ModelTypes["StaffItem"][],
	paginateStaffItem:ModelTypes["StaffItemConnection"],
	validateCreateStaffItem:ModelTypes["_ValidationResult"],
	validateUpdateStaffItem:ModelTypes["_ValidationResult"],
	getStaffList?:ModelTypes["StaffList"],
	listStaffList:ModelTypes["StaffList"][],
	paginateStaffList:ModelTypes["StaffListConnection"],
	validateCreateStaffList:ModelTypes["_ValidationResult"],
	validateUpdateStaffList:ModelTypes["_ValidationResult"],
	getIcon?:ModelTypes["Icon"],
	listIcon:ModelTypes["Icon"][],
	paginateIcon:ModelTypes["IconConnection"],
	validateCreateIcon:ModelTypes["_ValidationResult"],
	validateUpdateIcon:ModelTypes["_ValidationResult"],
	getPrincipleItem?:ModelTypes["PrincipleItem"],
	listPrincipleItem:ModelTypes["PrincipleItem"][],
	paginatePrincipleItem:ModelTypes["PrincipleItemConnection"],
	validateCreatePrincipleItem:ModelTypes["_ValidationResult"],
	validateUpdatePrincipleItem:ModelTypes["_ValidationResult"],
	getPrincipleList?:ModelTypes["PrincipleList"],
	listPrincipleList:ModelTypes["PrincipleList"][],
	paginatePrincipleList:ModelTypes["PrincipleListConnection"],
	validateCreatePrincipleList:ModelTypes["_ValidationResult"],
	validateUpdatePrincipleList:ModelTypes["_ValidationResult"],
	getLinkItem?:ModelTypes["LinkItem"],
	listLinkItem:ModelTypes["LinkItem"][],
	paginateLinkItem:ModelTypes["LinkItemConnection"],
	validateCreateLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateLinkItem:ModelTypes["_ValidationResult"],
	getLinkList?:ModelTypes["LinkList"],
	listLinkList:ModelTypes["LinkList"][],
	paginateLinkList:ModelTypes["LinkListConnection"],
	validateCreateLinkList:ModelTypes["_ValidationResult"],
	validateUpdateLinkList:ModelTypes["_ValidationResult"],
	getLinkSubGroup?:ModelTypes["LinkSubGroup"],
	listLinkSubGroup:ModelTypes["LinkSubGroup"][],
	paginateLinkSubGroup:ModelTypes["LinkSubGroupConnection"],
	validateCreateLinkSubGroup:ModelTypes["_ValidationResult"],
	validateUpdateLinkSubGroup:ModelTypes["_ValidationResult"],
	getYoutubeVideoList?:ModelTypes["YoutubeVideoList"],
	listYoutubeVideoList:ModelTypes["YoutubeVideoList"][],
	paginateYoutubeVideoList:ModelTypes["YoutubeVideoListConnection"],
	validateCreateYoutubeVideoList:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideoList:ModelTypes["_ValidationResult"],
	getYoutubeVideoListItem?:ModelTypes["YoutubeVideoListItem"],
	listYoutubeVideoListItem:ModelTypes["YoutubeVideoListItem"][],
	paginateYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemConnection"],
	validateCreateYoutubeVideoListItem:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideoListItem:ModelTypes["_ValidationResult"],
	getImageList?:ModelTypes["ImageList"],
	listImageList:ModelTypes["ImageList"][],
	paginateImageList:ModelTypes["ImageListConnection"],
	validateCreateImageList:ModelTypes["_ValidationResult"],
	validateUpdateImageList:ModelTypes["_ValidationResult"],
	getImageListItem?:ModelTypes["ImageListItem"],
	listImageListItem:ModelTypes["ImageListItem"][],
	paginateImageListItem:ModelTypes["ImageListItemConnection"],
	validateCreateImageListItem:ModelTypes["_ValidationResult"],
	validateUpdateImageListItem:ModelTypes["_ValidationResult"],
	getCitationItem?:ModelTypes["CitationItem"],
	listCitationItem:ModelTypes["CitationItem"][],
	paginateCitationItem:ModelTypes["CitationItemConnection"],
	validateCreateCitationItem:ModelTypes["_ValidationResult"],
	validateUpdateCitationItem:ModelTypes["_ValidationResult"],
	getCitationList?:ModelTypes["CitationList"],
	listCitationList:ModelTypes["CitationList"][],
	paginateCitationList:ModelTypes["CitationListConnection"],
	validateCreateCitationList:ModelTypes["_ValidationResult"],
	validateUpdateCitationList:ModelTypes["_ValidationResult"],
	getContentImageLinkItem?:ModelTypes["ContentImageLinkItem"],
	listContentImageLinkItem:ModelTypes["ContentImageLinkItem"][],
	paginateContentImageLinkItem:ModelTypes["ContentImageLinkItemConnection"],
	validateCreateContentImageLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateContentImageLinkItem:ModelTypes["_ValidationResult"],
	getContentImageLinkList?:ModelTypes["ContentImageLinkList"],
	listContentImageLinkList:ModelTypes["ContentImageLinkList"][],
	paginateContentImageLinkList:ModelTypes["ContentImageLinkListConnection"],
	validateCreateContentImageLinkList:ModelTypes["_ValidationResult"],
	validateUpdateContentImageLinkList:ModelTypes["_ValidationResult"],
	getNews?:ModelTypes["News"],
	listNews:ModelTypes["News"][],
	paginateNews:ModelTypes["NewsConnection"],
	validateCreateNews:ModelTypes["_ValidationResult"],
	validateUpdateNews:ModelTypes["_ValidationResult"],
	getStories?:ModelTypes["Stories"],
	listStories:ModelTypes["Stories"][],
	paginateStories:ModelTypes["StoriesConnection"],
	validateCreateStories:ModelTypes["_ValidationResult"],
	validateUpdateStories:ModelTypes["_ValidationResult"],
	getNewsPage?:ModelTypes["NewsPage"],
	listNewsPage:ModelTypes["NewsPage"][],
	paginateNewsPage:ModelTypes["NewsPageConnection"],
	validateCreateNewsPage:ModelTypes["_ValidationResult"],
	validateUpdateNewsPage:ModelTypes["_ValidationResult"],
	getStoriesPage?:ModelTypes["StoriesPage"],
	listStoriesPage:ModelTypes["StoriesPage"][],
	paginateStoriesPage:ModelTypes["StoriesPageConnection"],
	validateCreateStoriesPage:ModelTypes["_ValidationResult"],
	validateUpdateStoriesPage:ModelTypes["_ValidationResult"],
	getStoriesList?:ModelTypes["StoriesList"],
	listStoriesList:ModelTypes["StoriesList"][],
	paginateStoriesList:ModelTypes["StoriesListConnection"],
	validateCreateStoriesList:ModelTypes["_ValidationResult"],
	validateUpdateStoriesList:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["Content"]: {
		_meta?:ModelTypes["ContentMeta"],
	id:ModelTypes["UUID"],
	blocks:ModelTypes["ContentBlock"][],
	blocksByReferences?:ModelTypes["ContentBlock"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:string;
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["Content"],
	references:ModelTypes["ContentReference"][],
	referencesByLink?:ModelTypes["ContentReference"],
	referencesByFileList?:ModelTypes["ContentReference"],
	referencesByTextList?:ModelTypes["ContentReference"],
	referencesByStaffList?:ModelTypes["ContentReference"],
	referencesByPrincipleList?:ModelTypes["ContentReference"],
	referencesByImageLinkList?:ModelTypes["ContentReference"],
	referencesByCitationList?:ModelTypes["ContentReference"],
	referencesByStoriesList?:ModelTypes["ContentReference"],
	paginateReferences:ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["ProgramWhere"]: GraphQLTypes["ProgramWhere"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["BulletPointWhere"]: GraphQLTypes["BulletPointWhere"];
	["BulletPointItemWhere"]: GraphQLTypes["BulletPointItemWhere"];
	["HomePageWhere"]: GraphQLTypes["HomePageWhere"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["One"]: GraphQLTypes["One"];
	["RedirectWhere"]: GraphQLTypes["RedirectWhere"];
	["ProgramPageWhere"]: GraphQLTypes["ProgramPageWhere"];
	["GenericPageWhere"]: GraphQLTypes["GenericPageWhere"];
	["NewsPageWhere"]: GraphQLTypes["NewsPageWhere"];
	["NewsWhere"]: GraphQLTypes["NewsWhere"];
	["DateTimeCondition"]: GraphQLTypes["DateTimeCondition"];
	["DateTime"]:string;
	["StoriesWhere"]: GraphQLTypes["StoriesWhere"];
	["StoriesListWhere"]: GraphQLTypes["StoriesListWhere"];
	["StoriesPageWhere"]: GraphQLTypes["StoriesPageWhere"];
	["YoutubeVideoWhere"]: GraphQLTypes["YoutubeVideoWhere"];
	["FileListWhere"]: GraphQLTypes["FileListWhere"];
	["FileItemWhere"]: GraphQLTypes["FileItemWhere"];
	["TextListWhere"]: GraphQLTypes["TextListWhere"];
	["TextItemWhere"]: GraphQLTypes["TextItemWhere"];
	["StaffListWhere"]: GraphQLTypes["StaffListWhere"];
	["StaffItemWhere"]: GraphQLTypes["StaffItemWhere"];
	["StaffWhere"]: GraphQLTypes["StaffWhere"];
	["PrincipleListWhere"]: GraphQLTypes["PrincipleListWhere"];
	["PrincipleItemWhere"]: GraphQLTypes["PrincipleItemWhere"];
	["IconWhere"]: GraphQLTypes["IconWhere"];
	["ViewCondition"]: GraphQLTypes["ViewCondition"];
	["View"]: GraphQLTypes["View"];
	["AligningCondition"]: GraphQLTypes["AligningCondition"];
	["Aligning"]: GraphQLTypes["Aligning"];
	["ContentImageLinkListWhere"]: GraphQLTypes["ContentImageLinkListWhere"];
	["ContentImageLinkItemWhere"]: GraphQLTypes["ContentImageLinkItemWhere"];
	["CitationListWhere"]: GraphQLTypes["CitationListWhere"];
	["CitationItemWhere"]: GraphQLTypes["CitationItemWhere"];
	["ContentReference"]: {
		_meta?:ModelTypes["ContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["ContentReferenceType"],
	block?:ModelTypes["ContentBlock"],
	link?:ModelTypes["Link"],
	image?:ModelTypes["Image"],
	youtubeVideo?:ModelTypes["YoutubeVideo"],
	primaryText?:string,
	secondaryText?:string,
	fileList?:ModelTypes["FileList"],
	textList?:ModelTypes["TextList"],
	staffList?:ModelTypes["StaffList"],
	principleList?:ModelTypes["PrincipleList"],
	view?:ModelTypes["View"],
	aligning?:ModelTypes["Aligning"],
	numbered?:boolean,
	tertiaryText?:string,
	imageLinkList?:ModelTypes["ContentImageLinkList"],
	citationList?:ModelTypes["CitationList"],
	storiesList?:ModelTypes["StoriesList"]
};
	["ContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	block?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	youtubeVideo?:ModelTypes["FieldMeta"],
	primaryText?:ModelTypes["FieldMeta"],
	secondaryText?:ModelTypes["FieldMeta"],
	fileList?:ModelTypes["FieldMeta"],
	textList?:ModelTypes["FieldMeta"],
	staffList?:ModelTypes["FieldMeta"],
	principleList?:ModelTypes["FieldMeta"],
	view?:ModelTypes["FieldMeta"],
	aligning?:ModelTypes["FieldMeta"],
	numbered?:ModelTypes["FieldMeta"],
	tertiaryText?:ModelTypes["FieldMeta"],
	imageLinkList?:ModelTypes["FieldMeta"],
	citationList?:ModelTypes["FieldMeta"],
	storiesList?:ModelTypes["FieldMeta"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	title?:string,
	externalLink?:string,
	internalLink?:ModelTypes["Linkable"],
	isTargetBlank?:boolean
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	internalLink?:ModelTypes["FieldMeta"],
	isTargetBlank?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	program?:ModelTypes["Program"],
	homePage?:ModelTypes["HomePage"],
	redirect?:ModelTypes["Redirect"],
	programPage?:ModelTypes["ProgramPage"],
	genericPage?:ModelTypes["GenericPage"],
	newsPage?:ModelTypes["NewsPage"],
	news?:ModelTypes["News"],
	story?:ModelTypes["Stories"],
	storiesPage?:ModelTypes["StoriesPage"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	program?:ModelTypes["FieldMeta"],
	homePage?:ModelTypes["FieldMeta"],
	redirect?:ModelTypes["FieldMeta"],
	programPage?:ModelTypes["FieldMeta"],
	genericPage?:ModelTypes["FieldMeta"],
	newsPage?:ModelTypes["FieldMeta"],
	news?:ModelTypes["FieldMeta"],
	story?:ModelTypes["FieldMeta"],
	storiesPage?:ModelTypes["FieldMeta"]
};
	["Program"]: {
		_meta?:ModelTypes["ProgramMeta"],
	id:ModelTypes["UUID"],
	order:number,
	name?:string,
	title?:string,
	leadParagraph?:string,
	link?:ModelTypes["Linkable"],
	image?:ModelTypes["Image"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"],
	ilustration?:ModelTypes["Image"],
	bulletPoint?:ModelTypes["BulletPoint"],
	showDetailLink?:boolean
};
	["ProgramMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	ilustration?:ModelTypes["FieldMeta"],
	bulletPoint?:ModelTypes["FieldMeta"],
	showDetailLink?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	alt?:string,
	fileName?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"],
	fileName?:ModelTypes["FieldMeta"]
};
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	ogImage?:ModelTypes["Image"],
	noIndex?:boolean,
	noFollow?:boolean
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"],
	noIndex?:ModelTypes["FieldMeta"],
	noFollow?:ModelTypes["FieldMeta"]
};
	["BulletPoint"]: {
		_meta?:ModelTypes["BulletPointMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["BulletPointItem"][],
	paginateItems:ModelTypes["BulletPointItemConnection"]
};
	["BulletPointMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["BulletPointItem"]: {
		_meta?:ModelTypes["BulletPointItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	text?:string,
	list?:ModelTypes["BulletPoint"]
};
	["BulletPointItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"]
};
	["BulletPointItemOrderBy"]: GraphQLTypes["BulletPointItemOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["BulletPointOrderBy"]: GraphQLTypes["BulletPointOrderBy"];
	["BulletPointItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BulletPointItemEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["BulletPointItemEdge"]: {
		node:ModelTypes["BulletPointItem"]
};
	["HomePage"]: {
		_meta?:ModelTypes["HomePageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	leadParagraph?:string,
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	logo?:ModelTypes["Image"]
};
	["HomePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"]
};
	["Redirect"]: {
		_meta?:ModelTypes["RedirectMeta"],
	id:ModelTypes["UUID"],
	targetUrl?:string,
	link?:ModelTypes["Linkable"],
	target?:ModelTypes["Linkable"]
};
	["RedirectMeta"]: {
		id?:ModelTypes["FieldMeta"],
	targetUrl?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["ProgramPage"]: {
		_meta?:ModelTypes["ProgramPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	leadParagraph?:string,
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"]
};
	["ProgramPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["GenericPage"]: {
		_meta?:ModelTypes["GenericPageMeta"],
	id:ModelTypes["UUID"],
	name:string,
	leadParagraph:string,
	image?:ModelTypes["Image"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	darujmeWidget?:boolean
};
	["GenericPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	darujmeWidget?:ModelTypes["FieldMeta"]
};
	["NewsPage"]: {
		_meta?:ModelTypes["NewsPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	leadParagraph?:string,
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"]
};
	["NewsPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["News"]: {
		_meta?:ModelTypes["NewsMeta"],
	id:ModelTypes["UUID"],
	publishDate?:ModelTypes["DateTime"],
	title:string,
	perex?:string,
	coverImage?:ModelTypes["Image"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"],
	order:number,
	link?:ModelTypes["Linkable"],
	isDraft?:boolean
};
	["NewsMeta"]: {
		id?:ModelTypes["FieldMeta"],
	publishDate?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	perex?:ModelTypes["FieldMeta"],
	coverImage?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	isDraft?:ModelTypes["FieldMeta"]
};
	["Stories"]: {
		_meta?:ModelTypes["StoriesMeta"],
	id:ModelTypes["UUID"],
	title:string,
	perex?:string,
	coverImage?:ModelTypes["Image"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"],
	order:number,
	link?:ModelTypes["Linkable"],
	list?:ModelTypes["StoriesList"],
	isDraft?:boolean
};
	["StoriesMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	perex?:ModelTypes["FieldMeta"],
	coverImage?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	isDraft?:ModelTypes["FieldMeta"]
};
	["StoriesList"]: {
		_meta?:ModelTypes["StoriesListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["Stories"][],
	itemsByContent?:ModelTypes["Stories"],
	itemsBySeo?:ModelTypes["Stories"],
	itemsByLink?:ModelTypes["Stories"],
	paginateItems:ModelTypes["StoriesConnection"]
};
	["StoriesListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["StoriesOrderBy"]: GraphQLTypes["StoriesOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["ProgramOrderBy"]: GraphQLTypes["ProgramOrderBy"];
	["HomePageOrderBy"]: GraphQLTypes["HomePageOrderBy"];
	["RedirectOrderBy"]: GraphQLTypes["RedirectOrderBy"];
	["ProgramPageOrderBy"]: GraphQLTypes["ProgramPageOrderBy"];
	["GenericPageOrderBy"]: GraphQLTypes["GenericPageOrderBy"];
	["NewsPageOrderBy"]: GraphQLTypes["NewsPageOrderBy"];
	["NewsOrderBy"]: GraphQLTypes["NewsOrderBy"];
	["StoriesPageOrderBy"]: GraphQLTypes["StoriesPageOrderBy"];
	["StoriesListOrderBy"]: GraphQLTypes["StoriesListOrderBy"];
	["StoriesListItemsByContentUniqueWhere"]: GraphQLTypes["StoriesListItemsByContentUniqueWhere"];
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["FileListUniqueWhere"]: GraphQLTypes["FileListUniqueWhere"];
	["FileItemUniqueWhere"]: GraphQLTypes["FileItemUniqueWhere"];
	["TextListUniqueWhere"]: GraphQLTypes["TextListUniqueWhere"];
	["TextItemUniqueWhere"]: GraphQLTypes["TextItemUniqueWhere"];
	["StaffListUniqueWhere"]: GraphQLTypes["StaffListUniqueWhere"];
	["StaffItemUniqueWhere"]: GraphQLTypes["StaffItemUniqueWhere"];
	["PrincipleListUniqueWhere"]: GraphQLTypes["PrincipleListUniqueWhere"];
	["PrincipleItemUniqueWhere"]: GraphQLTypes["PrincipleItemUniqueWhere"];
	["ContentImageLinkListUniqueWhere"]: GraphQLTypes["ContentImageLinkListUniqueWhere"];
	["ContentImageLinkItemUniqueWhere"]: GraphQLTypes["ContentImageLinkItemUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["CitationListUniqueWhere"]: GraphQLTypes["CitationListUniqueWhere"];
	["CitationItemUniqueWhere"]: GraphQLTypes["CitationItemUniqueWhere"];
	["StoriesListUniqueWhere"]: GraphQLTypes["StoriesListUniqueWhere"];
	["StoriesUniqueWhere"]: GraphQLTypes["StoriesUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["ProgramUniqueWhere"]: GraphQLTypes["ProgramUniqueWhere"];
	["BulletPointUniqueWhere"]: GraphQLTypes["BulletPointUniqueWhere"];
	["BulletPointItemUniqueWhere"]: GraphQLTypes["BulletPointItemUniqueWhere"];
	["HomePageUniqueWhere"]: GraphQLTypes["HomePageUniqueWhere"];
	["RedirectUniqueWhere"]: GraphQLTypes["RedirectUniqueWhere"];
	["ProgramPageUniqueWhere"]: GraphQLTypes["ProgramPageUniqueWhere"];
	["GenericPageUniqueWhere"]: GraphQLTypes["GenericPageUniqueWhere"];
	["NewsPageUniqueWhere"]: GraphQLTypes["NewsPageUniqueWhere"];
	["NewsUniqueWhere"]: GraphQLTypes["NewsUniqueWhere"];
	["StoriesPageUniqueWhere"]: GraphQLTypes["StoriesPageUniqueWhere"];
	["StoriesListItemsBySeoUniqueWhere"]: GraphQLTypes["StoriesListItemsBySeoUniqueWhere"];
	["StoriesListItemsByLinkUniqueWhere"]: GraphQLTypes["StoriesListItemsByLinkUniqueWhere"];
	["StoriesConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StoriesEdge"][]
};
	["StoriesEdge"]: {
		node:ModelTypes["Stories"]
};
	["StoriesPage"]: {
		_meta?:ModelTypes["StoriesPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	leadParagraph?:string,
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"]
};
	["StoriesPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["YoutubeVideo"]: {
		_meta?:ModelTypes["YoutubeVideoMeta"],
	id:ModelTypes["UUID"],
	videoId:string
};
	["YoutubeVideoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	videoId?:ModelTypes["FieldMeta"]
};
	["FileList"]: {
		_meta?:ModelTypes["FileListMeta"],
	id:ModelTypes["UUID"],
	reference?:ModelTypes["ContentReference"],
	items:ModelTypes["FileItem"][],
	paginateItems:ModelTypes["FileItemConnection"]
};
	["FileListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	reference?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["FileItem"]: {
		_meta?:ModelTypes["FileItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	name?:string,
	url?:string,
	fileType?:string,
	list?:ModelTypes["FileList"]
};
	["FileItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	fileType?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"]
};
	["FileItemOrderBy"]: GraphQLTypes["FileItemOrderBy"];
	["FileListOrderBy"]: GraphQLTypes["FileListOrderBy"];
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["YoutubeVideoOrderBy"]: GraphQLTypes["YoutubeVideoOrderBy"];
	["TextListOrderBy"]: GraphQLTypes["TextListOrderBy"];
	["StaffListOrderBy"]: GraphQLTypes["StaffListOrderBy"];
	["PrincipleListOrderBy"]: GraphQLTypes["PrincipleListOrderBy"];
	["ContentImageLinkListOrderBy"]: GraphQLTypes["ContentImageLinkListOrderBy"];
	["CitationListOrderBy"]: GraphQLTypes["CitationListOrderBy"];
	["FileItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FileItemEdge"][]
};
	["FileItemEdge"]: {
		node:ModelTypes["FileItem"]
};
	["TextList"]: {
		_meta?:ModelTypes["TextListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["TextItem"][],
	itemsByLink?:ModelTypes["TextItem"],
	paginateItems:ModelTypes["TextItemConnection"]
};
	["TextListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["TextItem"]: {
		_meta?:ModelTypes["TextItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	text?:string,
	list?:ModelTypes["TextList"],
	link?:ModelTypes["Link"]
};
	["TextItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["TextItemOrderBy"]: GraphQLTypes["TextItemOrderBy"];
	["TextListItemsByLinkUniqueWhere"]: GraphQLTypes["TextListItemsByLinkUniqueWhere"];
	["TextItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TextItemEdge"][]
};
	["TextItemEdge"]: {
		node:ModelTypes["TextItem"]
};
	["StaffList"]: {
		_meta?:ModelTypes["StaffListMeta"],
	id:ModelTypes["UUID"],
	reference?:ModelTypes["ContentReference"],
	items:ModelTypes["StaffItem"][],
	paginateItems:ModelTypes["StaffItemConnection"]
};
	["StaffListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	reference?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["StaffItem"]: {
		_meta?:ModelTypes["StaffItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	list?:ModelTypes["StaffList"],
	staff?:ModelTypes["Staff"]
};
	["StaffItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	staff?:ModelTypes["FieldMeta"]
};
	["Staff"]: {
		_meta?:ModelTypes["StaffMeta"],
	id:ModelTypes["UUID"],
	name?:string,
	position?:string,
	image?:ModelTypes["Image"],
	order:number,
	info?:string
};
	["StaffMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	position?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	info?:ModelTypes["FieldMeta"]
};
	["StaffItemOrderBy"]: GraphQLTypes["StaffItemOrderBy"];
	["StaffOrderBy"]: GraphQLTypes["StaffOrderBy"];
	["StaffItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StaffItemEdge"][]
};
	["StaffItemEdge"]: {
		node:ModelTypes["StaffItem"]
};
	["PrincipleList"]: {
		_meta?:ModelTypes["PrincipleListMeta"],
	id:ModelTypes["UUID"],
	reference?:ModelTypes["ContentReference"],
	items:ModelTypes["PrincipleItem"][],
	paginateItems:ModelTypes["PrincipleItemConnection"]
};
	["PrincipleListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	reference?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["PrincipleItem"]: {
		_meta?:ModelTypes["PrincipleItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	text?:string,
	list?:ModelTypes["PrincipleList"],
	icon?:ModelTypes["Icon"],
	title?:string
};
	["PrincipleItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"]
};
	["Icon"]: {
		_meta?:ModelTypes["IconMeta"],
	id:ModelTypes["UUID"],
	order:number,
	image?:ModelTypes["Image"]
};
	["IconMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["PrincipleItemOrderBy"]: GraphQLTypes["PrincipleItemOrderBy"];
	["IconOrderBy"]: GraphQLTypes["IconOrderBy"];
	["PrincipleItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PrincipleItemEdge"][]
};
	["PrincipleItemEdge"]: {
		node:ModelTypes["PrincipleItem"]
};
	["ContentImageLinkList"]: {
		_meta?:ModelTypes["ContentImageLinkListMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	items:ModelTypes["ContentImageLinkItem"][],
	link?:ModelTypes["Link"],
	itemsByImage?:ModelTypes["ContentImageLinkItem"],
	itemsByLink?:ModelTypes["ContentImageLinkItem"],
	paginateItems:ModelTypes["ContentImageLinkItemConnection"]
};
	["ContentImageLinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["ContentImageLinkItem"]: {
		_meta?:ModelTypes["ContentImageLinkItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	list?:ModelTypes["ContentImageLinkList"],
	image?:ModelTypes["Image"],
	link?:ModelTypes["Link"]
};
	["ContentImageLinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["ContentImageLinkItemOrderBy"]: GraphQLTypes["ContentImageLinkItemOrderBy"];
	["ContentImageLinkListItemsByImageUniqueWhere"]: GraphQLTypes["ContentImageLinkListItemsByImageUniqueWhere"];
	["ContentImageLinkListItemsByLinkUniqueWhere"]: GraphQLTypes["ContentImageLinkListItemsByLinkUniqueWhere"];
	["ContentImageLinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentImageLinkItemEdge"][]
};
	["ContentImageLinkItemEdge"]: {
		node:ModelTypes["ContentImageLinkItem"]
};
	["CitationList"]: {
		_meta?:ModelTypes["CitationListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["CitationItem"][],
	paginateItems:ModelTypes["CitationItemConnection"]
};
	["CitationListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["CitationItem"]: {
		_meta?:ModelTypes["CitationItemMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	text?:string,
	list?:ModelTypes["CitationList"],
	image?:ModelTypes["Image"],
	order?:number
};
	["CitationItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["CitationItemOrderBy"]: GraphQLTypes["CitationItemOrderBy"];
	["CitationItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CitationItemEdge"][]
};
	["CitationItemEdge"]: {
		node:ModelTypes["CitationItem"]
};
	["ContentBlockReferencesByLinkUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByLinkUniqueWhere"];
	["ContentBlockReferencesByFileListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByFileListUniqueWhere"];
	["ContentBlockReferencesByTextListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByTextListUniqueWhere"];
	["ContentBlockReferencesByStaffListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByStaffListUniqueWhere"];
	["ContentBlockReferencesByPrincipleListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByPrincipleListUniqueWhere"];
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByImageLinkListUniqueWhere"];
	["ContentBlockReferencesByCitationListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByCitationListUniqueWhere"];
	["ContentBlockReferencesByStoriesListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByStoriesListUniqueWhere"];
	["ContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceEdge"][]
};
	["ContentReferenceEdge"]: {
		node:ModelTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: GraphQLTypes["ContentBlocksByReferencesUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["ContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentEdge"][]
};
	["ContentEdge"]: {
		node:ModelTypes["Content"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: GraphQLTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateProgramEntityRelationInput"]: GraphQLTypes["LinkableCreateProgramEntityRelationInput"];
	["ProgramWithoutLinkCreateInput"]: GraphQLTypes["ProgramWithoutLinkCreateInput"];
	["ProgramCreateImageEntityRelationInput"]: GraphQLTypes["ProgramCreateImageEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["ProgramCreateContentEntityRelationInput"]: GraphQLTypes["ProgramCreateContentEntityRelationInput"];
	["ProgramCreateSeoEntityRelationInput"]: GraphQLTypes["ProgramCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["ProgramCreateIlustrationEntityRelationInput"]: GraphQLTypes["ProgramCreateIlustrationEntityRelationInput"];
	["ProgramCreateBulletPointEntityRelationInput"]: GraphQLTypes["ProgramCreateBulletPointEntityRelationInput"];
	["BulletPointCreateInput"]: GraphQLTypes["BulletPointCreateInput"];
	["BulletPointCreateItemsEntityRelationInput"]: GraphQLTypes["BulletPointCreateItemsEntityRelationInput"];
	["BulletPointItemWithoutListCreateInput"]: GraphQLTypes["BulletPointItemWithoutListCreateInput"];
	["LinkableCreateHomePageEntityRelationInput"]: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"];
	["HomePageWithoutLinkCreateInput"]: GraphQLTypes["HomePageWithoutLinkCreateInput"];
	["HomePageCreateContentEntityRelationInput"]: GraphQLTypes["HomePageCreateContentEntityRelationInput"];
	["HomePageCreateSeoEntityRelationInput"]: GraphQLTypes["HomePageCreateSeoEntityRelationInput"];
	["HomePageCreateLogoEntityRelationInput"]: GraphQLTypes["HomePageCreateLogoEntityRelationInput"];
	["LinkableCreateRedirectEntityRelationInput"]: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"];
	["RedirectWithoutLinkCreateInput"]: GraphQLTypes["RedirectWithoutLinkCreateInput"];
	["RedirectCreateTargetEntityRelationInput"]: GraphQLTypes["RedirectCreateTargetEntityRelationInput"];
	["LinkableCreateProgramPageEntityRelationInput"]: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"];
	["ProgramPageWithoutLinkCreateInput"]: GraphQLTypes["ProgramPageWithoutLinkCreateInput"];
	["ProgramPageCreateSeoEntityRelationInput"]: GraphQLTypes["ProgramPageCreateSeoEntityRelationInput"];
	["LinkableCreateGenericPageEntityRelationInput"]: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"];
	["GenericPageWithoutLinkCreateInput"]: GraphQLTypes["GenericPageWithoutLinkCreateInput"];
	["GenericPageCreateImageEntityRelationInput"]: GraphQLTypes["GenericPageCreateImageEntityRelationInput"];
	["GenericPageCreateContentEntityRelationInput"]: GraphQLTypes["GenericPageCreateContentEntityRelationInput"];
	["GenericPageCreateSeoEntityRelationInput"]: GraphQLTypes["GenericPageCreateSeoEntityRelationInput"];
	["LinkableCreateNewsPageEntityRelationInput"]: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"];
	["NewsPageWithoutLinkCreateInput"]: GraphQLTypes["NewsPageWithoutLinkCreateInput"];
	["NewsPageCreateSeoEntityRelationInput"]: GraphQLTypes["NewsPageCreateSeoEntityRelationInput"];
	["LinkableCreateNewsEntityRelationInput"]: GraphQLTypes["LinkableCreateNewsEntityRelationInput"];
	["NewsWithoutLinkCreateInput"]: GraphQLTypes["NewsWithoutLinkCreateInput"];
	["NewsCreateCoverImageEntityRelationInput"]: GraphQLTypes["NewsCreateCoverImageEntityRelationInput"];
	["NewsCreateContentEntityRelationInput"]: GraphQLTypes["NewsCreateContentEntityRelationInput"];
	["NewsCreateSeoEntityRelationInput"]: GraphQLTypes["NewsCreateSeoEntityRelationInput"];
	["LinkableCreateStoryEntityRelationInput"]: GraphQLTypes["LinkableCreateStoryEntityRelationInput"];
	["StoriesWithoutLinkCreateInput"]: GraphQLTypes["StoriesWithoutLinkCreateInput"];
	["StoriesCreateCoverImageEntityRelationInput"]: GraphQLTypes["StoriesCreateCoverImageEntityRelationInput"];
	["StoriesCreateContentEntityRelationInput"]: GraphQLTypes["StoriesCreateContentEntityRelationInput"];
	["StoriesCreateSeoEntityRelationInput"]: GraphQLTypes["StoriesCreateSeoEntityRelationInput"];
	["StoriesCreateListEntityRelationInput"]: GraphQLTypes["StoriesCreateListEntityRelationInput"];
	["StoriesListWithoutItemsCreateInput"]: GraphQLTypes["StoriesListWithoutItemsCreateInput"];
	["LinkableCreateStoriesPageEntityRelationInput"]: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"];
	["StoriesPageWithoutLinkCreateInput"]: GraphQLTypes["StoriesPageWithoutLinkCreateInput"];
	["StoriesPageCreateSeoEntityRelationInput"]: GraphQLTypes["StoriesPageCreateSeoEntityRelationInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ContentReferenceCreateYoutubeVideoEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"];
	["YoutubeVideoUniqueWhere"]: GraphQLTypes["YoutubeVideoUniqueWhere"];
	["YoutubeVideoCreateInput"]: GraphQLTypes["YoutubeVideoCreateInput"];
	["ContentReferenceCreateFileListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateFileListEntityRelationInput"];
	["FileListWithoutReferenceCreateInput"]: GraphQLTypes["FileListWithoutReferenceCreateInput"];
	["FileListCreateItemsEntityRelationInput"]: GraphQLTypes["FileListCreateItemsEntityRelationInput"];
	["FileItemWithoutListCreateInput"]: GraphQLTypes["FileItemWithoutListCreateInput"];
	["ContentReferenceCreateTextListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"];
	["TextListCreateInput"]: GraphQLTypes["TextListCreateInput"];
	["TextListCreateItemsEntityRelationInput"]: GraphQLTypes["TextListCreateItemsEntityRelationInput"];
	["TextItemWithoutListCreateInput"]: GraphQLTypes["TextItemWithoutListCreateInput"];
	["TextItemCreateLinkEntityRelationInput"]: GraphQLTypes["TextItemCreateLinkEntityRelationInput"];
	["ContentReferenceCreateStaffListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateStaffListEntityRelationInput"];
	["StaffListWithoutReferenceCreateInput"]: GraphQLTypes["StaffListWithoutReferenceCreateInput"];
	["StaffListCreateItemsEntityRelationInput"]: GraphQLTypes["StaffListCreateItemsEntityRelationInput"];
	["StaffItemWithoutListCreateInput"]: GraphQLTypes["StaffItemWithoutListCreateInput"];
	["StaffItemCreateStaffEntityRelationInput"]: GraphQLTypes["StaffItemCreateStaffEntityRelationInput"];
	["StaffUniqueWhere"]: GraphQLTypes["StaffUniqueWhere"];
	["StaffCreateInput"]: GraphQLTypes["StaffCreateInput"];
	["StaffCreateImageEntityRelationInput"]: GraphQLTypes["StaffCreateImageEntityRelationInput"];
	["ContentReferenceCreatePrincipleListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreatePrincipleListEntityRelationInput"];
	["PrincipleListWithoutReferenceCreateInput"]: GraphQLTypes["PrincipleListWithoutReferenceCreateInput"];
	["PrincipleListCreateItemsEntityRelationInput"]: GraphQLTypes["PrincipleListCreateItemsEntityRelationInput"];
	["PrincipleItemWithoutListCreateInput"]: GraphQLTypes["PrincipleItemWithoutListCreateInput"];
	["PrincipleItemCreateIconEntityRelationInput"]: GraphQLTypes["PrincipleItemCreateIconEntityRelationInput"];
	["IconUniqueWhere"]: GraphQLTypes["IconUniqueWhere"];
	["IconCreateInput"]: GraphQLTypes["IconCreateInput"];
	["IconCreateImageEntityRelationInput"]: GraphQLTypes["IconCreateImageEntityRelationInput"];
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"];
	["ContentImageLinkListCreateInput"]: GraphQLTypes["ContentImageLinkListCreateInput"];
	["ContentImageLinkListCreateItemsEntityRelationInput"]: GraphQLTypes["ContentImageLinkListCreateItemsEntityRelationInput"];
	["ContentImageLinkItemWithoutListCreateInput"]: GraphQLTypes["ContentImageLinkItemWithoutListCreateInput"];
	["ContentImageLinkItemCreateImageEntityRelationInput"]: GraphQLTypes["ContentImageLinkItemCreateImageEntityRelationInput"];
	["ContentImageLinkItemCreateLinkEntityRelationInput"]: GraphQLTypes["ContentImageLinkItemCreateLinkEntityRelationInput"];
	["ContentImageLinkListCreateLinkEntityRelationInput"]: GraphQLTypes["ContentImageLinkListCreateLinkEntityRelationInput"];
	["ContentReferenceCreateCitationListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateCitationListEntityRelationInput"];
	["CitationListCreateInput"]: GraphQLTypes["CitationListCreateInput"];
	["CitationListCreateItemsEntityRelationInput"]: GraphQLTypes["CitationListCreateItemsEntityRelationInput"];
	["CitationItemWithoutListCreateInput"]: GraphQLTypes["CitationItemWithoutListCreateInput"];
	["CitationItemCreateImageEntityRelationInput"]: GraphQLTypes["CitationItemCreateImageEntityRelationInput"];
	["ContentReferenceCreateStoriesListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateStoriesListEntityRelationInput"];
	["StoriesListCreateInput"]: GraphQLTypes["StoriesListCreateInput"];
	["StoriesListCreateItemsEntityRelationInput"]: GraphQLTypes["StoriesListCreateItemsEntityRelationInput"];
	["StoriesWithoutListCreateInput"]: GraphQLTypes["StoriesWithoutListCreateInput"];
	["StoriesCreateLinkEntityRelationInput"]: GraphQLTypes["StoriesCreateLinkEntityRelationInput"];
	["LinkableWithoutStoryCreateInput"]: GraphQLTypes["LinkableWithoutStoryCreateInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: GraphQLTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateProgramEntityRelationInput"]: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"];
	["ProgramWithoutLinkUpdateInput"]: GraphQLTypes["ProgramWithoutLinkUpdateInput"];
	["ProgramUpdateImageEntityRelationInput"]: GraphQLTypes["ProgramUpdateImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["ProgramUpsertImageRelationInput"]: GraphQLTypes["ProgramUpsertImageRelationInput"];
	["ProgramUpdateContentEntityRelationInput"]: GraphQLTypes["ProgramUpdateContentEntityRelationInput"];
	["ProgramUpsertContentRelationInput"]: GraphQLTypes["ProgramUpsertContentRelationInput"];
	["ProgramUpdateSeoEntityRelationInput"]: GraphQLTypes["ProgramUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["ProgramUpsertSeoRelationInput"]: GraphQLTypes["ProgramUpsertSeoRelationInput"];
	["ProgramUpdateIlustrationEntityRelationInput"]: GraphQLTypes["ProgramUpdateIlustrationEntityRelationInput"];
	["ProgramUpsertIlustrationRelationInput"]: GraphQLTypes["ProgramUpsertIlustrationRelationInput"];
	["ProgramUpdateBulletPointEntityRelationInput"]: GraphQLTypes["ProgramUpdateBulletPointEntityRelationInput"];
	["BulletPointUpdateInput"]: GraphQLTypes["BulletPointUpdateInput"];
	["BulletPointUpdateItemsEntityRelationInput"]: GraphQLTypes["BulletPointUpdateItemsEntityRelationInput"];
	["BulletPointUpdateItemsRelationInput"]: GraphQLTypes["BulletPointUpdateItemsRelationInput"];
	["BulletPointItemWithoutListUpdateInput"]: GraphQLTypes["BulletPointItemWithoutListUpdateInput"];
	["BulletPointUpsertItemsRelationInput"]: GraphQLTypes["BulletPointUpsertItemsRelationInput"];
	["ProgramUpsertBulletPointRelationInput"]: GraphQLTypes["ProgramUpsertBulletPointRelationInput"];
	["LinkableUpsertProgramRelationInput"]: GraphQLTypes["LinkableUpsertProgramRelationInput"];
	["LinkableUpdateHomePageEntityRelationInput"]: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"];
	["HomePageWithoutLinkUpdateInput"]: GraphQLTypes["HomePageWithoutLinkUpdateInput"];
	["HomePageUpdateContentEntityRelationInput"]: GraphQLTypes["HomePageUpdateContentEntityRelationInput"];
	["HomePageUpsertContentRelationInput"]: GraphQLTypes["HomePageUpsertContentRelationInput"];
	["HomePageUpdateSeoEntityRelationInput"]: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"];
	["HomePageUpsertSeoRelationInput"]: GraphQLTypes["HomePageUpsertSeoRelationInput"];
	["HomePageUpdateLogoEntityRelationInput"]: GraphQLTypes["HomePageUpdateLogoEntityRelationInput"];
	["HomePageUpsertLogoRelationInput"]: GraphQLTypes["HomePageUpsertLogoRelationInput"];
	["LinkableUpsertHomePageRelationInput"]: GraphQLTypes["LinkableUpsertHomePageRelationInput"];
	["LinkableUpdateRedirectEntityRelationInput"]: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"];
	["RedirectWithoutLinkUpdateInput"]: GraphQLTypes["RedirectWithoutLinkUpdateInput"];
	["RedirectUpdateTargetEntityRelationInput"]: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"];
	["RedirectUpsertTargetRelationInput"]: GraphQLTypes["RedirectUpsertTargetRelationInput"];
	["LinkableUpsertRedirectRelationInput"]: GraphQLTypes["LinkableUpsertRedirectRelationInput"];
	["LinkableUpdateProgramPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"];
	["ProgramPageWithoutLinkUpdateInput"]: GraphQLTypes["ProgramPageWithoutLinkUpdateInput"];
	["ProgramPageUpdateSeoEntityRelationInput"]: GraphQLTypes["ProgramPageUpdateSeoEntityRelationInput"];
	["ProgramPageUpsertSeoRelationInput"]: GraphQLTypes["ProgramPageUpsertSeoRelationInput"];
	["LinkableUpsertProgramPageRelationInput"]: GraphQLTypes["LinkableUpsertProgramPageRelationInput"];
	["LinkableUpdateGenericPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"];
	["GenericPageWithoutLinkUpdateInput"]: GraphQLTypes["GenericPageWithoutLinkUpdateInput"];
	["GenericPageUpdateImageEntityRelationInput"]: GraphQLTypes["GenericPageUpdateImageEntityRelationInput"];
	["GenericPageUpsertImageRelationInput"]: GraphQLTypes["GenericPageUpsertImageRelationInput"];
	["GenericPageUpdateContentEntityRelationInput"]: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"];
	["GenericPageUpsertContentRelationInput"]: GraphQLTypes["GenericPageUpsertContentRelationInput"];
	["GenericPageUpdateSeoEntityRelationInput"]: GraphQLTypes["GenericPageUpdateSeoEntityRelationInput"];
	["GenericPageUpsertSeoRelationInput"]: GraphQLTypes["GenericPageUpsertSeoRelationInput"];
	["LinkableUpsertGenericPageRelationInput"]: GraphQLTypes["LinkableUpsertGenericPageRelationInput"];
	["LinkableUpdateNewsPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"];
	["NewsPageWithoutLinkUpdateInput"]: GraphQLTypes["NewsPageWithoutLinkUpdateInput"];
	["NewsPageUpdateSeoEntityRelationInput"]: GraphQLTypes["NewsPageUpdateSeoEntityRelationInput"];
	["NewsPageUpsertSeoRelationInput"]: GraphQLTypes["NewsPageUpsertSeoRelationInput"];
	["LinkableUpsertNewsPageRelationInput"]: GraphQLTypes["LinkableUpsertNewsPageRelationInput"];
	["LinkableUpdateNewsEntityRelationInput"]: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"];
	["NewsWithoutLinkUpdateInput"]: GraphQLTypes["NewsWithoutLinkUpdateInput"];
	["NewsUpdateCoverImageEntityRelationInput"]: GraphQLTypes["NewsUpdateCoverImageEntityRelationInput"];
	["NewsUpsertCoverImageRelationInput"]: GraphQLTypes["NewsUpsertCoverImageRelationInput"];
	["NewsUpdateContentEntityRelationInput"]: GraphQLTypes["NewsUpdateContentEntityRelationInput"];
	["NewsUpsertContentRelationInput"]: GraphQLTypes["NewsUpsertContentRelationInput"];
	["NewsUpdateSeoEntityRelationInput"]: GraphQLTypes["NewsUpdateSeoEntityRelationInput"];
	["NewsUpsertSeoRelationInput"]: GraphQLTypes["NewsUpsertSeoRelationInput"];
	["LinkableUpsertNewsRelationInput"]: GraphQLTypes["LinkableUpsertNewsRelationInput"];
	["LinkableUpdateStoryEntityRelationInput"]: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"];
	["StoriesWithoutLinkUpdateInput"]: GraphQLTypes["StoriesWithoutLinkUpdateInput"];
	["StoriesUpdateCoverImageEntityRelationInput"]: GraphQLTypes["StoriesUpdateCoverImageEntityRelationInput"];
	["StoriesUpsertCoverImageRelationInput"]: GraphQLTypes["StoriesUpsertCoverImageRelationInput"];
	["StoriesUpdateContentEntityRelationInput"]: GraphQLTypes["StoriesUpdateContentEntityRelationInput"];
	["StoriesUpsertContentRelationInput"]: GraphQLTypes["StoriesUpsertContentRelationInput"];
	["StoriesUpdateSeoEntityRelationInput"]: GraphQLTypes["StoriesUpdateSeoEntityRelationInput"];
	["StoriesUpsertSeoRelationInput"]: GraphQLTypes["StoriesUpsertSeoRelationInput"];
	["StoriesUpdateListEntityRelationInput"]: GraphQLTypes["StoriesUpdateListEntityRelationInput"];
	["StoriesListWithoutItemsUpdateInput"]: GraphQLTypes["StoriesListWithoutItemsUpdateInput"];
	["StoriesUpsertListRelationInput"]: GraphQLTypes["StoriesUpsertListRelationInput"];
	["LinkableUpsertStoryRelationInput"]: GraphQLTypes["LinkableUpsertStoryRelationInput"];
	["LinkableUpdateStoriesPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"];
	["StoriesPageWithoutLinkUpdateInput"]: GraphQLTypes["StoriesPageWithoutLinkUpdateInput"];
	["StoriesPageUpdateSeoEntityRelationInput"]: GraphQLTypes["StoriesPageUpdateSeoEntityRelationInput"];
	["StoriesPageUpsertSeoRelationInput"]: GraphQLTypes["StoriesPageUpsertSeoRelationInput"];
	["LinkableUpsertStoriesPageRelationInput"]: GraphQLTypes["LinkableUpsertStoriesPageRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ContentReferenceUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageRelationInput"];
	["ContentReferenceUpdateYoutubeVideoEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"];
	["YoutubeVideoUpdateInput"]: GraphQLTypes["YoutubeVideoUpdateInput"];
	["ContentReferenceUpsertYoutubeVideoRelationInput"]: GraphQLTypes["ContentReferenceUpsertYoutubeVideoRelationInput"];
	["ContentReferenceUpdateFileListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateFileListEntityRelationInput"];
	["FileListWithoutReferenceUpdateInput"]: GraphQLTypes["FileListWithoutReferenceUpdateInput"];
	["FileListUpdateItemsEntityRelationInput"]: GraphQLTypes["FileListUpdateItemsEntityRelationInput"];
	["FileListUpdateItemsRelationInput"]: GraphQLTypes["FileListUpdateItemsRelationInput"];
	["FileItemWithoutListUpdateInput"]: GraphQLTypes["FileItemWithoutListUpdateInput"];
	["FileListUpsertItemsRelationInput"]: GraphQLTypes["FileListUpsertItemsRelationInput"];
	["ContentReferenceUpsertFileListRelationInput"]: GraphQLTypes["ContentReferenceUpsertFileListRelationInput"];
	["ContentReferenceUpdateTextListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"];
	["TextListUpdateInput"]: GraphQLTypes["TextListUpdateInput"];
	["TextListUpdateItemsEntityRelationInput"]: GraphQLTypes["TextListUpdateItemsEntityRelationInput"];
	["TextListUpdateItemsRelationInput"]: GraphQLTypes["TextListUpdateItemsRelationInput"];
	["TextItemWithoutListUpdateInput"]: GraphQLTypes["TextItemWithoutListUpdateInput"];
	["TextItemUpdateLinkEntityRelationInput"]: GraphQLTypes["TextItemUpdateLinkEntityRelationInput"];
	["TextItemUpsertLinkRelationInput"]: GraphQLTypes["TextItemUpsertLinkRelationInput"];
	["TextListUpsertItemsRelationInput"]: GraphQLTypes["TextListUpsertItemsRelationInput"];
	["ContentReferenceUpsertTextListRelationInput"]: GraphQLTypes["ContentReferenceUpsertTextListRelationInput"];
	["ContentReferenceUpdateStaffListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateStaffListEntityRelationInput"];
	["StaffListWithoutReferenceUpdateInput"]: GraphQLTypes["StaffListWithoutReferenceUpdateInput"];
	["StaffListUpdateItemsEntityRelationInput"]: GraphQLTypes["StaffListUpdateItemsEntityRelationInput"];
	["StaffListUpdateItemsRelationInput"]: GraphQLTypes["StaffListUpdateItemsRelationInput"];
	["StaffItemWithoutListUpdateInput"]: GraphQLTypes["StaffItemWithoutListUpdateInput"];
	["StaffItemUpdateStaffEntityRelationInput"]: GraphQLTypes["StaffItemUpdateStaffEntityRelationInput"];
	["StaffUpdateInput"]: GraphQLTypes["StaffUpdateInput"];
	["StaffUpdateImageEntityRelationInput"]: GraphQLTypes["StaffUpdateImageEntityRelationInput"];
	["StaffUpsertImageRelationInput"]: GraphQLTypes["StaffUpsertImageRelationInput"];
	["StaffItemUpsertStaffRelationInput"]: GraphQLTypes["StaffItemUpsertStaffRelationInput"];
	["StaffListUpsertItemsRelationInput"]: GraphQLTypes["StaffListUpsertItemsRelationInput"];
	["ContentReferenceUpsertStaffListRelationInput"]: GraphQLTypes["ContentReferenceUpsertStaffListRelationInput"];
	["ContentReferenceUpdatePrincipleListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"];
	["PrincipleListWithoutReferenceUpdateInput"]: GraphQLTypes["PrincipleListWithoutReferenceUpdateInput"];
	["PrincipleListUpdateItemsEntityRelationInput"]: GraphQLTypes["PrincipleListUpdateItemsEntityRelationInput"];
	["PrincipleListUpdateItemsRelationInput"]: GraphQLTypes["PrincipleListUpdateItemsRelationInput"];
	["PrincipleItemWithoutListUpdateInput"]: GraphQLTypes["PrincipleItemWithoutListUpdateInput"];
	["PrincipleItemUpdateIconEntityRelationInput"]: GraphQLTypes["PrincipleItemUpdateIconEntityRelationInput"];
	["IconUpdateInput"]: GraphQLTypes["IconUpdateInput"];
	["IconUpdateImageEntityRelationInput"]: GraphQLTypes["IconUpdateImageEntityRelationInput"];
	["IconUpsertImageRelationInput"]: GraphQLTypes["IconUpsertImageRelationInput"];
	["PrincipleItemUpsertIconRelationInput"]: GraphQLTypes["PrincipleItemUpsertIconRelationInput"];
	["PrincipleListUpsertItemsRelationInput"]: GraphQLTypes["PrincipleListUpsertItemsRelationInput"];
	["ContentReferenceUpsertPrincipleListRelationInput"]: GraphQLTypes["ContentReferenceUpsertPrincipleListRelationInput"];
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"];
	["ContentImageLinkListUpdateInput"]: GraphQLTypes["ContentImageLinkListUpdateInput"];
	["ContentImageLinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["ContentImageLinkListUpdateItemsEntityRelationInput"];
	["ContentImageLinkListUpdateItemsRelationInput"]: GraphQLTypes["ContentImageLinkListUpdateItemsRelationInput"];
	["ContentImageLinkItemWithoutListUpdateInput"]: GraphQLTypes["ContentImageLinkItemWithoutListUpdateInput"];
	["ContentImageLinkItemUpdateImageEntityRelationInput"]: GraphQLTypes["ContentImageLinkItemUpdateImageEntityRelationInput"];
	["ContentImageLinkItemUpsertImageRelationInput"]: GraphQLTypes["ContentImageLinkItemUpsertImageRelationInput"];
	["ContentImageLinkItemUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentImageLinkItemUpdateLinkEntityRelationInput"];
	["ContentImageLinkItemUpsertLinkRelationInput"]: GraphQLTypes["ContentImageLinkItemUpsertLinkRelationInput"];
	["ContentImageLinkListUpsertItemsRelationInput"]: GraphQLTypes["ContentImageLinkListUpsertItemsRelationInput"];
	["ContentImageLinkListUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentImageLinkListUpdateLinkEntityRelationInput"];
	["ContentImageLinkListUpsertLinkRelationInput"]: GraphQLTypes["ContentImageLinkListUpsertLinkRelationInput"];
	["ContentReferenceUpsertImageLinkListRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageLinkListRelationInput"];
	["ContentReferenceUpdateCitationListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateCitationListEntityRelationInput"];
	["CitationListUpdateInput"]: GraphQLTypes["CitationListUpdateInput"];
	["CitationListUpdateItemsEntityRelationInput"]: GraphQLTypes["CitationListUpdateItemsEntityRelationInput"];
	["CitationListUpdateItemsRelationInput"]: GraphQLTypes["CitationListUpdateItemsRelationInput"];
	["CitationItemWithoutListUpdateInput"]: GraphQLTypes["CitationItemWithoutListUpdateInput"];
	["CitationItemUpdateImageEntityRelationInput"]: GraphQLTypes["CitationItemUpdateImageEntityRelationInput"];
	["CitationItemUpsertImageRelationInput"]: GraphQLTypes["CitationItemUpsertImageRelationInput"];
	["CitationListUpsertItemsRelationInput"]: GraphQLTypes["CitationListUpsertItemsRelationInput"];
	["ContentReferenceUpsertCitationListRelationInput"]: GraphQLTypes["ContentReferenceUpsertCitationListRelationInput"];
	["ContentReferenceUpdateStoriesListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateStoriesListEntityRelationInput"];
	["StoriesListUpdateInput"]: GraphQLTypes["StoriesListUpdateInput"];
	["StoriesListUpdateItemsEntityRelationInput"]: GraphQLTypes["StoriesListUpdateItemsEntityRelationInput"];
	["StoriesListUpdateItemsRelationInput"]: GraphQLTypes["StoriesListUpdateItemsRelationInput"];
	["StoriesWithoutListUpdateInput"]: GraphQLTypes["StoriesWithoutListUpdateInput"];
	["StoriesUpdateLinkEntityRelationInput"]: GraphQLTypes["StoriesUpdateLinkEntityRelationInput"];
	["LinkableWithoutStoryUpdateInput"]: GraphQLTypes["LinkableWithoutStoryUpdateInput"];
	["StoriesUpsertLinkRelationInput"]: GraphQLTypes["StoriesUpsertLinkRelationInput"];
	["StoriesListUpsertItemsRelationInput"]: GraphQLTypes["StoriesListUpsertItemsRelationInput"];
	["ContentReferenceUpsertStoriesListRelationInput"]: GraphQLTypes["ContentReferenceUpsertStoriesListRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: GraphQLTypes["ContentUpsertBlocksRelationInput"];
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: GraphQLTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: GraphQLTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: GraphQLTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentReferenceUpsertBlockRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"];
	["FallbackSeo"]: {
		_meta?:ModelTypes["FallbackSeoMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["FallbackSeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["FallbackSeoUniqueWhere"]: GraphQLTypes["FallbackSeoUniqueWhere"];
	["FallbackSeoWhere"]: GraphQLTypes["FallbackSeoWhere"];
	["FallbackSeoOrderBy"]: GraphQLTypes["FallbackSeoOrderBy"];
	["FallbackSeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FallbackSeoEdge"][]
};
	["FallbackSeoEdge"]: {
		node:ModelTypes["FallbackSeo"]
};
	["FallbackSeoCreateInput"]: GraphQLTypes["FallbackSeoCreateInput"];
	["FallbackSeoCreateSeoEntityRelationInput"]: GraphQLTypes["FallbackSeoCreateSeoEntityRelationInput"];
	["FallbackSeoUpdateInput"]: GraphQLTypes["FallbackSeoUpdateInput"];
	["FallbackSeoUpdateSeoEntityRelationInput"]: GraphQLTypes["FallbackSeoUpdateSeoEntityRelationInput"];
	["FallbackSeoUpsertSeoRelationInput"]: GraphQLTypes["FallbackSeoUpsertSeoRelationInput"];
	["Footer"]: {
		_meta?:ModelTypes["FooterMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	copyright?:string,
	logoFirst?:ModelTypes["Image"],
	logoSecond?:ModelTypes["Image"],
	linksGroups:ModelTypes["FooterLinkGroups"][],
	phone?:string,
	email?:string,
	text?:string,
	link?:ModelTypes["Link"],
	paginateLinksGroups:ModelTypes["FooterLinkGroupsConnection"]
};
	["FooterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	copyright?:ModelTypes["FieldMeta"],
	logoFirst?:ModelTypes["FieldMeta"],
	logoSecond?:ModelTypes["FieldMeta"],
	linksGroups?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["FooterLinkGroups"]: {
		_meta?:ModelTypes["FooterLinkGroupsMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	links:ModelTypes["FooterLink"][],
	specialIdentifier?:string,
	paginateLinks:ModelTypes["FooterLinkConnection"]
};
	["FooterLinkGroupsMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"],
	specialIdentifier?:ModelTypes["FieldMeta"]
};
	["FooterLink"]: {
		_meta?:ModelTypes["FooterLinkMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"]
};
	["FooterLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["FooterLinkWhere"]: GraphQLTypes["FooterLinkWhere"];
	["FooterLinkOrderBy"]: GraphQLTypes["FooterLinkOrderBy"];
	["FooterLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterLinkEdge"][]
};
	["FooterLinkEdge"]: {
		node:ModelTypes["FooterLink"]
};
	["FooterLinkGroupsWhere"]: GraphQLTypes["FooterLinkGroupsWhere"];
	["FooterLinkGroupsOrderBy"]: GraphQLTypes["FooterLinkGroupsOrderBy"];
	["FooterLinkGroupsConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterLinkGroupsEdge"][]
};
	["FooterLinkGroupsEdge"]: {
		node:ModelTypes["FooterLinkGroups"]
};
	["FooterUniqueWhere"]: GraphQLTypes["FooterUniqueWhere"];
	["FooterWhere"]: GraphQLTypes["FooterWhere"];
	["FooterOrderBy"]: GraphQLTypes["FooterOrderBy"];
	["FooterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterEdge"][]
};
	["FooterEdge"]: {
		node:ModelTypes["Footer"]
};
	["FooterCreateInput"]: GraphQLTypes["FooterCreateInput"];
	["FooterCreateLogoFirstEntityRelationInput"]: GraphQLTypes["FooterCreateLogoFirstEntityRelationInput"];
	["FooterCreateLogoSecondEntityRelationInput"]: GraphQLTypes["FooterCreateLogoSecondEntityRelationInput"];
	["FooterCreateLinksGroupsEntityRelationInput"]: GraphQLTypes["FooterCreateLinksGroupsEntityRelationInput"];
	["FooterLinkGroupsUniqueWhere"]: GraphQLTypes["FooterLinkGroupsUniqueWhere"];
	["FooterLinkGroupsCreateInput"]: GraphQLTypes["FooterLinkGroupsCreateInput"];
	["FooterLinkGroupsCreateLinksEntityRelationInput"]: GraphQLTypes["FooterLinkGroupsCreateLinksEntityRelationInput"];
	["FooterLinkUniqueWhere"]: GraphQLTypes["FooterLinkUniqueWhere"];
	["FooterLinkCreateInput"]: GraphQLTypes["FooterLinkCreateInput"];
	["FooterLinkCreateLinkEntityRelationInput"]: GraphQLTypes["FooterLinkCreateLinkEntityRelationInput"];
	["FooterCreateLinkEntityRelationInput"]: GraphQLTypes["FooterCreateLinkEntityRelationInput"];
	["FooterUpdateInput"]: GraphQLTypes["FooterUpdateInput"];
	["FooterUpdateLogoFirstEntityRelationInput"]: GraphQLTypes["FooterUpdateLogoFirstEntityRelationInput"];
	["FooterUpsertLogoFirstRelationInput"]: GraphQLTypes["FooterUpsertLogoFirstRelationInput"];
	["FooterUpdateLogoSecondEntityRelationInput"]: GraphQLTypes["FooterUpdateLogoSecondEntityRelationInput"];
	["FooterUpsertLogoSecondRelationInput"]: GraphQLTypes["FooterUpsertLogoSecondRelationInput"];
	["FooterUpdateLinksGroupsEntityRelationInput"]: GraphQLTypes["FooterUpdateLinksGroupsEntityRelationInput"];
	["FooterUpdateLinksGroupsRelationInput"]: GraphQLTypes["FooterUpdateLinksGroupsRelationInput"];
	["FooterLinkGroupsUpdateInput"]: GraphQLTypes["FooterLinkGroupsUpdateInput"];
	["FooterLinkGroupsUpdateLinksEntityRelationInput"]: GraphQLTypes["FooterLinkGroupsUpdateLinksEntityRelationInput"];
	["FooterLinkGroupsUpdateLinksRelationInput"]: GraphQLTypes["FooterLinkGroupsUpdateLinksRelationInput"];
	["FooterLinkUpdateInput"]: GraphQLTypes["FooterLinkUpdateInput"];
	["FooterLinkUpdateLinkEntityRelationInput"]: GraphQLTypes["FooterLinkUpdateLinkEntityRelationInput"];
	["FooterLinkUpsertLinkRelationInput"]: GraphQLTypes["FooterLinkUpsertLinkRelationInput"];
	["FooterLinkGroupsUpsertLinksRelationInput"]: GraphQLTypes["FooterLinkGroupsUpsertLinksRelationInput"];
	["FooterUpsertLinksGroupsRelationInput"]: GraphQLTypes["FooterUpsertLinksGroupsRelationInput"];
	["FooterUpdateLinkEntityRelationInput"]: GraphQLTypes["FooterUpdateLinkEntityRelationInput"];
	["FooterUpsertLinkRelationInput"]: GraphQLTypes["FooterUpsertLinkRelationInput"];
	["Header"]: {
		_meta?:ModelTypes["HeaderMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	logoFirst?:ModelTypes["Image"],
	logoSecond?:ModelTypes["Image"],
	linkGroups?:ModelTypes["LinkList"]
};
	["HeaderMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	logoFirst?:ModelTypes["FieldMeta"],
	logoSecond?:ModelTypes["FieldMeta"],
	linkGroups?:ModelTypes["FieldMeta"]
};
	["LinkList"]: {
		_meta?:ModelTypes["LinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["LinkItem"][],
	itemsByLink?:ModelTypes["LinkItem"],
	itemsByGroup?:ModelTypes["LinkItem"],
	paginateItems:ModelTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["LinkItem"]: {
		_meta?:ModelTypes["LinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["LinkList"],
	link?:ModelTypes["Link"],
	group?:ModelTypes["LinkSubGroup"],
	isHighlighted?:boolean
};
	["LinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	group?:ModelTypes["FieldMeta"],
	isHighlighted?:ModelTypes["FieldMeta"]
};
	["LinkListWhere"]: GraphQLTypes["LinkListWhere"];
	["LinkItemWhere"]: GraphQLTypes["LinkItemWhere"];
	["LinkSubGroupWhere"]: GraphQLTypes["LinkSubGroupWhere"];
	["LinkSubGroup"]: {
		_meta?:ModelTypes["LinkSubGroupMeta"],
	id:ModelTypes["UUID"],
	order:number,
	links?:ModelTypes["LinkList"]
};
	["LinkSubGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"]
};
	["LinkItemOrderBy"]: GraphQLTypes["LinkItemOrderBy"];
	["LinkListOrderBy"]: GraphQLTypes["LinkListOrderBy"];
	["LinkSubGroupOrderBy"]: GraphQLTypes["LinkSubGroupOrderBy"];
	["LinkListItemsByLinkUniqueWhere"]: GraphQLTypes["LinkListItemsByLinkUniqueWhere"];
	["LinkListItemsByGroupUniqueWhere"]: GraphQLTypes["LinkListItemsByGroupUniqueWhere"];
	["LinkSubGroupUniqueWhere"]: GraphQLTypes["LinkSubGroupUniqueWhere"];
	["LinkListUniqueWhere"]: GraphQLTypes["LinkListUniqueWhere"];
	["LinkItemUniqueWhere"]: GraphQLTypes["LinkItemUniqueWhere"];
	["LinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkItemEdge"][]
};
	["LinkItemEdge"]: {
		node:ModelTypes["LinkItem"]
};
	["HeaderUniqueWhere"]: GraphQLTypes["HeaderUniqueWhere"];
	["HeaderWhere"]: GraphQLTypes["HeaderWhere"];
	["HeaderOrderBy"]: GraphQLTypes["HeaderOrderBy"];
	["HeaderConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderEdge"][]
};
	["HeaderEdge"]: {
		node:ModelTypes["Header"]
};
	["HeaderCreateInput"]: GraphQLTypes["HeaderCreateInput"];
	["HeaderCreateLogoFirstEntityRelationInput"]: GraphQLTypes["HeaderCreateLogoFirstEntityRelationInput"];
	["HeaderCreateLogoSecondEntityRelationInput"]: GraphQLTypes["HeaderCreateLogoSecondEntityRelationInput"];
	["HeaderCreateLinkGroupsEntityRelationInput"]: GraphQLTypes["HeaderCreateLinkGroupsEntityRelationInput"];
	["LinkListCreateInput"]: GraphQLTypes["LinkListCreateInput"];
	["LinkListCreateItemsEntityRelationInput"]: GraphQLTypes["LinkListCreateItemsEntityRelationInput"];
	["LinkItemWithoutListCreateInput"]: GraphQLTypes["LinkItemWithoutListCreateInput"];
	["LinkItemCreateLinkEntityRelationInput"]: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"];
	["LinkItemCreateGroupEntityRelationInput"]: GraphQLTypes["LinkItemCreateGroupEntityRelationInput"];
	["LinkSubGroupCreateInput"]: GraphQLTypes["LinkSubGroupCreateInput"];
	["LinkSubGroupCreateLinksEntityRelationInput"]: GraphQLTypes["LinkSubGroupCreateLinksEntityRelationInput"];
	["HeaderUpdateInput"]: GraphQLTypes["HeaderUpdateInput"];
	["HeaderUpdateLogoFirstEntityRelationInput"]: GraphQLTypes["HeaderUpdateLogoFirstEntityRelationInput"];
	["HeaderUpsertLogoFirstRelationInput"]: GraphQLTypes["HeaderUpsertLogoFirstRelationInput"];
	["HeaderUpdateLogoSecondEntityRelationInput"]: GraphQLTypes["HeaderUpdateLogoSecondEntityRelationInput"];
	["HeaderUpsertLogoSecondRelationInput"]: GraphQLTypes["HeaderUpsertLogoSecondRelationInput"];
	["HeaderUpdateLinkGroupsEntityRelationInput"]: GraphQLTypes["HeaderUpdateLinkGroupsEntityRelationInput"];
	["LinkListUpdateInput"]: GraphQLTypes["LinkListUpdateInput"];
	["LinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["LinkListUpdateItemsEntityRelationInput"];
	["LinkListUpdateItemsRelationInput"]: GraphQLTypes["LinkListUpdateItemsRelationInput"];
	["LinkItemWithoutListUpdateInput"]: GraphQLTypes["LinkItemWithoutListUpdateInput"];
	["LinkItemUpdateLinkEntityRelationInput"]: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"];
	["LinkItemUpsertLinkRelationInput"]: GraphQLTypes["LinkItemUpsertLinkRelationInput"];
	["LinkItemUpdateGroupEntityRelationInput"]: GraphQLTypes["LinkItemUpdateGroupEntityRelationInput"];
	["LinkSubGroupUpdateInput"]: GraphQLTypes["LinkSubGroupUpdateInput"];
	["LinkSubGroupUpdateLinksEntityRelationInput"]: GraphQLTypes["LinkSubGroupUpdateLinksEntityRelationInput"];
	["LinkSubGroupUpsertLinksRelationInput"]: GraphQLTypes["LinkSubGroupUpsertLinksRelationInput"];
	["LinkItemUpsertGroupRelationInput"]: GraphQLTypes["LinkItemUpsertGroupRelationInput"];
	["LinkListUpsertItemsRelationInput"]: GraphQLTypes["LinkListUpsertItemsRelationInput"];
	["HeaderUpsertLinkGroupsRelationInput"]: GraphQLTypes["HeaderUpsertLinkGroupsRelationInput"];
	["HomePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomePageEdge"][]
};
	["HomePageEdge"]: {
		node:ModelTypes["HomePage"]
};
	["HomePageCreateInput"]: GraphQLTypes["HomePageCreateInput"];
	["HomePageCreateLinkEntityRelationInput"]: GraphQLTypes["HomePageCreateLinkEntityRelationInput"];
	["LinkableWithoutHomePageCreateInput"]: GraphQLTypes["LinkableWithoutHomePageCreateInput"];
	["HomePageUpdateInput"]: GraphQLTypes["HomePageUpdateInput"];
	["HomePageUpdateLinkEntityRelationInput"]: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"];
	["LinkableWithoutHomePageUpdateInput"]: GraphQLTypes["LinkableWithoutHomePageUpdateInput"];
	["HomePageUpsertLinkRelationInput"]: GraphQLTypes["HomePageUpsertLinkRelationInput"];
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["ProgramConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProgramEdge"][]
};
	["ProgramEdge"]: {
		node:ModelTypes["Program"]
};
	["ProgramCreateInput"]: GraphQLTypes["ProgramCreateInput"];
	["ProgramCreateLinkEntityRelationInput"]: GraphQLTypes["ProgramCreateLinkEntityRelationInput"];
	["LinkableWithoutProgramCreateInput"]: GraphQLTypes["LinkableWithoutProgramCreateInput"];
	["ProgramUpdateInput"]: GraphQLTypes["ProgramUpdateInput"];
	["ProgramUpdateLinkEntityRelationInput"]: GraphQLTypes["ProgramUpdateLinkEntityRelationInput"];
	["LinkableWithoutProgramUpdateInput"]: GraphQLTypes["LinkableWithoutProgramUpdateInput"];
	["ProgramUpsertLinkRelationInput"]: GraphQLTypes["ProgramUpsertLinkRelationInput"];
	["RedirectConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RedirectEdge"][]
};
	["RedirectEdge"]: {
		node:ModelTypes["Redirect"]
};
	["RedirectCreateInput"]: GraphQLTypes["RedirectCreateInput"];
	["RedirectCreateLinkEntityRelationInput"]: GraphQLTypes["RedirectCreateLinkEntityRelationInput"];
	["LinkableWithoutRedirectCreateInput"]: GraphQLTypes["LinkableWithoutRedirectCreateInput"];
	["RedirectUpdateInput"]: GraphQLTypes["RedirectUpdateInput"];
	["RedirectUpdateLinkEntityRelationInput"]: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"];
	["LinkableWithoutRedirectUpdateInput"]: GraphQLTypes["LinkableWithoutRedirectUpdateInput"];
	["RedirectUpsertLinkRelationInput"]: GraphQLTypes["RedirectUpsertLinkRelationInput"];
	["YoutubeVideoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["YoutubeVideoEdge"][]
};
	["YoutubeVideoEdge"]: {
		node:ModelTypes["YoutubeVideo"]
};
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["BulletPointConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BulletPointEdge"][]
};
	["BulletPointEdge"]: {
		node:ModelTypes["BulletPoint"]
};
	["BulletPointItemCreateInput"]: GraphQLTypes["BulletPointItemCreateInput"];
	["BulletPointItemCreateListEntityRelationInput"]: GraphQLTypes["BulletPointItemCreateListEntityRelationInput"];
	["BulletPointWithoutItemsCreateInput"]: GraphQLTypes["BulletPointWithoutItemsCreateInput"];
	["BulletPointItemUpdateInput"]: GraphQLTypes["BulletPointItemUpdateInput"];
	["BulletPointItemUpdateListEntityRelationInput"]: GraphQLTypes["BulletPointItemUpdateListEntityRelationInput"];
	["BulletPointWithoutItemsUpdateInput"]: GraphQLTypes["BulletPointWithoutItemsUpdateInput"];
	["BulletPointItemUpsertListRelationInput"]: GraphQLTypes["BulletPointItemUpsertListRelationInput"];
	["FileItemCreateInput"]: GraphQLTypes["FileItemCreateInput"];
	["FileItemCreateListEntityRelationInput"]: GraphQLTypes["FileItemCreateListEntityRelationInput"];
	["FileListWithoutItemsCreateInput"]: GraphQLTypes["FileListWithoutItemsCreateInput"];
	["FileListCreateReferenceEntityRelationInput"]: GraphQLTypes["FileListCreateReferenceEntityRelationInput"];
	["ContentReferenceWithoutFileListCreateInput"]: GraphQLTypes["ContentReferenceWithoutFileListCreateInput"];
	["FileItemUpdateInput"]: GraphQLTypes["FileItemUpdateInput"];
	["FileItemUpdateListEntityRelationInput"]: GraphQLTypes["FileItemUpdateListEntityRelationInput"];
	["FileListWithoutItemsUpdateInput"]: GraphQLTypes["FileListWithoutItemsUpdateInput"];
	["FileListUpdateReferenceEntityRelationInput"]: GraphQLTypes["FileListUpdateReferenceEntityRelationInput"];
	["ContentReferenceWithoutFileListUpdateInput"]: GraphQLTypes["ContentReferenceWithoutFileListUpdateInput"];
	["FileListUpsertReferenceRelationInput"]: GraphQLTypes["FileListUpsertReferenceRelationInput"];
	["FileItemUpsertListRelationInput"]: GraphQLTypes["FileItemUpsertListRelationInput"];
	["FileListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FileListEdge"][]
};
	["FileListEdge"]: {
		node:ModelTypes["FileList"]
};
	["FileListCreateInput"]: GraphQLTypes["FileListCreateInput"];
	["FileListUpdateInput"]: GraphQLTypes["FileListUpdateInput"];
	["TextItemCreateInput"]: GraphQLTypes["TextItemCreateInput"];
	["TextItemCreateListEntityRelationInput"]: GraphQLTypes["TextItemCreateListEntityRelationInput"];
	["TextListWithoutItemsCreateInput"]: GraphQLTypes["TextListWithoutItemsCreateInput"];
	["TextItemUpdateInput"]: GraphQLTypes["TextItemUpdateInput"];
	["TextItemUpdateListEntityRelationInput"]: GraphQLTypes["TextItemUpdateListEntityRelationInput"];
	["TextListWithoutItemsUpdateInput"]: GraphQLTypes["TextListWithoutItemsUpdateInput"];
	["TextItemUpsertListRelationInput"]: GraphQLTypes["TextItemUpsertListRelationInput"];
	["TextListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TextListEdge"][]
};
	["TextListEdge"]: {
		node:ModelTypes["TextList"]
};
	["ProgramPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProgramPageEdge"][]
};
	["ProgramPageEdge"]: {
		node:ModelTypes["ProgramPage"]
};
	["ProgramPageCreateInput"]: GraphQLTypes["ProgramPageCreateInput"];
	["ProgramPageCreateLinkEntityRelationInput"]: GraphQLTypes["ProgramPageCreateLinkEntityRelationInput"];
	["LinkableWithoutProgramPageCreateInput"]: GraphQLTypes["LinkableWithoutProgramPageCreateInput"];
	["ProgramPageUpdateInput"]: GraphQLTypes["ProgramPageUpdateInput"];
	["ProgramPageUpdateLinkEntityRelationInput"]: GraphQLTypes["ProgramPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutProgramPageUpdateInput"]: GraphQLTypes["LinkableWithoutProgramPageUpdateInput"];
	["ProgramPageUpsertLinkRelationInput"]: GraphQLTypes["ProgramPageUpsertLinkRelationInput"];
	["GenericPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GenericPageEdge"][]
};
	["GenericPageEdge"]: {
		node:ModelTypes["GenericPage"]
};
	["GenericPageCreateInput"]: GraphQLTypes["GenericPageCreateInput"];
	["GenericPageCreateLinkEntityRelationInput"]: GraphQLTypes["GenericPageCreateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageCreateInput"]: GraphQLTypes["LinkableWithoutGenericPageCreateInput"];
	["GenericPageUpdateInput"]: GraphQLTypes["GenericPageUpdateInput"];
	["GenericPageUpdateLinkEntityRelationInput"]: GraphQLTypes["GenericPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageUpdateInput"]: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"];
	["GenericPageUpsertLinkRelationInput"]: GraphQLTypes["GenericPageUpsertLinkRelationInput"];
	["StaffConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StaffEdge"][]
};
	["StaffEdge"]: {
		node:ModelTypes["Staff"]
};
	["StaffItemCreateInput"]: GraphQLTypes["StaffItemCreateInput"];
	["StaffItemCreateListEntityRelationInput"]: GraphQLTypes["StaffItemCreateListEntityRelationInput"];
	["StaffListWithoutItemsCreateInput"]: GraphQLTypes["StaffListWithoutItemsCreateInput"];
	["StaffListCreateReferenceEntityRelationInput"]: GraphQLTypes["StaffListCreateReferenceEntityRelationInput"];
	["ContentReferenceWithoutStaffListCreateInput"]: GraphQLTypes["ContentReferenceWithoutStaffListCreateInput"];
	["StaffItemUpdateInput"]: GraphQLTypes["StaffItemUpdateInput"];
	["StaffItemUpdateListEntityRelationInput"]: GraphQLTypes["StaffItemUpdateListEntityRelationInput"];
	["StaffListWithoutItemsUpdateInput"]: GraphQLTypes["StaffListWithoutItemsUpdateInput"];
	["StaffListUpdateReferenceEntityRelationInput"]: GraphQLTypes["StaffListUpdateReferenceEntityRelationInput"];
	["ContentReferenceWithoutStaffListUpdateInput"]: GraphQLTypes["ContentReferenceWithoutStaffListUpdateInput"];
	["StaffListUpsertReferenceRelationInput"]: GraphQLTypes["StaffListUpsertReferenceRelationInput"];
	["StaffItemUpsertListRelationInput"]: GraphQLTypes["StaffItemUpsertListRelationInput"];
	["StaffListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StaffListEdge"][]
};
	["StaffListEdge"]: {
		node:ModelTypes["StaffList"]
};
	["StaffListCreateInput"]: GraphQLTypes["StaffListCreateInput"];
	["StaffListUpdateInput"]: GraphQLTypes["StaffListUpdateInput"];
	["IconConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["IconEdge"][]
};
	["IconEdge"]: {
		node:ModelTypes["Icon"]
};
	["PrincipleItemCreateInput"]: GraphQLTypes["PrincipleItemCreateInput"];
	["PrincipleItemCreateListEntityRelationInput"]: GraphQLTypes["PrincipleItemCreateListEntityRelationInput"];
	["PrincipleListWithoutItemsCreateInput"]: GraphQLTypes["PrincipleListWithoutItemsCreateInput"];
	["PrincipleListCreateReferenceEntityRelationInput"]: GraphQLTypes["PrincipleListCreateReferenceEntityRelationInput"];
	["ContentReferenceWithoutPrincipleListCreateInput"]: GraphQLTypes["ContentReferenceWithoutPrincipleListCreateInput"];
	["PrincipleItemUpdateInput"]: GraphQLTypes["PrincipleItemUpdateInput"];
	["PrincipleItemUpdateListEntityRelationInput"]: GraphQLTypes["PrincipleItemUpdateListEntityRelationInput"];
	["PrincipleListWithoutItemsUpdateInput"]: GraphQLTypes["PrincipleListWithoutItemsUpdateInput"];
	["PrincipleListUpdateReferenceEntityRelationInput"]: GraphQLTypes["PrincipleListUpdateReferenceEntityRelationInput"];
	["ContentReferenceWithoutPrincipleListUpdateInput"]: GraphQLTypes["ContentReferenceWithoutPrincipleListUpdateInput"];
	["PrincipleListUpsertReferenceRelationInput"]: GraphQLTypes["PrincipleListUpsertReferenceRelationInput"];
	["PrincipleItemUpsertListRelationInput"]: GraphQLTypes["PrincipleItemUpsertListRelationInput"];
	["PrincipleListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PrincipleListEdge"][]
};
	["PrincipleListEdge"]: {
		node:ModelTypes["PrincipleList"]
};
	["PrincipleListCreateInput"]: GraphQLTypes["PrincipleListCreateInput"];
	["PrincipleListUpdateInput"]: GraphQLTypes["PrincipleListUpdateInput"];
	["LinkItemCreateInput"]: GraphQLTypes["LinkItemCreateInput"];
	["LinkItemCreateListEntityRelationInput"]: GraphQLTypes["LinkItemCreateListEntityRelationInput"];
	["LinkListWithoutItemsCreateInput"]: GraphQLTypes["LinkListWithoutItemsCreateInput"];
	["LinkItemUpdateInput"]: GraphQLTypes["LinkItemUpdateInput"];
	["LinkItemUpdateListEntityRelationInput"]: GraphQLTypes["LinkItemUpdateListEntityRelationInput"];
	["LinkListWithoutItemsUpdateInput"]: GraphQLTypes["LinkListWithoutItemsUpdateInput"];
	["LinkItemUpsertListRelationInput"]: GraphQLTypes["LinkItemUpsertListRelationInput"];
	["LinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkListEdge"][]
};
	["LinkListEdge"]: {
		node:ModelTypes["LinkList"]
};
	["LinkSubGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkSubGroupEdge"][]
};
	["LinkSubGroupEdge"]: {
		node:ModelTypes["LinkSubGroup"]
};
	["YoutubeVideoList"]: {
		_meta?:ModelTypes["YoutubeVideoListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["YoutubeVideoListItem"][],
	itemsByYoutube?:ModelTypes["YoutubeVideoListItem"],
	paginateItems:ModelTypes["YoutubeVideoListItemConnection"]
};
	["YoutubeVideoListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["YoutubeVideoListItem"]: {
		_meta?:ModelTypes["YoutubeVideoListItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["YoutubeVideoList"],
	youtube?:ModelTypes["YoutubeVideo"]
};
	["YoutubeVideoListItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	youtube?:ModelTypes["FieldMeta"]
};
	["YoutubeVideoListWhere"]: GraphQLTypes["YoutubeVideoListWhere"];
	["YoutubeVideoListItemWhere"]: GraphQLTypes["YoutubeVideoListItemWhere"];
	["YoutubeVideoListItemOrderBy"]: GraphQLTypes["YoutubeVideoListItemOrderBy"];
	["YoutubeVideoListOrderBy"]: GraphQLTypes["YoutubeVideoListOrderBy"];
	["YoutubeVideoListItemsByYoutubeUniqueWhere"]: GraphQLTypes["YoutubeVideoListItemsByYoutubeUniqueWhere"];
	["YoutubeVideoListItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["YoutubeVideoListItemEdge"][]
};
	["YoutubeVideoListItemEdge"]: {
		node:ModelTypes["YoutubeVideoListItem"]
};
	["YoutubeVideoListUniqueWhere"]: GraphQLTypes["YoutubeVideoListUniqueWhere"];
	["YoutubeVideoListItemUniqueWhere"]: GraphQLTypes["YoutubeVideoListItemUniqueWhere"];
	["YoutubeVideoListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["YoutubeVideoListEdge"][]
};
	["YoutubeVideoListEdge"]: {
		node:ModelTypes["YoutubeVideoList"]
};
	["YoutubeVideoListCreateInput"]: GraphQLTypes["YoutubeVideoListCreateInput"];
	["YoutubeVideoListCreateItemsEntityRelationInput"]: GraphQLTypes["YoutubeVideoListCreateItemsEntityRelationInput"];
	["YoutubeVideoListItemWithoutListCreateInput"]: GraphQLTypes["YoutubeVideoListItemWithoutListCreateInput"];
	["YoutubeVideoListItemCreateYoutubeEntityRelationInput"]: GraphQLTypes["YoutubeVideoListItemCreateYoutubeEntityRelationInput"];
	["YoutubeVideoListUpdateInput"]: GraphQLTypes["YoutubeVideoListUpdateInput"];
	["YoutubeVideoListUpdateItemsEntityRelationInput"]: GraphQLTypes["YoutubeVideoListUpdateItemsEntityRelationInput"];
	["YoutubeVideoListUpdateItemsRelationInput"]: GraphQLTypes["YoutubeVideoListUpdateItemsRelationInput"];
	["YoutubeVideoListItemWithoutListUpdateInput"]: GraphQLTypes["YoutubeVideoListItemWithoutListUpdateInput"];
	["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"]: GraphQLTypes["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"];
	["YoutubeVideoListItemUpsertYoutubeRelationInput"]: GraphQLTypes["YoutubeVideoListItemUpsertYoutubeRelationInput"];
	["YoutubeVideoListUpsertItemsRelationInput"]: GraphQLTypes["YoutubeVideoListUpsertItemsRelationInput"];
	["YoutubeVideoListItemCreateInput"]: GraphQLTypes["YoutubeVideoListItemCreateInput"];
	["YoutubeVideoListItemCreateListEntityRelationInput"]: GraphQLTypes["YoutubeVideoListItemCreateListEntityRelationInput"];
	["YoutubeVideoListWithoutItemsCreateInput"]: GraphQLTypes["YoutubeVideoListWithoutItemsCreateInput"];
	["YoutubeVideoListItemUpdateInput"]: GraphQLTypes["YoutubeVideoListItemUpdateInput"];
	["YoutubeVideoListItemUpdateListEntityRelationInput"]: GraphQLTypes["YoutubeVideoListItemUpdateListEntityRelationInput"];
	["YoutubeVideoListWithoutItemsUpdateInput"]: GraphQLTypes["YoutubeVideoListWithoutItemsUpdateInput"];
	["YoutubeVideoListItemUpsertListRelationInput"]: GraphQLTypes["YoutubeVideoListItemUpsertListRelationInput"];
	["ImageList"]: {
		_meta?:ModelTypes["ImageListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ImageListItem"][],
	itemsByImage?:ModelTypes["ImageListItem"],
	paginateItems:ModelTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ImageListItem"]: {
		_meta?:ModelTypes["ImageListItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["ImageList"],
	image?:ModelTypes["Image"]
};
	["ImageListItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ImageListWhere"]: GraphQLTypes["ImageListWhere"];
	["ImageListItemWhere"]: GraphQLTypes["ImageListItemWhere"];
	["ImageListItemOrderBy"]: GraphQLTypes["ImageListItemOrderBy"];
	["ImageListOrderBy"]: GraphQLTypes["ImageListOrderBy"];
	["ImageListItemsByImageUniqueWhere"]: GraphQLTypes["ImageListItemsByImageUniqueWhere"];
	["ImageListItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageListItemEdge"][]
};
	["ImageListItemEdge"]: {
		node:ModelTypes["ImageListItem"]
};
	["ImageListUniqueWhere"]: GraphQLTypes["ImageListUniqueWhere"];
	["ImageListItemUniqueWhere"]: GraphQLTypes["ImageListItemUniqueWhere"];
	["ImageListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageListEdge"][]
};
	["ImageListEdge"]: {
		node:ModelTypes["ImageList"]
};
	["ImageListCreateInput"]: GraphQLTypes["ImageListCreateInput"];
	["ImageListCreateItemsEntityRelationInput"]: GraphQLTypes["ImageListCreateItemsEntityRelationInput"];
	["ImageListItemWithoutListCreateInput"]: GraphQLTypes["ImageListItemWithoutListCreateInput"];
	["ImageListItemCreateImageEntityRelationInput"]: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"];
	["ImageListUpdateInput"]: GraphQLTypes["ImageListUpdateInput"];
	["ImageListUpdateItemsEntityRelationInput"]: GraphQLTypes["ImageListUpdateItemsEntityRelationInput"];
	["ImageListUpdateItemsRelationInput"]: GraphQLTypes["ImageListUpdateItemsRelationInput"];
	["ImageListItemWithoutListUpdateInput"]: GraphQLTypes["ImageListItemWithoutListUpdateInput"];
	["ImageListItemUpdateImageEntityRelationInput"]: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"];
	["ImageListItemUpsertImageRelationInput"]: GraphQLTypes["ImageListItemUpsertImageRelationInput"];
	["ImageListUpsertItemsRelationInput"]: GraphQLTypes["ImageListUpsertItemsRelationInput"];
	["ImageListItemCreateInput"]: GraphQLTypes["ImageListItemCreateInput"];
	["ImageListItemCreateListEntityRelationInput"]: GraphQLTypes["ImageListItemCreateListEntityRelationInput"];
	["ImageListWithoutItemsCreateInput"]: GraphQLTypes["ImageListWithoutItemsCreateInput"];
	["ImageListItemUpdateInput"]: GraphQLTypes["ImageListItemUpdateInput"];
	["ImageListItemUpdateListEntityRelationInput"]: GraphQLTypes["ImageListItemUpdateListEntityRelationInput"];
	["ImageListWithoutItemsUpdateInput"]: GraphQLTypes["ImageListWithoutItemsUpdateInput"];
	["ImageListItemUpsertListRelationInput"]: GraphQLTypes["ImageListItemUpsertListRelationInput"];
	["CitationItemCreateInput"]: GraphQLTypes["CitationItemCreateInput"];
	["CitationItemCreateListEntityRelationInput"]: GraphQLTypes["CitationItemCreateListEntityRelationInput"];
	["CitationListWithoutItemsCreateInput"]: GraphQLTypes["CitationListWithoutItemsCreateInput"];
	["CitationItemUpdateInput"]: GraphQLTypes["CitationItemUpdateInput"];
	["CitationItemUpdateListEntityRelationInput"]: GraphQLTypes["CitationItemUpdateListEntityRelationInput"];
	["CitationListWithoutItemsUpdateInput"]: GraphQLTypes["CitationListWithoutItemsUpdateInput"];
	["CitationItemUpsertListRelationInput"]: GraphQLTypes["CitationItemUpsertListRelationInput"];
	["CitationListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CitationListEdge"][]
};
	["CitationListEdge"]: {
		node:ModelTypes["CitationList"]
};
	["ContentImageLinkItemCreateInput"]: GraphQLTypes["ContentImageLinkItemCreateInput"];
	["ContentImageLinkItemCreateListEntityRelationInput"]: GraphQLTypes["ContentImageLinkItemCreateListEntityRelationInput"];
	["ContentImageLinkListWithoutItemsCreateInput"]: GraphQLTypes["ContentImageLinkListWithoutItemsCreateInput"];
	["ContentImageLinkItemUpdateInput"]: GraphQLTypes["ContentImageLinkItemUpdateInput"];
	["ContentImageLinkItemUpdateListEntityRelationInput"]: GraphQLTypes["ContentImageLinkItemUpdateListEntityRelationInput"];
	["ContentImageLinkListWithoutItemsUpdateInput"]: GraphQLTypes["ContentImageLinkListWithoutItemsUpdateInput"];
	["ContentImageLinkItemUpsertListRelationInput"]: GraphQLTypes["ContentImageLinkItemUpsertListRelationInput"];
	["ContentImageLinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentImageLinkListEdge"][]
};
	["ContentImageLinkListEdge"]: {
		node:ModelTypes["ContentImageLinkList"]
};
	["NewsConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsEdge"][]
};
	["NewsEdge"]: {
		node:ModelTypes["News"]
};
	["NewsCreateInput"]: GraphQLTypes["NewsCreateInput"];
	["NewsCreateLinkEntityRelationInput"]: GraphQLTypes["NewsCreateLinkEntityRelationInput"];
	["LinkableWithoutNewsCreateInput"]: GraphQLTypes["LinkableWithoutNewsCreateInput"];
	["NewsUpdateInput"]: GraphQLTypes["NewsUpdateInput"];
	["NewsUpdateLinkEntityRelationInput"]: GraphQLTypes["NewsUpdateLinkEntityRelationInput"];
	["LinkableWithoutNewsUpdateInput"]: GraphQLTypes["LinkableWithoutNewsUpdateInput"];
	["NewsUpsertLinkRelationInput"]: GraphQLTypes["NewsUpsertLinkRelationInput"];
	["StoriesCreateInput"]: GraphQLTypes["StoriesCreateInput"];
	["StoriesUpdateInput"]: GraphQLTypes["StoriesUpdateInput"];
	["NewsPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsPageEdge"][]
};
	["NewsPageEdge"]: {
		node:ModelTypes["NewsPage"]
};
	["NewsPageCreateInput"]: GraphQLTypes["NewsPageCreateInput"];
	["NewsPageCreateLinkEntityRelationInput"]: GraphQLTypes["NewsPageCreateLinkEntityRelationInput"];
	["LinkableWithoutNewsPageCreateInput"]: GraphQLTypes["LinkableWithoutNewsPageCreateInput"];
	["NewsPageUpdateInput"]: GraphQLTypes["NewsPageUpdateInput"];
	["NewsPageUpdateLinkEntityRelationInput"]: GraphQLTypes["NewsPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutNewsPageUpdateInput"]: GraphQLTypes["LinkableWithoutNewsPageUpdateInput"];
	["NewsPageUpsertLinkRelationInput"]: GraphQLTypes["NewsPageUpsertLinkRelationInput"];
	["StoriesPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StoriesPageEdge"][]
};
	["StoriesPageEdge"]: {
		node:ModelTypes["StoriesPage"]
};
	["StoriesPageCreateInput"]: GraphQLTypes["StoriesPageCreateInput"];
	["StoriesPageCreateLinkEntityRelationInput"]: GraphQLTypes["StoriesPageCreateLinkEntityRelationInput"];
	["LinkableWithoutStoriesPageCreateInput"]: GraphQLTypes["LinkableWithoutStoriesPageCreateInput"];
	["StoriesPageUpdateInput"]: GraphQLTypes["StoriesPageUpdateInput"];
	["StoriesPageUpdateLinkEntityRelationInput"]: GraphQLTypes["StoriesPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutStoriesPageUpdateInput"]: GraphQLTypes["LinkableWithoutStoriesPageUpdateInput"];
	["StoriesPageUpsertLinkRelationInput"]: GraphQLTypes["StoriesPageUpsertLinkRelationInput"];
	["StoriesListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StoriesListEdge"][]
};
	["StoriesListEdge"]: {
		node:ModelTypes["StoriesList"]
};
	["QueryTransaction"]: {
		getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getFallbackSeo?:ModelTypes["FallbackSeo"],
	listFallbackSeo:ModelTypes["FallbackSeo"][],
	paginateFallbackSeo:ModelTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo:ModelTypes["_ValidationResult"],
	validateUpdateFallbackSeo:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getProgram?:ModelTypes["Program"],
	listProgram:ModelTypes["Program"][],
	paginateProgram:ModelTypes["ProgramConnection"],
	validateCreateProgram:ModelTypes["_ValidationResult"],
	validateUpdateProgram:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getYoutubeVideo?:ModelTypes["YoutubeVideo"],
	listYoutubeVideo:ModelTypes["YoutubeVideo"][],
	paginateYoutubeVideo:ModelTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideo:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getBulletPoint?:ModelTypes["BulletPoint"],
	listBulletPoint:ModelTypes["BulletPoint"][],
	paginateBulletPoint:ModelTypes["BulletPointConnection"],
	validateCreateBulletPoint:ModelTypes["_ValidationResult"],
	validateUpdateBulletPoint:ModelTypes["_ValidationResult"],
	getBulletPointItem?:ModelTypes["BulletPointItem"],
	listBulletPointItem:ModelTypes["BulletPointItem"][],
	paginateBulletPointItem:ModelTypes["BulletPointItemConnection"],
	validateCreateBulletPointItem:ModelTypes["_ValidationResult"],
	validateUpdateBulletPointItem:ModelTypes["_ValidationResult"],
	getFileItem?:ModelTypes["FileItem"],
	listFileItem:ModelTypes["FileItem"][],
	paginateFileItem:ModelTypes["FileItemConnection"],
	validateCreateFileItem:ModelTypes["_ValidationResult"],
	validateUpdateFileItem:ModelTypes["_ValidationResult"],
	getFileList?:ModelTypes["FileList"],
	listFileList:ModelTypes["FileList"][],
	paginateFileList:ModelTypes["FileListConnection"],
	validateCreateFileList:ModelTypes["_ValidationResult"],
	validateUpdateFileList:ModelTypes["_ValidationResult"],
	getFooterLink?:ModelTypes["FooterLink"],
	listFooterLink:ModelTypes["FooterLink"][],
	paginateFooterLink:ModelTypes["FooterLinkConnection"],
	validateCreateFooterLink:ModelTypes["_ValidationResult"],
	validateUpdateFooterLink:ModelTypes["_ValidationResult"],
	getFooterLinkGroups?:ModelTypes["FooterLinkGroups"],
	listFooterLinkGroups:ModelTypes["FooterLinkGroups"][],
	paginateFooterLinkGroups:ModelTypes["FooterLinkGroupsConnection"],
	validateCreateFooterLinkGroups:ModelTypes["_ValidationResult"],
	validateUpdateFooterLinkGroups:ModelTypes["_ValidationResult"],
	getTextItem?:ModelTypes["TextItem"],
	listTextItem:ModelTypes["TextItem"][],
	paginateTextItem:ModelTypes["TextItemConnection"],
	validateCreateTextItem:ModelTypes["_ValidationResult"],
	validateUpdateTextItem:ModelTypes["_ValidationResult"],
	getTextList?:ModelTypes["TextList"],
	listTextList:ModelTypes["TextList"][],
	paginateTextList:ModelTypes["TextListConnection"],
	validateCreateTextList:ModelTypes["_ValidationResult"],
	validateUpdateTextList:ModelTypes["_ValidationResult"],
	getProgramPage?:ModelTypes["ProgramPage"],
	listProgramPage:ModelTypes["ProgramPage"][],
	paginateProgramPage:ModelTypes["ProgramPageConnection"],
	validateCreateProgramPage:ModelTypes["_ValidationResult"],
	validateUpdateProgramPage:ModelTypes["_ValidationResult"],
	getGenericPage?:ModelTypes["GenericPage"],
	listGenericPage:ModelTypes["GenericPage"][],
	paginateGenericPage:ModelTypes["GenericPageConnection"],
	validateCreateGenericPage:ModelTypes["_ValidationResult"],
	validateUpdateGenericPage:ModelTypes["_ValidationResult"],
	getStaff?:ModelTypes["Staff"],
	listStaff:ModelTypes["Staff"][],
	paginateStaff:ModelTypes["StaffConnection"],
	validateCreateStaff:ModelTypes["_ValidationResult"],
	validateUpdateStaff:ModelTypes["_ValidationResult"],
	getStaffItem?:ModelTypes["StaffItem"],
	listStaffItem:ModelTypes["StaffItem"][],
	paginateStaffItem:ModelTypes["StaffItemConnection"],
	validateCreateStaffItem:ModelTypes["_ValidationResult"],
	validateUpdateStaffItem:ModelTypes["_ValidationResult"],
	getStaffList?:ModelTypes["StaffList"],
	listStaffList:ModelTypes["StaffList"][],
	paginateStaffList:ModelTypes["StaffListConnection"],
	validateCreateStaffList:ModelTypes["_ValidationResult"],
	validateUpdateStaffList:ModelTypes["_ValidationResult"],
	getIcon?:ModelTypes["Icon"],
	listIcon:ModelTypes["Icon"][],
	paginateIcon:ModelTypes["IconConnection"],
	validateCreateIcon:ModelTypes["_ValidationResult"],
	validateUpdateIcon:ModelTypes["_ValidationResult"],
	getPrincipleItem?:ModelTypes["PrincipleItem"],
	listPrincipleItem:ModelTypes["PrincipleItem"][],
	paginatePrincipleItem:ModelTypes["PrincipleItemConnection"],
	validateCreatePrincipleItem:ModelTypes["_ValidationResult"],
	validateUpdatePrincipleItem:ModelTypes["_ValidationResult"],
	getPrincipleList?:ModelTypes["PrincipleList"],
	listPrincipleList:ModelTypes["PrincipleList"][],
	paginatePrincipleList:ModelTypes["PrincipleListConnection"],
	validateCreatePrincipleList:ModelTypes["_ValidationResult"],
	validateUpdatePrincipleList:ModelTypes["_ValidationResult"],
	getLinkItem?:ModelTypes["LinkItem"],
	listLinkItem:ModelTypes["LinkItem"][],
	paginateLinkItem:ModelTypes["LinkItemConnection"],
	validateCreateLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateLinkItem:ModelTypes["_ValidationResult"],
	getLinkList?:ModelTypes["LinkList"],
	listLinkList:ModelTypes["LinkList"][],
	paginateLinkList:ModelTypes["LinkListConnection"],
	validateCreateLinkList:ModelTypes["_ValidationResult"],
	validateUpdateLinkList:ModelTypes["_ValidationResult"],
	getLinkSubGroup?:ModelTypes["LinkSubGroup"],
	listLinkSubGroup:ModelTypes["LinkSubGroup"][],
	paginateLinkSubGroup:ModelTypes["LinkSubGroupConnection"],
	validateCreateLinkSubGroup:ModelTypes["_ValidationResult"],
	validateUpdateLinkSubGroup:ModelTypes["_ValidationResult"],
	getYoutubeVideoList?:ModelTypes["YoutubeVideoList"],
	listYoutubeVideoList:ModelTypes["YoutubeVideoList"][],
	paginateYoutubeVideoList:ModelTypes["YoutubeVideoListConnection"],
	validateCreateYoutubeVideoList:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideoList:ModelTypes["_ValidationResult"],
	getYoutubeVideoListItem?:ModelTypes["YoutubeVideoListItem"],
	listYoutubeVideoListItem:ModelTypes["YoutubeVideoListItem"][],
	paginateYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemConnection"],
	validateCreateYoutubeVideoListItem:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideoListItem:ModelTypes["_ValidationResult"],
	getImageList?:ModelTypes["ImageList"],
	listImageList:ModelTypes["ImageList"][],
	paginateImageList:ModelTypes["ImageListConnection"],
	validateCreateImageList:ModelTypes["_ValidationResult"],
	validateUpdateImageList:ModelTypes["_ValidationResult"],
	getImageListItem?:ModelTypes["ImageListItem"],
	listImageListItem:ModelTypes["ImageListItem"][],
	paginateImageListItem:ModelTypes["ImageListItemConnection"],
	validateCreateImageListItem:ModelTypes["_ValidationResult"],
	validateUpdateImageListItem:ModelTypes["_ValidationResult"],
	getCitationItem?:ModelTypes["CitationItem"],
	listCitationItem:ModelTypes["CitationItem"][],
	paginateCitationItem:ModelTypes["CitationItemConnection"],
	validateCreateCitationItem:ModelTypes["_ValidationResult"],
	validateUpdateCitationItem:ModelTypes["_ValidationResult"],
	getCitationList?:ModelTypes["CitationList"],
	listCitationList:ModelTypes["CitationList"][],
	paginateCitationList:ModelTypes["CitationListConnection"],
	validateCreateCitationList:ModelTypes["_ValidationResult"],
	validateUpdateCitationList:ModelTypes["_ValidationResult"],
	getContentImageLinkItem?:ModelTypes["ContentImageLinkItem"],
	listContentImageLinkItem:ModelTypes["ContentImageLinkItem"][],
	paginateContentImageLinkItem:ModelTypes["ContentImageLinkItemConnection"],
	validateCreateContentImageLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateContentImageLinkItem:ModelTypes["_ValidationResult"],
	getContentImageLinkList?:ModelTypes["ContentImageLinkList"],
	listContentImageLinkList:ModelTypes["ContentImageLinkList"][],
	paginateContentImageLinkList:ModelTypes["ContentImageLinkListConnection"],
	validateCreateContentImageLinkList:ModelTypes["_ValidationResult"],
	validateUpdateContentImageLinkList:ModelTypes["_ValidationResult"],
	getNews?:ModelTypes["News"],
	listNews:ModelTypes["News"][],
	paginateNews:ModelTypes["NewsConnection"],
	validateCreateNews:ModelTypes["_ValidationResult"],
	validateUpdateNews:ModelTypes["_ValidationResult"],
	getStories?:ModelTypes["Stories"],
	listStories:ModelTypes["Stories"][],
	paginateStories:ModelTypes["StoriesConnection"],
	validateCreateStories:ModelTypes["_ValidationResult"],
	validateUpdateStories:ModelTypes["_ValidationResult"],
	getNewsPage?:ModelTypes["NewsPage"],
	listNewsPage:ModelTypes["NewsPage"][],
	paginateNewsPage:ModelTypes["NewsPageConnection"],
	validateCreateNewsPage:ModelTypes["_ValidationResult"],
	validateUpdateNewsPage:ModelTypes["_ValidationResult"],
	getStoriesPage?:ModelTypes["StoriesPage"],
	listStoriesPage:ModelTypes["StoriesPage"][],
	paginateStoriesPage:ModelTypes["StoriesPageConnection"],
	validateCreateStoriesPage:ModelTypes["_ValidationResult"],
	validateUpdateStoriesPage:ModelTypes["_ValidationResult"],
	getStoriesList?:ModelTypes["StoriesList"],
	listStoriesList:ModelTypes["StoriesList"][],
	paginateStoriesList:ModelTypes["StoriesListConnection"],
	validateCreateStoriesList:ModelTypes["_ValidationResult"],
	validateUpdateStoriesList:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createFallbackSeo:ModelTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo:ModelTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo:ModelTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo:ModelTypes["FallbackSeoUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createProgram:ModelTypes["ProgramCreateResult"],
	deleteProgram:ModelTypes["ProgramDeleteResult"],
	updateProgram:ModelTypes["ProgramUpdateResult"],
	upsertProgram:ModelTypes["ProgramUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createYoutubeVideo:ModelTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo:ModelTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo:ModelTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo:ModelTypes["YoutubeVideoUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createBulletPoint:ModelTypes["BulletPointCreateResult"],
	deleteBulletPoint:ModelTypes["BulletPointDeleteResult"],
	updateBulletPoint:ModelTypes["BulletPointUpdateResult"],
	upsertBulletPoint:ModelTypes["BulletPointUpsertResult"],
	createBulletPointItem:ModelTypes["BulletPointItemCreateResult"],
	deleteBulletPointItem:ModelTypes["BulletPointItemDeleteResult"],
	updateBulletPointItem:ModelTypes["BulletPointItemUpdateResult"],
	upsertBulletPointItem:ModelTypes["BulletPointItemUpsertResult"],
	createFileItem:ModelTypes["FileItemCreateResult"],
	deleteFileItem:ModelTypes["FileItemDeleteResult"],
	updateFileItem:ModelTypes["FileItemUpdateResult"],
	upsertFileItem:ModelTypes["FileItemUpsertResult"],
	createFileList:ModelTypes["FileListCreateResult"],
	deleteFileList:ModelTypes["FileListDeleteResult"],
	updateFileList:ModelTypes["FileListUpdateResult"],
	upsertFileList:ModelTypes["FileListUpsertResult"],
	createFooterLink:ModelTypes["FooterLinkCreateResult"],
	deleteFooterLink:ModelTypes["FooterLinkDeleteResult"],
	updateFooterLink:ModelTypes["FooterLinkUpdateResult"],
	upsertFooterLink:ModelTypes["FooterLinkUpsertResult"],
	createFooterLinkGroups:ModelTypes["FooterLinkGroupsCreateResult"],
	deleteFooterLinkGroups:ModelTypes["FooterLinkGroupsDeleteResult"],
	updateFooterLinkGroups:ModelTypes["FooterLinkGroupsUpdateResult"],
	upsertFooterLinkGroups:ModelTypes["FooterLinkGroupsUpsertResult"],
	createTextItem:ModelTypes["TextItemCreateResult"],
	deleteTextItem:ModelTypes["TextItemDeleteResult"],
	updateTextItem:ModelTypes["TextItemUpdateResult"],
	upsertTextItem:ModelTypes["TextItemUpsertResult"],
	createTextList:ModelTypes["TextListCreateResult"],
	deleteTextList:ModelTypes["TextListDeleteResult"],
	updateTextList:ModelTypes["TextListUpdateResult"],
	upsertTextList:ModelTypes["TextListUpsertResult"],
	createProgramPage:ModelTypes["ProgramPageCreateResult"],
	deleteProgramPage:ModelTypes["ProgramPageDeleteResult"],
	updateProgramPage:ModelTypes["ProgramPageUpdateResult"],
	upsertProgramPage:ModelTypes["ProgramPageUpsertResult"],
	createGenericPage:ModelTypes["GenericPageCreateResult"],
	deleteGenericPage:ModelTypes["GenericPageDeleteResult"],
	updateGenericPage:ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage:ModelTypes["GenericPageUpsertResult"],
	createStaff:ModelTypes["StaffCreateResult"],
	deleteStaff:ModelTypes["StaffDeleteResult"],
	updateStaff:ModelTypes["StaffUpdateResult"],
	upsertStaff:ModelTypes["StaffUpsertResult"],
	createStaffItem:ModelTypes["StaffItemCreateResult"],
	deleteStaffItem:ModelTypes["StaffItemDeleteResult"],
	updateStaffItem:ModelTypes["StaffItemUpdateResult"],
	upsertStaffItem:ModelTypes["StaffItemUpsertResult"],
	createStaffList:ModelTypes["StaffListCreateResult"],
	deleteStaffList:ModelTypes["StaffListDeleteResult"],
	updateStaffList:ModelTypes["StaffListUpdateResult"],
	upsertStaffList:ModelTypes["StaffListUpsertResult"],
	createIcon:ModelTypes["IconCreateResult"],
	deleteIcon:ModelTypes["IconDeleteResult"],
	updateIcon:ModelTypes["IconUpdateResult"],
	upsertIcon:ModelTypes["IconUpsertResult"],
	createPrincipleItem:ModelTypes["PrincipleItemCreateResult"],
	deletePrincipleItem:ModelTypes["PrincipleItemDeleteResult"],
	updatePrincipleItem:ModelTypes["PrincipleItemUpdateResult"],
	upsertPrincipleItem:ModelTypes["PrincipleItemUpsertResult"],
	createPrincipleList:ModelTypes["PrincipleListCreateResult"],
	deletePrincipleList:ModelTypes["PrincipleListDeleteResult"],
	updatePrincipleList:ModelTypes["PrincipleListUpdateResult"],
	upsertPrincipleList:ModelTypes["PrincipleListUpsertResult"],
	createLinkItem:ModelTypes["LinkItemCreateResult"],
	deleteLinkItem:ModelTypes["LinkItemDeleteResult"],
	updateLinkItem:ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem:ModelTypes["LinkItemUpsertResult"],
	createLinkList:ModelTypes["LinkListCreateResult"],
	deleteLinkList:ModelTypes["LinkListDeleteResult"],
	updateLinkList:ModelTypes["LinkListUpdateResult"],
	upsertLinkList:ModelTypes["LinkListUpsertResult"],
	createLinkSubGroup:ModelTypes["LinkSubGroupCreateResult"],
	deleteLinkSubGroup:ModelTypes["LinkSubGroupDeleteResult"],
	updateLinkSubGroup:ModelTypes["LinkSubGroupUpdateResult"],
	upsertLinkSubGroup:ModelTypes["LinkSubGroupUpsertResult"],
	createYoutubeVideoList:ModelTypes["YoutubeVideoListCreateResult"],
	deleteYoutubeVideoList:ModelTypes["YoutubeVideoListDeleteResult"],
	updateYoutubeVideoList:ModelTypes["YoutubeVideoListUpdateResult"],
	upsertYoutubeVideoList:ModelTypes["YoutubeVideoListUpsertResult"],
	createYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemCreateResult"],
	deleteYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemDeleteResult"],
	updateYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemUpdateResult"],
	upsertYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemUpsertResult"],
	createImageList:ModelTypes["ImageListCreateResult"],
	deleteImageList:ModelTypes["ImageListDeleteResult"],
	updateImageList:ModelTypes["ImageListUpdateResult"],
	upsertImageList:ModelTypes["ImageListUpsertResult"],
	createImageListItem:ModelTypes["ImageListItemCreateResult"],
	deleteImageListItem:ModelTypes["ImageListItemDeleteResult"],
	updateImageListItem:ModelTypes["ImageListItemUpdateResult"],
	upsertImageListItem:ModelTypes["ImageListItemUpsertResult"],
	createCitationItem:ModelTypes["CitationItemCreateResult"],
	deleteCitationItem:ModelTypes["CitationItemDeleteResult"],
	updateCitationItem:ModelTypes["CitationItemUpdateResult"],
	upsertCitationItem:ModelTypes["CitationItemUpsertResult"],
	createCitationList:ModelTypes["CitationListCreateResult"],
	deleteCitationList:ModelTypes["CitationListDeleteResult"],
	updateCitationList:ModelTypes["CitationListUpdateResult"],
	upsertCitationList:ModelTypes["CitationListUpsertResult"],
	createContentImageLinkItem:ModelTypes["ContentImageLinkItemCreateResult"],
	deleteContentImageLinkItem:ModelTypes["ContentImageLinkItemDeleteResult"],
	updateContentImageLinkItem:ModelTypes["ContentImageLinkItemUpdateResult"],
	upsertContentImageLinkItem:ModelTypes["ContentImageLinkItemUpsertResult"],
	createContentImageLinkList:ModelTypes["ContentImageLinkListCreateResult"],
	deleteContentImageLinkList:ModelTypes["ContentImageLinkListDeleteResult"],
	updateContentImageLinkList:ModelTypes["ContentImageLinkListUpdateResult"],
	upsertContentImageLinkList:ModelTypes["ContentImageLinkListUpsertResult"],
	createNews:ModelTypes["NewsCreateResult"],
	deleteNews:ModelTypes["NewsDeleteResult"],
	updateNews:ModelTypes["NewsUpdateResult"],
	upsertNews:ModelTypes["NewsUpsertResult"],
	createStories:ModelTypes["StoriesCreateResult"],
	deleteStories:ModelTypes["StoriesDeleteResult"],
	updateStories:ModelTypes["StoriesUpdateResult"],
	upsertStories:ModelTypes["StoriesUpsertResult"],
	createNewsPage:ModelTypes["NewsPageCreateResult"],
	deleteNewsPage:ModelTypes["NewsPageDeleteResult"],
	updateNewsPage:ModelTypes["NewsPageUpdateResult"],
	upsertNewsPage:ModelTypes["NewsPageUpsertResult"],
	createStoriesPage:ModelTypes["StoriesPageCreateResult"],
	deleteStoriesPage:ModelTypes["StoriesPageDeleteResult"],
	updateStoriesPage:ModelTypes["StoriesPageUpdateResult"],
	upsertStoriesPage:ModelTypes["StoriesPageUpsertResult"],
	createStoriesList:ModelTypes["StoriesListCreateResult"],
	deleteStoriesList:ModelTypes["StoriesListDeleteResult"],
	updateStoriesList:ModelTypes["StoriesListUpdateResult"],
	upsertStoriesList:ModelTypes["StoriesListUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["ContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["FallbackSeoCreateResult"] | ModelTypes["FallbackSeoDeleteResult"] | ModelTypes["FallbackSeoUpdateResult"] | ModelTypes["FallbackSeoUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["HomePageCreateResult"] | ModelTypes["HomePageDeleteResult"] | ModelTypes["HomePageUpdateResult"] | ModelTypes["HomePageUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["ProgramCreateResult"] | ModelTypes["ProgramDeleteResult"] | ModelTypes["ProgramUpdateResult"] | ModelTypes["ProgramUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"] | ModelTypes["YoutubeVideoCreateResult"] | ModelTypes["YoutubeVideoDeleteResult"] | ModelTypes["YoutubeVideoUpdateResult"] | ModelTypes["YoutubeVideoUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["BulletPointCreateResult"] | ModelTypes["BulletPointDeleteResult"] | ModelTypes["BulletPointUpdateResult"] | ModelTypes["BulletPointUpsertResult"] | ModelTypes["BulletPointItemCreateResult"] | ModelTypes["BulletPointItemDeleteResult"] | ModelTypes["BulletPointItemUpdateResult"] | ModelTypes["BulletPointItemUpsertResult"] | ModelTypes["FileItemCreateResult"] | ModelTypes["FileItemDeleteResult"] | ModelTypes["FileItemUpdateResult"] | ModelTypes["FileItemUpsertResult"] | ModelTypes["FileListCreateResult"] | ModelTypes["FileListDeleteResult"] | ModelTypes["FileListUpdateResult"] | ModelTypes["FileListUpsertResult"] | ModelTypes["FooterLinkCreateResult"] | ModelTypes["FooterLinkDeleteResult"] | ModelTypes["FooterLinkUpdateResult"] | ModelTypes["FooterLinkUpsertResult"] | ModelTypes["FooterLinkGroupsCreateResult"] | ModelTypes["FooterLinkGroupsDeleteResult"] | ModelTypes["FooterLinkGroupsUpdateResult"] | ModelTypes["FooterLinkGroupsUpsertResult"] | ModelTypes["TextItemCreateResult"] | ModelTypes["TextItemDeleteResult"] | ModelTypes["TextItemUpdateResult"] | ModelTypes["TextItemUpsertResult"] | ModelTypes["TextListCreateResult"] | ModelTypes["TextListDeleteResult"] | ModelTypes["TextListUpdateResult"] | ModelTypes["TextListUpsertResult"] | ModelTypes["ProgramPageCreateResult"] | ModelTypes["ProgramPageDeleteResult"] | ModelTypes["ProgramPageUpdateResult"] | ModelTypes["ProgramPageUpsertResult"] | ModelTypes["GenericPageCreateResult"] | ModelTypes["GenericPageDeleteResult"] | ModelTypes["GenericPageUpdateResult"] | ModelTypes["GenericPageUpsertResult"] | ModelTypes["StaffCreateResult"] | ModelTypes["StaffDeleteResult"] | ModelTypes["StaffUpdateResult"] | ModelTypes["StaffUpsertResult"] | ModelTypes["StaffItemCreateResult"] | ModelTypes["StaffItemDeleteResult"] | ModelTypes["StaffItemUpdateResult"] | ModelTypes["StaffItemUpsertResult"] | ModelTypes["StaffListCreateResult"] | ModelTypes["StaffListDeleteResult"] | ModelTypes["StaffListUpdateResult"] | ModelTypes["StaffListUpsertResult"] | ModelTypes["IconCreateResult"] | ModelTypes["IconDeleteResult"] | ModelTypes["IconUpdateResult"] | ModelTypes["IconUpsertResult"] | ModelTypes["PrincipleItemCreateResult"] | ModelTypes["PrincipleItemDeleteResult"] | ModelTypes["PrincipleItemUpdateResult"] | ModelTypes["PrincipleItemUpsertResult"] | ModelTypes["PrincipleListCreateResult"] | ModelTypes["PrincipleListDeleteResult"] | ModelTypes["PrincipleListUpdateResult"] | ModelTypes["PrincipleListUpsertResult"] | ModelTypes["LinkItemCreateResult"] | ModelTypes["LinkItemDeleteResult"] | ModelTypes["LinkItemUpdateResult"] | ModelTypes["LinkItemUpsertResult"] | ModelTypes["LinkListCreateResult"] | ModelTypes["LinkListDeleteResult"] | ModelTypes["LinkListUpdateResult"] | ModelTypes["LinkListUpsertResult"] | ModelTypes["LinkSubGroupCreateResult"] | ModelTypes["LinkSubGroupDeleteResult"] | ModelTypes["LinkSubGroupUpdateResult"] | ModelTypes["LinkSubGroupUpsertResult"] | ModelTypes["YoutubeVideoListCreateResult"] | ModelTypes["YoutubeVideoListDeleteResult"] | ModelTypes["YoutubeVideoListUpdateResult"] | ModelTypes["YoutubeVideoListUpsertResult"] | ModelTypes["YoutubeVideoListItemCreateResult"] | ModelTypes["YoutubeVideoListItemDeleteResult"] | ModelTypes["YoutubeVideoListItemUpdateResult"] | ModelTypes["YoutubeVideoListItemUpsertResult"] | ModelTypes["ImageListCreateResult"] | ModelTypes["ImageListDeleteResult"] | ModelTypes["ImageListUpdateResult"] | ModelTypes["ImageListUpsertResult"] | ModelTypes["ImageListItemCreateResult"] | ModelTypes["ImageListItemDeleteResult"] | ModelTypes["ImageListItemUpdateResult"] | ModelTypes["ImageListItemUpsertResult"] | ModelTypes["CitationItemCreateResult"] | ModelTypes["CitationItemDeleteResult"] | ModelTypes["CitationItemUpdateResult"] | ModelTypes["CitationItemUpsertResult"] | ModelTypes["CitationListCreateResult"] | ModelTypes["CitationListDeleteResult"] | ModelTypes["CitationListUpdateResult"] | ModelTypes["CitationListUpsertResult"] | ModelTypes["ContentImageLinkItemCreateResult"] | ModelTypes["ContentImageLinkItemDeleteResult"] | ModelTypes["ContentImageLinkItemUpdateResult"] | ModelTypes["ContentImageLinkItemUpsertResult"] | ModelTypes["ContentImageLinkListCreateResult"] | ModelTypes["ContentImageLinkListDeleteResult"] | ModelTypes["ContentImageLinkListUpdateResult"] | ModelTypes["ContentImageLinkListUpsertResult"] | ModelTypes["NewsCreateResult"] | ModelTypes["NewsDeleteResult"] | ModelTypes["NewsUpdateResult"] | ModelTypes["NewsUpsertResult"] | ModelTypes["StoriesCreateResult"] | ModelTypes["StoriesDeleteResult"] | ModelTypes["StoriesUpdateResult"] | ModelTypes["StoriesUpsertResult"] | ModelTypes["NewsPageCreateResult"] | ModelTypes["NewsPageDeleteResult"] | ModelTypes["NewsPageUpdateResult"] | ModelTypes["NewsPageUpsertResult"] | ModelTypes["StoriesPageCreateResult"] | ModelTypes["StoriesPageDeleteResult"] | ModelTypes["StoriesPageUpdateResult"] | ModelTypes["StoriesPageUpsertResult"] | ModelTypes["StoriesListCreateResult"] | ModelTypes["StoriesListDeleteResult"] | ModelTypes["StoriesListUpdateResult"] | ModelTypes["StoriesListUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["ContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"]
};
	["ContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"]
};
	["FallbackSeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"]
};
	["FooterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"]
};
	["HeaderUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProgramCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Program"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProgramDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Program"]
};
	["ProgramUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Program"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProgramUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Program"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"]
};
	["YoutubeVideoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["BulletPointCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPoint"],
	validation:ModelTypes["_ValidationResult"]
};
	["BulletPointDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPoint"]
};
	["BulletPointUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPoint"],
	validation:ModelTypes["_ValidationResult"]
};
	["BulletPointUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPoint"],
	validation:ModelTypes["_ValidationResult"]
};
	["BulletPointItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPointItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BulletPointItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPointItem"]
};
	["BulletPointItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPointItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BulletPointItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BulletPointItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileItem"]
};
	["FileItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileList"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileList"]
};
	["FileListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileList"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileList"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"]
};
	["FooterLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkGroupsCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinkGroups"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkGroupsDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinkGroups"]
};
	["FooterLinkGroupsUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinkGroups"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkGroupsUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinkGroups"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextItem"]
};
	["TextItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextList"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextList"]
};
	["TextListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextList"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProgramPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProgramPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProgramPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProgramPage"]
};
	["ProgramPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProgramPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProgramPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProgramPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"]
};
	["GenericPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Staff"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Staff"]
};
	["StaffUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Staff"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Staff"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffItem"]
};
	["StaffItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffList"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffList"]
};
	["StaffListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffList"],
	validation:ModelTypes["_ValidationResult"]
};
	["StaffListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StaffList"],
	validation:ModelTypes["_ValidationResult"]
};
	["IconCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Icon"],
	validation:ModelTypes["_ValidationResult"]
};
	["IconDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Icon"]
};
	["IconUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Icon"],
	validation:ModelTypes["_ValidationResult"]
};
	["IconUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Icon"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrincipleItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrincipleItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleItem"]
};
	["PrincipleItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrincipleItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrincipleListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleList"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrincipleListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleList"]
};
	["PrincipleListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleList"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrincipleListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrincipleList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"]
};
	["LinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"]
};
	["LinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkSubGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSubGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkSubGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSubGroup"]
};
	["LinkSubGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSubGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkSubGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSubGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoList"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoList"]
};
	["YoutubeVideoListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoList"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoList"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoListItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoListItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoListItem"]
};
	["YoutubeVideoListItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoListItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideoListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"]
};
	["ImageListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"]
};
	["ImageListItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["CitationItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["CitationItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationItem"]
};
	["CitationItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["CitationItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["CitationListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationList"],
	validation:ModelTypes["_ValidationResult"]
};
	["CitationListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationList"]
};
	["CitationListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationList"],
	validation:ModelTypes["_ValidationResult"]
};
	["CitationListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CitationList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentImageLinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentImageLinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkItem"]
};
	["ContentImageLinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentImageLinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentImageLinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentImageLinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkList"]
};
	["ContentImageLinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentImageLinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentImageLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["News"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["News"]
};
	["NewsUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["News"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["News"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Stories"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Stories"]
};
	["StoriesUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Stories"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Stories"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsPage"]
};
	["NewsPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesPage"]
};
	["StoriesPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesList"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesList"]
};
	["StoriesListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesList"],
	validation:ModelTypes["_ValidationResult"]
};
	["StoriesListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StoriesList"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createFallbackSeo:ModelTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo:ModelTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo:ModelTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo:ModelTypes["FallbackSeoUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createProgram:ModelTypes["ProgramCreateResult"],
	deleteProgram:ModelTypes["ProgramDeleteResult"],
	updateProgram:ModelTypes["ProgramUpdateResult"],
	upsertProgram:ModelTypes["ProgramUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createYoutubeVideo:ModelTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo:ModelTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo:ModelTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo:ModelTypes["YoutubeVideoUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createBulletPoint:ModelTypes["BulletPointCreateResult"],
	deleteBulletPoint:ModelTypes["BulletPointDeleteResult"],
	updateBulletPoint:ModelTypes["BulletPointUpdateResult"],
	upsertBulletPoint:ModelTypes["BulletPointUpsertResult"],
	createBulletPointItem:ModelTypes["BulletPointItemCreateResult"],
	deleteBulletPointItem:ModelTypes["BulletPointItemDeleteResult"],
	updateBulletPointItem:ModelTypes["BulletPointItemUpdateResult"],
	upsertBulletPointItem:ModelTypes["BulletPointItemUpsertResult"],
	createFileItem:ModelTypes["FileItemCreateResult"],
	deleteFileItem:ModelTypes["FileItemDeleteResult"],
	updateFileItem:ModelTypes["FileItemUpdateResult"],
	upsertFileItem:ModelTypes["FileItemUpsertResult"],
	createFileList:ModelTypes["FileListCreateResult"],
	deleteFileList:ModelTypes["FileListDeleteResult"],
	updateFileList:ModelTypes["FileListUpdateResult"],
	upsertFileList:ModelTypes["FileListUpsertResult"],
	createFooterLink:ModelTypes["FooterLinkCreateResult"],
	deleteFooterLink:ModelTypes["FooterLinkDeleteResult"],
	updateFooterLink:ModelTypes["FooterLinkUpdateResult"],
	upsertFooterLink:ModelTypes["FooterLinkUpsertResult"],
	createFooterLinkGroups:ModelTypes["FooterLinkGroupsCreateResult"],
	deleteFooterLinkGroups:ModelTypes["FooterLinkGroupsDeleteResult"],
	updateFooterLinkGroups:ModelTypes["FooterLinkGroupsUpdateResult"],
	upsertFooterLinkGroups:ModelTypes["FooterLinkGroupsUpsertResult"],
	createTextItem:ModelTypes["TextItemCreateResult"],
	deleteTextItem:ModelTypes["TextItemDeleteResult"],
	updateTextItem:ModelTypes["TextItemUpdateResult"],
	upsertTextItem:ModelTypes["TextItemUpsertResult"],
	createTextList:ModelTypes["TextListCreateResult"],
	deleteTextList:ModelTypes["TextListDeleteResult"],
	updateTextList:ModelTypes["TextListUpdateResult"],
	upsertTextList:ModelTypes["TextListUpsertResult"],
	createProgramPage:ModelTypes["ProgramPageCreateResult"],
	deleteProgramPage:ModelTypes["ProgramPageDeleteResult"],
	updateProgramPage:ModelTypes["ProgramPageUpdateResult"],
	upsertProgramPage:ModelTypes["ProgramPageUpsertResult"],
	createGenericPage:ModelTypes["GenericPageCreateResult"],
	deleteGenericPage:ModelTypes["GenericPageDeleteResult"],
	updateGenericPage:ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage:ModelTypes["GenericPageUpsertResult"],
	createStaff:ModelTypes["StaffCreateResult"],
	deleteStaff:ModelTypes["StaffDeleteResult"],
	updateStaff:ModelTypes["StaffUpdateResult"],
	upsertStaff:ModelTypes["StaffUpsertResult"],
	createStaffItem:ModelTypes["StaffItemCreateResult"],
	deleteStaffItem:ModelTypes["StaffItemDeleteResult"],
	updateStaffItem:ModelTypes["StaffItemUpdateResult"],
	upsertStaffItem:ModelTypes["StaffItemUpsertResult"],
	createStaffList:ModelTypes["StaffListCreateResult"],
	deleteStaffList:ModelTypes["StaffListDeleteResult"],
	updateStaffList:ModelTypes["StaffListUpdateResult"],
	upsertStaffList:ModelTypes["StaffListUpsertResult"],
	createIcon:ModelTypes["IconCreateResult"],
	deleteIcon:ModelTypes["IconDeleteResult"],
	updateIcon:ModelTypes["IconUpdateResult"],
	upsertIcon:ModelTypes["IconUpsertResult"],
	createPrincipleItem:ModelTypes["PrincipleItemCreateResult"],
	deletePrincipleItem:ModelTypes["PrincipleItemDeleteResult"],
	updatePrincipleItem:ModelTypes["PrincipleItemUpdateResult"],
	upsertPrincipleItem:ModelTypes["PrincipleItemUpsertResult"],
	createPrincipleList:ModelTypes["PrincipleListCreateResult"],
	deletePrincipleList:ModelTypes["PrincipleListDeleteResult"],
	updatePrincipleList:ModelTypes["PrincipleListUpdateResult"],
	upsertPrincipleList:ModelTypes["PrincipleListUpsertResult"],
	createLinkItem:ModelTypes["LinkItemCreateResult"],
	deleteLinkItem:ModelTypes["LinkItemDeleteResult"],
	updateLinkItem:ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem:ModelTypes["LinkItemUpsertResult"],
	createLinkList:ModelTypes["LinkListCreateResult"],
	deleteLinkList:ModelTypes["LinkListDeleteResult"],
	updateLinkList:ModelTypes["LinkListUpdateResult"],
	upsertLinkList:ModelTypes["LinkListUpsertResult"],
	createLinkSubGroup:ModelTypes["LinkSubGroupCreateResult"],
	deleteLinkSubGroup:ModelTypes["LinkSubGroupDeleteResult"],
	updateLinkSubGroup:ModelTypes["LinkSubGroupUpdateResult"],
	upsertLinkSubGroup:ModelTypes["LinkSubGroupUpsertResult"],
	createYoutubeVideoList:ModelTypes["YoutubeVideoListCreateResult"],
	deleteYoutubeVideoList:ModelTypes["YoutubeVideoListDeleteResult"],
	updateYoutubeVideoList:ModelTypes["YoutubeVideoListUpdateResult"],
	upsertYoutubeVideoList:ModelTypes["YoutubeVideoListUpsertResult"],
	createYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemCreateResult"],
	deleteYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemDeleteResult"],
	updateYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemUpdateResult"],
	upsertYoutubeVideoListItem:ModelTypes["YoutubeVideoListItemUpsertResult"],
	createImageList:ModelTypes["ImageListCreateResult"],
	deleteImageList:ModelTypes["ImageListDeleteResult"],
	updateImageList:ModelTypes["ImageListUpdateResult"],
	upsertImageList:ModelTypes["ImageListUpsertResult"],
	createImageListItem:ModelTypes["ImageListItemCreateResult"],
	deleteImageListItem:ModelTypes["ImageListItemDeleteResult"],
	updateImageListItem:ModelTypes["ImageListItemUpdateResult"],
	upsertImageListItem:ModelTypes["ImageListItemUpsertResult"],
	createCitationItem:ModelTypes["CitationItemCreateResult"],
	deleteCitationItem:ModelTypes["CitationItemDeleteResult"],
	updateCitationItem:ModelTypes["CitationItemUpdateResult"],
	upsertCitationItem:ModelTypes["CitationItemUpsertResult"],
	createCitationList:ModelTypes["CitationListCreateResult"],
	deleteCitationList:ModelTypes["CitationListDeleteResult"],
	updateCitationList:ModelTypes["CitationListUpdateResult"],
	upsertCitationList:ModelTypes["CitationListUpsertResult"],
	createContentImageLinkItem:ModelTypes["ContentImageLinkItemCreateResult"],
	deleteContentImageLinkItem:ModelTypes["ContentImageLinkItemDeleteResult"],
	updateContentImageLinkItem:ModelTypes["ContentImageLinkItemUpdateResult"],
	upsertContentImageLinkItem:ModelTypes["ContentImageLinkItemUpsertResult"],
	createContentImageLinkList:ModelTypes["ContentImageLinkListCreateResult"],
	deleteContentImageLinkList:ModelTypes["ContentImageLinkListDeleteResult"],
	updateContentImageLinkList:ModelTypes["ContentImageLinkListUpdateResult"],
	upsertContentImageLinkList:ModelTypes["ContentImageLinkListUpsertResult"],
	createNews:ModelTypes["NewsCreateResult"],
	deleteNews:ModelTypes["NewsDeleteResult"],
	updateNews:ModelTypes["NewsUpdateResult"],
	upsertNews:ModelTypes["NewsUpsertResult"],
	createStories:ModelTypes["StoriesCreateResult"],
	deleteStories:ModelTypes["StoriesDeleteResult"],
	updateStories:ModelTypes["StoriesUpdateResult"],
	upsertStories:ModelTypes["StoriesUpsertResult"],
	createNewsPage:ModelTypes["NewsPageCreateResult"],
	deleteNewsPage:ModelTypes["NewsPageDeleteResult"],
	updateNewsPage:ModelTypes["NewsPageUpdateResult"],
	upsertNewsPage:ModelTypes["NewsPageUpsertResult"],
	createStoriesPage:ModelTypes["StoriesPageCreateResult"],
	deleteStoriesPage:ModelTypes["StoriesPageDeleteResult"],
	updateStoriesPage:ModelTypes["StoriesPageUpdateResult"],
	upsertStoriesPage:ModelTypes["StoriesPageUpsertResult"],
	createStoriesList:ModelTypes["StoriesListCreateResult"],
	deleteStoriesList:ModelTypes["StoriesListDeleteResult"],
	updateStoriesList:ModelTypes["StoriesListUpdateResult"],
	upsertStoriesList:ModelTypes["StoriesListUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3Acl"]: GraphQLTypes["S3Acl"];
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getFallbackSeo?: GraphQLTypes["FallbackSeo"],
	listFallbackSeo: Array<GraphQLTypes["FallbackSeo"]>,
	paginateFallbackSeo: GraphQLTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateFallbackSeo: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getProgram?: GraphQLTypes["Program"],
	listProgram: Array<GraphQLTypes["Program"]>,
	paginateProgram: GraphQLTypes["ProgramConnection"],
	validateCreateProgram: GraphQLTypes["_ValidationResult"],
	validateUpdateProgram: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getYoutubeVideo?: GraphQLTypes["YoutubeVideo"],
	listYoutubeVideo: Array<GraphQLTypes["YoutubeVideo"]>,
	paginateYoutubeVideo: GraphQLTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getBulletPoint?: GraphQLTypes["BulletPoint"],
	listBulletPoint: Array<GraphQLTypes["BulletPoint"]>,
	paginateBulletPoint: GraphQLTypes["BulletPointConnection"],
	validateCreateBulletPoint: GraphQLTypes["_ValidationResult"],
	validateUpdateBulletPoint: GraphQLTypes["_ValidationResult"],
	getBulletPointItem?: GraphQLTypes["BulletPointItem"],
	listBulletPointItem: Array<GraphQLTypes["BulletPointItem"]>,
	paginateBulletPointItem: GraphQLTypes["BulletPointItemConnection"],
	validateCreateBulletPointItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBulletPointItem: GraphQLTypes["_ValidationResult"],
	getFileItem?: GraphQLTypes["FileItem"],
	listFileItem: Array<GraphQLTypes["FileItem"]>,
	paginateFileItem: GraphQLTypes["FileItemConnection"],
	validateCreateFileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFileItem: GraphQLTypes["_ValidationResult"],
	getFileList?: GraphQLTypes["FileList"],
	listFileList: Array<GraphQLTypes["FileList"]>,
	paginateFileList: GraphQLTypes["FileListConnection"],
	validateCreateFileList: GraphQLTypes["_ValidationResult"],
	validateUpdateFileList: GraphQLTypes["_ValidationResult"],
	getFooterLink?: GraphQLTypes["FooterLink"],
	listFooterLink: Array<GraphQLTypes["FooterLink"]>,
	paginateFooterLink: GraphQLTypes["FooterLinkConnection"],
	validateCreateFooterLink: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLink: GraphQLTypes["_ValidationResult"],
	getFooterLinkGroups?: GraphQLTypes["FooterLinkGroups"],
	listFooterLinkGroups: Array<GraphQLTypes["FooterLinkGroups"]>,
	paginateFooterLinkGroups: GraphQLTypes["FooterLinkGroupsConnection"],
	validateCreateFooterLinkGroups: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLinkGroups: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"],
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"],
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getProgramPage?: GraphQLTypes["ProgramPage"],
	listProgramPage: Array<GraphQLTypes["ProgramPage"]>,
	paginateProgramPage: GraphQLTypes["ProgramPageConnection"],
	validateCreateProgramPage: GraphQLTypes["_ValidationResult"],
	validateUpdateProgramPage: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"],
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getStaff?: GraphQLTypes["Staff"],
	listStaff: Array<GraphQLTypes["Staff"]>,
	paginateStaff: GraphQLTypes["StaffConnection"],
	validateCreateStaff: GraphQLTypes["_ValidationResult"],
	validateUpdateStaff: GraphQLTypes["_ValidationResult"],
	getStaffItem?: GraphQLTypes["StaffItem"],
	listStaffItem: Array<GraphQLTypes["StaffItem"]>,
	paginateStaffItem: GraphQLTypes["StaffItemConnection"],
	validateCreateStaffItem: GraphQLTypes["_ValidationResult"],
	validateUpdateStaffItem: GraphQLTypes["_ValidationResult"],
	getStaffList?: GraphQLTypes["StaffList"],
	listStaffList: Array<GraphQLTypes["StaffList"]>,
	paginateStaffList: GraphQLTypes["StaffListConnection"],
	validateCreateStaffList: GraphQLTypes["_ValidationResult"],
	validateUpdateStaffList: GraphQLTypes["_ValidationResult"],
	getIcon?: GraphQLTypes["Icon"],
	listIcon: Array<GraphQLTypes["Icon"]>,
	paginateIcon: GraphQLTypes["IconConnection"],
	validateCreateIcon: GraphQLTypes["_ValidationResult"],
	validateUpdateIcon: GraphQLTypes["_ValidationResult"],
	getPrincipleItem?: GraphQLTypes["PrincipleItem"],
	listPrincipleItem: Array<GraphQLTypes["PrincipleItem"]>,
	paginatePrincipleItem: GraphQLTypes["PrincipleItemConnection"],
	validateCreatePrincipleItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePrincipleItem: GraphQLTypes["_ValidationResult"],
	getPrincipleList?: GraphQLTypes["PrincipleList"],
	listPrincipleList: Array<GraphQLTypes["PrincipleList"]>,
	paginatePrincipleList: GraphQLTypes["PrincipleListConnection"],
	validateCreatePrincipleList: GraphQLTypes["_ValidationResult"],
	validateUpdatePrincipleList: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"],
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"],
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkSubGroup?: GraphQLTypes["LinkSubGroup"],
	listLinkSubGroup: Array<GraphQLTypes["LinkSubGroup"]>,
	paginateLinkSubGroup: GraphQLTypes["LinkSubGroupConnection"],
	validateCreateLinkSubGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkSubGroup: GraphQLTypes["_ValidationResult"],
	getYoutubeVideoList?: GraphQLTypes["YoutubeVideoList"],
	listYoutubeVideoList: Array<GraphQLTypes["YoutubeVideoList"]>,
	paginateYoutubeVideoList: GraphQLTypes["YoutubeVideoListConnection"],
	validateCreateYoutubeVideoList: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideoList: GraphQLTypes["_ValidationResult"],
	getYoutubeVideoListItem?: GraphQLTypes["YoutubeVideoListItem"],
	listYoutubeVideoListItem: Array<GraphQLTypes["YoutubeVideoListItem"]>,
	paginateYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemConnection"],
	validateCreateYoutubeVideoListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideoListItem: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"],
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"],
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getCitationItem?: GraphQLTypes["CitationItem"],
	listCitationItem: Array<GraphQLTypes["CitationItem"]>,
	paginateCitationItem: GraphQLTypes["CitationItemConnection"],
	validateCreateCitationItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCitationItem: GraphQLTypes["_ValidationResult"],
	getCitationList?: GraphQLTypes["CitationList"],
	listCitationList: Array<GraphQLTypes["CitationList"]>,
	paginateCitationList: GraphQLTypes["CitationListConnection"],
	validateCreateCitationList: GraphQLTypes["_ValidationResult"],
	validateUpdateCitationList: GraphQLTypes["_ValidationResult"],
	getContentImageLinkItem?: GraphQLTypes["ContentImageLinkItem"],
	listContentImageLinkItem: Array<GraphQLTypes["ContentImageLinkItem"]>,
	paginateContentImageLinkItem: GraphQLTypes["ContentImageLinkItemConnection"],
	validateCreateContentImageLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateContentImageLinkItem: GraphQLTypes["_ValidationResult"],
	getContentImageLinkList?: GraphQLTypes["ContentImageLinkList"],
	listContentImageLinkList: Array<GraphQLTypes["ContentImageLinkList"]>,
	paginateContentImageLinkList: GraphQLTypes["ContentImageLinkListConnection"],
	validateCreateContentImageLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateContentImageLinkList: GraphQLTypes["_ValidationResult"],
	getNews?: GraphQLTypes["News"],
	listNews: Array<GraphQLTypes["News"]>,
	paginateNews: GraphQLTypes["NewsConnection"],
	validateCreateNews: GraphQLTypes["_ValidationResult"],
	validateUpdateNews: GraphQLTypes["_ValidationResult"],
	getStories?: GraphQLTypes["Stories"],
	listStories: Array<GraphQLTypes["Stories"]>,
	paginateStories: GraphQLTypes["StoriesConnection"],
	validateCreateStories: GraphQLTypes["_ValidationResult"],
	validateUpdateStories: GraphQLTypes["_ValidationResult"],
	getNewsPage?: GraphQLTypes["NewsPage"],
	listNewsPage: Array<GraphQLTypes["NewsPage"]>,
	paginateNewsPage: GraphQLTypes["NewsPageConnection"],
	validateCreateNewsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsPage: GraphQLTypes["_ValidationResult"],
	getStoriesPage?: GraphQLTypes["StoriesPage"],
	listStoriesPage: Array<GraphQLTypes["StoriesPage"]>,
	paginateStoriesPage: GraphQLTypes["StoriesPageConnection"],
	validateCreateStoriesPage: GraphQLTypes["_ValidationResult"],
	validateUpdateStoriesPage: GraphQLTypes["_ValidationResult"],
	getStoriesList?: GraphQLTypes["StoriesList"],
	listStoriesList: Array<GraphQLTypes["StoriesList"]>,
	paginateStoriesList: GraphQLTypes["StoriesListConnection"],
	validateCreateStoriesList: GraphQLTypes["_ValidationResult"],
	validateUpdateStoriesList: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"],
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:string;
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"],
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByLink?: GraphQLTypes["ContentReference"],
	referencesByFileList?: GraphQLTypes["ContentReference"],
	referencesByTextList?: GraphQLTypes["ContentReference"],
	referencesByStaffList?: GraphQLTypes["ContentReference"],
	referencesByPrincipleList?: GraphQLTypes["ContentReference"],
	referencesByImageLinkList?: GraphQLTypes["ContentReference"],
	referencesByCitationList?: GraphQLTypes["ContentReference"],
	referencesByStoriesList?: GraphQLTypes["ContentReference"],
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	and?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	not?: GraphQLTypes["ContentWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	references?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ContentReferenceTypeCondition"],
	block?: GraphQLTypes["ContentBlockWhere"],
	link?: GraphQLTypes["LinkWhere"],
	image?: GraphQLTypes["ImageWhere"],
	youtubeVideo?: GraphQLTypes["YoutubeVideoWhere"],
	primaryText?: GraphQLTypes["StringCondition"],
	secondaryText?: GraphQLTypes["StringCondition"],
	fileList?: GraphQLTypes["FileListWhere"],
	textList?: GraphQLTypes["TextListWhere"],
	staffList?: GraphQLTypes["StaffListWhere"],
	principleList?: GraphQLTypes["PrincipleListWhere"],
	view?: GraphQLTypes["ViewCondition"],
	aligning?: GraphQLTypes["AligningCondition"],
	numbered?: GraphQLTypes["BooleanCondition"],
	tertiaryText?: GraphQLTypes["StringCondition"],
	imageLinkList?: GraphQLTypes["ContentImageLinkListWhere"],
	citationList?: GraphQLTypes["CitationListWhere"],
	storiesList?: GraphQLTypes["StoriesListWhere"],
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceWhere"]
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["ContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceType"],
	notEq?: GraphQLTypes["ContentReferenceType"],
	in?: Array<GraphQLTypes["ContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]>,
	lt?: GraphQLTypes["ContentReferenceType"],
	lte?: GraphQLTypes["ContentReferenceType"],
	gt?: GraphQLTypes["ContentReferenceType"],
	gte?: GraphQLTypes["ContentReferenceType"]
};
	["ContentReferenceType"]: ContentReferenceType;
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	title?: GraphQLTypes["StringCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	internalLink?: GraphQLTypes["LinkableWhere"],
	isTargetBlank?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	program?: GraphQLTypes["ProgramWhere"],
	homePage?: GraphQLTypes["HomePageWhere"],
	redirect?: GraphQLTypes["RedirectWhere"],
	programPage?: GraphQLTypes["ProgramPageWhere"],
	genericPage?: GraphQLTypes["GenericPageWhere"],
	newsPage?: GraphQLTypes["NewsPageWhere"],
	news?: GraphQLTypes["NewsWhere"],
	story?: GraphQLTypes["StoriesWhere"],
	storiesPage?: GraphQLTypes["StoriesPageWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["ProgramWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	name?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	image?: GraphQLTypes["ImageWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	ilustration?: GraphQLTypes["ImageWhere"],
	bulletPoint?: GraphQLTypes["BulletPointWhere"],
	showDetailLink?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["ProgramWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProgramWhere"] | undefined>,
	not?: GraphQLTypes["ProgramWhere"]
};
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	fileName?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	noIndex?: GraphQLTypes["BooleanCondition"],
	noFollow?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["BulletPointWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["BulletPointItemWhere"],
	and?: Array<GraphQLTypes["BulletPointWhere"] | undefined>,
	or?: Array<GraphQLTypes["BulletPointWhere"] | undefined>,
	not?: GraphQLTypes["BulletPointWhere"]
};
	["BulletPointItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	text?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["BulletPointWhere"],
	and?: Array<GraphQLTypes["BulletPointItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["BulletPointItemWhere"] | undefined>,
	not?: GraphQLTypes["BulletPointItemWhere"]
};
	["HomePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	not?: GraphQLTypes["HomePageWhere"]
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["One"]: One;
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	targetUrl?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	target?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	not?: GraphQLTypes["RedirectWhere"]
};
	["ProgramPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["ProgramPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProgramPageWhere"] | undefined>,
	not?: GraphQLTypes["ProgramPageWhere"]
};
	["GenericPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	darujmeWidget?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["GenericPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["GenericPageWhere"] | undefined>,
	not?: GraphQLTypes["GenericPageWhere"]
};
	["NewsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["NewsPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsPageWhere"] | undefined>,
	not?: GraphQLTypes["NewsPageWhere"]
};
	["NewsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	publishDate?: GraphQLTypes["DateTimeCondition"],
	title?: GraphQLTypes["StringCondition"],
	perex?: GraphQLTypes["StringCondition"],
	coverImage?: GraphQLTypes["ImageWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	isDraft?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["NewsWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsWhere"] | undefined>,
	not?: GraphQLTypes["NewsWhere"]
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]>,
	or?: Array<GraphQLTypes["DateTimeCondition"]>,
	not?: GraphQLTypes["DateTimeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["DateTime"],
	notEq?: GraphQLTypes["DateTime"],
	in?: Array<GraphQLTypes["DateTime"]>,
	notIn?: Array<GraphQLTypes["DateTime"]>,
	lt?: GraphQLTypes["DateTime"],
	lte?: GraphQLTypes["DateTime"],
	gt?: GraphQLTypes["DateTime"],
	gte?: GraphQLTypes["DateTime"]
};
	["DateTime"]:string;
	["StoriesWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	perex?: GraphQLTypes["StringCondition"],
	coverImage?: GraphQLTypes["ImageWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	list?: GraphQLTypes["StoriesListWhere"],
	isDraft?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["StoriesWhere"] | undefined>,
	or?: Array<GraphQLTypes["StoriesWhere"] | undefined>,
	not?: GraphQLTypes["StoriesWhere"]
};
	["StoriesListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["StoriesWhere"],
	and?: Array<GraphQLTypes["StoriesListWhere"] | undefined>,
	or?: Array<GraphQLTypes["StoriesListWhere"] | undefined>,
	not?: GraphQLTypes["StoriesListWhere"]
};
	["StoriesPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["StoriesPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["StoriesPageWhere"] | undefined>,
	not?: GraphQLTypes["StoriesPageWhere"]
};
	["YoutubeVideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	videoId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["YoutubeVideoWhere"] | undefined>,
	or?: Array<GraphQLTypes["YoutubeVideoWhere"] | undefined>,
	not?: GraphQLTypes["YoutubeVideoWhere"]
};
	["FileListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	reference?: GraphQLTypes["ContentReferenceWhere"],
	items?: GraphQLTypes["FileItemWhere"],
	and?: Array<GraphQLTypes["FileListWhere"] | undefined>,
	or?: Array<GraphQLTypes["FileListWhere"] | undefined>,
	not?: GraphQLTypes["FileListWhere"]
};
	["FileItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	name?: GraphQLTypes["StringCondition"],
	url?: GraphQLTypes["StringCondition"],
	fileType?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["FileListWhere"],
	and?: Array<GraphQLTypes["FileItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["FileItemWhere"] | undefined>,
	not?: GraphQLTypes["FileItemWhere"]
};
	["TextListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["TextItemWhere"],
	and?: Array<GraphQLTypes["TextListWhere"] | undefined>,
	or?: Array<GraphQLTypes["TextListWhere"] | undefined>,
	not?: GraphQLTypes["TextListWhere"]
};
	["TextItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["TextListWhere"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["TextItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["TextItemWhere"] | undefined>,
	not?: GraphQLTypes["TextItemWhere"]
};
	["StaffListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	reference?: GraphQLTypes["ContentReferenceWhere"],
	items?: GraphQLTypes["StaffItemWhere"],
	and?: Array<GraphQLTypes["StaffListWhere"] | undefined>,
	or?: Array<GraphQLTypes["StaffListWhere"] | undefined>,
	not?: GraphQLTypes["StaffListWhere"]
};
	["StaffItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["StaffListWhere"],
	staff?: GraphQLTypes["StaffWhere"],
	and?: Array<GraphQLTypes["StaffItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["StaffItemWhere"] | undefined>,
	not?: GraphQLTypes["StaffItemWhere"]
};
	["StaffWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	position?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	order?: GraphQLTypes["IntCondition"],
	info?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["StaffWhere"] | undefined>,
	or?: Array<GraphQLTypes["StaffWhere"] | undefined>,
	not?: GraphQLTypes["StaffWhere"]
};
	["PrincipleListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	reference?: GraphQLTypes["ContentReferenceWhere"],
	items?: GraphQLTypes["PrincipleItemWhere"],
	and?: Array<GraphQLTypes["PrincipleListWhere"] | undefined>,
	or?: Array<GraphQLTypes["PrincipleListWhere"] | undefined>,
	not?: GraphQLTypes["PrincipleListWhere"]
};
	["PrincipleItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	text?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["PrincipleListWhere"],
	icon?: GraphQLTypes["IconWhere"],
	title?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["PrincipleItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["PrincipleItemWhere"] | undefined>,
	not?: GraphQLTypes["PrincipleItemWhere"]
};
	["IconWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["IconWhere"] | undefined>,
	or?: Array<GraphQLTypes["IconWhere"] | undefined>,
	not?: GraphQLTypes["IconWhere"]
};
	["ViewCondition"]: {
		and?: Array<GraphQLTypes["ViewCondition"]>,
	or?: Array<GraphQLTypes["ViewCondition"]>,
	not?: GraphQLTypes["ViewCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["View"],
	notEq?: GraphQLTypes["View"],
	in?: Array<GraphQLTypes["View"]>,
	notIn?: Array<GraphQLTypes["View"]>,
	lt?: GraphQLTypes["View"],
	lte?: GraphQLTypes["View"],
	gt?: GraphQLTypes["View"],
	gte?: GraphQLTypes["View"]
};
	["View"]: View;
	["AligningCondition"]: {
		and?: Array<GraphQLTypes["AligningCondition"]>,
	or?: Array<GraphQLTypes["AligningCondition"]>,
	not?: GraphQLTypes["AligningCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["Aligning"],
	notEq?: GraphQLTypes["Aligning"],
	in?: Array<GraphQLTypes["Aligning"]>,
	notIn?: Array<GraphQLTypes["Aligning"]>,
	lt?: GraphQLTypes["Aligning"],
	lte?: GraphQLTypes["Aligning"],
	gt?: GraphQLTypes["Aligning"],
	gte?: GraphQLTypes["Aligning"]
};
	["Aligning"]: Aligning;
	["ContentImageLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	items?: GraphQLTypes["ContentImageLinkItemWhere"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["ContentImageLinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentImageLinkListWhere"] | undefined>,
	not?: GraphQLTypes["ContentImageLinkListWhere"]
};
	["ContentImageLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ContentImageLinkListWhere"],
	image?: GraphQLTypes["ImageWhere"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["ContentImageLinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentImageLinkItemWhere"] | undefined>,
	not?: GraphQLTypes["ContentImageLinkItemWhere"]
};
	["CitationListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["CitationItemWhere"],
	and?: Array<GraphQLTypes["CitationListWhere"] | undefined>,
	or?: Array<GraphQLTypes["CitationListWhere"] | undefined>,
	not?: GraphQLTypes["CitationListWhere"]
};
	["CitationItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["CitationListWhere"],
	image?: GraphQLTypes["ImageWhere"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["CitationItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["CitationItemWhere"] | undefined>,
	not?: GraphQLTypes["CitationItemWhere"]
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentBlock"],
	link?: GraphQLTypes["Link"],
	image?: GraphQLTypes["Image"],
	youtubeVideo?: GraphQLTypes["YoutubeVideo"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["FileList"],
	textList?: GraphQLTypes["TextList"],
	staffList?: GraphQLTypes["StaffList"],
	principleList?: GraphQLTypes["PrincipleList"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentImageLinkList"],
	citationList?: GraphQLTypes["CitationList"],
	storiesList?: GraphQLTypes["StoriesList"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	block?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	youtubeVideo?: GraphQLTypes["FieldMeta"],
	primaryText?: GraphQLTypes["FieldMeta"],
	secondaryText?: GraphQLTypes["FieldMeta"],
	fileList?: GraphQLTypes["FieldMeta"],
	textList?: GraphQLTypes["FieldMeta"],
	staffList?: GraphQLTypes["FieldMeta"],
	principleList?: GraphQLTypes["FieldMeta"],
	view?: GraphQLTypes["FieldMeta"],
	aligning?: GraphQLTypes["FieldMeta"],
	numbered?: GraphQLTypes["FieldMeta"],
	tertiaryText?: GraphQLTypes["FieldMeta"],
	imageLinkList?: GraphQLTypes["FieldMeta"],
	citationList?: GraphQLTypes["FieldMeta"],
	storiesList?: GraphQLTypes["FieldMeta"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["Linkable"],
	isTargetBlank?: boolean
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	internalLink?: GraphQLTypes["FieldMeta"],
	isTargetBlank?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	program?: GraphQLTypes["Program"],
	homePage?: GraphQLTypes["HomePage"],
	redirect?: GraphQLTypes["Redirect"],
	programPage?: GraphQLTypes["ProgramPage"],
	genericPage?: GraphQLTypes["GenericPage"],
	newsPage?: GraphQLTypes["NewsPage"],
	news?: GraphQLTypes["News"],
	story?: GraphQLTypes["Stories"],
	storiesPage?: GraphQLTypes["StoriesPage"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	program?: GraphQLTypes["FieldMeta"],
	homePage?: GraphQLTypes["FieldMeta"],
	redirect?: GraphQLTypes["FieldMeta"],
	programPage?: GraphQLTypes["FieldMeta"],
	genericPage?: GraphQLTypes["FieldMeta"],
	newsPage?: GraphQLTypes["FieldMeta"],
	news?: GraphQLTypes["FieldMeta"],
	story?: GraphQLTypes["FieldMeta"],
	storiesPage?: GraphQLTypes["FieldMeta"]
};
	["Program"]: {
	__typename: "Program",
	_meta?: GraphQLTypes["ProgramMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	name?: string,
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["Linkable"],
	image?: GraphQLTypes["Image"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"],
	ilustration?: GraphQLTypes["Image"],
	bulletPoint?: GraphQLTypes["BulletPoint"],
	showDetailLink?: boolean
};
	["ProgramMeta"]: {
	__typename: "ProgramMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	ilustration?: GraphQLTypes["FieldMeta"],
	bulletPoint?: GraphQLTypes["FieldMeta"],
	showDetailLink?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	fileName?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"],
	fileName?: GraphQLTypes["FieldMeta"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["Image"],
	noIndex?: boolean,
	noFollow?: boolean
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"],
	noIndex?: GraphQLTypes["FieldMeta"],
	noFollow?: GraphQLTypes["FieldMeta"]
};
	["BulletPoint"]: {
	__typename: "BulletPoint",
	_meta?: GraphQLTypes["BulletPointMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["BulletPointItem"]>,
	paginateItems: GraphQLTypes["BulletPointItemConnection"]
};
	["BulletPointMeta"]: {
	__typename: "BulletPointMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["BulletPointItem"]: {
	__typename: "BulletPointItem",
	_meta?: GraphQLTypes["BulletPointItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string,
	list?: GraphQLTypes["BulletPoint"]
};
	["BulletPointItemMeta"]: {
	__typename: "BulletPointItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"]
};
	["BulletPointItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["BulletPointOrderBy"]
};
	["OrderDirection"]: OrderDirection;
	["BulletPointOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["BulletPointItemConnection"]: {
	__typename: "BulletPointItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BulletPointItemEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["BulletPointItemEdge"]: {
	__typename: "BulletPointItemEdge",
	node: GraphQLTypes["BulletPointItem"]
};
	["HomePage"]: {
	__typename: "HomePage",
	_meta?: GraphQLTypes["HomePageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	leadParagraph?: string,
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	logo?: GraphQLTypes["Image"]
};
	["HomePageMeta"]: {
	__typename: "HomePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"]
};
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"],
	id: GraphQLTypes["UUID"],
	targetUrl?: string,
	link?: GraphQLTypes["Linkable"],
	target?: GraphQLTypes["Linkable"]
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"],
	targetUrl?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["ProgramPage"]: {
	__typename: "ProgramPage",
	_meta?: GraphQLTypes["ProgramPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"]
};
	["ProgramPageMeta"]: {
	__typename: "ProgramPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["GenericPage"]: {
	__typename: "GenericPage",
	_meta?: GraphQLTypes["GenericPageMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	leadParagraph: string,
	image?: GraphQLTypes["Image"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	darujmeWidget?: boolean
};
	["GenericPageMeta"]: {
	__typename: "GenericPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	darujmeWidget?: GraphQLTypes["FieldMeta"]
};
	["NewsPage"]: {
	__typename: "NewsPage",
	_meta?: GraphQLTypes["NewsPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"]
};
	["NewsPageMeta"]: {
	__typename: "NewsPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["News"]: {
	__typename: "News",
	_meta?: GraphQLTypes["NewsMeta"],
	id: GraphQLTypes["UUID"],
	publishDate?: GraphQLTypes["DateTime"],
	title: string,
	perex?: string,
	coverImage?: GraphQLTypes["Image"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"],
	order: number,
	link?: GraphQLTypes["Linkable"],
	isDraft?: boolean
};
	["NewsMeta"]: {
	__typename: "NewsMeta",
	id?: GraphQLTypes["FieldMeta"],
	publishDate?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	perex?: GraphQLTypes["FieldMeta"],
	coverImage?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	isDraft?: GraphQLTypes["FieldMeta"]
};
	["Stories"]: {
	__typename: "Stories",
	_meta?: GraphQLTypes["StoriesMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	perex?: string,
	coverImage?: GraphQLTypes["Image"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"],
	order: number,
	link?: GraphQLTypes["Linkable"],
	list?: GraphQLTypes["StoriesList"],
	isDraft?: boolean
};
	["StoriesMeta"]: {
	__typename: "StoriesMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	perex?: GraphQLTypes["FieldMeta"],
	coverImage?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	isDraft?: GraphQLTypes["FieldMeta"]
};
	["StoriesList"]: {
	__typename: "StoriesList",
	_meta?: GraphQLTypes["StoriesListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["Stories"]>,
	itemsByContent?: GraphQLTypes["Stories"],
	itemsBySeo?: GraphQLTypes["Stories"],
	itemsByLink?: GraphQLTypes["Stories"],
	paginateItems: GraphQLTypes["StoriesConnection"]
};
	["StoriesListMeta"]: {
	__typename: "StoriesListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["StoriesOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	perex?: GraphQLTypes["OrderDirection"],
	coverImage?: GraphQLTypes["ImageOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	list?: GraphQLTypes["StoriesListOrderBy"],
	isDraft?: GraphQLTypes["OrderDirection"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"],
	fileName?: GraphQLTypes["OrderDirection"]
};
	["ContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"],
	noIndex?: GraphQLTypes["OrderDirection"],
	noFollow?: GraphQLTypes["OrderDirection"]
};
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	program?: GraphQLTypes["ProgramOrderBy"],
	homePage?: GraphQLTypes["HomePageOrderBy"],
	redirect?: GraphQLTypes["RedirectOrderBy"],
	programPage?: GraphQLTypes["ProgramPageOrderBy"],
	genericPage?: GraphQLTypes["GenericPageOrderBy"],
	newsPage?: GraphQLTypes["NewsPageOrderBy"],
	news?: GraphQLTypes["NewsOrderBy"],
	story?: GraphQLTypes["StoriesOrderBy"],
	storiesPage?: GraphQLTypes["StoriesPageOrderBy"]
};
	["ProgramOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	ilustration?: GraphQLTypes["ImageOrderBy"],
	bulletPoint?: GraphQLTypes["BulletPointOrderBy"],
	showDetailLink?: GraphQLTypes["OrderDirection"]
};
	["HomePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	logo?: GraphQLTypes["ImageOrderBy"]
};
	["RedirectOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	targetUrl?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	target?: GraphQLTypes["LinkableOrderBy"]
};
	["ProgramPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["GenericPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	darujmeWidget?: GraphQLTypes["OrderDirection"]
};
	["NewsPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["NewsOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	publishDate?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	perex?: GraphQLTypes["OrderDirection"],
	coverImage?: GraphQLTypes["ImageOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	isDraft?: GraphQLTypes["OrderDirection"]
};
	["StoriesPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["StoriesListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["StoriesListItemsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"],
	fileList?: GraphQLTypes["FileListUniqueWhere"],
	textList?: GraphQLTypes["TextListUniqueWhere"],
	staffList?: GraphQLTypes["StaffListUniqueWhere"],
	principleList?: GraphQLTypes["PrincipleListUniqueWhere"],
	imageLinkList?: GraphQLTypes["ContentImageLinkListUniqueWhere"],
	citationList?: GraphQLTypes["CitationListUniqueWhere"],
	storiesList?: GraphQLTypes["StoriesListUniqueWhere"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FileListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["ContentReferenceUniqueWhere"],
	items?: GraphQLTypes["FileItemUniqueWhere"]
};
	["FileItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["TextListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["TextItemUniqueWhere"]
};
	["TextItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["StaffListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["ContentReferenceUniqueWhere"],
	items?: GraphQLTypes["StaffItemUniqueWhere"]
};
	["StaffItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["PrincipleListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["ContentReferenceUniqueWhere"],
	items?: GraphQLTypes["PrincipleItemUniqueWhere"]
};
	["PrincipleItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentImageLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ContentImageLinkItemUniqueWhere"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentImageLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["CitationListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["CitationItemUniqueWhere"]
};
	["CitationItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["StoriesListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["StoriesUniqueWhere"]
};
	["StoriesUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["ProgramUniqueWhere"],
	homePage?: GraphQLTypes["HomePageUniqueWhere"],
	redirect?: GraphQLTypes["RedirectUniqueWhere"],
	programPage?: GraphQLTypes["ProgramPageUniqueWhere"],
	genericPage?: GraphQLTypes["GenericPageUniqueWhere"],
	newsPage?: GraphQLTypes["NewsPageUniqueWhere"],
	news?: GraphQLTypes["NewsUniqueWhere"],
	story?: GraphQLTypes["StoriesUniqueWhere"],
	storiesPage?: GraphQLTypes["StoriesPageUniqueWhere"]
};
	["ProgramUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	ilustration?: GraphQLTypes["ImageUniqueWhere"],
	bulletPoint?: GraphQLTypes["BulletPointUniqueWhere"]
};
	["BulletPointUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["BulletPointItemUniqueWhere"]
};
	["BulletPointItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["HomePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	logo?: GraphQLTypes["ImageUniqueWhere"]
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["ProgramPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["GenericPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["NewsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["NewsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["StoriesPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["StoriesListItemsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["StoriesListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["StoriesConnection"]: {
	__typename: "StoriesConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoriesEdge"]>
};
	["StoriesEdge"]: {
	__typename: "StoriesEdge",
	node: GraphQLTypes["Stories"]
};
	["StoriesPage"]: {
	__typename: "StoriesPage",
	_meta?: GraphQLTypes["StoriesPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"]
};
	["StoriesPageMeta"]: {
	__typename: "StoriesPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["YoutubeVideo"]: {
	__typename: "YoutubeVideo",
	_meta?: GraphQLTypes["YoutubeVideoMeta"],
	id: GraphQLTypes["UUID"],
	videoId: string
};
	["YoutubeVideoMeta"]: {
	__typename: "YoutubeVideoMeta",
	id?: GraphQLTypes["FieldMeta"],
	videoId?: GraphQLTypes["FieldMeta"]
};
	["FileList"]: {
	__typename: "FileList",
	_meta?: GraphQLTypes["FileListMeta"],
	id: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["ContentReference"],
	items: Array<GraphQLTypes["FileItem"]>,
	paginateItems: GraphQLTypes["FileItemConnection"]
};
	["FileListMeta"]: {
	__typename: "FileListMeta",
	id?: GraphQLTypes["FieldMeta"],
	reference?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["FileItem"]: {
	__typename: "FileItem",
	_meta?: GraphQLTypes["FileItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	url?: string,
	fileType?: string,
	list?: GraphQLTypes["FileList"]
};
	["FileItemMeta"]: {
	__typename: "FileItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	fileType?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"]
};
	["FileItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	fileType?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["FileListOrderBy"]
};
	["FileListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	reference?: GraphQLTypes["ContentReferenceOrderBy"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	block?: GraphQLTypes["ContentBlockOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	youtubeVideo?: GraphQLTypes["YoutubeVideoOrderBy"],
	primaryText?: GraphQLTypes["OrderDirection"],
	secondaryText?: GraphQLTypes["OrderDirection"],
	fileList?: GraphQLTypes["FileListOrderBy"],
	textList?: GraphQLTypes["TextListOrderBy"],
	staffList?: GraphQLTypes["StaffListOrderBy"],
	principleList?: GraphQLTypes["PrincipleListOrderBy"],
	view?: GraphQLTypes["OrderDirection"],
	aligning?: GraphQLTypes["OrderDirection"],
	numbered?: GraphQLTypes["OrderDirection"],
	tertiaryText?: GraphQLTypes["OrderDirection"],
	imageLinkList?: GraphQLTypes["ContentImageLinkListOrderBy"],
	citationList?: GraphQLTypes["CitationListOrderBy"],
	storiesList?: GraphQLTypes["StoriesListOrderBy"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	internalLink?: GraphQLTypes["LinkableOrderBy"],
	isTargetBlank?: GraphQLTypes["OrderDirection"]
};
	["YoutubeVideoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	videoId?: GraphQLTypes["OrderDirection"]
};
	["TextListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["StaffListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	reference?: GraphQLTypes["ContentReferenceOrderBy"]
};
	["PrincipleListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	reference?: GraphQLTypes["ContentReferenceOrderBy"]
};
	["ContentImageLinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["CitationListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["FileItemConnection"]: {
	__typename: "FileItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileItemEdge"]>
};
	["FileItemEdge"]: {
	__typename: "FileItemEdge",
	node: GraphQLTypes["FileItem"]
};
	["TextList"]: {
	__typename: "TextList",
	_meta?: GraphQLTypes["TextListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["TextItem"]>,
	itemsByLink?: GraphQLTypes["TextItem"],
	paginateItems: GraphQLTypes["TextItemConnection"]
};
	["TextListMeta"]: {
	__typename: "TextListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["TextItem"]: {
	__typename: "TextItem",
	_meta?: GraphQLTypes["TextItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	text?: string,
	list?: GraphQLTypes["TextList"],
	link?: GraphQLTypes["Link"]
};
	["TextItemMeta"]: {
	__typename: "TextItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["TextItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["TextListOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["TextListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["TextItemConnection"]: {
	__typename: "TextItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextItemEdge"]>
};
	["TextItemEdge"]: {
	__typename: "TextItemEdge",
	node: GraphQLTypes["TextItem"]
};
	["StaffList"]: {
	__typename: "StaffList",
	_meta?: GraphQLTypes["StaffListMeta"],
	id: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["ContentReference"],
	items: Array<GraphQLTypes["StaffItem"]>,
	paginateItems: GraphQLTypes["StaffItemConnection"]
};
	["StaffListMeta"]: {
	__typename: "StaffListMeta",
	id?: GraphQLTypes["FieldMeta"],
	reference?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["StaffItem"]: {
	__typename: "StaffItem",
	_meta?: GraphQLTypes["StaffItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["StaffList"],
	staff?: GraphQLTypes["Staff"]
};
	["StaffItemMeta"]: {
	__typename: "StaffItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	staff?: GraphQLTypes["FieldMeta"]
};
	["Staff"]: {
	__typename: "Staff",
	_meta?: GraphQLTypes["StaffMeta"],
	id: GraphQLTypes["UUID"],
	name?: string,
	position?: string,
	image?: GraphQLTypes["Image"],
	order: number,
	info?: string
};
	["StaffMeta"]: {
	__typename: "StaffMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	position?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	info?: GraphQLTypes["FieldMeta"]
};
	["StaffItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["StaffListOrderBy"],
	staff?: GraphQLTypes["StaffOrderBy"]
};
	["StaffOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	position?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	info?: GraphQLTypes["OrderDirection"]
};
	["StaffItemConnection"]: {
	__typename: "StaffItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StaffItemEdge"]>
};
	["StaffItemEdge"]: {
	__typename: "StaffItemEdge",
	node: GraphQLTypes["StaffItem"]
};
	["PrincipleList"]: {
	__typename: "PrincipleList",
	_meta?: GraphQLTypes["PrincipleListMeta"],
	id: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["ContentReference"],
	items: Array<GraphQLTypes["PrincipleItem"]>,
	paginateItems: GraphQLTypes["PrincipleItemConnection"]
};
	["PrincipleListMeta"]: {
	__typename: "PrincipleListMeta",
	id?: GraphQLTypes["FieldMeta"],
	reference?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["PrincipleItem"]: {
	__typename: "PrincipleItem",
	_meta?: GraphQLTypes["PrincipleItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string,
	list?: GraphQLTypes["PrincipleList"],
	icon?: GraphQLTypes["Icon"],
	title?: string
};
	["PrincipleItemMeta"]: {
	__typename: "PrincipleItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"]
};
	["Icon"]: {
	__typename: "Icon",
	_meta?: GraphQLTypes["IconMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	image?: GraphQLTypes["Image"]
};
	["IconMeta"]: {
	__typename: "IconMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["PrincipleItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["PrincipleListOrderBy"],
	icon?: GraphQLTypes["IconOrderBy"],
	title?: GraphQLTypes["OrderDirection"]
};
	["IconOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["PrincipleItemConnection"]: {
	__typename: "PrincipleItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PrincipleItemEdge"]>
};
	["PrincipleItemEdge"]: {
	__typename: "PrincipleItemEdge",
	node: GraphQLTypes["PrincipleItem"]
};
	["ContentImageLinkList"]: {
	__typename: "ContentImageLinkList",
	_meta?: GraphQLTypes["ContentImageLinkListMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	items: Array<GraphQLTypes["ContentImageLinkItem"]>,
	link?: GraphQLTypes["Link"],
	itemsByImage?: GraphQLTypes["ContentImageLinkItem"],
	itemsByLink?: GraphQLTypes["ContentImageLinkItem"],
	paginateItems: GraphQLTypes["ContentImageLinkItemConnection"]
};
	["ContentImageLinkListMeta"]: {
	__typename: "ContentImageLinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["ContentImageLinkItem"]: {
	__typename: "ContentImageLinkItem",
	_meta?: GraphQLTypes["ContentImageLinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ContentImageLinkList"],
	image?: GraphQLTypes["Image"],
	link?: GraphQLTypes["Link"]
};
	["ContentImageLinkItemMeta"]: {
	__typename: "ContentImageLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["ContentImageLinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ContentImageLinkListOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["ContentImageLinkListItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ContentImageLinkListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentImageLinkItemConnection"]: {
	__typename: "ContentImageLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentImageLinkItemEdge"]>
};
	["ContentImageLinkItemEdge"]: {
	__typename: "ContentImageLinkItemEdge",
	node: GraphQLTypes["ContentImageLinkItem"]
};
	["CitationList"]: {
	__typename: "CitationList",
	_meta?: GraphQLTypes["CitationListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["CitationItem"]>,
	paginateItems: GraphQLTypes["CitationItemConnection"]
};
	["CitationListMeta"]: {
	__typename: "CitationListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["CitationItem"]: {
	__typename: "CitationItem",
	_meta?: GraphQLTypes["CitationItemMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	list?: GraphQLTypes["CitationList"],
	image?: GraphQLTypes["Image"],
	order?: number
};
	["CitationItemMeta"]: {
	__typename: "CitationItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["CitationItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["CitationListOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	order?: GraphQLTypes["OrderDirection"]
};
	["CitationItemConnection"]: {
	__typename: "CitationItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CitationItemEdge"]>
};
	["CitationItemEdge"]: {
	__typename: "CitationItemEdge",
	node: GraphQLTypes["CitationItem"]
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentBlockReferencesByFileListUniqueWhere"]: {
		fileList?: GraphQLTypes["FileListUniqueWhere"]
};
	["ContentBlockReferencesByTextListUniqueWhere"]: {
		textList?: GraphQLTypes["TextListUniqueWhere"]
};
	["ContentBlockReferencesByStaffListUniqueWhere"]: {
		staffList?: GraphQLTypes["StaffListUniqueWhere"]
};
	["ContentBlockReferencesByPrincipleListUniqueWhere"]: {
		principleList?: GraphQLTypes["PrincipleListUniqueWhere"]
};
	["ContentBlockReferencesByImageLinkListUniqueWhere"]: {
		imageLinkList?: GraphQLTypes["ContentImageLinkListUniqueWhere"]
};
	["ContentBlockReferencesByCitationListUniqueWhere"]: {
		citationList?: GraphQLTypes["CitationListUniqueWhere"]
};
	["ContentBlockReferencesByStoriesListUniqueWhere"]: {
		storiesList?: GraphQLTypes["StoriesListUniqueWhere"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	alias?: string
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceCreateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceCreateStaffListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceCreatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceCreateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceCreateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"],
	isTargetBlank?: boolean,
	_dummy_field_?: boolean
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateProgramEntityRelationInput"]: {
		connect?: GraphQLTypes["ProgramUniqueWhere"],
	create?: GraphQLTypes["ProgramWithoutLinkCreateInput"]
};
	["ProgramWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	title?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["ProgramCreateImageEntityRelationInput"],
	content?: GraphQLTypes["ProgramCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["ProgramCreateSeoEntityRelationInput"],
	ilustration?: GraphQLTypes["ProgramCreateIlustrationEntityRelationInput"],
	bulletPoint?: GraphQLTypes["ProgramCreateBulletPointEntityRelationInput"],
	showDetailLink?: boolean,
	_dummy_field_?: boolean
};
	["ProgramCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	fileName?: string,
	_dummy_field_?: boolean
};
	["ProgramCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ProgramCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	noIndex?: boolean,
	noFollow?: boolean,
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ProgramCreateIlustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ProgramCreateBulletPointEntityRelationInput"]: {
		connect?: GraphQLTypes["BulletPointUniqueWhere"],
	create?: GraphQLTypes["BulletPointCreateInput"]
};
	["BulletPointCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["BulletPointCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BulletPointCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["BulletPointItemUniqueWhere"],
	create?: GraphQLTypes["BulletPointItemWithoutListCreateInput"],
	alias?: string
};
	["BulletPointItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["LinkableCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutLinkCreateInput"]
};
	["HomePageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	content?: GraphQLTypes["HomePageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	logo?: GraphQLTypes["HomePageCreateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["HomePageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HomePageCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LinkableCreateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["RedirectWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	targetUrl?: string,
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateProgramPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ProgramPageUniqueWhere"],
	create?: GraphQLTypes["ProgramPageWithoutLinkCreateInput"]
};
	["ProgramPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	seo?: GraphQLTypes["ProgramPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"],
	create?: GraphQLTypes["GenericPageWithoutLinkCreateInput"]
};
	["GenericPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["GenericPageCreateImageEntityRelationInput"],
	content?: GraphQLTypes["GenericPageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["GenericPageCreateSeoEntityRelationInput"],
	darujmeWidget?: boolean,
	_dummy_field_?: boolean
};
	["GenericPageCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["GenericPageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateNewsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsPageUniqueWhere"],
	create?: GraphQLTypes["NewsPageWithoutLinkCreateInput"]
};
	["NewsPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	seo?: GraphQLTypes["NewsPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateNewsEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsUniqueWhere"],
	create?: GraphQLTypes["NewsWithoutLinkCreateInput"]
};
	["NewsWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	publishDate?: GraphQLTypes["DateTime"],
	title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["NewsCreateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["NewsCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["NewsCreateSeoEntityRelationInput"],
	order?: number,
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["NewsCreateCoverImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["NewsCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["NewsCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateStoryEntityRelationInput"]: {
		connect?: GraphQLTypes["StoriesUniqueWhere"],
	create?: GraphQLTypes["StoriesWithoutLinkCreateInput"]
};
	["StoriesWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["StoriesCreateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["StoriesCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["StoriesCreateSeoEntityRelationInput"],
	order?: number,
	list?: GraphQLTypes["StoriesCreateListEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["StoriesCreateCoverImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["StoriesCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["StoriesCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["StoriesCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoriesListUniqueWhere"],
	create?: GraphQLTypes["StoriesListWithoutItemsCreateInput"]
};
	["StoriesListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["LinkableCreateStoriesPageEntityRelationInput"]: {
		connect?: GraphQLTypes["StoriesPageUniqueWhere"],
	create?: GraphQLTypes["StoriesPageWithoutLinkCreateInput"]
};
	["StoriesPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	seo?: GraphQLTypes["StoriesPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StoriesPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateYoutubeVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["YoutubeVideoUniqueWhere"],
	create?: GraphQLTypes["YoutubeVideoCreateInput"]
};
	["YoutubeVideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["YoutubeVideoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	videoId?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateFileListEntityRelationInput"]: {
		connect?: GraphQLTypes["FileListUniqueWhere"],
	create?: GraphQLTypes["FileListWithoutReferenceCreateInput"]
};
	["FileListWithoutReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["FileListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FileListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["FileItemUniqueWhere"],
	create?: GraphQLTypes["FileItemWithoutListCreateInput"],
	alias?: string
};
	["FileItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	url?: string,
	fileType?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"],
	create?: GraphQLTypes["TextListCreateInput"]
};
	["TextListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["TextListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["TextItemUniqueWhere"],
	create?: GraphQLTypes["TextItemWithoutListCreateInput"],
	alias?: string
};
	["TextItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	text?: string,
	link?: GraphQLTypes["TextItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateStaffListEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffListUniqueWhere"],
	create?: GraphQLTypes["StaffListWithoutReferenceCreateInput"]
};
	["StaffListWithoutReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["StaffListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["StaffListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffItemUniqueWhere"],
	create?: GraphQLTypes["StaffItemWithoutListCreateInput"],
	alias?: string
};
	["StaffItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	staff?: GraphQLTypes["StaffItemCreateStaffEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffItemCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"],
	create?: GraphQLTypes["StaffCreateInput"]
};
	["StaffUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["StaffCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	position?: string,
	image?: GraphQLTypes["StaffCreateImageEntityRelationInput"],
	order?: number,
	info?: string,
	_dummy_field_?: boolean
};
	["StaffCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreatePrincipleListEntityRelationInput"]: {
		connect?: GraphQLTypes["PrincipleListUniqueWhere"],
	create?: GraphQLTypes["PrincipleListWithoutReferenceCreateInput"]
};
	["PrincipleListWithoutReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["PrincipleListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PrincipleListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["PrincipleItemUniqueWhere"],
	create?: GraphQLTypes["PrincipleItemWithoutListCreateInput"],
	alias?: string
};
	["PrincipleItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	icon?: GraphQLTypes["PrincipleItemCreateIconEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["PrincipleItemCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["IconUniqueWhere"],
	create?: GraphQLTypes["IconCreateInput"]
};
	["IconUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["IconCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["IconCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["IconCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateImageLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentImageLinkListUniqueWhere"],
	create?: GraphQLTypes["ContentImageLinkListCreateInput"]
};
	["ContentImageLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	items?: Array<GraphQLTypes["ContentImageLinkListCreateItemsEntityRelationInput"]>,
	link?: GraphQLTypes["ContentImageLinkListCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentImageLinkItemUniqueWhere"],
	create?: GraphQLTypes["ContentImageLinkItemWithoutListCreateInput"],
	alias?: string
};
	["ContentImageLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["ContentImageLinkItemCreateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentImageLinkItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentImageLinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentImageLinkListCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateCitationListEntityRelationInput"]: {
		connect?: GraphQLTypes["CitationListUniqueWhere"],
	create?: GraphQLTypes["CitationListCreateInput"]
};
	["CitationListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["CitationListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CitationListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["CitationItemUniqueWhere"],
	create?: GraphQLTypes["CitationItemWithoutListCreateInput"],
	alias?: string
};
	["CitationItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	image?: GraphQLTypes["CitationItemCreateImageEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["CitationItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateStoriesListEntityRelationInput"]: {
		connect?: GraphQLTypes["StoriesListUniqueWhere"],
	create?: GraphQLTypes["StoriesListCreateInput"]
};
	["StoriesListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["StoriesListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["StoriesListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["StoriesUniqueWhere"],
	create?: GraphQLTypes["StoriesWithoutListCreateInput"],
	alias?: string
};
	["StoriesWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["StoriesCreateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["StoriesCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["StoriesCreateSeoEntityRelationInput"],
	order?: number,
	link?: GraphQLTypes["StoriesCreateLinkEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["StoriesCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutStoryCreateInput"]
};
	["LinkableWithoutStoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["ContentUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceUpdateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceUpdateStaffListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceUpdateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceUpdateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"],
	isTargetBlank?: boolean,
	_dummy_field_?: boolean
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateProgramEntityRelationInput"]: {
		create?: GraphQLTypes["ProgramWithoutLinkCreateInput"],
	update?: GraphQLTypes["ProgramWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertProgramRelationInput"],
	connect?: GraphQLTypes["ProgramUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProgramWithoutLinkUpdateInput"]: {
		order?: number,
	name?: string,
	title?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["ProgramUpdateImageEntityRelationInput"],
	content?: GraphQLTypes["ProgramUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["ProgramUpdateSeoEntityRelationInput"],
	ilustration?: GraphQLTypes["ProgramUpdateIlustrationEntityRelationInput"],
	bulletPoint?: GraphQLTypes["ProgramUpdateBulletPointEntityRelationInput"],
	showDetailLink?: boolean,
	_dummy_field_?: boolean
};
	["ProgramUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ProgramUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	fileName?: string,
	_dummy_field_?: boolean
};
	["ProgramUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ProgramUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ProgramUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProgramUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ProgramUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ProgramUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	noIndex?: boolean,
	noFollow?: boolean,
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ProgramUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ProgramUpdateIlustrationEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ProgramUpsertIlustrationRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProgramUpsertIlustrationRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ProgramUpdateBulletPointEntityRelationInput"]: {
		create?: GraphQLTypes["BulletPointCreateInput"],
	update?: GraphQLTypes["BulletPointUpdateInput"],
	upsert?: GraphQLTypes["ProgramUpsertBulletPointRelationInput"],
	connect?: GraphQLTypes["BulletPointUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["BulletPointUpdateInput"]: {
		items?: Array<GraphQLTypes["BulletPointUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BulletPointUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["BulletPointItemWithoutListCreateInput"],
	update?: GraphQLTypes["BulletPointUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["BulletPointUpsertItemsRelationInput"],
	connect?: GraphQLTypes["BulletPointItemUniqueWhere"],
	disconnect?: GraphQLTypes["BulletPointItemUniqueWhere"],
	delete?: GraphQLTypes["BulletPointItemUniqueWhere"],
	alias?: string
};
	["BulletPointUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["BulletPointItemUniqueWhere"],
	data?: GraphQLTypes["BulletPointItemWithoutListUpdateInput"]
};
	["BulletPointItemWithoutListUpdateInput"]: {
		order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["BulletPointUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["BulletPointItemUniqueWhere"],
	update?: GraphQLTypes["BulletPointItemWithoutListUpdateInput"],
	create?: GraphQLTypes["BulletPointItemWithoutListCreateInput"]
};
	["ProgramUpsertBulletPointRelationInput"]: {
		update?: GraphQLTypes["BulletPointUpdateInput"],
	create?: GraphQLTypes["BulletPointCreateInput"]
};
	["LinkableUpsertProgramRelationInput"]: {
		update?: GraphQLTypes["ProgramWithoutLinkUpdateInput"],
	create?: GraphQLTypes["ProgramWithoutLinkCreateInput"]
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageWithoutLinkCreateInput"],
	update?: GraphQLTypes["HomePageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertHomePageRelationInput"],
	connect?: GraphQLTypes["HomePageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	content?: GraphQLTypes["HomePageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	logo?: GraphQLTypes["HomePageUpdateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["HomePageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HomePageUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LinkableUpsertHomePageRelationInput"]: {
		update?: GraphQLTypes["HomePageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["HomePageWithoutLinkCreateInput"]
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutLinkCreateInput"],
	update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertRedirectRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectWithoutLinkUpdateInput"]: {
		targetUrl?: string,
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
		update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableUpdateProgramPageEntityRelationInput"]: {
		create?: GraphQLTypes["ProgramPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["ProgramPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertProgramPageRelationInput"],
	connect?: GraphQLTypes["ProgramPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProgramPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	seo?: GraphQLTypes["ProgramPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ProgramPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProgramPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertProgramPageRelationInput"]: {
		update?: GraphQLTypes["ProgramPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["ProgramPageWithoutLinkCreateInput"]
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["GenericPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertGenericPageRelationInput"],
	connect?: GraphQLTypes["GenericPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageWithoutLinkUpdateInput"]: {
		name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["GenericPageUpdateImageEntityRelationInput"],
	content?: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["GenericPageUpdateSeoEntityRelationInput"],
	darujmeWidget?: boolean,
	_dummy_field_?: boolean
};
	["GenericPageUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["GenericPageUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertGenericPageRelationInput"]: {
		update?: GraphQLTypes["GenericPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["GenericPageWithoutLinkCreateInput"]
};
	["LinkableUpdateNewsPageEntityRelationInput"]: {
		create?: GraphQLTypes["NewsPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["NewsPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertNewsPageRelationInput"],
	connect?: GraphQLTypes["NewsPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	seo?: GraphQLTypes["NewsPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["NewsPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertNewsPageRelationInput"]: {
		update?: GraphQLTypes["NewsPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["NewsPageWithoutLinkCreateInput"]
};
	["LinkableUpdateNewsEntityRelationInput"]: {
		create?: GraphQLTypes["NewsWithoutLinkCreateInput"],
	update?: GraphQLTypes["NewsWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertNewsRelationInput"],
	connect?: GraphQLTypes["NewsUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsWithoutLinkUpdateInput"]: {
		publishDate?: GraphQLTypes["DateTime"],
	title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["NewsUpdateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["NewsUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["NewsUpdateSeoEntityRelationInput"],
	order?: number,
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["NewsUpdateCoverImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["NewsUpsertCoverImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsUpsertCoverImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["NewsUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["NewsUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["NewsUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["NewsUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertNewsRelationInput"]: {
		update?: GraphQLTypes["NewsWithoutLinkUpdateInput"],
	create?: GraphQLTypes["NewsWithoutLinkCreateInput"]
};
	["LinkableUpdateStoryEntityRelationInput"]: {
		create?: GraphQLTypes["StoriesWithoutLinkCreateInput"],
	update?: GraphQLTypes["StoriesWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertStoryRelationInput"],
	connect?: GraphQLTypes["StoriesUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesWithoutLinkUpdateInput"]: {
		title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["StoriesUpdateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["StoriesUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["StoriesUpdateSeoEntityRelationInput"],
	order?: number,
	list?: GraphQLTypes["StoriesUpdateListEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["StoriesUpdateCoverImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["StoriesUpsertCoverImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesUpsertCoverImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["StoriesUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["StoriesUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["StoriesUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["StoriesUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["StoriesUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["StoriesListWithoutItemsCreateInput"],
	update?: GraphQLTypes["StoriesListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["StoriesUpsertListRelationInput"],
	connect?: GraphQLTypes["StoriesListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["StoriesUpsertListRelationInput"]: {
		update?: GraphQLTypes["StoriesListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["StoriesListWithoutItemsCreateInput"]
};
	["LinkableUpsertStoryRelationInput"]: {
		update?: GraphQLTypes["StoriesWithoutLinkUpdateInput"],
	create?: GraphQLTypes["StoriesWithoutLinkCreateInput"]
};
	["LinkableUpdateStoriesPageEntityRelationInput"]: {
		create?: GraphQLTypes["StoriesPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["StoriesPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertStoriesPageRelationInput"],
	connect?: GraphQLTypes["StoriesPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	seo?: GraphQLTypes["StoriesPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StoriesPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["StoriesPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertStoriesPageRelationInput"]: {
		update?: GraphQLTypes["StoriesPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["StoriesPageWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateYoutubeVideoEntityRelationInput"]: {
		create?: GraphQLTypes["YoutubeVideoCreateInput"],
	update?: GraphQLTypes["YoutubeVideoUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertYoutubeVideoRelationInput"],
	connect?: GraphQLTypes["YoutubeVideoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["YoutubeVideoUpdateInput"]: {
		videoId?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertYoutubeVideoRelationInput"]: {
		update?: GraphQLTypes["YoutubeVideoUpdateInput"],
	create?: GraphQLTypes["YoutubeVideoCreateInput"]
};
	["ContentReferenceUpdateFileListEntityRelationInput"]: {
		create?: GraphQLTypes["FileListWithoutReferenceCreateInput"],
	update?: GraphQLTypes["FileListWithoutReferenceUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertFileListRelationInput"],
	connect?: GraphQLTypes["FileListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FileListWithoutReferenceUpdateInput"]: {
		items?: Array<GraphQLTypes["FileListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FileListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["FileItemWithoutListCreateInput"],
	update?: GraphQLTypes["FileListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["FileListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["FileItemUniqueWhere"],
	disconnect?: GraphQLTypes["FileItemUniqueWhere"],
	delete?: GraphQLTypes["FileItemUniqueWhere"],
	alias?: string
};
	["FileListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["FileItemUniqueWhere"],
	data?: GraphQLTypes["FileItemWithoutListUpdateInput"]
};
	["FileItemWithoutListUpdateInput"]: {
		order?: number,
	name?: string,
	url?: string,
	fileType?: string,
	_dummy_field_?: boolean
};
	["FileListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["FileItemUniqueWhere"],
	update?: GraphQLTypes["FileItemWithoutListUpdateInput"],
	create?: GraphQLTypes["FileItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertFileListRelationInput"]: {
		update?: GraphQLTypes["FileListWithoutReferenceUpdateInput"],
	create?: GraphQLTypes["FileListWithoutReferenceCreateInput"]
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
		create?: GraphQLTypes["TextListCreateInput"],
	update?: GraphQLTypes["TextListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertTextListRelationInput"],
	connect?: GraphQLTypes["TextListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TextListUpdateInput"]: {
		items?: Array<GraphQLTypes["TextListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["TextItemWithoutListCreateInput"],
	update?: GraphQLTypes["TextListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["TextListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["TextItemUniqueWhere"],
	disconnect?: GraphQLTypes["TextItemUniqueWhere"],
	delete?: GraphQLTypes["TextItemUniqueWhere"],
	alias?: string
};
	["TextListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["TextItemUniqueWhere"],
	data?: GraphQLTypes["TextItemWithoutListUpdateInput"]
};
	["TextItemWithoutListUpdateInput"]: {
		order?: number,
	title?: string,
	text?: string,
	link?: GraphQLTypes["TextItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["TextItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TextItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["TextListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["TextItemUniqueWhere"],
	update?: GraphQLTypes["TextItemWithoutListUpdateInput"],
	create?: GraphQLTypes["TextItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertTextListRelationInput"]: {
		update?: GraphQLTypes["TextListUpdateInput"],
	create?: GraphQLTypes["TextListCreateInput"]
};
	["ContentReferenceUpdateStaffListEntityRelationInput"]: {
		create?: GraphQLTypes["StaffListWithoutReferenceCreateInput"],
	update?: GraphQLTypes["StaffListWithoutReferenceUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertStaffListRelationInput"],
	connect?: GraphQLTypes["StaffListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StaffListWithoutReferenceUpdateInput"]: {
		items?: Array<GraphQLTypes["StaffListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["StaffListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["StaffItemWithoutListCreateInput"],
	update?: GraphQLTypes["StaffListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["StaffListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["StaffItemUniqueWhere"],
	disconnect?: GraphQLTypes["StaffItemUniqueWhere"],
	delete?: GraphQLTypes["StaffItemUniqueWhere"],
	alias?: string
};
	["StaffListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["StaffItemUniqueWhere"],
	data?: GraphQLTypes["StaffItemWithoutListUpdateInput"]
};
	["StaffItemWithoutListUpdateInput"]: {
		order?: number,
	staff?: GraphQLTypes["StaffItemUpdateStaffEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffItemUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffCreateInput"],
	update?: GraphQLTypes["StaffUpdateInput"],
	upsert?: GraphQLTypes["StaffItemUpsertStaffRelationInput"],
	connect?: GraphQLTypes["StaffUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StaffUpdateInput"]: {
		name?: string,
	position?: string,
	image?: GraphQLTypes["StaffUpdateImageEntityRelationInput"],
	order?: number,
	info?: string,
	_dummy_field_?: boolean
};
	["StaffUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["StaffUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StaffUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["StaffItemUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffUpdateInput"],
	create?: GraphQLTypes["StaffCreateInput"]
};
	["StaffListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["StaffItemUniqueWhere"],
	update?: GraphQLTypes["StaffItemWithoutListUpdateInput"],
	create?: GraphQLTypes["StaffItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertStaffListRelationInput"]: {
		update?: GraphQLTypes["StaffListWithoutReferenceUpdateInput"],
	create?: GraphQLTypes["StaffListWithoutReferenceCreateInput"]
};
	["ContentReferenceUpdatePrincipleListEntityRelationInput"]: {
		create?: GraphQLTypes["PrincipleListWithoutReferenceCreateInput"],
	update?: GraphQLTypes["PrincipleListWithoutReferenceUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertPrincipleListRelationInput"],
	connect?: GraphQLTypes["PrincipleListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PrincipleListWithoutReferenceUpdateInput"]: {
		items?: Array<GraphQLTypes["PrincipleListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PrincipleListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["PrincipleItemWithoutListCreateInput"],
	update?: GraphQLTypes["PrincipleListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["PrincipleListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["PrincipleItemUniqueWhere"],
	disconnect?: GraphQLTypes["PrincipleItemUniqueWhere"],
	delete?: GraphQLTypes["PrincipleItemUniqueWhere"],
	alias?: string
};
	["PrincipleListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["PrincipleItemUniqueWhere"],
	data?: GraphQLTypes["PrincipleItemWithoutListUpdateInput"]
};
	["PrincipleItemWithoutListUpdateInput"]: {
		order?: number,
	text?: string,
	icon?: GraphQLTypes["PrincipleItemUpdateIconEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["PrincipleItemUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["IconCreateInput"],
	update?: GraphQLTypes["IconUpdateInput"],
	upsert?: GraphQLTypes["PrincipleItemUpsertIconRelationInput"],
	connect?: GraphQLTypes["IconUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["IconUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["IconUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["IconUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["IconUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["IconUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["PrincipleItemUpsertIconRelationInput"]: {
		update?: GraphQLTypes["IconUpdateInput"],
	create?: GraphQLTypes["IconCreateInput"]
};
	["PrincipleListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["PrincipleItemUniqueWhere"],
	update?: GraphQLTypes["PrincipleItemWithoutListUpdateInput"],
	create?: GraphQLTypes["PrincipleItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertPrincipleListRelationInput"]: {
		update?: GraphQLTypes["PrincipleListWithoutReferenceUpdateInput"],
	create?: GraphQLTypes["PrincipleListWithoutReferenceCreateInput"]
};
	["ContentReferenceUpdateImageLinkListEntityRelationInput"]: {
		create?: GraphQLTypes["ContentImageLinkListCreateInput"],
	update?: GraphQLTypes["ContentImageLinkListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageLinkListRelationInput"],
	connect?: GraphQLTypes["ContentImageLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentImageLinkListUpdateInput"]: {
		title?: string,
	items?: Array<GraphQLTypes["ContentImageLinkListUpdateItemsEntityRelationInput"]>,
	link?: GraphQLTypes["ContentImageLinkListUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ContentImageLinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["ContentImageLinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ContentImageLinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ContentImageLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["ContentImageLinkItemUniqueWhere"],
	delete?: GraphQLTypes["ContentImageLinkItemUniqueWhere"],
	alias?: string
};
	["ContentImageLinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ContentImageLinkItemUniqueWhere"],
	data?: GraphQLTypes["ContentImageLinkItemWithoutListUpdateInput"]
};
	["ContentImageLinkItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["ContentImageLinkItemUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentImageLinkItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentImageLinkItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentImageLinkItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentImageLinkItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentImageLinkItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentImageLinkItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentImageLinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ContentImageLinkItemUniqueWhere"],
	update?: GraphQLTypes["ContentImageLinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ContentImageLinkItemWithoutListCreateInput"]
};
	["ContentImageLinkListUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentImageLinkListUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentImageLinkListUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpsertImageLinkListRelationInput"]: {
		update?: GraphQLTypes["ContentImageLinkListUpdateInput"],
	create?: GraphQLTypes["ContentImageLinkListCreateInput"]
};
	["ContentReferenceUpdateCitationListEntityRelationInput"]: {
		create?: GraphQLTypes["CitationListCreateInput"],
	update?: GraphQLTypes["CitationListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertCitationListRelationInput"],
	connect?: GraphQLTypes["CitationListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CitationListUpdateInput"]: {
		items?: Array<GraphQLTypes["CitationListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CitationListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["CitationItemWithoutListCreateInput"],
	update?: GraphQLTypes["CitationListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["CitationListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["CitationItemUniqueWhere"],
	disconnect?: GraphQLTypes["CitationItemUniqueWhere"],
	delete?: GraphQLTypes["CitationItemUniqueWhere"],
	alias?: string
};
	["CitationListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["CitationItemUniqueWhere"],
	data?: GraphQLTypes["CitationItemWithoutListUpdateInput"]
};
	["CitationItemWithoutListUpdateInput"]: {
		title?: string,
	text?: string,
	image?: GraphQLTypes["CitationItemUpdateImageEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["CitationItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["CitationItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CitationItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["CitationListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["CitationItemUniqueWhere"],
	update?: GraphQLTypes["CitationItemWithoutListUpdateInput"],
	create?: GraphQLTypes["CitationItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertCitationListRelationInput"]: {
		update?: GraphQLTypes["CitationListUpdateInput"],
	create?: GraphQLTypes["CitationListCreateInput"]
};
	["ContentReferenceUpdateStoriesListEntityRelationInput"]: {
		create?: GraphQLTypes["StoriesListCreateInput"],
	update?: GraphQLTypes["StoriesListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertStoriesListRelationInput"],
	connect?: GraphQLTypes["StoriesListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StoriesListUpdateInput"]: {
		items?: Array<GraphQLTypes["StoriesListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["StoriesListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["StoriesWithoutListCreateInput"],
	update?: GraphQLTypes["StoriesListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["StoriesListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["StoriesUniqueWhere"],
	disconnect?: GraphQLTypes["StoriesUniqueWhere"],
	delete?: GraphQLTypes["StoriesUniqueWhere"],
	alias?: string
};
	["StoriesListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["StoriesUniqueWhere"],
	data?: GraphQLTypes["StoriesWithoutListUpdateInput"]
};
	["StoriesWithoutListUpdateInput"]: {
		title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["StoriesUpdateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["StoriesUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["StoriesUpdateSeoEntityRelationInput"],
	order?: number,
	link?: GraphQLTypes["StoriesUpdateLinkEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["StoriesUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutStoryCreateInput"],
	update?: GraphQLTypes["LinkableWithoutStoryUpdateInput"],
	upsert?: GraphQLTypes["StoriesUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutStoryUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StoriesUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutStoryUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutStoryCreateInput"]
};
	["StoriesListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["StoriesUniqueWhere"],
	update?: GraphQLTypes["StoriesWithoutListUpdateInput"],
	create?: GraphQLTypes["StoriesWithoutListCreateInput"]
};
	["ContentReferenceUpsertStoriesListRelationInput"]: {
		update?: GraphQLTypes["StoriesListUpdateInput"],
	create?: GraphQLTypes["StoriesListCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentWithoutBlocksCreateInput"],
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	delete?: boolean
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentBlockUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceCreateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceCreateStaffListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceCreatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceCreateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceCreateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceUpdateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceUpdateStaffListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceUpdateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceUpdateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"],
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: boolean
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["FallbackSeo"]: {
	__typename: "FallbackSeo",
	_meta?: GraphQLTypes["FallbackSeoMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["FallbackSeoMeta"]: {
	__typename: "FallbackSeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["FallbackSeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["FallbackSeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["FallbackSeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["FallbackSeoWhere"] | undefined>,
	not?: GraphQLTypes["FallbackSeoWhere"]
};
	["FallbackSeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["FallbackSeoConnection"]: {
	__typename: "FallbackSeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FallbackSeoEdge"]>
};
	["FallbackSeoEdge"]: {
	__typename: "FallbackSeoEdge",
	node: GraphQLTypes["FallbackSeo"]
};
	["FallbackSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["FallbackSeoCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FallbackSeoCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["FallbackSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["FallbackSeoUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FallbackSeoUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["FallbackSeoUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FallbackSeoUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	copyright?: string,
	logoFirst?: GraphQLTypes["Image"],
	logoSecond?: GraphQLTypes["Image"],
	linksGroups: Array<GraphQLTypes["FooterLinkGroups"]>,
	phone?: string,
	email?: string,
	text?: string,
	link?: GraphQLTypes["Link"],
	paginateLinksGroups: GraphQLTypes["FooterLinkGroupsConnection"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	copyright?: GraphQLTypes["FieldMeta"],
	logoFirst?: GraphQLTypes["FieldMeta"],
	logoSecond?: GraphQLTypes["FieldMeta"],
	linksGroups?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["FooterLinkGroups"]: {
	__typename: "FooterLinkGroups",
	_meta?: GraphQLTypes["FooterLinkGroupsMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	links: Array<GraphQLTypes["FooterLink"]>,
	specialIdentifier?: string,
	paginateLinks: GraphQLTypes["FooterLinkConnection"]
};
	["FooterLinkGroupsMeta"]: {
	__typename: "FooterLinkGroupsMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"],
	specialIdentifier?: GraphQLTypes["FieldMeta"]
};
	["FooterLink"]: {
	__typename: "FooterLink",
	_meta?: GraphQLTypes["FooterLinkMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"]
};
	["FooterLinkMeta"]: {
	__typename: "FooterLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["FooterLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["FooterLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterLinkWhere"] | undefined>,
	not?: GraphQLTypes["FooterLinkWhere"]
};
	["FooterLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["FooterLinkConnection"]: {
	__typename: "FooterLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLinkEdge"]>
};
	["FooterLinkEdge"]: {
	__typename: "FooterLinkEdge",
	node: GraphQLTypes["FooterLink"]
};
	["FooterLinkGroupsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	links?: GraphQLTypes["FooterLinkWhere"],
	specialIdentifier?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["FooterLinkGroupsWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterLinkGroupsWhere"] | undefined>,
	not?: GraphQLTypes["FooterLinkGroupsWhere"]
};
	["FooterLinkGroupsOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	specialIdentifier?: GraphQLTypes["OrderDirection"]
};
	["FooterLinkGroupsConnection"]: {
	__typename: "FooterLinkGroupsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLinkGroupsEdge"]>
};
	["FooterLinkGroupsEdge"]: {
	__typename: "FooterLinkGroupsEdge",
	node: GraphQLTypes["FooterLinkGroups"]
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logoFirst?: GraphQLTypes["ImageUniqueWhere"],
	logoSecond?: GraphQLTypes["ImageUniqueWhere"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	copyright?: GraphQLTypes["StringCondition"],
	logoFirst?: GraphQLTypes["ImageWhere"],
	logoSecond?: GraphQLTypes["ImageWhere"],
	linksGroups?: GraphQLTypes["FooterLinkGroupsWhere"],
	phone?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	not?: GraphQLTypes["FooterWhere"]
};
	["FooterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	copyright?: GraphQLTypes["OrderDirection"],
	logoFirst?: GraphQLTypes["ImageOrderBy"],
	logoSecond?: GraphQLTypes["ImageOrderBy"],
	phone?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	copyright?: string,
	logoFirst?: GraphQLTypes["FooterCreateLogoFirstEntityRelationInput"],
	logoSecond?: GraphQLTypes["FooterCreateLogoSecondEntityRelationInput"],
	linksGroups?: Array<GraphQLTypes["FooterCreateLinksGroupsEntityRelationInput"]>,
	phone?: string,
	email?: string,
	text?: string,
	link?: GraphQLTypes["FooterCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterCreateLogoFirstEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterCreateLogoSecondEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterCreateLinksGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLinkGroupsUniqueWhere"],
	create?: GraphQLTypes["FooterLinkGroupsCreateInput"],
	alias?: string
};
	["FooterLinkGroupsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FooterLinkGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	links?: Array<GraphQLTypes["FooterLinkGroupsCreateLinksEntityRelationInput"]>,
	specialIdentifier?: string,
	_dummy_field_?: boolean
};
	["FooterLinkGroupsCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLinkUniqueWhere"],
	create?: GraphQLTypes["FooterLinkCreateInput"],
	alias?: string
};
	["FooterLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["FooterLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["FooterLinkCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	copyright?: string,
	logoFirst?: GraphQLTypes["FooterUpdateLogoFirstEntityRelationInput"],
	logoSecond?: GraphQLTypes["FooterUpdateLogoSecondEntityRelationInput"],
	linksGroups?: Array<GraphQLTypes["FooterUpdateLinksGroupsEntityRelationInput"]>,
	phone?: string,
	email?: string,
	text?: string,
	link?: GraphQLTypes["FooterUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterUpdateLogoFirstEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertLogoFirstRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertLogoFirstRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterUpdateLogoSecondEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertLogoSecondRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertLogoSecondRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterUpdateLinksGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLinkGroupsCreateInput"],
	update?: GraphQLTypes["FooterUpdateLinksGroupsRelationInput"],
	upsert?: GraphQLTypes["FooterUpsertLinksGroupsRelationInput"],
	connect?: GraphQLTypes["FooterLinkGroupsUniqueWhere"],
	disconnect?: GraphQLTypes["FooterLinkGroupsUniqueWhere"],
	delete?: GraphQLTypes["FooterLinkGroupsUniqueWhere"],
	alias?: string
};
	["FooterUpdateLinksGroupsRelationInput"]: {
		by?: GraphQLTypes["FooterLinkGroupsUniqueWhere"],
	data?: GraphQLTypes["FooterLinkGroupsUpdateInput"]
};
	["FooterLinkGroupsUpdateInput"]: {
		order?: number,
	title?: string,
	links?: Array<GraphQLTypes["FooterLinkGroupsUpdateLinksEntityRelationInput"]>,
	specialIdentifier?: string,
	_dummy_field_?: boolean
};
	["FooterLinkGroupsUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLinkCreateInput"],
	update?: GraphQLTypes["FooterLinkGroupsUpdateLinksRelationInput"],
	upsert?: GraphQLTypes["FooterLinkGroupsUpsertLinksRelationInput"],
	connect?: GraphQLTypes["FooterLinkUniqueWhere"],
	disconnect?: GraphQLTypes["FooterLinkUniqueWhere"],
	delete?: GraphQLTypes["FooterLinkUniqueWhere"],
	alias?: string
};
	["FooterLinkGroupsUpdateLinksRelationInput"]: {
		by?: GraphQLTypes["FooterLinkUniqueWhere"],
	data?: GraphQLTypes["FooterLinkUpdateInput"]
};
	["FooterLinkUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["FooterLinkUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLinkUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FooterLinkUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterLinkUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterLinkGroupsUpsertLinksRelationInput"]: {
		by?: GraphQLTypes["FooterLinkUniqueWhere"],
	update?: GraphQLTypes["FooterLinkUpdateInput"],
	create?: GraphQLTypes["FooterLinkCreateInput"]
};
	["FooterUpsertLinksGroupsRelationInput"]: {
		by?: GraphQLTypes["FooterLinkGroupsUniqueWhere"],
	update?: GraphQLTypes["FooterLinkGroupsUpdateInput"],
	create?: GraphQLTypes["FooterLinkGroupsCreateInput"]
};
	["FooterUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	logoFirst?: GraphQLTypes["Image"],
	logoSecond?: GraphQLTypes["Image"],
	linkGroups?: GraphQLTypes["LinkList"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	logoFirst?: GraphQLTypes["FieldMeta"],
	logoSecond?: GraphQLTypes["FieldMeta"],
	linkGroups?: GraphQLTypes["FieldMeta"]
};
	["LinkList"]: {
	__typename: "LinkList",
	_meta?: GraphQLTypes["LinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["LinkItem"]>,
	itemsByLink?: GraphQLTypes["LinkItem"],
	itemsByGroup?: GraphQLTypes["LinkItem"],
	paginateItems: GraphQLTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
	__typename: "LinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["LinkItem"]: {
	__typename: "LinkItem",
	_meta?: GraphQLTypes["LinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["LinkList"],
	link?: GraphQLTypes["Link"],
	group?: GraphQLTypes["LinkSubGroup"],
	isHighlighted?: boolean
};
	["LinkItemMeta"]: {
	__typename: "LinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	group?: GraphQLTypes["FieldMeta"],
	isHighlighted?: GraphQLTypes["FieldMeta"]
};
	["LinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["LinkItemWhere"],
	and?: Array<GraphQLTypes["LinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkListWhere"] | undefined>,
	not?: GraphQLTypes["LinkListWhere"]
};
	["LinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["LinkListWhere"],
	link?: GraphQLTypes["LinkWhere"],
	group?: GraphQLTypes["LinkSubGroupWhere"],
	isHighlighted?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["LinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkItemWhere"] | undefined>,
	not?: GraphQLTypes["LinkItemWhere"]
};
	["LinkSubGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	links?: GraphQLTypes["LinkListWhere"],
	and?: Array<GraphQLTypes["LinkSubGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkSubGroupWhere"] | undefined>,
	not?: GraphQLTypes["LinkSubGroupWhere"]
};
	["LinkSubGroup"]: {
	__typename: "LinkSubGroup",
	_meta?: GraphQLTypes["LinkSubGroupMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	links?: GraphQLTypes["LinkList"]
};
	["LinkSubGroupMeta"]: {
	__typename: "LinkSubGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"]
};
	["LinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["LinkListOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	group?: GraphQLTypes["LinkSubGroupOrderBy"],
	isHighlighted?: GraphQLTypes["OrderDirection"]
};
	["LinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["LinkSubGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	links?: GraphQLTypes["LinkListOrderBy"]
};
	["LinkListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["LinkListItemsByGroupUniqueWhere"]: {
		group?: GraphQLTypes["LinkSubGroupUniqueWhere"]
};
	["LinkSubGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	links?: GraphQLTypes["LinkListUniqueWhere"]
};
	["LinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["LinkItemUniqueWhere"]
};
	["LinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"],
	group?: GraphQLTypes["LinkSubGroupUniqueWhere"]
};
	["LinkItemConnection"]: {
	__typename: "LinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkItemEdge"]>
};
	["LinkItemEdge"]: {
	__typename: "LinkItemEdge",
	node: GraphQLTypes["LinkItem"]
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logoFirst?: GraphQLTypes["ImageUniqueWhere"],
	logoSecond?: GraphQLTypes["ImageUniqueWhere"],
	linkGroups?: GraphQLTypes["LinkListUniqueWhere"]
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	logoFirst?: GraphQLTypes["ImageWhere"],
	logoSecond?: GraphQLTypes["ImageWhere"],
	linkGroups?: GraphQLTypes["LinkListWhere"],
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	not?: GraphQLTypes["HeaderWhere"]
};
	["HeaderOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	logoFirst?: GraphQLTypes["ImageOrderBy"],
	logoSecond?: GraphQLTypes["ImageOrderBy"],
	linkGroups?: GraphQLTypes["LinkListOrderBy"]
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logoFirst?: GraphQLTypes["HeaderCreateLogoFirstEntityRelationInput"],
	logoSecond?: GraphQLTypes["HeaderCreateLogoSecondEntityRelationInput"],
	linkGroups?: GraphQLTypes["HeaderCreateLinkGroupsEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderCreateLogoFirstEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderCreateLogoSecondEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderCreateLinkGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["LinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["LinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkItemUniqueWhere"],
	create?: GraphQLTypes["LinkItemWithoutListCreateInput"],
	alias?: string
};
	["LinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"],
	group?: GraphQLTypes["LinkItemCreateGroupEntityRelationInput"],
	isHighlighted?: boolean,
	_dummy_field_?: boolean
};
	["LinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkItemCreateGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkSubGroupUniqueWhere"],
	create?: GraphQLTypes["LinkSubGroupCreateInput"]
};
	["LinkSubGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	links?: GraphQLTypes["LinkSubGroupCreateLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkSubGroupCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["HeaderUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logoFirst?: GraphQLTypes["HeaderUpdateLogoFirstEntityRelationInput"],
	logoSecond?: GraphQLTypes["HeaderUpdateLogoSecondEntityRelationInput"],
	linkGroups?: GraphQLTypes["HeaderUpdateLinkGroupsEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderUpdateLogoFirstEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertLogoFirstRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertLogoFirstRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderUpdateLogoSecondEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertLogoSecondRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertLogoSecondRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderUpdateLinkGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertLinkGroupsRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["LinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["LinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["LinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["LinkItemUniqueWhere"],
	delete?: GraphQLTypes["LinkItemUniqueWhere"],
	alias?: string
};
	["LinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["LinkItemUniqueWhere"],
	data?: GraphQLTypes["LinkItemWithoutListUpdateInput"]
};
	["LinkItemWithoutListUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"],
	group?: GraphQLTypes["LinkItemUpdateGroupEntityRelationInput"],
	isHighlighted?: boolean,
	_dummy_field_?: boolean
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkItemUpdateGroupEntityRelationInput"]: {
		create?: GraphQLTypes["LinkSubGroupCreateInput"],
	update?: GraphQLTypes["LinkSubGroupUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertGroupRelationInput"],
	connect?: GraphQLTypes["LinkSubGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkSubGroupUpdateInput"]: {
		order?: number,
	links?: GraphQLTypes["LinkSubGroupUpdateLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkSubGroupUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateInput"],
	upsert?: GraphQLTypes["LinkSubGroupUpsertLinksRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkSubGroupUpsertLinksRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["LinkItemUpsertGroupRelationInput"]: {
		update?: GraphQLTypes["LinkSubGroupUpdateInput"],
	create?: GraphQLTypes["LinkSubGroupCreateInput"]
};
	["LinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["LinkItemUniqueWhere"],
	update?: GraphQLTypes["LinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["LinkItemWithoutListCreateInput"]
};
	["HeaderUpsertLinkGroupsRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["HomePageConnection"]: {
	__typename: "HomePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageEdge"]>
};
	["HomePageEdge"]: {
	__typename: "HomePageEdge",
	node: GraphQLTypes["HomePage"]
};
	["HomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	content?: GraphQLTypes["HomePageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["HomePageCreateLinkEntityRelationInput"],
	logo?: GraphQLTypes["HomePageCreateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["LinkableWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	content?: GraphQLTypes["HomePageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"],
	logo?: GraphQLTypes["HomePageUpdateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutHomePageUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["ProgramConnection"]: {
	__typename: "ProgramConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProgramEdge"]>
};
	["ProgramEdge"]: {
	__typename: "ProgramEdge",
	node: GraphQLTypes["Program"]
};
	["ProgramCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["ProgramCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ProgramCreateImageEntityRelationInput"],
	content?: GraphQLTypes["ProgramCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["ProgramCreateSeoEntityRelationInput"],
	ilustration?: GraphQLTypes["ProgramCreateIlustrationEntityRelationInput"],
	bulletPoint?: GraphQLTypes["ProgramCreateBulletPointEntityRelationInput"],
	showDetailLink?: boolean,
	_dummy_field_?: boolean
};
	["ProgramCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutProgramCreateInput"]
};
	["LinkableWithoutProgramCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramUpdateInput"]: {
		order?: number,
	name?: string,
	title?: string,
	leadParagraph?: string,
	link?: GraphQLTypes["ProgramUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ProgramUpdateImageEntityRelationInput"],
	content?: GraphQLTypes["ProgramUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["ProgramUpdateSeoEntityRelationInput"],
	ilustration?: GraphQLTypes["ProgramUpdateIlustrationEntityRelationInput"],
	bulletPoint?: GraphQLTypes["ProgramUpdateBulletPointEntityRelationInput"],
	showDetailLink?: boolean,
	_dummy_field_?: boolean
};
	["ProgramUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutProgramCreateInput"],
	update?: GraphQLTypes["LinkableWithoutProgramUpdateInput"],
	upsert?: GraphQLTypes["ProgramUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutProgramUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutProgramUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutProgramCreateInput"]
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	targetUrl?: string,
	link?: GraphQLTypes["RedirectCreateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkableWithoutRedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateInput"]: {
		targetUrl?: string,
	link?: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"],
	update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutRedirectUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["YoutubeVideoConnection"]: {
	__typename: "YoutubeVideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["YoutubeVideoEdge"]>
};
	["YoutubeVideoEdge"]: {
	__typename: "YoutubeVideoEdge",
	node: GraphQLTypes["YoutubeVideo"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["BulletPointConnection"]: {
	__typename: "BulletPointConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BulletPointEdge"]>
};
	["BulletPointEdge"]: {
	__typename: "BulletPointEdge",
	node: GraphQLTypes["BulletPoint"]
};
	["BulletPointItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	list?: GraphQLTypes["BulletPointItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BulletPointItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["BulletPointUniqueWhere"],
	create?: GraphQLTypes["BulletPointWithoutItemsCreateInput"]
};
	["BulletPointWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["BulletPointItemUpdateInput"]: {
		order?: number,
	text?: string,
	list?: GraphQLTypes["BulletPointItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BulletPointItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["BulletPointWithoutItemsCreateInput"],
	update?: GraphQLTypes["BulletPointWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["BulletPointItemUpsertListRelationInput"],
	connect?: GraphQLTypes["BulletPointUniqueWhere"],
	delete?: boolean
};
	["BulletPointWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["BulletPointItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["BulletPointWithoutItemsUpdateInput"],
	create?: GraphQLTypes["BulletPointWithoutItemsCreateInput"]
};
	["FileItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	url?: string,
	fileType?: string,
	list?: GraphQLTypes["FileItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["FileListUniqueWhere"],
	create?: GraphQLTypes["FileListWithoutItemsCreateInput"]
};
	["FileListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["FileListCreateReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileListCreateReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutFileListCreateInput"]
};
	["ContentReferenceWithoutFileListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceCreateStaffListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceCreatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceCreateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceCreateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileItemUpdateInput"]: {
		order?: number,
	name?: string,
	url?: string,
	fileType?: string,
	list?: GraphQLTypes["FileItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["FileListWithoutItemsCreateInput"],
	update?: GraphQLTypes["FileListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["FileItemUpsertListRelationInput"],
	connect?: GraphQLTypes["FileListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FileListWithoutItemsUpdateInput"]: {
		reference?: GraphQLTypes["FileListUpdateReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileListUpdateReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutFileListCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutFileListUpdateInput"],
	upsert?: GraphQLTypes["FileListUpsertReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceWithoutFileListUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceUpdateStaffListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceUpdateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceUpdateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileListUpsertReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutFileListUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutFileListCreateInput"]
};
	["FileItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["FileListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["FileListWithoutItemsCreateInput"]
};
	["FileListConnection"]: {
	__typename: "FileListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileListEdge"]>
};
	["FileListEdge"]: {
	__typename: "FileListEdge",
	node: GraphQLTypes["FileList"]
};
	["FileListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["FileListCreateReferenceEntityRelationInput"],
	items?: Array<GraphQLTypes["FileListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FileListUpdateInput"]: {
		reference?: GraphQLTypes["FileListUpdateReferenceEntityRelationInput"],
	items?: Array<GraphQLTypes["FileListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	text?: string,
	list?: GraphQLTypes["TextItemCreateListEntityRelationInput"],
	link?: GraphQLTypes["TextItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"],
	create?: GraphQLTypes["TextListWithoutItemsCreateInput"]
};
	["TextListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["TextItemUpdateInput"]: {
		order?: number,
	title?: string,
	text?: string,
	list?: GraphQLTypes["TextItemUpdateListEntityRelationInput"],
	link?: GraphQLTypes["TextItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["TextListWithoutItemsCreateInput"],
	update?: GraphQLTypes["TextListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["TextItemUpsertListRelationInput"],
	connect?: GraphQLTypes["TextListUniqueWhere"],
	delete?: boolean
};
	["TextListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["TextItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["TextListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["TextListWithoutItemsCreateInput"]
};
	["TextListConnection"]: {
	__typename: "TextListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextListEdge"]>
};
	["TextListEdge"]: {
	__typename: "TextListEdge",
	node: GraphQLTypes["TextList"]
};
	["ProgramPageConnection"]: {
	__typename: "ProgramPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProgramPageEdge"]>
};
	["ProgramPageEdge"]: {
	__typename: "ProgramPageEdge",
	node: GraphQLTypes["ProgramPage"]
};
	["ProgramPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["ProgramPageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ProgramPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutProgramPageCreateInput"]
};
	["LinkableWithoutProgramPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["ProgramPageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ProgramPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutProgramPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutProgramPageUpdateInput"],
	upsert?: GraphQLTypes["ProgramPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutProgramPageUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProgramPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutProgramPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutProgramPageCreateInput"]
};
	["GenericPageConnection"]: {
	__typename: "GenericPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageEdge"]>
};
	["GenericPageEdge"]: {
	__typename: "GenericPageEdge",
	node: GraphQLTypes["GenericPage"]
};
	["GenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["GenericPageCreateImageEntityRelationInput"],
	content?: GraphQLTypes["GenericPageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["GenericPageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["GenericPageCreateLinkEntityRelationInput"],
	darujmeWidget?: boolean,
	_dummy_field_?: boolean
};
	["GenericPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["LinkableWithoutGenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GenericPageUpdateInput"]: {
		name?: string,
	leadParagraph?: string,
	image?: GraphQLTypes["GenericPageUpdateImageEntityRelationInput"],
	content?: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["GenericPageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["GenericPageUpdateLinkEntityRelationInput"],
	darujmeWidget?: boolean,
	_dummy_field_?: boolean
};
	["GenericPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutGenericPageUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GenericPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["StaffConnection"]: {
	__typename: "StaffConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StaffEdge"]>
};
	["StaffEdge"]: {
	__typename: "StaffEdge",
	node: GraphQLTypes["Staff"]
};
	["StaffItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["StaffItemCreateListEntityRelationInput"],
	staff?: GraphQLTypes["StaffItemCreateStaffEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffListUniqueWhere"],
	create?: GraphQLTypes["StaffListWithoutItemsCreateInput"]
};
	["StaffListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["StaffListCreateReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffListCreateReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutStaffListCreateInput"]
};
	["ContentReferenceWithoutStaffListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceCreateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceCreatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceCreateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceCreateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["StaffItemUpdateListEntityRelationInput"],
	staff?: GraphQLTypes["StaffItemUpdateStaffEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["StaffListWithoutItemsCreateInput"],
	update?: GraphQLTypes["StaffListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["StaffItemUpsertListRelationInput"],
	connect?: GraphQLTypes["StaffListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StaffListWithoutItemsUpdateInput"]: {
		reference?: GraphQLTypes["StaffListUpdateReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffListUpdateReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutStaffListCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutStaffListUpdateInput"],
	upsert?: GraphQLTypes["StaffListUpsertReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceWithoutStaffListUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceUpdateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"],
	principleList?: GraphQLTypes["ContentReferenceUpdatePrincipleListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceUpdateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceUpdateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StaffListUpsertReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutStaffListUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutStaffListCreateInput"]
};
	["StaffItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["StaffListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["StaffListWithoutItemsCreateInput"]
};
	["StaffListConnection"]: {
	__typename: "StaffListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StaffListEdge"]>
};
	["StaffListEdge"]: {
	__typename: "StaffListEdge",
	node: GraphQLTypes["StaffList"]
};
	["StaffListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["StaffListCreateReferenceEntityRelationInput"],
	items?: Array<GraphQLTypes["StaffListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["StaffListUpdateInput"]: {
		reference?: GraphQLTypes["StaffListUpdateReferenceEntityRelationInput"],
	items?: Array<GraphQLTypes["StaffListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["IconConnection"]: {
	__typename: "IconConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IconEdge"]>
};
	["IconEdge"]: {
	__typename: "IconEdge",
	node: GraphQLTypes["Icon"]
};
	["PrincipleItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	list?: GraphQLTypes["PrincipleItemCreateListEntityRelationInput"],
	icon?: GraphQLTypes["PrincipleItemCreateIconEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["PrincipleItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PrincipleListUniqueWhere"],
	create?: GraphQLTypes["PrincipleListWithoutItemsCreateInput"]
};
	["PrincipleListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["PrincipleListCreateReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrincipleListCreateReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutPrincipleListCreateInput"]
};
	["ContentReferenceWithoutPrincipleListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceCreateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceCreateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceCreateStaffListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceCreateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceCreateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceCreateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrincipleItemUpdateInput"]: {
		order?: number,
	text?: string,
	list?: GraphQLTypes["PrincipleItemUpdateListEntityRelationInput"],
	icon?: GraphQLTypes["PrincipleItemUpdateIconEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["PrincipleItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["PrincipleListWithoutItemsCreateInput"],
	update?: GraphQLTypes["PrincipleListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["PrincipleItemUpsertListRelationInput"],
	connect?: GraphQLTypes["PrincipleListUniqueWhere"],
	delete?: boolean
};
	["PrincipleListWithoutItemsUpdateInput"]: {
		reference?: GraphQLTypes["PrincipleListUpdateReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrincipleListUpdateReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutPrincipleListCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutPrincipleListUpdateInput"],
	upsert?: GraphQLTypes["PrincipleListUpsertReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceWithoutPrincipleListUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	youtubeVideo?: GraphQLTypes["ContentReferenceUpdateYoutubeVideoEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fileList?: GraphQLTypes["ContentReferenceUpdateFileListEntityRelationInput"],
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"],
	staffList?: GraphQLTypes["ContentReferenceUpdateStaffListEntityRelationInput"],
	view?: GraphQLTypes["View"],
	aligning?: GraphQLTypes["Aligning"],
	numbered?: boolean,
	tertiaryText?: string,
	imageLinkList?: GraphQLTypes["ContentReferenceUpdateImageLinkListEntityRelationInput"],
	citationList?: GraphQLTypes["ContentReferenceUpdateCitationListEntityRelationInput"],
	storiesList?: GraphQLTypes["ContentReferenceUpdateStoriesListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrincipleListUpsertReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutPrincipleListUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutPrincipleListCreateInput"]
};
	["PrincipleItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["PrincipleListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["PrincipleListWithoutItemsCreateInput"]
};
	["PrincipleListConnection"]: {
	__typename: "PrincipleListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PrincipleListEdge"]>
};
	["PrincipleListEdge"]: {
	__typename: "PrincipleListEdge",
	node: GraphQLTypes["PrincipleList"]
};
	["PrincipleListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	reference?: GraphQLTypes["PrincipleListCreateReferenceEntityRelationInput"],
	items?: Array<GraphQLTypes["PrincipleListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PrincipleListUpdateInput"]: {
		reference?: GraphQLTypes["PrincipleListUpdateReferenceEntityRelationInput"],
	items?: Array<GraphQLTypes["PrincipleListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["LinkItemCreateListEntityRelationInput"],
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"],
	group?: GraphQLTypes["LinkItemCreateGroupEntityRelationInput"],
	isHighlighted?: boolean,
	_dummy_field_?: boolean
};
	["LinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["LinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["LinkItemUpdateListEntityRelationInput"],
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"],
	group?: GraphQLTypes["LinkItemUpdateGroupEntityRelationInput"],
	isHighlighted?: boolean,
	_dummy_field_?: boolean
};
	["LinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	delete?: boolean
};
	["LinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["LinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkListConnection"]: {
	__typename: "LinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListEdge"]>
};
	["LinkListEdge"]: {
	__typename: "LinkListEdge",
	node: GraphQLTypes["LinkList"]
};
	["LinkSubGroupConnection"]: {
	__typename: "LinkSubGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkSubGroupEdge"]>
};
	["LinkSubGroupEdge"]: {
	__typename: "LinkSubGroupEdge",
	node: GraphQLTypes["LinkSubGroup"]
};
	["YoutubeVideoList"]: {
	__typename: "YoutubeVideoList",
	_meta?: GraphQLTypes["YoutubeVideoListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["YoutubeVideoListItem"]>,
	itemsByYoutube?: GraphQLTypes["YoutubeVideoListItem"],
	paginateItems: GraphQLTypes["YoutubeVideoListItemConnection"]
};
	["YoutubeVideoListMeta"]: {
	__typename: "YoutubeVideoListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["YoutubeVideoListItem"]: {
	__typename: "YoutubeVideoListItem",
	_meta?: GraphQLTypes["YoutubeVideoListItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["YoutubeVideoList"],
	youtube?: GraphQLTypes["YoutubeVideo"]
};
	["YoutubeVideoListItemMeta"]: {
	__typename: "YoutubeVideoListItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	youtube?: GraphQLTypes["FieldMeta"]
};
	["YoutubeVideoListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["YoutubeVideoListItemWhere"],
	and?: Array<GraphQLTypes["YoutubeVideoListWhere"] | undefined>,
	or?: Array<GraphQLTypes["YoutubeVideoListWhere"] | undefined>,
	not?: GraphQLTypes["YoutubeVideoListWhere"]
};
	["YoutubeVideoListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["YoutubeVideoListWhere"],
	youtube?: GraphQLTypes["YoutubeVideoWhere"],
	and?: Array<GraphQLTypes["YoutubeVideoListItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["YoutubeVideoListItemWhere"] | undefined>,
	not?: GraphQLTypes["YoutubeVideoListItemWhere"]
};
	["YoutubeVideoListItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["YoutubeVideoListOrderBy"],
	youtube?: GraphQLTypes["YoutubeVideoOrderBy"]
};
	["YoutubeVideoListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["YoutubeVideoListItemsByYoutubeUniqueWhere"]: {
		youtube?: GraphQLTypes["YoutubeVideoUniqueWhere"]
};
	["YoutubeVideoListItemConnection"]: {
	__typename: "YoutubeVideoListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["YoutubeVideoListItemEdge"]>
};
	["YoutubeVideoListItemEdge"]: {
	__typename: "YoutubeVideoListItemEdge",
	node: GraphQLTypes["YoutubeVideoListItem"]
};
	["YoutubeVideoListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["YoutubeVideoListItemUniqueWhere"]
};
	["YoutubeVideoListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	youtube?: GraphQLTypes["YoutubeVideoUniqueWhere"]
};
	["YoutubeVideoListConnection"]: {
	__typename: "YoutubeVideoListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["YoutubeVideoListEdge"]>
};
	["YoutubeVideoListEdge"]: {
	__typename: "YoutubeVideoListEdge",
	node: GraphQLTypes["YoutubeVideoList"]
};
	["YoutubeVideoListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["YoutubeVideoListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["YoutubeVideoListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["YoutubeVideoListItemUniqueWhere"],
	create?: GraphQLTypes["YoutubeVideoListItemWithoutListCreateInput"],
	alias?: string
};
	["YoutubeVideoListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	youtube?: GraphQLTypes["YoutubeVideoListItemCreateYoutubeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["YoutubeVideoListItemCreateYoutubeEntityRelationInput"]: {
		connect?: GraphQLTypes["YoutubeVideoUniqueWhere"],
	create?: GraphQLTypes["YoutubeVideoCreateInput"]
};
	["YoutubeVideoListUpdateInput"]: {
		items?: Array<GraphQLTypes["YoutubeVideoListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["YoutubeVideoListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["YoutubeVideoListItemWithoutListCreateInput"],
	update?: GraphQLTypes["YoutubeVideoListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["YoutubeVideoListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["YoutubeVideoListItemUniqueWhere"],
	disconnect?: GraphQLTypes["YoutubeVideoListItemUniqueWhere"],
	delete?: GraphQLTypes["YoutubeVideoListItemUniqueWhere"],
	alias?: string
};
	["YoutubeVideoListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["YoutubeVideoListItemUniqueWhere"],
	data?: GraphQLTypes["YoutubeVideoListItemWithoutListUpdateInput"]
};
	["YoutubeVideoListItemWithoutListUpdateInput"]: {
		order?: number,
	youtube?: GraphQLTypes["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"]: {
		create?: GraphQLTypes["YoutubeVideoCreateInput"],
	update?: GraphQLTypes["YoutubeVideoUpdateInput"],
	upsert?: GraphQLTypes["YoutubeVideoListItemUpsertYoutubeRelationInput"],
	connect?: GraphQLTypes["YoutubeVideoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["YoutubeVideoListItemUpsertYoutubeRelationInput"]: {
		update?: GraphQLTypes["YoutubeVideoUpdateInput"],
	create?: GraphQLTypes["YoutubeVideoCreateInput"]
};
	["YoutubeVideoListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["YoutubeVideoListItemUniqueWhere"],
	update?: GraphQLTypes["YoutubeVideoListItemWithoutListUpdateInput"],
	create?: GraphQLTypes["YoutubeVideoListItemWithoutListCreateInput"]
};
	["YoutubeVideoListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["YoutubeVideoListItemCreateListEntityRelationInput"],
	youtube?: GraphQLTypes["YoutubeVideoListItemCreateYoutubeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["YoutubeVideoListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["YoutubeVideoListUniqueWhere"],
	create?: GraphQLTypes["YoutubeVideoListWithoutItemsCreateInput"]
};
	["YoutubeVideoListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["YoutubeVideoListItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["YoutubeVideoListItemUpdateListEntityRelationInput"],
	youtube?: GraphQLTypes["YoutubeVideoListItemUpdateYoutubeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["YoutubeVideoListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["YoutubeVideoListWithoutItemsCreateInput"],
	update?: GraphQLTypes["YoutubeVideoListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["YoutubeVideoListItemUpsertListRelationInput"],
	connect?: GraphQLTypes["YoutubeVideoListUniqueWhere"],
	delete?: boolean
};
	["YoutubeVideoListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["YoutubeVideoListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["YoutubeVideoListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["YoutubeVideoListWithoutItemsCreateInput"]
};
	["ImageList"]: {
	__typename: "ImageList",
	_meta?: GraphQLTypes["ImageListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageListItem"]>,
	itemsByImage?: GraphQLTypes["ImageListItem"],
	paginateItems: GraphQLTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
	__typename: "ImageListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ImageListItem"]: {
	__typename: "ImageListItem",
	_meta?: GraphQLTypes["ImageListItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ImageList"],
	image?: GraphQLTypes["Image"]
};
	["ImageListItemMeta"]: {
	__typename: "ImageListItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ImageListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ImageListItemWhere"],
	and?: Array<GraphQLTypes["ImageListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageListWhere"] | undefined>,
	not?: GraphQLTypes["ImageListWhere"]
};
	["ImageListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ImageListWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ImageListItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageListItemWhere"] | undefined>,
	not?: GraphQLTypes["ImageListItemWhere"]
};
	["ImageListItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ImageListOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ImageListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ImageListItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageListItemConnection"]: {
	__typename: "ImageListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListItemEdge"]>
};
	["ImageListItemEdge"]: {
	__typename: "ImageListItemEdge",
	node: GraphQLTypes["ImageListItem"]
};
	["ImageListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ImageListItemUniqueWhere"]
};
	["ImageListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageListConnection"]: {
	__typename: "ImageListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListEdge"]>
};
	["ImageListEdge"]: {
	__typename: "ImageListEdge",
	node: GraphQLTypes["ImageList"]
};
	["ImageListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ImageListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListItemUniqueWhere"],
	create?: GraphQLTypes["ImageListItemWithoutListCreateInput"],
	alias?: string
};
	["ImageListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageListUpdateInput"]: {
		items?: Array<GraphQLTypes["ImageListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListItemWithoutListCreateInput"],
	update?: GraphQLTypes["ImageListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ImageListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ImageListItemUniqueWhere"],
	disconnect?: GraphQLTypes["ImageListItemUniqueWhere"],
	delete?: GraphQLTypes["ImageListItemUniqueWhere"],
	alias?: string
};
	["ImageListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ImageListItemUniqueWhere"],
	data?: GraphQLTypes["ImageListItemWithoutListUpdateInput"]
};
	["ImageListItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ImageListItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageListItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ImageListItemUniqueWhere"],
	update?: GraphQLTypes["ImageListItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ImageListItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"],
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["ImageListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ImageListItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ImageListItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ImageListItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ImageListUniqueWhere"],
	delete?: boolean
};
	["ImageListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ImageListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["CitationItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	list?: GraphQLTypes["CitationItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["CitationItemCreateImageEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["CitationItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["CitationListUniqueWhere"],
	create?: GraphQLTypes["CitationListWithoutItemsCreateInput"]
};
	["CitationListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["CitationItemUpdateInput"]: {
		title?: string,
	text?: string,
	list?: GraphQLTypes["CitationItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["CitationItemUpdateImageEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["CitationItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["CitationListWithoutItemsCreateInput"],
	update?: GraphQLTypes["CitationListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["CitationItemUpsertListRelationInput"],
	connect?: GraphQLTypes["CitationListUniqueWhere"],
	delete?: boolean
};
	["CitationListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["CitationItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["CitationListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["CitationListWithoutItemsCreateInput"]
};
	["CitationListConnection"]: {
	__typename: "CitationListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CitationListEdge"]>
};
	["CitationListEdge"]: {
	__typename: "CitationListEdge",
	node: GraphQLTypes["CitationList"]
};
	["ContentImageLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ContentImageLinkItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["ContentImageLinkItemCreateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentImageLinkItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentImageLinkListUniqueWhere"],
	create?: GraphQLTypes["ContentImageLinkListWithoutItemsCreateInput"]
};
	["ContentImageLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["ContentImageLinkListCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ContentImageLinkItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["ContentImageLinkItemUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentImageLinkItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ContentImageLinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ContentImageLinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ContentImageLinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ContentImageLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentImageLinkListWithoutItemsUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["ContentImageLinkListUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentImageLinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ContentImageLinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ContentImageLinkListWithoutItemsCreateInput"]
};
	["ContentImageLinkListConnection"]: {
	__typename: "ContentImageLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentImageLinkListEdge"]>
};
	["ContentImageLinkListEdge"]: {
	__typename: "ContentImageLinkListEdge",
	node: GraphQLTypes["ContentImageLinkList"]
};
	["NewsConnection"]: {
	__typename: "NewsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsEdge"]>
};
	["NewsEdge"]: {
	__typename: "NewsEdge",
	node: GraphQLTypes["News"]
};
	["NewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	publishDate?: GraphQLTypes["DateTime"],
	title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["NewsCreateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["NewsCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["NewsCreateSeoEntityRelationInput"],
	order?: number,
	link?: GraphQLTypes["NewsCreateLinkEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["NewsCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutNewsCreateInput"]
};
	["LinkableWithoutNewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsUpdateInput"]: {
		publishDate?: GraphQLTypes["DateTime"],
	title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["NewsUpdateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["NewsUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["NewsUpdateSeoEntityRelationInput"],
	order?: number,
	link?: GraphQLTypes["NewsUpdateLinkEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["NewsUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutNewsCreateInput"],
	update?: GraphQLTypes["LinkableWithoutNewsUpdateInput"],
	upsert?: GraphQLTypes["NewsUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutNewsUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutNewsUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutNewsCreateInput"]
};
	["StoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["StoriesCreateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["StoriesCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["StoriesCreateSeoEntityRelationInput"],
	order?: number,
	link?: GraphQLTypes["StoriesCreateLinkEntityRelationInput"],
	list?: GraphQLTypes["StoriesCreateListEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["StoriesUpdateInput"]: {
		title?: string,
	perex?: string,
	coverImage?: GraphQLTypes["StoriesUpdateCoverImageEntityRelationInput"],
	content?: GraphQLTypes["StoriesUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["StoriesUpdateSeoEntityRelationInput"],
	order?: number,
	link?: GraphQLTypes["StoriesUpdateLinkEntityRelationInput"],
	list?: GraphQLTypes["StoriesUpdateListEntityRelationInput"],
	isDraft?: boolean,
	_dummy_field_?: boolean
};
	["NewsPageConnection"]: {
	__typename: "NewsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsPageEdge"]>
};
	["NewsPageEdge"]: {
	__typename: "NewsPageEdge",
	node: GraphQLTypes["NewsPage"]
};
	["NewsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["NewsPageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["NewsPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutNewsPageCreateInput"]
};
	["LinkableWithoutNewsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableCreateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["NewsPageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["NewsPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutNewsPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutNewsPageUpdateInput"],
	upsert?: GraphQLTypes["NewsPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutNewsPageUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	storiesPage?: GraphQLTypes["LinkableUpdateStoriesPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutNewsPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutNewsPageCreateInput"]
};
	["StoriesPageConnection"]: {
	__typename: "StoriesPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoriesPageEdge"]>
};
	["StoriesPageEdge"]: {
	__typename: "StoriesPageEdge",
	node: GraphQLTypes["StoriesPage"]
};
	["StoriesPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["StoriesPageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["StoriesPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StoriesPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutStoriesPageCreateInput"]
};
	["LinkableWithoutStoriesPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	program?: GraphQLTypes["LinkableCreateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableCreateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableCreateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableCreateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableCreateStoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StoriesPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	leadParagraph?: string,
	link?: GraphQLTypes["StoriesPageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["StoriesPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StoriesPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutStoriesPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutStoriesPageUpdateInput"],
	upsert?: GraphQLTypes["StoriesPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutStoriesPageUpdateInput"]: {
		url?: string,
	program?: GraphQLTypes["LinkableUpdateProgramEntityRelationInput"],
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	programPage?: GraphQLTypes["LinkableUpdateProgramPageEntityRelationInput"],
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	newsPage?: GraphQLTypes["LinkableUpdateNewsPageEntityRelationInput"],
	news?: GraphQLTypes["LinkableUpdateNewsEntityRelationInput"],
	story?: GraphQLTypes["LinkableUpdateStoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StoriesPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutStoriesPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutStoriesPageCreateInput"]
};
	["StoriesListConnection"]: {
	__typename: "StoriesListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoriesListEdge"]>
};
	["StoriesListEdge"]: {
	__typename: "StoriesListEdge",
	node: GraphQLTypes["StoriesList"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getFallbackSeo?: GraphQLTypes["FallbackSeo"],
	listFallbackSeo: Array<GraphQLTypes["FallbackSeo"]>,
	paginateFallbackSeo: GraphQLTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateFallbackSeo: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getProgram?: GraphQLTypes["Program"],
	listProgram: Array<GraphQLTypes["Program"]>,
	paginateProgram: GraphQLTypes["ProgramConnection"],
	validateCreateProgram: GraphQLTypes["_ValidationResult"],
	validateUpdateProgram: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getYoutubeVideo?: GraphQLTypes["YoutubeVideo"],
	listYoutubeVideo: Array<GraphQLTypes["YoutubeVideo"]>,
	paginateYoutubeVideo: GraphQLTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getBulletPoint?: GraphQLTypes["BulletPoint"],
	listBulletPoint: Array<GraphQLTypes["BulletPoint"]>,
	paginateBulletPoint: GraphQLTypes["BulletPointConnection"],
	validateCreateBulletPoint: GraphQLTypes["_ValidationResult"],
	validateUpdateBulletPoint: GraphQLTypes["_ValidationResult"],
	getBulletPointItem?: GraphQLTypes["BulletPointItem"],
	listBulletPointItem: Array<GraphQLTypes["BulletPointItem"]>,
	paginateBulletPointItem: GraphQLTypes["BulletPointItemConnection"],
	validateCreateBulletPointItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBulletPointItem: GraphQLTypes["_ValidationResult"],
	getFileItem?: GraphQLTypes["FileItem"],
	listFileItem: Array<GraphQLTypes["FileItem"]>,
	paginateFileItem: GraphQLTypes["FileItemConnection"],
	validateCreateFileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFileItem: GraphQLTypes["_ValidationResult"],
	getFileList?: GraphQLTypes["FileList"],
	listFileList: Array<GraphQLTypes["FileList"]>,
	paginateFileList: GraphQLTypes["FileListConnection"],
	validateCreateFileList: GraphQLTypes["_ValidationResult"],
	validateUpdateFileList: GraphQLTypes["_ValidationResult"],
	getFooterLink?: GraphQLTypes["FooterLink"],
	listFooterLink: Array<GraphQLTypes["FooterLink"]>,
	paginateFooterLink: GraphQLTypes["FooterLinkConnection"],
	validateCreateFooterLink: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLink: GraphQLTypes["_ValidationResult"],
	getFooterLinkGroups?: GraphQLTypes["FooterLinkGroups"],
	listFooterLinkGroups: Array<GraphQLTypes["FooterLinkGroups"]>,
	paginateFooterLinkGroups: GraphQLTypes["FooterLinkGroupsConnection"],
	validateCreateFooterLinkGroups: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLinkGroups: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"],
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"],
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getProgramPage?: GraphQLTypes["ProgramPage"],
	listProgramPage: Array<GraphQLTypes["ProgramPage"]>,
	paginateProgramPage: GraphQLTypes["ProgramPageConnection"],
	validateCreateProgramPage: GraphQLTypes["_ValidationResult"],
	validateUpdateProgramPage: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"],
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getStaff?: GraphQLTypes["Staff"],
	listStaff: Array<GraphQLTypes["Staff"]>,
	paginateStaff: GraphQLTypes["StaffConnection"],
	validateCreateStaff: GraphQLTypes["_ValidationResult"],
	validateUpdateStaff: GraphQLTypes["_ValidationResult"],
	getStaffItem?: GraphQLTypes["StaffItem"],
	listStaffItem: Array<GraphQLTypes["StaffItem"]>,
	paginateStaffItem: GraphQLTypes["StaffItemConnection"],
	validateCreateStaffItem: GraphQLTypes["_ValidationResult"],
	validateUpdateStaffItem: GraphQLTypes["_ValidationResult"],
	getStaffList?: GraphQLTypes["StaffList"],
	listStaffList: Array<GraphQLTypes["StaffList"]>,
	paginateStaffList: GraphQLTypes["StaffListConnection"],
	validateCreateStaffList: GraphQLTypes["_ValidationResult"],
	validateUpdateStaffList: GraphQLTypes["_ValidationResult"],
	getIcon?: GraphQLTypes["Icon"],
	listIcon: Array<GraphQLTypes["Icon"]>,
	paginateIcon: GraphQLTypes["IconConnection"],
	validateCreateIcon: GraphQLTypes["_ValidationResult"],
	validateUpdateIcon: GraphQLTypes["_ValidationResult"],
	getPrincipleItem?: GraphQLTypes["PrincipleItem"],
	listPrincipleItem: Array<GraphQLTypes["PrincipleItem"]>,
	paginatePrincipleItem: GraphQLTypes["PrincipleItemConnection"],
	validateCreatePrincipleItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePrincipleItem: GraphQLTypes["_ValidationResult"],
	getPrincipleList?: GraphQLTypes["PrincipleList"],
	listPrincipleList: Array<GraphQLTypes["PrincipleList"]>,
	paginatePrincipleList: GraphQLTypes["PrincipleListConnection"],
	validateCreatePrincipleList: GraphQLTypes["_ValidationResult"],
	validateUpdatePrincipleList: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"],
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"],
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkSubGroup?: GraphQLTypes["LinkSubGroup"],
	listLinkSubGroup: Array<GraphQLTypes["LinkSubGroup"]>,
	paginateLinkSubGroup: GraphQLTypes["LinkSubGroupConnection"],
	validateCreateLinkSubGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkSubGroup: GraphQLTypes["_ValidationResult"],
	getYoutubeVideoList?: GraphQLTypes["YoutubeVideoList"],
	listYoutubeVideoList: Array<GraphQLTypes["YoutubeVideoList"]>,
	paginateYoutubeVideoList: GraphQLTypes["YoutubeVideoListConnection"],
	validateCreateYoutubeVideoList: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideoList: GraphQLTypes["_ValidationResult"],
	getYoutubeVideoListItem?: GraphQLTypes["YoutubeVideoListItem"],
	listYoutubeVideoListItem: Array<GraphQLTypes["YoutubeVideoListItem"]>,
	paginateYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemConnection"],
	validateCreateYoutubeVideoListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideoListItem: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"],
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"],
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getCitationItem?: GraphQLTypes["CitationItem"],
	listCitationItem: Array<GraphQLTypes["CitationItem"]>,
	paginateCitationItem: GraphQLTypes["CitationItemConnection"],
	validateCreateCitationItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCitationItem: GraphQLTypes["_ValidationResult"],
	getCitationList?: GraphQLTypes["CitationList"],
	listCitationList: Array<GraphQLTypes["CitationList"]>,
	paginateCitationList: GraphQLTypes["CitationListConnection"],
	validateCreateCitationList: GraphQLTypes["_ValidationResult"],
	validateUpdateCitationList: GraphQLTypes["_ValidationResult"],
	getContentImageLinkItem?: GraphQLTypes["ContentImageLinkItem"],
	listContentImageLinkItem: Array<GraphQLTypes["ContentImageLinkItem"]>,
	paginateContentImageLinkItem: GraphQLTypes["ContentImageLinkItemConnection"],
	validateCreateContentImageLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateContentImageLinkItem: GraphQLTypes["_ValidationResult"],
	getContentImageLinkList?: GraphQLTypes["ContentImageLinkList"],
	listContentImageLinkList: Array<GraphQLTypes["ContentImageLinkList"]>,
	paginateContentImageLinkList: GraphQLTypes["ContentImageLinkListConnection"],
	validateCreateContentImageLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateContentImageLinkList: GraphQLTypes["_ValidationResult"],
	getNews?: GraphQLTypes["News"],
	listNews: Array<GraphQLTypes["News"]>,
	paginateNews: GraphQLTypes["NewsConnection"],
	validateCreateNews: GraphQLTypes["_ValidationResult"],
	validateUpdateNews: GraphQLTypes["_ValidationResult"],
	getStories?: GraphQLTypes["Stories"],
	listStories: Array<GraphQLTypes["Stories"]>,
	paginateStories: GraphQLTypes["StoriesConnection"],
	validateCreateStories: GraphQLTypes["_ValidationResult"],
	validateUpdateStories: GraphQLTypes["_ValidationResult"],
	getNewsPage?: GraphQLTypes["NewsPage"],
	listNewsPage: Array<GraphQLTypes["NewsPage"]>,
	paginateNewsPage: GraphQLTypes["NewsPageConnection"],
	validateCreateNewsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsPage: GraphQLTypes["_ValidationResult"],
	getStoriesPage?: GraphQLTypes["StoriesPage"],
	listStoriesPage: Array<GraphQLTypes["StoriesPage"]>,
	paginateStoriesPage: GraphQLTypes["StoriesPageConnection"],
	validateCreateStoriesPage: GraphQLTypes["_ValidationResult"],
	validateUpdateStoriesPage: GraphQLTypes["_ValidationResult"],
	getStoriesList?: GraphQLTypes["StoriesList"],
	listStoriesList: Array<GraphQLTypes["StoriesList"]>,
	paginateStoriesList: GraphQLTypes["StoriesListConnection"],
	validateCreateStoriesList: GraphQLTypes["_ValidationResult"],
	validateUpdateStoriesList: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createFallbackSeo: GraphQLTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo: GraphQLTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo: GraphQLTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo: GraphQLTypes["FallbackSeoUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createProgram: GraphQLTypes["ProgramCreateResult"],
	deleteProgram: GraphQLTypes["ProgramDeleteResult"],
	updateProgram: GraphQLTypes["ProgramUpdateResult"],
	upsertProgram: GraphQLTypes["ProgramUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createYoutubeVideo: GraphQLTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo: GraphQLTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo: GraphQLTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo: GraphQLTypes["YoutubeVideoUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createBulletPoint: GraphQLTypes["BulletPointCreateResult"],
	deleteBulletPoint: GraphQLTypes["BulletPointDeleteResult"],
	updateBulletPoint: GraphQLTypes["BulletPointUpdateResult"],
	upsertBulletPoint: GraphQLTypes["BulletPointUpsertResult"],
	createBulletPointItem: GraphQLTypes["BulletPointItemCreateResult"],
	deleteBulletPointItem: GraphQLTypes["BulletPointItemDeleteResult"],
	updateBulletPointItem: GraphQLTypes["BulletPointItemUpdateResult"],
	upsertBulletPointItem: GraphQLTypes["BulletPointItemUpsertResult"],
	createFileItem: GraphQLTypes["FileItemCreateResult"],
	deleteFileItem: GraphQLTypes["FileItemDeleteResult"],
	updateFileItem: GraphQLTypes["FileItemUpdateResult"],
	upsertFileItem: GraphQLTypes["FileItemUpsertResult"],
	createFileList: GraphQLTypes["FileListCreateResult"],
	deleteFileList: GraphQLTypes["FileListDeleteResult"],
	updateFileList: GraphQLTypes["FileListUpdateResult"],
	upsertFileList: GraphQLTypes["FileListUpsertResult"],
	createFooterLink: GraphQLTypes["FooterLinkCreateResult"],
	deleteFooterLink: GraphQLTypes["FooterLinkDeleteResult"],
	updateFooterLink: GraphQLTypes["FooterLinkUpdateResult"],
	upsertFooterLink: GraphQLTypes["FooterLinkUpsertResult"],
	createFooterLinkGroups: GraphQLTypes["FooterLinkGroupsCreateResult"],
	deleteFooterLinkGroups: GraphQLTypes["FooterLinkGroupsDeleteResult"],
	updateFooterLinkGroups: GraphQLTypes["FooterLinkGroupsUpdateResult"],
	upsertFooterLinkGroups: GraphQLTypes["FooterLinkGroupsUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createProgramPage: GraphQLTypes["ProgramPageCreateResult"],
	deleteProgramPage: GraphQLTypes["ProgramPageDeleteResult"],
	updateProgramPage: GraphQLTypes["ProgramPageUpdateResult"],
	upsertProgramPage: GraphQLTypes["ProgramPageUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createStaff: GraphQLTypes["StaffCreateResult"],
	deleteStaff: GraphQLTypes["StaffDeleteResult"],
	updateStaff: GraphQLTypes["StaffUpdateResult"],
	upsertStaff: GraphQLTypes["StaffUpsertResult"],
	createStaffItem: GraphQLTypes["StaffItemCreateResult"],
	deleteStaffItem: GraphQLTypes["StaffItemDeleteResult"],
	updateStaffItem: GraphQLTypes["StaffItemUpdateResult"],
	upsertStaffItem: GraphQLTypes["StaffItemUpsertResult"],
	createStaffList: GraphQLTypes["StaffListCreateResult"],
	deleteStaffList: GraphQLTypes["StaffListDeleteResult"],
	updateStaffList: GraphQLTypes["StaffListUpdateResult"],
	upsertStaffList: GraphQLTypes["StaffListUpsertResult"],
	createIcon: GraphQLTypes["IconCreateResult"],
	deleteIcon: GraphQLTypes["IconDeleteResult"],
	updateIcon: GraphQLTypes["IconUpdateResult"],
	upsertIcon: GraphQLTypes["IconUpsertResult"],
	createPrincipleItem: GraphQLTypes["PrincipleItemCreateResult"],
	deletePrincipleItem: GraphQLTypes["PrincipleItemDeleteResult"],
	updatePrincipleItem: GraphQLTypes["PrincipleItemUpdateResult"],
	upsertPrincipleItem: GraphQLTypes["PrincipleItemUpsertResult"],
	createPrincipleList: GraphQLTypes["PrincipleListCreateResult"],
	deletePrincipleList: GraphQLTypes["PrincipleListDeleteResult"],
	updatePrincipleList: GraphQLTypes["PrincipleListUpdateResult"],
	upsertPrincipleList: GraphQLTypes["PrincipleListUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkSubGroup: GraphQLTypes["LinkSubGroupCreateResult"],
	deleteLinkSubGroup: GraphQLTypes["LinkSubGroupDeleteResult"],
	updateLinkSubGroup: GraphQLTypes["LinkSubGroupUpdateResult"],
	upsertLinkSubGroup: GraphQLTypes["LinkSubGroupUpsertResult"],
	createYoutubeVideoList: GraphQLTypes["YoutubeVideoListCreateResult"],
	deleteYoutubeVideoList: GraphQLTypes["YoutubeVideoListDeleteResult"],
	updateYoutubeVideoList: GraphQLTypes["YoutubeVideoListUpdateResult"],
	upsertYoutubeVideoList: GraphQLTypes["YoutubeVideoListUpsertResult"],
	createYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemCreateResult"],
	deleteYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemDeleteResult"],
	updateYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemUpdateResult"],
	upsertYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createCitationItem: GraphQLTypes["CitationItemCreateResult"],
	deleteCitationItem: GraphQLTypes["CitationItemDeleteResult"],
	updateCitationItem: GraphQLTypes["CitationItemUpdateResult"],
	upsertCitationItem: GraphQLTypes["CitationItemUpsertResult"],
	createCitationList: GraphQLTypes["CitationListCreateResult"],
	deleteCitationList: GraphQLTypes["CitationListDeleteResult"],
	updateCitationList: GraphQLTypes["CitationListUpdateResult"],
	upsertCitationList: GraphQLTypes["CitationListUpsertResult"],
	createContentImageLinkItem: GraphQLTypes["ContentImageLinkItemCreateResult"],
	deleteContentImageLinkItem: GraphQLTypes["ContentImageLinkItemDeleteResult"],
	updateContentImageLinkItem: GraphQLTypes["ContentImageLinkItemUpdateResult"],
	upsertContentImageLinkItem: GraphQLTypes["ContentImageLinkItemUpsertResult"],
	createContentImageLinkList: GraphQLTypes["ContentImageLinkListCreateResult"],
	deleteContentImageLinkList: GraphQLTypes["ContentImageLinkListDeleteResult"],
	updateContentImageLinkList: GraphQLTypes["ContentImageLinkListUpdateResult"],
	upsertContentImageLinkList: GraphQLTypes["ContentImageLinkListUpsertResult"],
	createNews: GraphQLTypes["NewsCreateResult"],
	deleteNews: GraphQLTypes["NewsDeleteResult"],
	updateNews: GraphQLTypes["NewsUpdateResult"],
	upsertNews: GraphQLTypes["NewsUpsertResult"],
	createStories: GraphQLTypes["StoriesCreateResult"],
	deleteStories: GraphQLTypes["StoriesDeleteResult"],
	updateStories: GraphQLTypes["StoriesUpdateResult"],
	upsertStories: GraphQLTypes["StoriesUpsertResult"],
	createNewsPage: GraphQLTypes["NewsPageCreateResult"],
	deleteNewsPage: GraphQLTypes["NewsPageDeleteResult"],
	updateNewsPage: GraphQLTypes["NewsPageUpdateResult"],
	upsertNewsPage: GraphQLTypes["NewsPageUpsertResult"],
	createStoriesPage: GraphQLTypes["StoriesPageCreateResult"],
	deleteStoriesPage: GraphQLTypes["StoriesPageDeleteResult"],
	updateStoriesPage: GraphQLTypes["StoriesPageUpdateResult"],
	upsertStoriesPage: GraphQLTypes["StoriesPageUpsertResult"],
	createStoriesList: GraphQLTypes["StoriesListCreateResult"],
	deleteStoriesList: GraphQLTypes["StoriesListDeleteResult"],
	updateStoriesList: GraphQLTypes["StoriesListUpdateResult"],
	upsertStoriesList: GraphQLTypes["StoriesListUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "FallbackSeoCreateResult" | "FallbackSeoDeleteResult" | "FallbackSeoUpdateResult" | "FallbackSeoUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "HomePageCreateResult" | "HomePageDeleteResult" | "HomePageUpdateResult" | "HomePageUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "ProgramCreateResult" | "ProgramDeleteResult" | "ProgramUpdateResult" | "ProgramUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult" | "YoutubeVideoCreateResult" | "YoutubeVideoDeleteResult" | "YoutubeVideoUpdateResult" | "YoutubeVideoUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "BulletPointCreateResult" | "BulletPointDeleteResult" | "BulletPointUpdateResult" | "BulletPointUpsertResult" | "BulletPointItemCreateResult" | "BulletPointItemDeleteResult" | "BulletPointItemUpdateResult" | "BulletPointItemUpsertResult" | "FileItemCreateResult" | "FileItemDeleteResult" | "FileItemUpdateResult" | "FileItemUpsertResult" | "FileListCreateResult" | "FileListDeleteResult" | "FileListUpdateResult" | "FileListUpsertResult" | "FooterLinkCreateResult" | "FooterLinkDeleteResult" | "FooterLinkUpdateResult" | "FooterLinkUpsertResult" | "FooterLinkGroupsCreateResult" | "FooterLinkGroupsDeleteResult" | "FooterLinkGroupsUpdateResult" | "FooterLinkGroupsUpsertResult" | "TextItemCreateResult" | "TextItemDeleteResult" | "TextItemUpdateResult" | "TextItemUpsertResult" | "TextListCreateResult" | "TextListDeleteResult" | "TextListUpdateResult" | "TextListUpsertResult" | "ProgramPageCreateResult" | "ProgramPageDeleteResult" | "ProgramPageUpdateResult" | "ProgramPageUpsertResult" | "GenericPageCreateResult" | "GenericPageDeleteResult" | "GenericPageUpdateResult" | "GenericPageUpsertResult" | "StaffCreateResult" | "StaffDeleteResult" | "StaffUpdateResult" | "StaffUpsertResult" | "StaffItemCreateResult" | "StaffItemDeleteResult" | "StaffItemUpdateResult" | "StaffItemUpsertResult" | "StaffListCreateResult" | "StaffListDeleteResult" | "StaffListUpdateResult" | "StaffListUpsertResult" | "IconCreateResult" | "IconDeleteResult" | "IconUpdateResult" | "IconUpsertResult" | "PrincipleItemCreateResult" | "PrincipleItemDeleteResult" | "PrincipleItemUpdateResult" | "PrincipleItemUpsertResult" | "PrincipleListCreateResult" | "PrincipleListDeleteResult" | "PrincipleListUpdateResult" | "PrincipleListUpsertResult" | "LinkItemCreateResult" | "LinkItemDeleteResult" | "LinkItemUpdateResult" | "LinkItemUpsertResult" | "LinkListCreateResult" | "LinkListDeleteResult" | "LinkListUpdateResult" | "LinkListUpsertResult" | "LinkSubGroupCreateResult" | "LinkSubGroupDeleteResult" | "LinkSubGroupUpdateResult" | "LinkSubGroupUpsertResult" | "YoutubeVideoListCreateResult" | "YoutubeVideoListDeleteResult" | "YoutubeVideoListUpdateResult" | "YoutubeVideoListUpsertResult" | "YoutubeVideoListItemCreateResult" | "YoutubeVideoListItemDeleteResult" | "YoutubeVideoListItemUpdateResult" | "YoutubeVideoListItemUpsertResult" | "ImageListCreateResult" | "ImageListDeleteResult" | "ImageListUpdateResult" | "ImageListUpsertResult" | "ImageListItemCreateResult" | "ImageListItemDeleteResult" | "ImageListItemUpdateResult" | "ImageListItemUpsertResult" | "CitationItemCreateResult" | "CitationItemDeleteResult" | "CitationItemUpdateResult" | "CitationItemUpsertResult" | "CitationListCreateResult" | "CitationListDeleteResult" | "CitationListUpdateResult" | "CitationListUpsertResult" | "ContentImageLinkItemCreateResult" | "ContentImageLinkItemDeleteResult" | "ContentImageLinkItemUpdateResult" | "ContentImageLinkItemUpsertResult" | "ContentImageLinkListCreateResult" | "ContentImageLinkListDeleteResult" | "ContentImageLinkListUpdateResult" | "ContentImageLinkListUpsertResult" | "NewsCreateResult" | "NewsDeleteResult" | "NewsUpdateResult" | "NewsUpsertResult" | "StoriesCreateResult" | "StoriesDeleteResult" | "StoriesUpdateResult" | "StoriesUpsertResult" | "NewsPageCreateResult" | "NewsPageDeleteResult" | "NewsPageUpdateResult" | "NewsPageUpsertResult" | "StoriesPageCreateResult" | "StoriesPageDeleteResult" | "StoriesPageUpdateResult" | "StoriesPageUpsertResult" | "StoriesListCreateResult" | "StoriesListDeleteResult" | "StoriesListUpdateResult" | "StoriesListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on FallbackSeoCreateResult']: '__union' & GraphQLTypes["FallbackSeoCreateResult"];
	['...on FallbackSeoDeleteResult']: '__union' & GraphQLTypes["FallbackSeoDeleteResult"];
	['...on FallbackSeoUpdateResult']: '__union' & GraphQLTypes["FallbackSeoUpdateResult"];
	['...on FallbackSeoUpsertResult']: '__union' & GraphQLTypes["FallbackSeoUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on HomePageCreateResult']: '__union' & GraphQLTypes["HomePageCreateResult"];
	['...on HomePageDeleteResult']: '__union' & GraphQLTypes["HomePageDeleteResult"];
	['...on HomePageUpdateResult']: '__union' & GraphQLTypes["HomePageUpdateResult"];
	['...on HomePageUpsertResult']: '__union' & GraphQLTypes["HomePageUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on ProgramCreateResult']: '__union' & GraphQLTypes["ProgramCreateResult"];
	['...on ProgramDeleteResult']: '__union' & GraphQLTypes["ProgramDeleteResult"];
	['...on ProgramUpdateResult']: '__union' & GraphQLTypes["ProgramUpdateResult"];
	['...on ProgramUpsertResult']: '__union' & GraphQLTypes["ProgramUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
	['...on YoutubeVideoCreateResult']: '__union' & GraphQLTypes["YoutubeVideoCreateResult"];
	['...on YoutubeVideoDeleteResult']: '__union' & GraphQLTypes["YoutubeVideoDeleteResult"];
	['...on YoutubeVideoUpdateResult']: '__union' & GraphQLTypes["YoutubeVideoUpdateResult"];
	['...on YoutubeVideoUpsertResult']: '__union' & GraphQLTypes["YoutubeVideoUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on BulletPointCreateResult']: '__union' & GraphQLTypes["BulletPointCreateResult"];
	['...on BulletPointDeleteResult']: '__union' & GraphQLTypes["BulletPointDeleteResult"];
	['...on BulletPointUpdateResult']: '__union' & GraphQLTypes["BulletPointUpdateResult"];
	['...on BulletPointUpsertResult']: '__union' & GraphQLTypes["BulletPointUpsertResult"];
	['...on BulletPointItemCreateResult']: '__union' & GraphQLTypes["BulletPointItemCreateResult"];
	['...on BulletPointItemDeleteResult']: '__union' & GraphQLTypes["BulletPointItemDeleteResult"];
	['...on BulletPointItemUpdateResult']: '__union' & GraphQLTypes["BulletPointItemUpdateResult"];
	['...on BulletPointItemUpsertResult']: '__union' & GraphQLTypes["BulletPointItemUpsertResult"];
	['...on FileItemCreateResult']: '__union' & GraphQLTypes["FileItemCreateResult"];
	['...on FileItemDeleteResult']: '__union' & GraphQLTypes["FileItemDeleteResult"];
	['...on FileItemUpdateResult']: '__union' & GraphQLTypes["FileItemUpdateResult"];
	['...on FileItemUpsertResult']: '__union' & GraphQLTypes["FileItemUpsertResult"];
	['...on FileListCreateResult']: '__union' & GraphQLTypes["FileListCreateResult"];
	['...on FileListDeleteResult']: '__union' & GraphQLTypes["FileListDeleteResult"];
	['...on FileListUpdateResult']: '__union' & GraphQLTypes["FileListUpdateResult"];
	['...on FileListUpsertResult']: '__union' & GraphQLTypes["FileListUpsertResult"];
	['...on FooterLinkCreateResult']: '__union' & GraphQLTypes["FooterLinkCreateResult"];
	['...on FooterLinkDeleteResult']: '__union' & GraphQLTypes["FooterLinkDeleteResult"];
	['...on FooterLinkUpdateResult']: '__union' & GraphQLTypes["FooterLinkUpdateResult"];
	['...on FooterLinkUpsertResult']: '__union' & GraphQLTypes["FooterLinkUpsertResult"];
	['...on FooterLinkGroupsCreateResult']: '__union' & GraphQLTypes["FooterLinkGroupsCreateResult"];
	['...on FooterLinkGroupsDeleteResult']: '__union' & GraphQLTypes["FooterLinkGroupsDeleteResult"];
	['...on FooterLinkGroupsUpdateResult']: '__union' & GraphQLTypes["FooterLinkGroupsUpdateResult"];
	['...on FooterLinkGroupsUpsertResult']: '__union' & GraphQLTypes["FooterLinkGroupsUpsertResult"];
	['...on TextItemCreateResult']: '__union' & GraphQLTypes["TextItemCreateResult"];
	['...on TextItemDeleteResult']: '__union' & GraphQLTypes["TextItemDeleteResult"];
	['...on TextItemUpdateResult']: '__union' & GraphQLTypes["TextItemUpdateResult"];
	['...on TextItemUpsertResult']: '__union' & GraphQLTypes["TextItemUpsertResult"];
	['...on TextListCreateResult']: '__union' & GraphQLTypes["TextListCreateResult"];
	['...on TextListDeleteResult']: '__union' & GraphQLTypes["TextListDeleteResult"];
	['...on TextListUpdateResult']: '__union' & GraphQLTypes["TextListUpdateResult"];
	['...on TextListUpsertResult']: '__union' & GraphQLTypes["TextListUpsertResult"];
	['...on ProgramPageCreateResult']: '__union' & GraphQLTypes["ProgramPageCreateResult"];
	['...on ProgramPageDeleteResult']: '__union' & GraphQLTypes["ProgramPageDeleteResult"];
	['...on ProgramPageUpdateResult']: '__union' & GraphQLTypes["ProgramPageUpdateResult"];
	['...on ProgramPageUpsertResult']: '__union' & GraphQLTypes["ProgramPageUpsertResult"];
	['...on GenericPageCreateResult']: '__union' & GraphQLTypes["GenericPageCreateResult"];
	['...on GenericPageDeleteResult']: '__union' & GraphQLTypes["GenericPageDeleteResult"];
	['...on GenericPageUpdateResult']: '__union' & GraphQLTypes["GenericPageUpdateResult"];
	['...on GenericPageUpsertResult']: '__union' & GraphQLTypes["GenericPageUpsertResult"];
	['...on StaffCreateResult']: '__union' & GraphQLTypes["StaffCreateResult"];
	['...on StaffDeleteResult']: '__union' & GraphQLTypes["StaffDeleteResult"];
	['...on StaffUpdateResult']: '__union' & GraphQLTypes["StaffUpdateResult"];
	['...on StaffUpsertResult']: '__union' & GraphQLTypes["StaffUpsertResult"];
	['...on StaffItemCreateResult']: '__union' & GraphQLTypes["StaffItemCreateResult"];
	['...on StaffItemDeleteResult']: '__union' & GraphQLTypes["StaffItemDeleteResult"];
	['...on StaffItemUpdateResult']: '__union' & GraphQLTypes["StaffItemUpdateResult"];
	['...on StaffItemUpsertResult']: '__union' & GraphQLTypes["StaffItemUpsertResult"];
	['...on StaffListCreateResult']: '__union' & GraphQLTypes["StaffListCreateResult"];
	['...on StaffListDeleteResult']: '__union' & GraphQLTypes["StaffListDeleteResult"];
	['...on StaffListUpdateResult']: '__union' & GraphQLTypes["StaffListUpdateResult"];
	['...on StaffListUpsertResult']: '__union' & GraphQLTypes["StaffListUpsertResult"];
	['...on IconCreateResult']: '__union' & GraphQLTypes["IconCreateResult"];
	['...on IconDeleteResult']: '__union' & GraphQLTypes["IconDeleteResult"];
	['...on IconUpdateResult']: '__union' & GraphQLTypes["IconUpdateResult"];
	['...on IconUpsertResult']: '__union' & GraphQLTypes["IconUpsertResult"];
	['...on PrincipleItemCreateResult']: '__union' & GraphQLTypes["PrincipleItemCreateResult"];
	['...on PrincipleItemDeleteResult']: '__union' & GraphQLTypes["PrincipleItemDeleteResult"];
	['...on PrincipleItemUpdateResult']: '__union' & GraphQLTypes["PrincipleItemUpdateResult"];
	['...on PrincipleItemUpsertResult']: '__union' & GraphQLTypes["PrincipleItemUpsertResult"];
	['...on PrincipleListCreateResult']: '__union' & GraphQLTypes["PrincipleListCreateResult"];
	['...on PrincipleListDeleteResult']: '__union' & GraphQLTypes["PrincipleListDeleteResult"];
	['...on PrincipleListUpdateResult']: '__union' & GraphQLTypes["PrincipleListUpdateResult"];
	['...on PrincipleListUpsertResult']: '__union' & GraphQLTypes["PrincipleListUpsertResult"];
	['...on LinkItemCreateResult']: '__union' & GraphQLTypes["LinkItemCreateResult"];
	['...on LinkItemDeleteResult']: '__union' & GraphQLTypes["LinkItemDeleteResult"];
	['...on LinkItemUpdateResult']: '__union' & GraphQLTypes["LinkItemUpdateResult"];
	['...on LinkItemUpsertResult']: '__union' & GraphQLTypes["LinkItemUpsertResult"];
	['...on LinkListCreateResult']: '__union' & GraphQLTypes["LinkListCreateResult"];
	['...on LinkListDeleteResult']: '__union' & GraphQLTypes["LinkListDeleteResult"];
	['...on LinkListUpdateResult']: '__union' & GraphQLTypes["LinkListUpdateResult"];
	['...on LinkListUpsertResult']: '__union' & GraphQLTypes["LinkListUpsertResult"];
	['...on LinkSubGroupCreateResult']: '__union' & GraphQLTypes["LinkSubGroupCreateResult"];
	['...on LinkSubGroupDeleteResult']: '__union' & GraphQLTypes["LinkSubGroupDeleteResult"];
	['...on LinkSubGroupUpdateResult']: '__union' & GraphQLTypes["LinkSubGroupUpdateResult"];
	['...on LinkSubGroupUpsertResult']: '__union' & GraphQLTypes["LinkSubGroupUpsertResult"];
	['...on YoutubeVideoListCreateResult']: '__union' & GraphQLTypes["YoutubeVideoListCreateResult"];
	['...on YoutubeVideoListDeleteResult']: '__union' & GraphQLTypes["YoutubeVideoListDeleteResult"];
	['...on YoutubeVideoListUpdateResult']: '__union' & GraphQLTypes["YoutubeVideoListUpdateResult"];
	['...on YoutubeVideoListUpsertResult']: '__union' & GraphQLTypes["YoutubeVideoListUpsertResult"];
	['...on YoutubeVideoListItemCreateResult']: '__union' & GraphQLTypes["YoutubeVideoListItemCreateResult"];
	['...on YoutubeVideoListItemDeleteResult']: '__union' & GraphQLTypes["YoutubeVideoListItemDeleteResult"];
	['...on YoutubeVideoListItemUpdateResult']: '__union' & GraphQLTypes["YoutubeVideoListItemUpdateResult"];
	['...on YoutubeVideoListItemUpsertResult']: '__union' & GraphQLTypes["YoutubeVideoListItemUpsertResult"];
	['...on ImageListCreateResult']: '__union' & GraphQLTypes["ImageListCreateResult"];
	['...on ImageListDeleteResult']: '__union' & GraphQLTypes["ImageListDeleteResult"];
	['...on ImageListUpdateResult']: '__union' & GraphQLTypes["ImageListUpdateResult"];
	['...on ImageListUpsertResult']: '__union' & GraphQLTypes["ImageListUpsertResult"];
	['...on ImageListItemCreateResult']: '__union' & GraphQLTypes["ImageListItemCreateResult"];
	['...on ImageListItemDeleteResult']: '__union' & GraphQLTypes["ImageListItemDeleteResult"];
	['...on ImageListItemUpdateResult']: '__union' & GraphQLTypes["ImageListItemUpdateResult"];
	['...on ImageListItemUpsertResult']: '__union' & GraphQLTypes["ImageListItemUpsertResult"];
	['...on CitationItemCreateResult']: '__union' & GraphQLTypes["CitationItemCreateResult"];
	['...on CitationItemDeleteResult']: '__union' & GraphQLTypes["CitationItemDeleteResult"];
	['...on CitationItemUpdateResult']: '__union' & GraphQLTypes["CitationItemUpdateResult"];
	['...on CitationItemUpsertResult']: '__union' & GraphQLTypes["CitationItemUpsertResult"];
	['...on CitationListCreateResult']: '__union' & GraphQLTypes["CitationListCreateResult"];
	['...on CitationListDeleteResult']: '__union' & GraphQLTypes["CitationListDeleteResult"];
	['...on CitationListUpdateResult']: '__union' & GraphQLTypes["CitationListUpdateResult"];
	['...on CitationListUpsertResult']: '__union' & GraphQLTypes["CitationListUpsertResult"];
	['...on ContentImageLinkItemCreateResult']: '__union' & GraphQLTypes["ContentImageLinkItemCreateResult"];
	['...on ContentImageLinkItemDeleteResult']: '__union' & GraphQLTypes["ContentImageLinkItemDeleteResult"];
	['...on ContentImageLinkItemUpdateResult']: '__union' & GraphQLTypes["ContentImageLinkItemUpdateResult"];
	['...on ContentImageLinkItemUpsertResult']: '__union' & GraphQLTypes["ContentImageLinkItemUpsertResult"];
	['...on ContentImageLinkListCreateResult']: '__union' & GraphQLTypes["ContentImageLinkListCreateResult"];
	['...on ContentImageLinkListDeleteResult']: '__union' & GraphQLTypes["ContentImageLinkListDeleteResult"];
	['...on ContentImageLinkListUpdateResult']: '__union' & GraphQLTypes["ContentImageLinkListUpdateResult"];
	['...on ContentImageLinkListUpsertResult']: '__union' & GraphQLTypes["ContentImageLinkListUpsertResult"];
	['...on NewsCreateResult']: '__union' & GraphQLTypes["NewsCreateResult"];
	['...on NewsDeleteResult']: '__union' & GraphQLTypes["NewsDeleteResult"];
	['...on NewsUpdateResult']: '__union' & GraphQLTypes["NewsUpdateResult"];
	['...on NewsUpsertResult']: '__union' & GraphQLTypes["NewsUpsertResult"];
	['...on StoriesCreateResult']: '__union' & GraphQLTypes["StoriesCreateResult"];
	['...on StoriesDeleteResult']: '__union' & GraphQLTypes["StoriesDeleteResult"];
	['...on StoriesUpdateResult']: '__union' & GraphQLTypes["StoriesUpdateResult"];
	['...on StoriesUpsertResult']: '__union' & GraphQLTypes["StoriesUpsertResult"];
	['...on NewsPageCreateResult']: '__union' & GraphQLTypes["NewsPageCreateResult"];
	['...on NewsPageDeleteResult']: '__union' & GraphQLTypes["NewsPageDeleteResult"];
	['...on NewsPageUpdateResult']: '__union' & GraphQLTypes["NewsPageUpdateResult"];
	['...on NewsPageUpsertResult']: '__union' & GraphQLTypes["NewsPageUpsertResult"];
	['...on StoriesPageCreateResult']: '__union' & GraphQLTypes["StoriesPageCreateResult"];
	['...on StoriesPageDeleteResult']: '__union' & GraphQLTypes["StoriesPageDeleteResult"];
	['...on StoriesPageUpdateResult']: '__union' & GraphQLTypes["StoriesPageUpdateResult"];
	['...on StoriesPageUpsertResult']: '__union' & GraphQLTypes["StoriesPageUpsertResult"];
	['...on StoriesListCreateResult']: '__union' & GraphQLTypes["StoriesListCreateResult"];
	['...on StoriesListDeleteResult']: '__union' & GraphQLTypes["StoriesListDeleteResult"];
	['...on StoriesListUpdateResult']: '__union' & GraphQLTypes["StoriesListUpdateResult"];
	['...on StoriesListUpsertResult']: '__union' & GraphQLTypes["StoriesListUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"]
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoCreateResult"]: {
	__typename: "FallbackSeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoDeleteResult"]: {
	__typename: "FallbackSeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"]
};
	["FallbackSeoUpdateResult"]: {
	__typename: "FallbackSeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoUpsertResult"]: {
	__typename: "FallbackSeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"]
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"]
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
	__typename: "HomePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
	__typename: "HomePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
	__typename: "HomePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
	__typename: "HomePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProgramCreateResult"]: {
	__typename: "ProgramCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Program"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProgramDeleteResult"]: {
	__typename: "ProgramDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Program"]
};
	["ProgramUpdateResult"]: {
	__typename: "ProgramUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Program"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProgramUpsertResult"]: {
	__typename: "ProgramUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Program"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoCreateResult"]: {
	__typename: "YoutubeVideoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoDeleteResult"]: {
	__typename: "YoutubeVideoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"]
};
	["YoutubeVideoUpdateResult"]: {
	__typename: "YoutubeVideoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoUpsertResult"]: {
	__typename: "YoutubeVideoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BulletPointCreateResult"]: {
	__typename: "BulletPointCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPoint"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BulletPointDeleteResult"]: {
	__typename: "BulletPointDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPoint"]
};
	["BulletPointUpdateResult"]: {
	__typename: "BulletPointUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPoint"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BulletPointUpsertResult"]: {
	__typename: "BulletPointUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPoint"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BulletPointItemCreateResult"]: {
	__typename: "BulletPointItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPointItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BulletPointItemDeleteResult"]: {
	__typename: "BulletPointItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPointItem"]
};
	["BulletPointItemUpdateResult"]: {
	__typename: "BulletPointItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPointItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BulletPointItemUpsertResult"]: {
	__typename: "BulletPointItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BulletPointItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileItemCreateResult"]: {
	__typename: "FileItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileItemDeleteResult"]: {
	__typename: "FileItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileItem"]
};
	["FileItemUpdateResult"]: {
	__typename: "FileItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileItemUpsertResult"]: {
	__typename: "FileItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileListCreateResult"]: {
	__typename: "FileListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileListDeleteResult"]: {
	__typename: "FileListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileList"]
};
	["FileListUpdateResult"]: {
	__typename: "FileListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileListUpsertResult"]: {
	__typename: "FileListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkCreateResult"]: {
	__typename: "FooterLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkDeleteResult"]: {
	__typename: "FooterLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"]
};
	["FooterLinkUpdateResult"]: {
	__typename: "FooterLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkUpsertResult"]: {
	__typename: "FooterLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkGroupsCreateResult"]: {
	__typename: "FooterLinkGroupsCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinkGroups"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkGroupsDeleteResult"]: {
	__typename: "FooterLinkGroupsDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinkGroups"]
};
	["FooterLinkGroupsUpdateResult"]: {
	__typename: "FooterLinkGroupsUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinkGroups"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkGroupsUpsertResult"]: {
	__typename: "FooterLinkGroupsUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinkGroups"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemCreateResult"]: {
	__typename: "TextItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemDeleteResult"]: {
	__typename: "TextItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"]
};
	["TextItemUpdateResult"]: {
	__typename: "TextItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemUpsertResult"]: {
	__typename: "TextItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListCreateResult"]: {
	__typename: "TextListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListDeleteResult"]: {
	__typename: "TextListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"]
};
	["TextListUpdateResult"]: {
	__typename: "TextListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListUpsertResult"]: {
	__typename: "TextListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProgramPageCreateResult"]: {
	__typename: "ProgramPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProgramPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProgramPageDeleteResult"]: {
	__typename: "ProgramPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProgramPage"]
};
	["ProgramPageUpdateResult"]: {
	__typename: "ProgramPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProgramPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProgramPageUpsertResult"]: {
	__typename: "ProgramPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProgramPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
	__typename: "GenericPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
	__typename: "GenericPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"]
};
	["GenericPageUpdateResult"]: {
	__typename: "GenericPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
	__typename: "GenericPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffCreateResult"]: {
	__typename: "StaffCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffDeleteResult"]: {
	__typename: "StaffDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"]
};
	["StaffUpdateResult"]: {
	__typename: "StaffUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffUpsertResult"]: {
	__typename: "StaffUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffItemCreateResult"]: {
	__typename: "StaffItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffItemDeleteResult"]: {
	__typename: "StaffItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffItem"]
};
	["StaffItemUpdateResult"]: {
	__typename: "StaffItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffItemUpsertResult"]: {
	__typename: "StaffItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffListCreateResult"]: {
	__typename: "StaffListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffListDeleteResult"]: {
	__typename: "StaffListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffList"]
};
	["StaffListUpdateResult"]: {
	__typename: "StaffListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffListUpsertResult"]: {
	__typename: "StaffListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StaffList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IconCreateResult"]: {
	__typename: "IconCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IconDeleteResult"]: {
	__typename: "IconDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"]
};
	["IconUpdateResult"]: {
	__typename: "IconUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IconUpsertResult"]: {
	__typename: "IconUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrincipleItemCreateResult"]: {
	__typename: "PrincipleItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrincipleItemDeleteResult"]: {
	__typename: "PrincipleItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleItem"]
};
	["PrincipleItemUpdateResult"]: {
	__typename: "PrincipleItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrincipleItemUpsertResult"]: {
	__typename: "PrincipleItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrincipleListCreateResult"]: {
	__typename: "PrincipleListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrincipleListDeleteResult"]: {
	__typename: "PrincipleListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleList"]
};
	["PrincipleListUpdateResult"]: {
	__typename: "PrincipleListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrincipleListUpsertResult"]: {
	__typename: "PrincipleListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrincipleList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
	__typename: "LinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
	__typename: "LinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"]
};
	["LinkItemUpdateResult"]: {
	__typename: "LinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
	__typename: "LinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
	__typename: "LinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
	__typename: "LinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"]
};
	["LinkListUpdateResult"]: {
	__typename: "LinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
	__typename: "LinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkSubGroupCreateResult"]: {
	__typename: "LinkSubGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSubGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkSubGroupDeleteResult"]: {
	__typename: "LinkSubGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSubGroup"]
};
	["LinkSubGroupUpdateResult"]: {
	__typename: "LinkSubGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSubGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkSubGroupUpsertResult"]: {
	__typename: "LinkSubGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSubGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoListCreateResult"]: {
	__typename: "YoutubeVideoListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoListDeleteResult"]: {
	__typename: "YoutubeVideoListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoList"]
};
	["YoutubeVideoListUpdateResult"]: {
	__typename: "YoutubeVideoListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoListUpsertResult"]: {
	__typename: "YoutubeVideoListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoListItemCreateResult"]: {
	__typename: "YoutubeVideoListItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoListItemDeleteResult"]: {
	__typename: "YoutubeVideoListItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoListItem"]
};
	["YoutubeVideoListItemUpdateResult"]: {
	__typename: "YoutubeVideoListItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoListItemUpsertResult"]: {
	__typename: "YoutubeVideoListItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideoListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
	__typename: "ImageListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
	__typename: "ImageListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"]
};
	["ImageListUpdateResult"]: {
	__typename: "ImageListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
	__typename: "ImageListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
	__typename: "ImageListItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
	__typename: "ImageListItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"]
};
	["ImageListItemUpdateResult"]: {
	__typename: "ImageListItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
	__typename: "ImageListItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CitationItemCreateResult"]: {
	__typename: "CitationItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CitationItemDeleteResult"]: {
	__typename: "CitationItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationItem"]
};
	["CitationItemUpdateResult"]: {
	__typename: "CitationItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CitationItemUpsertResult"]: {
	__typename: "CitationItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CitationListCreateResult"]: {
	__typename: "CitationListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CitationListDeleteResult"]: {
	__typename: "CitationListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationList"]
};
	["CitationListUpdateResult"]: {
	__typename: "CitationListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CitationListUpsertResult"]: {
	__typename: "CitationListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CitationList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentImageLinkItemCreateResult"]: {
	__typename: "ContentImageLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentImageLinkItemDeleteResult"]: {
	__typename: "ContentImageLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkItem"]
};
	["ContentImageLinkItemUpdateResult"]: {
	__typename: "ContentImageLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentImageLinkItemUpsertResult"]: {
	__typename: "ContentImageLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentImageLinkListCreateResult"]: {
	__typename: "ContentImageLinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentImageLinkListDeleteResult"]: {
	__typename: "ContentImageLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkList"]
};
	["ContentImageLinkListUpdateResult"]: {
	__typename: "ContentImageLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentImageLinkListUpsertResult"]: {
	__typename: "ContentImageLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentImageLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsCreateResult"]: {
	__typename: "NewsCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["News"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsDeleteResult"]: {
	__typename: "NewsDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["News"]
};
	["NewsUpdateResult"]: {
	__typename: "NewsUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["News"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsUpsertResult"]: {
	__typename: "NewsUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["News"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesCreateResult"]: {
	__typename: "StoriesCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Stories"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesDeleteResult"]: {
	__typename: "StoriesDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Stories"]
};
	["StoriesUpdateResult"]: {
	__typename: "StoriesUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Stories"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesUpsertResult"]: {
	__typename: "StoriesUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Stories"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsPageCreateResult"]: {
	__typename: "NewsPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsPageDeleteResult"]: {
	__typename: "NewsPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsPage"]
};
	["NewsPageUpdateResult"]: {
	__typename: "NewsPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsPageUpsertResult"]: {
	__typename: "NewsPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesPageCreateResult"]: {
	__typename: "StoriesPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesPageDeleteResult"]: {
	__typename: "StoriesPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesPage"]
};
	["StoriesPageUpdateResult"]: {
	__typename: "StoriesPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesPageUpsertResult"]: {
	__typename: "StoriesPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesListCreateResult"]: {
	__typename: "StoriesListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesListDeleteResult"]: {
	__typename: "StoriesListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesList"]
};
	["StoriesListUpdateResult"]: {
	__typename: "StoriesListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoriesListUpsertResult"]: {
	__typename: "StoriesListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StoriesList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createFallbackSeo: GraphQLTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo: GraphQLTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo: GraphQLTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo: GraphQLTypes["FallbackSeoUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createProgram: GraphQLTypes["ProgramCreateResult"],
	deleteProgram: GraphQLTypes["ProgramDeleteResult"],
	updateProgram: GraphQLTypes["ProgramUpdateResult"],
	upsertProgram: GraphQLTypes["ProgramUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createYoutubeVideo: GraphQLTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo: GraphQLTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo: GraphQLTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo: GraphQLTypes["YoutubeVideoUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createBulletPoint: GraphQLTypes["BulletPointCreateResult"],
	deleteBulletPoint: GraphQLTypes["BulletPointDeleteResult"],
	updateBulletPoint: GraphQLTypes["BulletPointUpdateResult"],
	upsertBulletPoint: GraphQLTypes["BulletPointUpsertResult"],
	createBulletPointItem: GraphQLTypes["BulletPointItemCreateResult"],
	deleteBulletPointItem: GraphQLTypes["BulletPointItemDeleteResult"],
	updateBulletPointItem: GraphQLTypes["BulletPointItemUpdateResult"],
	upsertBulletPointItem: GraphQLTypes["BulletPointItemUpsertResult"],
	createFileItem: GraphQLTypes["FileItemCreateResult"],
	deleteFileItem: GraphQLTypes["FileItemDeleteResult"],
	updateFileItem: GraphQLTypes["FileItemUpdateResult"],
	upsertFileItem: GraphQLTypes["FileItemUpsertResult"],
	createFileList: GraphQLTypes["FileListCreateResult"],
	deleteFileList: GraphQLTypes["FileListDeleteResult"],
	updateFileList: GraphQLTypes["FileListUpdateResult"],
	upsertFileList: GraphQLTypes["FileListUpsertResult"],
	createFooterLink: GraphQLTypes["FooterLinkCreateResult"],
	deleteFooterLink: GraphQLTypes["FooterLinkDeleteResult"],
	updateFooterLink: GraphQLTypes["FooterLinkUpdateResult"],
	upsertFooterLink: GraphQLTypes["FooterLinkUpsertResult"],
	createFooterLinkGroups: GraphQLTypes["FooterLinkGroupsCreateResult"],
	deleteFooterLinkGroups: GraphQLTypes["FooterLinkGroupsDeleteResult"],
	updateFooterLinkGroups: GraphQLTypes["FooterLinkGroupsUpdateResult"],
	upsertFooterLinkGroups: GraphQLTypes["FooterLinkGroupsUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createProgramPage: GraphQLTypes["ProgramPageCreateResult"],
	deleteProgramPage: GraphQLTypes["ProgramPageDeleteResult"],
	updateProgramPage: GraphQLTypes["ProgramPageUpdateResult"],
	upsertProgramPage: GraphQLTypes["ProgramPageUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createStaff: GraphQLTypes["StaffCreateResult"],
	deleteStaff: GraphQLTypes["StaffDeleteResult"],
	updateStaff: GraphQLTypes["StaffUpdateResult"],
	upsertStaff: GraphQLTypes["StaffUpsertResult"],
	createStaffItem: GraphQLTypes["StaffItemCreateResult"],
	deleteStaffItem: GraphQLTypes["StaffItemDeleteResult"],
	updateStaffItem: GraphQLTypes["StaffItemUpdateResult"],
	upsertStaffItem: GraphQLTypes["StaffItemUpsertResult"],
	createStaffList: GraphQLTypes["StaffListCreateResult"],
	deleteStaffList: GraphQLTypes["StaffListDeleteResult"],
	updateStaffList: GraphQLTypes["StaffListUpdateResult"],
	upsertStaffList: GraphQLTypes["StaffListUpsertResult"],
	createIcon: GraphQLTypes["IconCreateResult"],
	deleteIcon: GraphQLTypes["IconDeleteResult"],
	updateIcon: GraphQLTypes["IconUpdateResult"],
	upsertIcon: GraphQLTypes["IconUpsertResult"],
	createPrincipleItem: GraphQLTypes["PrincipleItemCreateResult"],
	deletePrincipleItem: GraphQLTypes["PrincipleItemDeleteResult"],
	updatePrincipleItem: GraphQLTypes["PrincipleItemUpdateResult"],
	upsertPrincipleItem: GraphQLTypes["PrincipleItemUpsertResult"],
	createPrincipleList: GraphQLTypes["PrincipleListCreateResult"],
	deletePrincipleList: GraphQLTypes["PrincipleListDeleteResult"],
	updatePrincipleList: GraphQLTypes["PrincipleListUpdateResult"],
	upsertPrincipleList: GraphQLTypes["PrincipleListUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkSubGroup: GraphQLTypes["LinkSubGroupCreateResult"],
	deleteLinkSubGroup: GraphQLTypes["LinkSubGroupDeleteResult"],
	updateLinkSubGroup: GraphQLTypes["LinkSubGroupUpdateResult"],
	upsertLinkSubGroup: GraphQLTypes["LinkSubGroupUpsertResult"],
	createYoutubeVideoList: GraphQLTypes["YoutubeVideoListCreateResult"],
	deleteYoutubeVideoList: GraphQLTypes["YoutubeVideoListDeleteResult"],
	updateYoutubeVideoList: GraphQLTypes["YoutubeVideoListUpdateResult"],
	upsertYoutubeVideoList: GraphQLTypes["YoutubeVideoListUpsertResult"],
	createYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemCreateResult"],
	deleteYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemDeleteResult"],
	updateYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemUpdateResult"],
	upsertYoutubeVideoListItem: GraphQLTypes["YoutubeVideoListItemUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createCitationItem: GraphQLTypes["CitationItemCreateResult"],
	deleteCitationItem: GraphQLTypes["CitationItemDeleteResult"],
	updateCitationItem: GraphQLTypes["CitationItemUpdateResult"],
	upsertCitationItem: GraphQLTypes["CitationItemUpsertResult"],
	createCitationList: GraphQLTypes["CitationListCreateResult"],
	deleteCitationList: GraphQLTypes["CitationListDeleteResult"],
	updateCitationList: GraphQLTypes["CitationListUpdateResult"],
	upsertCitationList: GraphQLTypes["CitationListUpsertResult"],
	createContentImageLinkItem: GraphQLTypes["ContentImageLinkItemCreateResult"],
	deleteContentImageLinkItem: GraphQLTypes["ContentImageLinkItemDeleteResult"],
	updateContentImageLinkItem: GraphQLTypes["ContentImageLinkItemUpdateResult"],
	upsertContentImageLinkItem: GraphQLTypes["ContentImageLinkItemUpsertResult"],
	createContentImageLinkList: GraphQLTypes["ContentImageLinkListCreateResult"],
	deleteContentImageLinkList: GraphQLTypes["ContentImageLinkListDeleteResult"],
	updateContentImageLinkList: GraphQLTypes["ContentImageLinkListUpdateResult"],
	upsertContentImageLinkList: GraphQLTypes["ContentImageLinkListUpsertResult"],
	createNews: GraphQLTypes["NewsCreateResult"],
	deleteNews: GraphQLTypes["NewsDeleteResult"],
	updateNews: GraphQLTypes["NewsUpdateResult"],
	upsertNews: GraphQLTypes["NewsUpsertResult"],
	createStories: GraphQLTypes["StoriesCreateResult"],
	deleteStories: GraphQLTypes["StoriesDeleteResult"],
	updateStories: GraphQLTypes["StoriesUpdateResult"],
	upsertStories: GraphQLTypes["StoriesUpsertResult"],
	createNewsPage: GraphQLTypes["NewsPageCreateResult"],
	deleteNewsPage: GraphQLTypes["NewsPageDeleteResult"],
	updateNewsPage: GraphQLTypes["NewsPageUpdateResult"],
	upsertNewsPage: GraphQLTypes["NewsPageUpsertResult"],
	createStoriesPage: GraphQLTypes["StoriesPageCreateResult"],
	deleteStoriesPage: GraphQLTypes["StoriesPageDeleteResult"],
	updateStoriesPage: GraphQLTypes["StoriesPageUpdateResult"],
	upsertStoriesPage: GraphQLTypes["StoriesPageUpsertResult"],
	createStoriesList: GraphQLTypes["StoriesListCreateResult"],
	deleteStoriesList: GraphQLTypes["StoriesListDeleteResult"],
	updateStoriesList: GraphQLTypes["StoriesListUpdateResult"],
	upsertStoriesList: GraphQLTypes["StoriesListUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean
};
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3Acl"]: S3Acl;
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum ContentReferenceType {
	image = "image",
	youtubeVideo = "youtubeVideo",
	banner = "banner",
	downloads = "downloads",
	jumbotron = "jumbotron",
	steps = "steps",
	staff = "staff",
	boxes = "boxes",
	principles = "principles",
	button = "button",
	line = "line",
	link = "link",
	imageList = "imageList",
	citationList = "citationList",
	achievementList = "achievementList",
	storiesBlock = "storiesBlock",
	newsBlock = "newsBlock",
	widget = "widget"
}
export const enum LinkType {
	internal = "internal",
	external = "external"
}
export const enum One {
	One = "One"
}
export const enum View {
	line = "line",
	noLine = "noLine"
}
export const enum Aligning {
	left = "left",
	center = "center",
	right = "right"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export const enum S3Acl {
	PUBLIC_READ = "PUBLIC_READ",
	PRIVATE = "PRIVATE",
	NONE = "NONE"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: true;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type OperationToGraphQL<V, T> = <Z extends V>(o: Z | V, options?: OperationOptions) => Promise<InputType<T, Z>>;
export type SubscriptionToGraphQL<V, T> = <Z extends V>(
  o: Z | V,
  options?: OperationOptions,
) => {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?:string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => void;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});

export const fullChainConstructor = <F extends FetchFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullChainConstruct(fn)(operation, key)(o as any, options)) as OperationToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));

export const fullSubscriptionConstructor = <F extends SubscriptionFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullSubscriptionConstruct(fn)(operation, key)(o as any, options)) as SubscriptionToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };


export const Thunder = (fn: FetchFunction, subscriptionFn: SubscriptionFunction) => ({
  query: fullChainConstructor(fn,'query', 'Query'),
mutation: fullChainConstructor(fn,'mutation', 'Mutation')
});

export const Chain = (...options: chainOptions) => ({
  query: fullChainConstructor(apiFetch(options),'query', 'Query'),
mutation: fullChainConstructor(apiFetch(options),'mutation', 'Mutation')
});
export const Zeus = {
  query: (o:ValueTypes["Query"], operationName?: string) => queryConstruct('query', 'Query', operationName)(o),
mutation: (o:ValueTypes["Mutation"], operationName?: string) => queryConstruct('mutation', 'Mutation', operationName)(o)
};
export const Selectors = {
  query: ZeusSelect<ValueTypes["Query"]>(),
mutation: ZeusSelect<ValueTypes["Mutation"]>()
};
  
export type FragmentResult<K extends keyof GraphQLTypes, Q extends unknown | ((...args: any[]) => unknown)> = InputType<
	GraphQLTypes[K],
	Q extends (...args: any[]) => unknown ? ReturnType<Q> : Q
>